webpackJsonp([0],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var application_service_1 = __webpack_require__(128);
var Mappings = (function () {
    function Mappings(application) {
        this.application = application;
        /* base urls */
        this.Web_Api_Base_Url = this.application.config.apiUrl;
        /* Google key for map */
        this.Google_Maps_Key = "AIzaSyBXymPQfgG39aceYOuzkdVynFoFRf3lMKc";
        this.Web_Api_Get_Token_Url = this.Web_Api_Base_Url + "/token";
        this.Web_Api_Menu_GetCmsPageByUrl = this.Web_Api_Base_Url + "/menu/getcmspagebyurl/{customerid}/{lang}/{cartid}/{url}";
        this.Web_Api_Menu_GetCmsPageById = this.Web_Api_Base_Url + "/menu/getcmsmenu/{customerid}/{lang}/{id}/{cartid}";
        this.Web_Api_Get_Template_Url = this.Web_Api_Base_Url + "/template/getTemplateHtml/{type}/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Default_Company = this.Web_Api_Base_Url + "/company/getdefault";
        this.Web_Api_Get_Article_List = this.Web_Api_Base_Url + "/article/getarticlelist/{category}/{listtype}/{lang}";
        this.Web_Api_Get_News_Details = this.Web_Api_Base_Url + "/article/getarticledetailsbyid/{lang}/{id}/{userid}/{cartid}";
        this.Web_Api_Get_Article_By_Url = this.Web_Api_Base_Url + "/article/getarticledetailsbyseourl/{lang}/{userid}/{cartid}/{seoUrl}";
        this.Web_Api_Get_Article_Category_By_Id = this.Web_Api_Base_Url + "/article/getcategorybyid/{categoryId}/{lang}/{startRowIndex}/{maxRows}/{userid}/{cartid}";
        this.Web_Api_Get_Article_Category_By_Url = this.Web_Api_Base_Url + "/article/getcategorybyurl/{lang}/{startRowIndex}/{maxRows}/{userid}/{cartid/{categoryUrl}";
        this.Web_Api_Get_Article_List_Category = this.Web_Api_Base_Url + "/article/getarticlelistcategory/{lang}";
        this.Web_Api_Get_Article_By_Category_Id = this.Web_Api_Base_Url + "/article/getarticledetailsbycategoryid/{categoryId}/{lang}/{startRowIndex}/{maxRows}";
        this.Web_Api_Get_Blog_Data = this.Web_Api_Base_Url + "/article/getblogdata/{lang}/{startRowIndex}/{maxRows}/{userid}/{cartid}";
        this.Web_Api_Get_Cms_Menu_List = this.Web_Api_Base_Url + "/menu/getcmsmenus/{id}/{lang}";
        this.Web_Api_Get_FaqData = this.Web_Api_Base_Url + "/article/getfaqdata/{lang}/{userid}/{cartid}";
        this.Web_Api_Post_Newsletter_Subscribe = this.Web_Api_Base_Url + "/newsletter/subscribe/{email}/{lang}";
        this.Web_Api_Get_Newsletter_Page_Data = this.Web_Api_Base_Url + "/newsletter/pagedata/{lang}";
        this.Web_Api_Get_Newsletter_Confirmation_Page_Data = this.Web_Api_Base_Url + "/newsletter/confirmationpage/{lang}";
        this.Web_Api_Get_Wizard_Data_Address = this.Web_Api_Base_Url + "/quoting/getwizarddata/{modelType}/{resourceId}/{userId}/{lang}";
        this.Web_Api_Get_Category_Details = this.Web_Api_Base_Url + "/inventory/getcategory/{categoryId}/{lang}/{customerid}/{currency}/{cartid}/{templatebuilderid}";
        this.Web_Api_Get_Catalog_Categories_Data = this.Web_Api_Base_Url + "/inventory/getcatalogcategoriesdata/{lang}/{currency}/{userid}/{cartid}";
        this.Web_Api_Get_Catalog_Categories_Price_Data = this.Web_Api_Base_Url + "/inventory/getcategorypricedata/{categoryId}/{customerid}/{lang}/{currency}";
        this.Web_Api_Get_Category_By_Url = this.Web_Api_Base_Url + "/inventory/getcategorybyseourl/{lang}/{customerid}/{currency}/{cartid}/{templatebuilderid}/{seoUrl}";
        this.Web_Api_Post_Send_Category_Info_Request = this.Web_Api_Base_Url + "/inventory/getcategoryinfo";
        this.Web_Api_Get_Product_Details = this.Web_Api_Base_Url + "/inventory/getproduct/{productType}/{productId}/{lang}/{customerid}/{currency}/{cartid}/{templatebuilderid}";
        this.Web_Api_Get_Price_Data = this.Web_Api_Base_Url + "/inventory/getproductpricedata/{productId}/{lang}/{customerid}/{currency}";
        this.Web_Api_Get_Products_In_Promotion_Data = this.Web_Api_Base_Url + "/inventory/getproductsinpromotiondata/{lang}/{currency}/{userid}/{cartid}";
        this.Web_Api_Get_Product_By_Url = this.Web_Api_Base_Url + "/inventory/getproductbyseourl/{lang}/{customerid}/{currency}/{cartid}/{templatebuilderid}/{seoUrl}";
        this.Web_Api_Post_Send_Info_Request = this.Web_Api_Base_Url + "/info/contactrequest";
        this.Web_Api_Post_Send_Login_Request = this.Web_Api_Base_Url + "/account/login";
        this.Web_Api_Post_User_Authentification = this.Web_Api_Base_Url + "/account/authentificateuser";
        this.Web_Api_Recover_Password = this.Web_Api_Base_Url + "/account/passwordrequest";
        this.Web_Api_Get_Recover_Password_Data = this.Web_Api_Base_Url + "/account/getrecoverpassworddata/{lang}/{userid}/{cartid}";
        this.Web_Api_Post_Register = this.Web_Api_Base_Url + "/account/register";
        this.Web_Api_Get_Register_Data = this.Web_Api_Base_Url + "/account/registerdata/{lang}/{userid}/{cartid}/{templatebuilderid}";
        this.Web_Api_Get_Registration_Complete_Page_Data = this.Web_Api_Base_Url + "/registration/confirmationpage/{lang}/{userid}/{cartid}";
        this.Web_Api_Post_Confirm_Registration = this.Web_Api_Base_Url + "/account/activate/{id}";
        this.Web_Api_Get_Save_Cart = this.Web_Api_Base_Url + "/cart/postsavecartinfo/{userId}/{cartId}/{paymentId}/{shipmentId}";
        this.Web_Api_Set_Cart_Voucher = this.Web_Api_Base_Url + "/cart/setvoucher";
        this.Web_Api_Set_Job_Name = this.Web_Api_Base_Url + "/cart/setcartjobname";
        this.Web_Api_Set_Cart_Address = this.Web_Api_Base_Url + "/cart/setcartaddress";
        this.Web_Api_Post_Cart_Confirm_Order = this.Web_Api_Base_Url + "/cart/confirmorder";
        this.Web_Api_Get_Cart_Payment_Shipment = this.Web_Api_Base_Url + "/cart/getcartpaymentshipment/{userId}/{cartId}/{lang}/{currency}";
        this.Web_Api_Get_Client_Area_Details = this.Web_Api_Base_Url + "/clientarea/getdetails/{id}/{lang}/{cartid}";
        this.Web_Api_Get_Client_Area_User_Profile = this.Web_Api_Base_Url + "/clientarea/getuserprofile/{userId}/{lang}/{cartid}";
        this.Web_Api_Post_Client_Area_Add_New_Address = this.Web_Api_Base_Url + "/clientarea/adduseraddress";
        this.Web_Api_Post_Client_Area_Update_User_Password = this.Web_Api_Base_Url + "/clientarea/updateuserpassword";
        this.Web_Api_Post_Client_Area_Update_User_Profile = this.Web_Api_Base_Url + "/clientarea/updateuserprofile";
        this.Web_Api_Post_Client_Area_Update_User_Address = this.Web_Api_Base_Url + "/clientarea/updateuseraddresses";
        this.Web_Api_Post_Client_Area_Remove_Address = this.Web_Api_Base_Url + "/clientarea/removeuseraddress";
        this.Web_Api_Get_Client_Area_Order_Details = this.Web_Api_Base_Url + "/clientarea/getorderdetails/{userId}/{orderId}/{lang}/{currency}/{cartid}";
        this.Web_Api_Get_Client_Area_Catalog_Private = this.Web_Api_Base_Url + "/clientarea/getcatalogprivate/{userId}/{lang}/{currency}/{cartid}";
        this.Web_Api_Get_Client_Area_Order_List = this.Web_Api_Base_Url + "/clientarea/getorderlist/{userId}/{dateFrom}/{dateTo}/{orderNumber}/{orderStatus}/{lang}/{currency}/{cartid}";
        this.Web_Api_Get_Client_Area_Invoices = this.Web_Api_Base_Url + "/clientarea/getinvoiceslist/{userId}/{orderNumber}/{invoiceNumber}/{documentType}/{lang}/{currency}/{cartid}";
        this.Web_Api_Get_Client_Area_Order_Send_Message = this.Web_Api_Base_Url + "/clientarea/postsendprocessordermessage";
        this.Web_Api_Get_Client_Area_Proccess_Order_File = this.Web_Api_Base_Url + "/clientarea/getorderprocessfiles";
        this.Web_Api_Get_Client_Area_Update_Bonifico_Payment = this.Web_Api_Base_Url + "/clientarea/updatebonificopaymentdetails";
        this.Web_Api_Get_Configuration = this.Web_Api_Base_Url + "/config/getconfiguration/{lang}";
        this.Web_Api_Get_Routes = this.Web_Api_Base_Url + "/config/getroutes/{lang}";
        this.Web_Api_Get_Header_Data = this.Web_Api_Base_Url + "/cms/getheaderdata/{lang}/{userid}/{cartid}/{currency}/{templatebuilderid}";
        this.Web_Api_Get_Footer_Data = this.Web_Api_Base_Url + "/cms/getfooterdata/{lang}/{currency}";
        this.Web_Api_Get_Side_Menu_Data = this.Web_Api_Base_Url + "/cms/getsidemenudata/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Home_Page_Data = this.Web_Api_Base_Url + "/cms/gethomepagedata/{lang}";
        this.Web_Api_Get_Home_Page_Data_Optimized = this.Web_Api_Base_Url + "/cms/gethomepagedataoptimized/{lang}/{userid}/{cartid}/{currency}/{templatebuilderid}";
        this.Web_Api_Get_Home_HilightPromoProduct = this.Web_Api_Base_Url + "/cms/getproducthilightpromo/{lang}";
        this.Web_Api_Get_Info_Request_Data = this.Web_Api_Base_Url + "/cms/getinforequestdata/{lang}/{userid}/{cartid}";
        this.Web_Api_Get_Privacy_Policy_Data = this.Web_Api_Base_Url + "/privacypolicy/getprivacypolicydata/{lang}/{userid}/{cartid}";
        this.Web_Api_Get_Cookie_Policy_Data = this.Web_Api_Base_Url + "/cookiepolicy/getcookiepolicydata/{lang}/{cartid}/{userid}";
        this.Web_Api_Get_Purchase_Condition_Data = this.Web_Api_Base_Url + "/puchasecondition/puchaseconditiondata/{lang}/{userid}/{cartid}";
        this.Web_Api_Get_Slider_Data = this.Web_Api_Base_Url + "/slider/getsliderdata/{lang}/{id}/{type}";
        this.Web_Api_Get_Seo_Data = this.Web_Api_Base_Url + "/cms/gethomepageseodata/{lang}";
        this.Web_Api_Get_Shopping_Cart_Data = this.Web_Api_Base_Url + "/cms/getcartdata/{userid}/{cartid}/{lang}/{currency}";
        this.Web_Api_Get_Shopping_Cart_Cash_Data = this.Web_Api_Base_Url + "/cms/getcartcashdata/{userid}/{cartid}/{lang}/{currency}";
        this.Web_Api_Get_Shopping_Cart_Submitted_Data = this.Web_Api_Base_Url + "/cms/getcartsubmitteddata/{userid}/{orderid}/{lang}/{currency}/{cartid}";
        this.Web_Api_Get_Client_Area_Messages = this.Web_Api_Base_Url + "/clientarea/setmessagesasread";
        this.Web_Api_Add_Static_Product_To_Cart = this.Web_Api_Base_Url + "/cart/addstaticproducttocart";
        this.Web_Api_Add_Static_Product_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addstaticproductscontisticatocart";
        this.Web_Api_Add_Matrix_Product_To_Cart = this.Web_Api_Base_Url + "/cart/addmatrixproducttocart";
        this.Web_Api_Get_Offline_Page_Data = this.Web_Api_Base_Url + "/cms/getofflinepagedata/{lang}/{userid}/{cartid}";
        this.Web_Api_Get_Login_Page_Data = this.Web_Api_Base_Url + "/cms/loginpage/{lang}/{userid}/{cartid}/{templatebuilderid}";
        this.Web_Api_Set_Cart_Payment = this.Web_Api_Base_Url + "/cart/setcartpayment";
        this.Web_Api_Empty_Cart_Page = this.Web_Api_Base_Url + "/cart/emptycartpage/{lang}/{userid}/{cartid}";
        this.Web_Api_Set_Cart_Shipment = this.Web_Api_Base_Url + "/cart/setcartshipping";
        this.Web_Api_Remove_From_Cart = this.Web_Api_Base_Url + "/cart/removefromcart";
        this.Web_Api_Post_Cancel_Order = this.Web_Api_Base_Url + "/clientarea/postcancelorder/{userId}/{orderId}";
        this.Web_Api_Post_Get_Bonifico_Uploaded_Files = this.Web_Api_Base_Url + "/clientarea/getorderbonificofiles";
        this.Web_Api_Add_Wizard_Calcolato_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardcalcolatoproducttocart";
        this.Web_Api_Add_Wizard_Calcolato_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardcalcolatoscontisticaproducttocart";
        this.Web_Api_Add_Wizard_Listino_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardlistinostandardproducttocart";
        this.Web_Api_Add_Wizard_Listino_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardlistinoscontisticaproducttocart";
        this.Web_Api_Update_Prev_Canvas_Info = this.Web_Api_Base_Url + "/cart/updateprevcanvasinfo";
        this.Web_Api_Add_Other_Product_Listino_To_Cart = this.Web_Api_Base_Url + "/cart/addotherproductlistinotocart";
        this.Web_Api_Add_Other_Product_Listino_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addotherproductlistinoscontisticatocart";
        this.Web_Api_Add_Other_Product_Calcolato_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addotherproductcalcolatoscontisticatocart";
        this.Web_Api_Add_Other_Product_Listino_Calcolato_To_Cart = this.Web_Api_Base_Url + "/cart/addotherproductlistinocalcolatotocart";
        this.Web_Api_Add_Other_Product_Listino_Calcolato_Scontistica_To_Cart = this.Web_Api_Base_Url + "/cart/addotherproductlistinocalcolatoscontisticatocart";
        this.Web_Api_Get_Other_Product_Form_Data = this.Web_Api_Base_Url + "/quoting/getotherproductformdata/{lang}/{productid}/{userId}/{templatebuilderid}";
        this.Web_Api_Get_Script = this.Web_Api_Base_Url + "/cms/getscript/{rowid}/{type}/{lang}";
        this.Web_Api_Get_Wizard_Editoria_Data = this.Web_Api_Base_Url + "/quoting/getwizardeditoriadata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Wizard_Commerciale_Data = this.Web_Api_Base_Url + "/quoting/getwizardcommercialedata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Check_If_Param_Exists_In_Db = this.Web_Api_Base_Url + "/account/checkifexists/{type}/{value}";
        this.Web_Api_Set_Order_As_Payed = this.Web_Api_Base_Url + "/clientarea/setorderaspaid";
        this.Web_Api_Get_Head_Foot_Data = this.Web_Api_Base_Url + "/template/getheadfootdata/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Wizard_Etichette_Data = this.Web_Api_Base_Url + "/quoting/getwizardetichettedata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Post_Get_Wizard_Price_Estimation = this.Web_Api_Base_Url + "/quoting/getwizardpriceestimation";
        this.Web_Api_Post_Send_Request_Info_Wizard = this.Web_Api_Base_Url + "/quoting/sendrequestinfo";
        this.Web_Api_Get_Wizard_Buste_Data = this.Web_Api_Base_Url + "/quoting/getwizardbustedata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Wizard_Adesivi_Data = this.Web_Api_Base_Url + "/quoting/getwizardadesividata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Wizard_Banner_Data = this.Web_Api_Base_Url + "/quoting/getwizardbannerdata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Get_Wizard_Stampa_Data = this.Web_Api_Base_Url + "/quoting/getwizardstampadata/{modelType}/{resourceId}/{userId}/{lang}/{templatebuilderid}";
        this.Web_Api_Post_Get_Ap_Price_Estimation = this.Web_Api_Base_Url + "/quoting/getappriceestimation";
        this.Web_Api_Add_Wizard_Buste_Listino_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardlistinobustetocart";
        this.Web_Api_Add_Wizard_Buste_Listino_Buste_To_Cart = this.Web_Api_Base_Url + "/cart/addwizardlistinoscontisticabustetocart";
        this.Web_Api_Check_Is_Order_Payed_Unicredit = this.Web_Api_Base_Url + "/pagonline/verifyunicreditpayment/{orderId}";
        this.Web_Api_Get_Product_And_Categories = this.Web_Api_Base_Url + "/article/getsearchresults/{startRowIndex}/{maxRows}/{lang}/{query}";
        this.Web_Api_Get_Script_Head = this.Web_Api_Base_Url + "/cms/getscripthead/{rowid}/{type}/{lang}";
        this.Web_Api_Get_Information_ThankYouPage_Paypal_Url = this.Web_Api_Base_Url + "/template/getthankyoupagepaypalinfo/{type}/{orderid}/{lang}/{cartid}/{userid}";
        this.Web_Api_Get_Information_ThankYouPage_PagOnline_Url = this.Web_Api_Base_Url + "/pagonline/getthankyoupagepagonlineinfo/{type}/{orderid}/{lang}/{cartid}/{userid}";
        this.Web_Api_Get_Information_ThankYouPage_Nexi_Url = this.Web_Api_Base_Url + "/nexi/getthankyoupagenexiinfo/{type}/{orderid}/{messaggio}/{data}/{orario}/{lang}/{cartid}/{userid}";
        this.Web_Api_Get_Information_ThankYouPage_BancaSella_Url = this.Web_Api_Base_Url + "/bancasella/getthankyoupagebancasellainfo/{type}/{orderid}/{messaggio}/{lang}/{cartid}/{userid}";
        this.Web_Api_Get_Template_Url_Page_Not_Found = this.Web_Api_Base_Url + "/template/getcomponenttemplatepagenotfound/{type}/{lang}/{userid}/{cartid}";
        this.Web_Api_Delete_Customers_Canvas_State = "/api/users/{userId}/states/{stateId}";
        this.Web_Api_Create_Paypal_Payment = this.Web_Api_Base_Url + "/paypal/createpaypalpayment";
        this.Web_Api_Execute_Paypal_Payment = this.Web_Api_Base_Url + "/paypal/executepaypalpayment";
        this.Web_Api_Get_Trustpilot_Data = this.Web_Api_Base_Url + "/gettrustpilotdata/{type}/{lang}";
        this.Web_Api_Get_DefaultCurrency = this.Web_Api_Base_Url + "/config/getdefaultcurrency";
        this.Web_Api_Get_Client_Area_Riorder_List = this.Web_Api_Base_Url + "/clientarea/getriorderlist/{orderid}/{lang}/{currency}";
        this.Web_Api_Get_Client_Area_CalculatePrice_Riorder = this.Web_Api_Base_Url + "/clientarea/calculatepriceriorder";
        this.Web_Api_Get_Client_Area_Get_Cart_Riorder = this.Web_Api_Base_Url + "/cart/getcartforriorder/{userId}/{cartId}/{lang}";
        this.Web_Api_Get_Client_Area_Add_Product_To_Cart_Riorder = this.Web_Api_Base_Url + "/cart/addproductriordertocart";
        this.Canvas_Web_Api_Base_Url = "https://h.customerscanvas.com/Users/{apiKey}/SimplePolygraphy";
        this.Paypal_JS_Lirary_Url = "https://www.paypalobjects.com/api/checkout.js";
        /* constants */
        this.Auth_User_Cookie = "Auth_User";
        this.WscPrinter_Lang = "WscPrinter_Lang";
        this.Default_Lang = "it";
        /* images */
        this.Offers_Image_Url = "http://wscprinter.dynamicsoft.it/angular/global_app/writefolder/img/OFFERTE.jpg";
        this.Products_Image_Url = "http://wscprinter.dynamicsoft.it/angular/global_app/writefolder/img/prodotti.jpg";
        this.WizardCheck_Image_Url = "http://wscprinter.dynamicsoft.it/angular/global_app/writefolder/img/Wizard_Check-icon.png";
        this.WizardAlert_Image_Url = "http://wscprinter.dynamicsoft.it/angular/global_app/writefolder/img/Wizard_Alert-icon.png";
        this.UserLoginImg_Url = "http://wscprinter.dynamicsoft.it/angular/global_app/writefolder/img/customer.jpg";
    }
    /* web api urls */
    Mappings.Web_Api_Get_Token_Url = "/token";
    Mappings = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof application_service_1.ApplicationService !== 'undefined' && application_service_1.ApplicationService) === 'function' && _a) || Object])
    ], Mappings);
    return Mappings;
    var _a;
}());
exports.Mappings = Mappings;


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var angular2_meta_1 = __webpack_require__(99);
var dom_adapter_1 = __webpack_require__(32);
var platform_browser_1 = __webpack_require__(7);
var core_2 = __webpack_require__(27);
var SeoService = (function () {
    function SeoService(_document, metaService, translate) {
        this._document = _document;
        this.metaService = metaService;
        this.translate = translate;
        this._dom = dom_adapter_1.getDOM();
    }
    SeoService.prototype.setSeoInformation = function (seoInformation) {
        this.metaService.updateTag('name=Keywords', { name: 'Keywords', content: seoInformation.Keywords });
        this.metaService.updateTag('name=Description', { name: 'Description', content: seoInformation.Description });
        this.metaService.updateTag('property="og:description"', { property: 'og:description', content: seoInformation.Description });
        this.metaService.updateTag('property="og:title"', { property: 'og:title', content: seoInformation.Title });
        this.metaService.updateTag('name=Robots', { name: 'Robots', content: seoInformation.SeoRobots });
        this.metaService.setTitle(seoInformation.Title);
        this.updateCanonicalTag('link', { rel: 'canonical', href: seoInformation.Url });
    };
    SeoService.prototype.setSeoUserArea = function (url) {
        this.metaService.updateTag('name=Keywords', { name: 'Keywords', content: "" });
        this.metaService.updateTag('name=Description', { name: 'Description', content: "" });
        this.metaService.updateTag('property="og:description"', { property: 'og:description', content: "" });
        this.metaService.updateTag('property="og:title"', { property: 'og:title', content: "" });
        this.metaService.updateTag('name=Robots', { name: 'Robots', content: "index,follow" });
        var title = this.getLabel("user_area");
        this.metaService.setTitle(title);
        this.updateCanonicalTag('link', { rel: 'canonical', href: url });
    };
    SeoService.prototype.getLabel = function (label) {
        var message;
        this.translate.get(label, this.translate).subscribe(function (res) {
            message = res;
        });
        return message;
    };
    SeoService.prototype.getCanonicalLink = function (selector) {
        if (!selector)
            return null;
        return this._dom.query(selector);
    };
    SeoService.prototype.updateCanonicalTag = function (selector, tag) {
        var canonical = this.getCanonicalLink(selector);
        if (!canonical) {
            //create element if it doesn't exist
            return this._addInternalCanonical(tag);
        }
        return this._prepareLinkElement(tag, canonical);
    };
    //-- *********************************** ANGULAR SERVER SIDE SEO SETUP START ***********************************
    SeoService.prototype.generateSeoDomServerSide = function (document, renderer, seoData) {
        var rootElement, h1, h2, h3, linkEl, nodeList, description;
        if (!seoData)
            return;
        //-- Creating root element which will be hidden, but available for crawling
        rootElement = renderer.createElement(document.body, 'div');
        renderer.setElementClass(rootElement, 'd-none', true);
        nodeList = [];
        //-- Creating h1 element
        if (seoData.H1) {
            h1 = renderer.createElement(document.body, 'h1');
            renderer.createText(h1, seoData.H1);
            nodeList.push(h1);
        }
        //-- Creating h2 element
        if (seoData.H2) {
            h2 = renderer.createElement(document.body, 'h2');
            renderer.createText(h2, seoData.H2);
            nodeList.push(h2);
        }
        //-- Creating h3 element
        if (seoData.H3) {
            //console.log("qui")
            if (!seoData.H3.includes("<iframe")) {
                h3 = renderer.createElement(document.body, 'h3');
                renderer.createText(h3, seoData.H3);
                nodeList.push(h3);
            }
        }
        //-- Creating p short description element
        if (seoData.ShortDescription) {
            description = renderer.createElement(document.body, 'p');
            renderer.setElementProperty(description, 'innerHTML', seoData.ShortDescription);
            nodeList.push(description);
        }
        //-- Creating p short description element
        if (seoData.LongDescription) {
            description = renderer.createElement(document.body, 'p');
            renderer.setElementProperty(description, 'innerHTML', seoData.LongDescription);
            nodeList.push(description);
        }
        //-- Appending all elements to the root element as a children
        renderer.projectNodes(rootElement, nodeList);
        //generate sitemap list for all pages
        this.generateSiteMapList(document, seoData.SiteMapList);
    };
    SeoService.prototype.generateSiteMapList = function (document, siteMapHtml) {
        var stringToInject = "<ul class='d-none'>";
        //this.appendHtmlString(document.body,"<ul>");
        siteMapHtml.forEach(function (element) {
            stringToInject += "<li>" + element + "</li>";
        });
        stringToInject += "</ul>";
        //this.appendHtmlString(document.body,"</ul>");
        this.appendHtmlString(document.body, stringToInject);
    };
    SeoService.prototype.appendHtmlString = function (el, template) {
        var div = this._dom.createElement('');
        this._dom.setInnerHTML(div, template);
        this._dom.insertAllBefore(el.lastChild, this._dom.childNodes(div));
    };
    SeoService.prototype.appendScriptsToDOM = function (el, template) {
        var _this = this;
        var div = this._dom.createElement('div');
        this._dom.setInnerHTML(div, template);
        var listEl = this._dom.childNodesAsList(div);
        listEl.forEach(function (element) { return _this._dom.insertAfter(el.lastChild, element); });
    };
    SeoService.prototype.setSeoMetaData = function (document, renderer, seoData, imgLink) {
        if (imgLink === void 0) { imgLink = ""; }
        //console.log( seoData)
        if (!seoData)
            return;
        //console.log( seoData.Title)
        this.updateMetaDataTitle(renderer, seoData.Title || '');
        //-- Setting canonicals
        this.createMetaTagUniversalAttribute(document, renderer, 'link', 'rel', 'canonical', 'href', seoData.Url || '');
        //-- Setting meta tags and open graph tags
        this.createMetaTagUniversalAttribute(document, renderer, 'meta', 'name', 'Keywords', 'content', seoData.Keywords || '');
        this.createMetaTagUniversalAttribute(document, renderer, 'meta', 'name', 'Robots', 'content', seoData.SeoRobots || '');
        this.createMetaTagUniversalAttribute(document, renderer, 'meta', 'name', 'description', 'content', seoData.Description || '');
        this.createMetaTagUniversalProperty(document, renderer, 'meta', 'property', 'og:description', 'content', seoData.Description || '');
        this.createMetaTagUniversalProperty(document, renderer, 'meta', 'property', 'og:title', 'content', seoData.Title || '');
        if (imgLink != null && imgLink.length > 0) {
            this.createMetaTagUniversalProperty(document, renderer, 'meta', 'property', 'og:image', 'content', imgLink || '');
        }
        this.createMetaTagUniversalProperty(document, renderer, 'meta', 'property', 'og:type', 'content', 'article');
    };
    //-- Updating of title for seo optimization
    SeoService.prototype.updateMetaDataTitle = function (renderer, value) {
        if (renderer && value)
            renderer.setText(renderer.selectRootElement('title'), value);
    };
    //-- Creating meta attributes for seo
    SeoService.prototype.createMetaTagUniversalAttribute = function (document, renderer, elementType, propertyNameFirst, valueFirst, propertyNameSecond, valueSecond) {
        if (propertyNameSecond === void 0) { propertyNameSecond = ""; }
        if (valueSecond === void 0) { valueSecond = ""; }
        var elem = renderer.createElement(document.head, elementType);
        if (propertyNameFirst && valueFirst) {
            renderer.setElementAttribute(elem, propertyNameFirst, valueFirst);
        }
        if (propertyNameSecond && valueSecond)
            renderer.setElementAttribute(elem, propertyNameSecond, valueSecond);
    };
    //-- Creating meta properties for social networks seo
    SeoService.prototype.createMetaTagUniversalProperty = function (document, renderer, elementType, propertyNameFirst, valueFirst, propertyNameSecond, valueSecond) {
        if (propertyNameSecond === void 0) { propertyNameSecond = ""; }
        if (valueSecond === void 0) { valueSecond = ""; }
        var elem = renderer.createElement(document.head, elementType);
        if (propertyNameFirst && valueFirst) {
            renderer.setElementProperty(elem, propertyNameFirst, valueFirst);
        }
        if (propertyNameSecond && valueSecond)
            renderer.setElementProperty(elem, propertyNameSecond, valueSecond);
    };
    //-- ************************************ ANGULAR SERVER SIDE SEO SETUP END*************************************
    SeoService.prototype._addInternalCanonical = function (tag) {
        var canonical = this._createLinkElement();
        this._prepareLinkElement(tag, canonical);
        this._appendLinkElement(canonical);
        return canonical;
    };
    SeoService.prototype._prepareLinkElement = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    SeoService.prototype._appendLinkElement = function (meta) {
        var head = this._document.head;
        this._dom.appendChild(head, meta);
    };
    SeoService.prototype._createLinkElement = function () {
        return this._dom.createElement('link');
    };
    SeoService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Object, (typeof (_a = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _a) || Object, (typeof (_b = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _b) || Object])
    ], SeoService);
    return SeoService;
    var _a, _b;
}());
exports.SeoService = SeoService;


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var ArticleService = (function () {
    function ArticleService(_api, _cache, mappings, languageService, cartService, authService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.languageService = languageService;
        this.cartService = cartService;
        this.authService = authService;
    }
    ArticleService.prototype.getArticleList = function (category, listtype) {
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Article_List.replace('{category}', category).replace('{listtype}', listtype).replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getArticleDetails = function (id, lang) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_News_Details.replace('{lang}', lang).replace('{id}', id.toString()).replace('{userid}', customerId).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getArticleByUrl = function (lang, seoUrl) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Article_By_Url.replace('{lang}', lang).replace('{seoUrl}', seoUrl).replace('{userid}', customerId).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.GetArticleByCategoryIdandRows = function (categoryId, lang, startRowIndex, maxRows) {
        var url = this.mappings.Web_Api_Get_Article_By_Category_Id.replace('{categoryId}', categoryId.toString()).replace('{lang}', lang).replace('{startRowIndex}', startRowIndex.toString()).replace('{maxRows}', maxRows.toString());
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getBlogData = function (lang, startRowIndex, maxRows) {
        var numberOfItems = 15;
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Blog_Data.replace('{lang}', lang).replace('{startRowIndex}', startRowIndex.toString()).replace('{maxRows}', maxRows.toString()).replace('{userid}', customerId).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getArticleListCategory = function (lang) {
        var url = this.mappings.Web_Api_Get_Article_List_Category.replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getCategoryArticleById = function (categoryId, lang, startRowIndex, maxRows) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Article_Category_By_Id
            .replace('{categoryId}', categoryId)
            .replace('{lang}', lang)
            .replace('{startRowIndex}', startRowIndex.toString())
            .replace('{maxRows}', maxRows.toString())
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ArticleService.prototype.getArticleCategoryByUrl = function (lang, categoryUrl, startRowIndex, maxRows) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Article_Category_By_Url
            .replace('{lang}', lang)
            .replace('{startRowIndex}', startRowIndex.toString())
            .replace('{maxRows}', maxRows.toString())
            .replace('{categoryUrl}', categoryUrl)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ArticleService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
    ], ArticleService);
    return ArticleService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ArticleService = ArticleService;


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var rxjs_1 = __webpack_require__(265);
var api_service_1 = __webpack_require__(13);
var auth_service_1 = __webpack_require__(9);
var HeaderService = (function () {
    function HeaderService(_api, authService) {
        this._api = _api;
        this.authService = authService;
        this.toShowQuickRegistration = false;
        // Observable source of logged in user
        this.loginInfo = this.authService.GetData();
        this.loggedInUser = new rxjs_1.BehaviorSubject(this.loginInfo);
    }
    HeaderService.prototype.getLoggedInUser = function () {
        return this.loggedInUser.asObservable();
    };
    HeaderService.prototype.setLoggedInUser = function (user) {
        this.loggedInUser.next(user);
    };
    HeaderService.prototype.setToShowQuickRegistration = function (toShow) {
        this.toShowQuickRegistration = toShow;
    };
    HeaderService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
    ], HeaderService);
    return HeaderService;
    var _a, _b;
}());
exports.HeaderService = HeaderService;


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(95);
var mapping_1 = __webpack_require__(10);
var api_service_1 = __webpack_require__(13);
var cookie_1 = __webpack_require__(85);
var cache_service_1 = __webpack_require__(21);
var node_logger_service_1 = __webpack_require__(260);
var ApplicationService = (function () {
    function ApplicationService(api, isNode, cookie, cache, nodeLogger) {
        this.api = api;
        this.isNode = isNode;
        this.cookie = cookie;
        this.cache = cache;
        this.nodeLogger = nodeLogger;
        this.getConfig();
    }
    Object.defineProperty(ApplicationService.prototype, "accessToken", {
        get: function () {
            return this.cookie.get(ApplicationService.ACCESS_TOKEN_KEY);
        },
        enumerable: true,
        configurable: true
    });
    ApplicationService.prototype.getToken = function () {
        var _this = this;
        if (!this.isNode /*|| 'string' === typeof this.accessToken*/) {
            return;
        }
        var startDate = new Date();
        var params = this.getCredentialsParams();
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.api
            .post("" + this.config.apiUrl + mapping_1.Mappings.Web_Api_Get_Token_Url, params, { headers: headers })
            .do(function (_a) {
            var access_token = _a.access_token;
            if (access_token) {
                _this.cache.set('__ACCESS_TOKEN__', access_token);
                _this.cookie.put(ApplicationService.ACCESS_TOKEN_KEY, access_token);
            }
        });
    };
    ApplicationService.prototype.getCredentialsParams = function () {
        var config = this.getConfig();
        var params = new http_1.URLSearchParams();
        params.set('grant_type', 'password');
        params.set('username', config.credentials.username);
        params.set('password', config.credentials.password);
        return params;
    };
    ApplicationService.prototype.getConfig = function () {
        if (this.config) {
            return this.config;
        }
        if (this.isNode) {
            var fs = __webpack_require__(429);
            this.config = JSON.parse(fs.readFileSync('src/assets/config.json', 'utf8'));
            this.setConfigToCache();
        }
        else {
            this.config = this.cache.get(ApplicationService.APPLICATION_CONFIG);
        }
        return this.config;
    };
    ApplicationService.prototype.setConfigToCache = function () {
        var privateKeys = ['credentials'];
        var configForCache = {};
        for (var key in this.config)
            if (this.config.hasOwnProperty(key)) {
                if (privateKeys.indexOf(key) === -1) {
                    configForCache[key] = this.config[key];
                }
            }
        this.cache.set(ApplicationService.APPLICATION_CONFIG, configForCache);
    };
    ApplicationService.ACCESS_TOKEN_KEY = 'accessToken';
    ApplicationService.APPLICATION_CONFIG = 'ApplicationConfig';
    ApplicationService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject('isNode')),
        __param(2, core_1.Inject('CookieService')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _b) || Object, (typeof (_c = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _c) || Object, (typeof (_d = typeof node_logger_service_1.NodeLoggerService !== 'undefined' && node_logger_service_1.NodeLoggerService) === 'function' && _d) || Object])
    ], ApplicationService);
    return ApplicationService;
    var _a, _b, _c, _d;
}());
exports.ApplicationService = ApplicationService;


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//Angular

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
//System
var mapping_1 = __webpack_require__(10);
//Services
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var CompanyService = (function () {
    function CompanyService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
    }
    CompanyService.prototype.getCompany = function () {
        var url = this.mappings.Web_Api_Get_Default_Company;
        var key = url;
        return this._api.get(url);
    };
    CompanyService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], CompanyService);
    return CompanyService;
    var _a, _b, _c;
}());
exports.CompanyService = CompanyService;


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(95);
var Observable_1 = __webpack_require__(1);
__webpack_require__(434);
__webpack_require__(186);
__webpack_require__(435);
__webpack_require__(432);
var cache_service_1 = __webpack_require__(21);
var node_logger_service_1 = __webpack_require__(260);
var cookie_1 = __webpack_require__(85);
var responseStatuses = {
    noContent: 204,
    authRequired: 401
};
var ApiService = (function () {
    function ApiService(http, cache, nodeLogger, isBrowser, cookie) {
        this.http = http;
        this.cache = cache;
        this.nodeLogger = nodeLogger;
        this.isBrowser = isBrowser;
        this.cookie = cookie;
        this.clientSideCaching = true;
    }
    /**
     * whatever domain/feature method name
     */
    ApiService.prototype.get = function (url, options) {
        var _this = this;
        if (this.clientSideCaching == false) {
            if (this.isBrowser && this.cache.has(url)) {
                var obs = Observable_1.Observable.of(this.cache.get(url));
                this.cache.clear(url);
                return obs;
            }
            options = this.createAuthorizationHeader(options);
            return this.http
                .get(url, options)
                .map(ApiService.extractData)
                .do(function (json) {
                if (!_this.isBrowser) {
                    _this.cache.set(url, json);
                }
            })
                .catch(function (err) { return _this.handleError(err); });
        }
        else {
            if (this.cache.has(url)) {
                var obs = Observable_1.Observable.of(this.cache.get(url));
                return obs;
            }
            options = this.createAuthorizationHeader(options);
            var startDate = new Date();
            this.nodeLogger.AddLogWithTime("START REQUEST " + url);
            return this.http
                .get(url, options)
                .map(ApiService.extractData)
                .do(function (json) {
                var endDate = new Date();
                var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
                var diffMs = Math.ceil(timeDiff);
                _this.nodeLogger.AddLogWithTime("END REQUEST " + url + "(" + diffMs + ")");
                _this.cache.set(url, json);
            })
                .catch(function (err) { return _this.handleError(err); });
        }
    };
    /**
   * whatever domain/feature method name
   */
    ApiService.prototype.getUniversalCached = function (url, options) {
        var _this = this;
        if (this.isBrowser && this.cache.has(url)) {
            var obs = Observable_1.Observable.of(this.cache.get(url));
            this.cache.clear(url);
            return obs;
        }
        options = this.createAuthorizationHeader(options);
        return this.http
            .get(url, options)
            .map(ApiService.extractData)
            .do(function (json) {
            if (!_this.isBrowser) {
                _this.cache.set(url, json);
            }
        })
            .catch(function (err) { return _this.handleError(err); });
    };
    ApiService.prototype.post = function (url, body, options) {
        var _this = this;
        options = this.createAuthorizationHeader(options);
        return this.http
            .post(url, body, options)
            .map(ApiService.extractData)
            .catch(function (err) { return _this.handleError(err); });
    };
    ApiService.prototype.createAuthorizationHeader = function (options) {
        if (options === void 0) { options = {}; }
        //Token is read from cache and not cookie. 
        //Note: Before it was read form cookie and it was not containing the last token.
        //Because the set cookie is done on the response and the get cookie is done on the request.
        var token = this.cache.get('__ACCESS_TOKEN__');
        if (token) {
            if (!options.headers) {
                options.headers = new http_1.Headers();
            }
            options.headers.append('Authorization', "Bearer " + token);
        }
        return options;
    };
    ApiService.extractData = function (res) {
        if (res.status === responseStatuses.noContent) {
            return {};
        }
        var body = res.json();
        return body || {};
    };
    ApiService.prototype.handleError = function (err) {
        this.nodeLogger.AddLogWithTime("Error: " + err);
        var cookieToken = this.cookie.get('accessToken');
        var cacheToken = this.cache.get('__ACCESS_TOKEN__');
        if (!this.isBrowser) {
            return Observable_1.Observable.empty();
        }
        switch (err.status) {
            case 401:
                this.handleUnauthorized();
                break;
            default:
                break;
        }
        return Observable_1.Observable.throw(err);
    };
    ApiService.prototype.handleUnauthorized = function () {
        //If the token expires while using the application, the user is redirected to home page to get a new token and start navigation from there.
        if (this.isBrowser) {
            window.location.href = "/";
        }
    };
    ApiService = __decorate([
        core_1.Injectable(),
        __param(3, core_1.Inject('isBrowser')),
        __param(4, core_1.Inject('CookieService')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof node_logger_service_1.NodeLoggerService !== 'undefined' && node_logger_service_1.NodeLoggerService) === 'function' && _c) || Object, Boolean, (typeof (_d = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _d) || Object])
    ], ApiService);
    return ApiService;
    var _a, _b, _c, _d;
}());
exports.ApiService = ApiService;


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var router_1 = __webpack_require__(12);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var MessagesService = (function () {
    function MessagesService(router, _api, mappings) {
        this.router = router;
        this._api = _api;
        this.mappings = mappings;
    }
    MessagesService.prototype.setMessagesAsRead = function (params) {
        var url = this.mappings.Web_Api_Get_Client_Area_Messages;
        return this._api.post(url, params);
    };
    MessagesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], MessagesService);
    return MessagesService;
    var _a, _b, _c;
}());
exports.MessagesService = MessagesService;


/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var router_1 = __webpack_require__(12);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var ValidationService = (function () {
    function ValidationService(router, _api, mappings) {
        this.router = router;
        this._api = _api;
        this.mappings = mappings;
    }
    //validation of phone numbers, disable writing any characters in input except of numbers    
    ValidationService.prototype.validatePhoneNumber = function (event) {
        var pattern = /[0-9]/;
        var inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };
    ValidationService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], ValidationService);
    return ValidationService;
    var _a, _b, _c;
}());
exports.ValidationService = ValidationService;


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var auth_service_1 = __webpack_require__(9);
var mapping_1 = __webpack_require__(10);
var shopping_cart_service_1 = __webpack_require__(20);
var currency_service_1 = __webpack_require__(29);
var ProductService = (function () {
    function ProductService(_api, _cache, currencyService, ShoppingCartService, mappings, authService) {
        this._api = _api;
        this._cache = _cache;
        this.currencyService = currencyService;
        this.ShoppingCartService = ShoppingCartService;
        this.mappings = mappings;
        this.authService = authService;
    }
    ProductService.prototype.getProductDetails = function (productId, productType, lang) {
        //Reading userId
        var customerId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        var cartId = this.ShoppingCartService.getCartId();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Product_Details
            .replace('{productId}', productId.toString())
            .replace('{productType}', productType)
            .replace('{lang}', lang)
            .replace('{customerid}', customerId)
            .replace('{currency}', curr)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    ProductService.prototype.getProductsPromotionsData = function (lang) {
        var customerId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Get_Products_In_Promotion_Data.replace('{lang}', lang).replace('{currency}', curr).replace('{userid}', customerId).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ProductService.prototype.getProductDetailsBySeoUrl = function (lang, seoUrl) {
        //Reading userId
        var customerId = this.authService.GetUserId();
        var curr = this.currencyService.getCurrency();
        var cartId = this.ShoppingCartService.getCartId();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Product_By_Url
            .replace('{lang}', lang)
            .replace('{customerid}', customerId)
            .replace('{currency}', curr)
            .replace('{seoUrl}', seoUrl)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    ProductService.prototype.getPriceData = function (productId, lang) {
        //Reading userId
        var customerId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Price_Data
            .replace('{productId}', productId.toString())
            .replace('{lang}', lang)
            .replace('{customerid}', customerId)
            .replace('{currency}', curr);
        return this._api.get(url);
    };
    ProductService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
    ], ProductService);
    return ProductService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ProductService = ProductService;


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var dom_adapter_1 = __webpack_require__(32);
var platform_browser_1 = __webpack_require__(7);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var seo_service_1 = __webpack_require__(11);
var angular2_meta_1 = __webpack_require__(99);
var ScriptService = (function () {
    function ScriptService(_api, document, mappings, language, seo, metaService) {
        this._api = _api;
        this.document = document;
        this.mappings = mappings;
        this.language = language;
        this.seo = seo;
        this.metaService = metaService;
        this._dom = dom_adapter_1.getDOM();
        this.typeSystemPage = "systemPage";
        this.typeArticleCategory = "articleCategory";
        this.typeArticle = "article";
        this.typeCmsPage = "page";
        this.typeCatalogCategory = "category";
        this.typeCatalogOtherProduct = "otherProduct";
        this.typeCatalogProduct = "product";
        this.infoRequestId = "26";
        this.userAreaId = "18";
        this.privacyPolicyId = "36";
        this.purchaseConditionsId = "37";
        this.faqsId = "38";
        this.cookiesId = "35";
        this.homeId = "1";
        this.loginId = "2";
        this.blogHomeId = "40";
        this.productsCatalogId = "29";
        this.promotionsId = "16";
        this.cartId = "12";
        this.cartCashId = "15";
        this.cartSubmittedId = "43";
        this.userRegistrationId = "5";
        this.userRecoverPasswordId = "7";
        this.subscriptionId = "45";
        this.cartEmptyId = "42";
        this.ThankYouPagePaypalId = "47";
        this.ThankYouPagePagOnlineId = "48";
        this.ThankYouNexiId = "52";
        this.subscriptionConfirmationId = "46";
        this.registrationCompletePageId = "49";
        this.SearchPageId = "50";
        this.SearchWithPagingPageId = "51";
    }
    ScriptService.prototype.getScript = function (type, rowId) {
        //reading language
        var longLang = this.language.getLongLang();
        var url = this.mappings.Web_Api_Get_Script
            .replace('{rowid}', rowId)
            .replace('{type}', type)
            .replace('{lang}', longLang);
        return this._api.get(url);
    };
    ScriptService.prototype.getScriptHead = function (type, rowId) {
        //reading language
        var longLang = this.language.getLongLang();
        var url = this.mappings.Web_Api_Get_Script_Head
            .replace('{rowid}', rowId)
            .replace('{type}', type)
            .replace('{lang}', longLang);
        return this._api.get(url);
    };
    ScriptService.prototype.checkIfScriptResponseIsValid = function (content) {
        var retVal = true;
        if (typeof content === 'object') {
            retVal = false;
        }
        else if (typeof content === 'string') {
            if (!content) {
                retVal = false;
            }
        }
        else {
            retVal = false;
        }
        return retVal;
    };
    ScriptService.prototype.getSystemPageRowId_OrderId = function (PageRowId, OrderId) {
        return PageRowId + "_" + OrderId;
    };
    ScriptService.prototype.setupExternalScripts = function (result, pageType, id) {
        var _this = this;
        //-- Retrieving the script to append
        if (result.SeoInformation.HasScripts) {
            this.getScriptHead(pageType, id).subscribe(function (response) {
                var isValidResponse = _this.checkIfScriptResponseIsValid(response);
                if (isValidResponse) {
                    _this.seo.appendScriptsToDOM(_this.document.head, response);
                }
            });
            this.getScript(pageType, id).subscribe(function (response) {
                var isValidResponse = _this.checkIfScriptResponseIsValid(response);
                if (isValidResponse) {
                    _this.seo.appendScriptsToDOM(_this.document.body, response);
                }
            });
        }
    };
    ScriptService.prototype.setGoogleScripts = function (seoInfo, countRecursive) {
        if (countRecursive === void 0) { countRecursive = 0; }
        if (!seoInfo)
            return;
        //-- Updating title on client side
        if (seoInfo.Title)
            this.metaService.setTitle(seoInfo.Title);
        //-- Update google analytics
        if (seoInfo.HasScripts && seoInfo.AnalyticsId) {
            try {
                gtag('config', seoInfo.AnalyticsId, { 'page_path': seoInfo.UrlForSeo });
            }
            catch (error) {
                if (countRecursive > 3) {
                    return;
                }
                countRecursive++;
                this.setGoogleScripts(seoInfo, countRecursive);
            }
        }
    };
    ScriptService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _d) || Object, (typeof (_e = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _e) || Object])
    ], ScriptService);
    return ScriptService;
    var _a, _b, _c, _d, _e;
}());
exports.ScriptService = ScriptService;


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wizardFormEditoriaModel = (function () {
    function wizardFormEditoriaModel() {
        this.numCopie = "";
        this.idCopie = "";
        this.tipoCopie = "";
        this.numFacciate = "";
        this.idFacciate = "";
        this.tipoFacciate = "";
        this.idFormati = "";
        this.idColori1 = "";
        this.idCarte1 = "";
        this.nomeCarte1 = "";
        this.nomeCarte2 = "";
        this.idGrammature1 = "";
        this.nomeGrammature1 = "";
        this.idPlastificazioni1 = "";
        this.idCopertine = "";
        this.idColori2 = "";
        this.idCarte2 = "";
        this.idGrammature2 = "";
        this.nomeGrammature2 = "";
        this.idPlastificazioni2 = "";
        this.idRilegature = "";
        this.taglio = false;
        this.sezione = "";
        this.tipoStampaInternoSoloFronte = false;
        this.stampa1_colori_fronte = "";
        this.stampa1_colori_retro = "";
        this.stampa2_colori_fronte = "";
        this.stampa2_colori_retro = "";
        this.wizardId = 0;
        this.tipoStampaCopertinaSoloFronte = false;
        this.macrocategoryWizardId = 0;
        this.richiestaName = "";
        this.richiestaSubName = "";
        this.richiestaEmail = "";
        this.isRichiestaEmailValid = false;
        this.richiestaTelephone = "";
        this.richiestaSocieta = "";
        this.richiestaJobname = "";
        this.richiestaCondizioni = false;
        this.richiestaNote = "";
        this.idPiegature = "";
        this.soggettiMultipli = false;
        this.numSoggetti = "";
        this.baseFormato = "";
        this.altezzaFormato = "";
        this.idTagli = "";
        this.idBusta = "";
        this.idMaterialiFlessibili = "";
        this.idSupportiRigidi = "";
        this.idOcchielli = "";
        this.idAsole = "";
        this.idCuciture = "";
        this.idElettrosaldature = "";
        this.disposizione_occhielli_id = "";
        this.distanza_occhielli = "";
        this.diametro_asola = "";
        this.disposizione_asola_id = "";
        this.disposizione_cucitura_id = "";
        this.disposizione_elettrosaldatura_id = "";
        this.tipoBifacciale = "";
        this.idBiancoCoprente = "";
        this.language = "";
        this.currency = "";
        this.idPantoneFronte1 = "";
        this.idPantoneFronte2 = "";
        this.idPantoneRetro1 = "";
        this.idPantoneRetro2 = "";
        this.idCartoncino = "";
        this.nomeCartoncino = "";
        this.idGrammatureCartoncino = "";
        this.nomeGrammatureCartoncino = "";
        this.numDiametroInternoAnimaLabel = 0;
        this.numDiametroMassimoEsternoAnimaLabel = 0;
        this.numEtichette = "";
        this.idAvvolgimento = "";
        this.idFustella = "";
        this.idFormatoTipo = "";
        this.idTipoLavoroLabel = "";
        this.subSection = "";
        this.isFormatoMultiploEnabled = false;
    }
    return wizardFormEditoriaModel;
}());
exports.wizardFormEditoriaModel = wizardFormEditoriaModel;
var FormatiMultipliObj = (function () {
    function FormatiMultipliObj() {
        this.copieIsValid = true;
        this.copieMessage = "";
        this.widthIsValid = true;
        this.widthMessage = "";
        this.heightIsValid = true;
        this.heightMessage = "";
    }
    ;
    ;
    ;
    ;
    ;
    return FormatiMultipliObj;
}());
exports.FormatiMultipliObj = FormatiMultipliObj;
var MatrixModelCalculation = (function () {
    function MatrixModelCalculation() {
    }
    return MatrixModelCalculation;
}());
exports.MatrixModelCalculation = MatrixModelCalculation;
var LavorazioniAccessorieModel = (function () {
    function LavorazioniAccessorieModel() {
        this.valoreLavorazione = "";
        this.numWidthFormValue = "";
        this.numHeightFormValue = "";
        this.numDepthFormValue = "";
        this.tipo = 0;
    }
    return LavorazioniAccessorieModel;
}());
exports.LavorazioniAccessorieModel = LavorazioniAccessorieModel;
var PriceEstimationModel = (function () {
    function PriceEstimationModel() {
        this.Currency = "€";
        this.UnitPrice = "0,00";
        this.Imponibile = "0,00";
        this.Iva = "0,00";
        this.Total = "0,00";
        this.TotalAmount = "0,00";
        this.WeightUm = "Kg";
        this.Weight = "0,00";
        this.DayName = "";
        this.TimePickup = "";
        this.DayNumber = "";
        this.Quantity = 0;
        this.AltezzaDorso = 0.00;
        this.PrezzoOriginaleimporto = 0.00;
        this.DayDescriptionName = "";
        this.iShowHourForDay = false;
    }
    return PriceEstimationModel;
}());
exports.PriceEstimationModel = PriceEstimationModel;
var FileCombinationModel = (function () {
    function FileCombinationModel() {
    }
    return FileCombinationModel;
}());
exports.FileCombinationModel = FileCombinationModel;
var wizardFormAdesiviModel = (function () {
    function wizardFormAdesiviModel() {
    }
    return wizardFormAdesiviModel;
}());
exports.wizardFormAdesiviModel = wizardFormAdesiviModel;
var wizardFormBandieraModel = (function () {
    function wizardFormBandieraModel() {
    }
    return wizardFormBandieraModel;
}());
exports.wizardFormBandieraModel = wizardFormBandieraModel;
var wizardFormBannerModel = (function () {
    function wizardFormBannerModel() {
    }
    return wizardFormBannerModel;
}());
exports.wizardFormBannerModel = wizardFormBannerModel;
var wizardFormBusteModel = (function () {
    function wizardFormBusteModel() {
        this.fronte = "";
    }
    return wizardFormBusteModel;
}());
exports.wizardFormBusteModel = wizardFormBusteModel;
var wizardFormCommercialeModel = (function () {
    function wizardFormCommercialeModel() {
    }
    return wizardFormCommercialeModel;
}());
exports.wizardFormCommercialeModel = wizardFormCommercialeModel;
var wizarFormEtichetteModel = (function () {
    function wizarFormEtichetteModel() {
        this.fronte = "";
    }
    return wizarFormEtichetteModel;
}());
exports.wizarFormEtichetteModel = wizarFormEtichetteModel;
var wizardFormStampaModel = (function () {
    function wizardFormStampaModel() {
    }
    return wizardFormStampaModel;
}());
exports.wizardFormStampaModel = wizardFormStampaModel;


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var CartInfo = (function () {
    function CartInfo() {
    }
    return CartInfo;
}());
exports.CartInfo = CartInfo;
var CartProductModel = (function () {
    function CartProductModel() {
    }
    return CartProductModel;
}());
exports.CartProductModel = CartProductModel;
var CartAddressModel = (function () {
    function CartAddressModel() {
    }
    return CartAddressModel;
}());
exports.CartAddressModel = CartAddressModel;
var CartPaymentModel = (function () {
    function CartPaymentModel() {
    }
    return CartPaymentModel;
}());
exports.CartPaymentModel = CartPaymentModel;
var CartShipmentModel = (function () {
    function CartShipmentModel() {
        this.UnitaId = 0;
    }
    return CartShipmentModel;
}());
exports.CartShipmentModel = CartShipmentModel;


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var language_service_1 = __webpack_require__(3);
var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var shopping_cart_service_1 = __webpack_require__(20);
var mapping_1 = __webpack_require__(10);
var LoginService = (function () {
    function LoginService(_api, _cache, mappings, cartService, langService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.cartService = cartService;
        this.langService = langService;
    }
    LoginService.prototype.sendLoginRequest = function (email, password) {
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Post_Send_Login_Request;
        var key = url;
        var x = 0;
        var params = {
            Email: email.toLowerCase(),
            Password: btoa(password),
            CartID: cartId
        };
        return this._api.post(url, params);
    };
    LoginService.prototype.authentificateUser = function (email, firstName, lastName) {
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Post_User_Authentification;
        var lang = this.langService.getLongLang();
        var key = url;
        var params = {
            Email: email.toLowerCase(),
            Password: "",
            FirstName: firstName,
            LastName: lastName,
            CartID: cartId,
            Lang: lang
        };
        return this._api.post(url, params);
    };
    LoginService.prototype.quickRegister = function (userInfo) {
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Post_User_Authentification;
        var lang = this.langService.getLongLang();
        var key = url;
        var params = {
            Email: userInfo.EmailRegister != null ? userInfo.EmailRegister.toLowerCase() : '',
            Password: userInfo.Password,
            FirstName: '',
            LastName: '',
            CustomerGroup: userInfo.CustomerGroup,
            CartID: cartId,
            Lang: lang,
            CodiceFiscale: userInfo.CodiceFiscale,
            PartitaIva: userInfo.PartitaIva,
            Newsletter: userInfo.Newsletter
        };
        return this._api.post(url, params);
    };
    LoginService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object])
    ], LoginService);
    return LoginService;
    var _a, _b, _c, _d, _e;
}());
exports.LoginService = LoginService;


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
//Services
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var cookie_service_1 = __webpack_require__(60);
//Models
var mapping_1 = __webpack_require__(10);
var cart_1 = __webpack_require__(178);
var currency_service_1 = __webpack_require__(29);
var ShoppingCartService = (function () {
    function ShoppingCartService(_api, _cache, mappings, authService, languageService, currencyService, cookieService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.authService = authService;
        this.languageService = languageService;
        this.currencyService = currencyService;
        this.cookieService = cookieService;
        this.cartId = 0;
        // value of customizationData is set from canvas-widget component after editing is approved. After we can get that data inside of parent component and send it to a server
        this.customizationData = null;
        this.isProductCanvasEdited = false;
    }
    ShoppingCartService.prototype.saveCart = function (userId, cartId, paymentId, shipmentId) {
        var url = this.mappings.Web_Api_Get_Save_Cart.replace('{userId}', userId).replace('{cartId}', cartId.toString()).replace('{paymentId}', paymentId.toString()).replace('{shipmentId}', shipmentId.toString());
        var key = url;
        return this._api.get(url);
    };
    ShoppingCartService.prototype.applyVoucher = function (voucherCode) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Set_Cart_Voucher;
        var param = {
            CartID: cartId,
            CustomerID: customerId,
            Voucher: voucherCode,
            Language: lang,
            Currency: curr
        };
        var key = url;
        return this._api.post(url, param);
    };
    ShoppingCartService.prototype.setJobName = function (rowId, jobName) {
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Set_Job_Name;
        var param = {
            CartID: cartId,
            ProductID: rowId,
            JobName: jobName
        };
        var key = url;
        return this._api.post(url, param);
    };
    ShoppingCartService.prototype.setAddress = function (addressObject) {
        var cartId = this.getCartId();
        var url = this.mappings.Web_Api_Set_Cart_Address;
        var param = {
            CartID: cartId,
            AddressCity: addressObject.City,
            AddressID: addressObject.Id,
            AddressMobile: addressObject.Mobile,
            AddressPhone: addressObject.Phone,
            AddressPostalCode: addressObject.ZipCode,
            AddressProvince: addressObject.Province,
            AddressRecipient: addressObject.Recipient,
            AddressStreet: addressObject.Address,
            CustomerID: addressObject.CustomerID,
            Language: addressObject.Language
        };
        var key = url;
        return this._api.post(url, param);
    };
    ShoppingCartService.prototype.confirmOrder = function () {
        var cartId = this.getCartId();
        var lang = this.getLang();
        var param = {
            CartID: cartId,
            Language: lang
        };
        var url = this.mappings.Web_Api_Post_Cart_Confirm_Order;
        return this._api.post(url, param);
    };
    ShoppingCartService.prototype.clearCartAfterConfirmation = function () {
        this.cookieService.remove("cartId");
        this.cartData = new cart_1.CartInfo();
        this.cartData.Products = [];
        this.cartData.Addresses = [];
        this.cartData.Payments = [];
        this.cartData.Shipments = [];
    };
    ShoppingCartService.prototype.getCartPaymentShipment = function (cartId, lang) {
        var userId = this.getCustomerId();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Cart_Payment_Shipment.replace('{userId}', userId).replace('{cartId}', cartId.toString()).replace('{lang}', lang).replace('{currency}', curr);
        var key = url;
        return this._api.get(url);
    };
    ShoppingCartService.prototype.addWizardCalcolatoToCart = function (wizardId, lavId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
        var isCanvasEdited = this.getIfProductIsCanvasEdited();
        var url = this.mappings.Web_Api_Add_Wizard_Calcolato_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            LavID: lavId.toString(),
            Currency: curr,
            isCanvasEdited: isCanvasEdited,
            CanvasStateId: canvasData != null ? canvasData.stateId : null,
            CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addApProductToCart = function (productId, lavId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Add_Wizard_Calcolato_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: productId.toString(),
            LavID: lavId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.getRiorderCart = function () {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Get_Client_Area_Get_Cart_Riorder
            .replace('{userId}', customerId)
            .replace('{cartId}', cartId.toString())
            .replace('{lang}', lang);
        return this._api.get(url);
    };
    ShoppingCartService.prototype.addWizardCalcolatoScontisticaToCart = function (wizardId, dateId, lavId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
        var isCanvasEdited = this.getIfProductIsCanvasEdited();
        var url = this.mappings.Web_Api_Add_Wizard_Calcolato_Scontistica_To_Cart;
        var curr = this.currencyService.getCurrency();
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            LavID: lavId.toString(),
            DateID: dateId.toString(),
            Currency: curr,
            isCanvasEdited: isCanvasEdited,
            CanvasStateId: canvasData != null ? canvasData.stateId : null,
            CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addWizardListinoToCart = function (wizardId, quantityId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Wizard_Listino_To_Cart;
        var curr = this.currencyService.getCurrency();
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addOtherProductListinoToCart = function (combinationId, quantityId, wizardId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Other_Product_Listino_To_Cart;
        var curr = this.currencyService.getCurrency();
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            CombinationId: combinationId.toString(),
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addOtherProductListinoScontisticaToCart = function (combinationId, quantityId, wizardId, dateId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Other_Product_Listino_Scontistica_To_Cart;
        var curr = this.currencyService.getCurrency();
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            CombinationId: combinationId.toString(),
            DateID: dateId.toString(),
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addOtherProductCalcolatoListinoToCart = function (combinationId, quantityId, wizardId, strVariantiCalcolate, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Other_Product_Listino_Calcolato_To_Cart;
        var curr = this.currencyService.getCurrency();
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            CombinationId: combinationId.toString(),
            StrVariantiCalcolate: strVariantiCalcolate,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addOtherProductCalcolatoListinoScontisticaToCart = function (combinationId, quantityId, wizardId, dateId, strVariantiCalcolate, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Other_Product_Listino_Calcolato_Scontistica_To_Cart;
        var curr = this.currencyService.getCurrency();
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            CombinationId: combinationId.toString(),
            DateID: dateId.toString(),
            StrVariantiCalcolate: strVariantiCalcolate,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addOtherProductCalcolatoScontisticaToCart = function (productId, lavId, dateId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Add_Other_Product_Calcolato_Scontistica_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: productId.toString(),
            LavID: lavId.toString(),
            DateID: dateId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addWizardListinoScontisticaBusteToCart = function (wizardId, quantityId, dateId, idPantoneFronte1, idPantoneFronte2, idPantoneRetro1, idPantoneRetro2, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Wizard_Buste_Listino_Buste_To_Cart;
        var curr = this.currencyService.getCurrency();
        var canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
        var isCanvasEdited = this.getIfProductIsCanvasEdited();
        var key = url;
        var x = 0;
        if (idPantoneFronte1 == null || idPantoneFronte1 == "") {
            idPantoneFronte1 = "0";
        }
        if (idPantoneFronte2 == null || idPantoneFronte2 == "") {
            idPantoneFronte2 = "0";
        }
        if (idPantoneRetro1 == null || idPantoneRetro1 == "") {
            idPantoneRetro1 = "0";
        }
        if (idPantoneRetro2 == null || idPantoneRetro2 == "") {
            idPantoneRetro2 = "0";
        }
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            DateID: dateId.toString(),
            IdPantoneFronte1: idPantoneFronte1.toString(),
            IdPantoneFronte2: idPantoneFronte2.toString(),
            IdPantoneRetro1: idPantoneRetro1.toString(),
            IdPantoneRetro2: idPantoneRetro2.toString(),
            Currency: curr,
            isCanvasEdited: isCanvasEdited,
            CanvasStateId: canvasData != null ? canvasData.stateId : null,
            CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addWizardListinoBusteToCart = function (wizardId, quantityId, idPantoneFronte1, idPantoneFronte2, idPantoneRetro1, idPantoneRetro2, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Wizard_Buste_Listino_To_Cart;
        var curr = this.currencyService.getCurrency();
        var canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
        var isCanvasEdited = this.getIfProductIsCanvasEdited();
        var key = url;
        var x = 0;
        if (idPantoneFronte1 == null || idPantoneFronte1 == "") {
            idPantoneFronte1 = "0";
        }
        if (idPantoneFronte2 == null || idPantoneFronte2 == "") {
            idPantoneFronte2 = "0";
        }
        if (idPantoneRetro1 == null || idPantoneRetro1 == "") {
            idPantoneRetro1 = "0";
        }
        if (idPantoneRetro2 == null || idPantoneRetro2 == "") {
            idPantoneRetro2 = "0";
        }
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            IdPantoneFronte1: idPantoneFronte1.toString(),
            IdPantoneFronte2: idPantoneFronte2.toString(),
            IdPantoneRetro1: idPantoneRetro1.toString(),
            IdPantoneRetro2: idPantoneRetro2.toString(),
            Currency: curr,
            isCanvasEdited: isCanvasEdited,
            CanvasStateId: canvasData != null ? canvasData.stateId : null,
            CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addWizardListinoScontisticaToCart = function (wizardId, quantityId, dateId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var url = this.mappings.Web_Api_Add_Wizard_Listino_Scontistica_To_Cart;
        var curr = this.currencyService.getCurrency();
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: wizardId.toString(),
            QuantityID: quantityId.toString(),
            DateID: dateId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addStaticProductToCart = function (productId, quantityId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Add_Static_Product_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: productId.toString(),
            QuantityID: quantityId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addStaticProductScontisticaToCart = function (productId, quantityId, dateId, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Add_Static_Product_Scontistica_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: productId.toString(),
            QuantityID: quantityId.toString(),
            DateID: dateId.toString(),
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.addMatrixProductToCart = function (productId, quantityId, type, colType) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Add_Matrix_Product_To_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            CustomerID: customerId,
            Language: lang,
            ProductID: productId.toString(),
            QuantityID: quantityId.toString(),
            Type: type,
            Currency: curr,
            ColType: colType
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.getCartId = function () {
        //Reading cartId from cookie
        var cartId = this.cookieService.get("cartId");
        if (cartId == null || cartId == "") {
            cartId = "0";
        }
        return cartId;
    };
    ShoppingCartService.prototype.setCartId = function (cartId) {
        this.cookieService.put("cartId", cartId.toString());
        this.cartId = cartId;
    };
    ShoppingCartService.prototype.getCustomerId = function () {
        var userId = this.authService.GetUserId();
        return userId;
    };
    ShoppingCartService.prototype.getLang = function () {
        var lang = this.languageService.getLongLang();
        return lang;
    };
    ShoppingCartService.prototype.updateCart = function (cartData) {
        var currentCartId = this.getCartId();
        if (currentCartId == "0") {
            this.setCartId(cartData.CartID);
        }
        //refreshing cart data
        this.cartData = cartData;
    };
    ShoppingCartService.prototype.getCart = function () {
        return this.cartData;
    };
    ShoppingCartService.prototype.initCart = function (cartData) {
        if (this.cartData == null) {
            this.cartData = cartData;
        }
    };
    ShoppingCartService.prototype.setPayment = function (paymentId) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Set_Cart_Payment;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            PaymentID: paymentId,
            CustomerID: customerId,
            Language: lang,
            Currency: curr
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.setShipment = function (shipmentId) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Set_Cart_Shipment;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            ShippmentID: shipmentId,
            CustomerID: customerId,
            Language: lang,
            Currency: curr
        };
        return this._api.post(url, params);
    };
    ShoppingCartService.prototype.removeFromCart = function (rowId) {
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var lang = this.getLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Remove_From_Cart;
        var key = url;
        var x = 0;
        var params = {
            CartID: cartId.toString(),
            ProductID: rowId,
            CustomerID: customerId.toString(),
            Language: lang,
            Currency: curr
        };
        return this._api.post(url, params);
    };
    //Check if the cart data is valid to access to the second step
    ShoppingCartService.prototype.isCartValid = function () {
        var res = false;
        var cartId = this.getCartId();
        var customerId = this.getCustomerId();
        //Checking if user is logged-ing
        if (customerId != null && customerId != "" && customerId != "0") {
            //Checking if there is a cart set
            if (cartId != null && cartId != "" && cartId != "0") {
                //Checking if there are products
                if (this.cartData.Products != null && this.cartData.Products.length > 0) {
                    //Checking if there is a payment set
                    if (this.cartData.Payments != null && this.cartData.Payments.length > 0) {
                        var flagPayment = false;
                        for (var _i = 0, _a = this.cartData.Payments; _i < _a.length; _i++) {
                            var payment = _a[_i];
                            if (payment.Selected == true) {
                                flagPayment = true;
                                break;
                            }
                        }
                        //Checking if there is a shipment set
                        if (flagPayment == true) {
                            if (this.cartData.Shipments != null && this.cartData.Shipments.length > 0) {
                                var flagShipment = false;
                                for (var _b = 0, _c = this.cartData.Shipments; _b < _c.length; _b++) {
                                    var shipment = _c[_b];
                                    if (shipment.Selected == true) {
                                        flagShipment = true;
                                        break;
                                    }
                                }
                                if (flagShipment == true) {
                                    res = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        return res;
    };
    ShoppingCartService.prototype.addProductRiorderToCart = function (params) {
        var url = this.mappings.Web_Api_Get_Client_Area_Add_Product_To_Cart_Riorder;
        var key = url;
        var x = 0;
        return this._api.post(url, params);
    };
    //Getting Empty cart page data
    ShoppingCartService.prototype.getEmptyCartPageData = function () {
        var lang = this.getLang();
        var customerId = this.getCustomerId();
        var cartId = this.getCartId();
        var url = this.mappings.Web_Api_Empty_Cart_Page.replace("{lang}", lang).replace('{userid}', customerId).replace('{cartid}', cartId);
        return this._api.get(url);
    };
    ShoppingCartService.prototype.setIfProductIsCanvasEdited = function (isEdited) {
        this.isProductCanvasEdited = isEdited;
    };
    ShoppingCartService.prototype.getIfProductIsCanvasEdited = function () {
        return this.isProductCanvasEdited;
    };
    ShoppingCartService.prototype.getCustomizationCanvasData = function () {
        return this.customizationData;
    };
    ShoppingCartService.prototype.setCustomizationCanvasData = function (newData) {
        this.customizationData = newData;
    };
    // reset canvas state because of next adding to a cart
    ShoppingCartService.prototype.resetCanvasData = function () {
        var emptyObj = {};
        this.setIfProductIsCanvasEdited(false);
        this.setCustomizationCanvasData(emptyObj);
    };
    ShoppingCartService = __decorate([
        core_1.Injectable(),
        __param(6, core_1.Inject('CookieService')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _f) || Object, (typeof (_g = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _g) || Object])
    ], ShoppingCartService);
    return ShoppingCartService;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.ShoppingCartService = ShoppingCartService;


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var CacheService = (function () {
    function CacheService(_cache) {
        this._cache = _cache;
    }
    /**
     * check if there is a value in our store
     */
    CacheService.prototype.has = function (key) {
        var _key = this.normalizeKey(key);
        return this._cache.has(_key);
    };
    /**
     * store our state
     */
    CacheService.prototype.set = function (key, value) {
        var _key = this.normalizeKey(key);
        if (value && 'string' === typeof value && (/<[a-z][\s\S]*>/i).test(value)) {
            value = {
                _escapedHtml: encodeURIComponent(value)
            };
        }
        this._cache.set(_key, value);
    };
    /**
     * get our cached value
     */
    CacheService.prototype.get = function (key) {
        var _key = this.normalizeKey(key);
        var value = this._cache.get(_key);
        if (value && 'object' === typeof value && value._escapedHtml) {
            value = decodeURIComponent(value._escapedHtml);
        }
        return value;
    };
    /**
     * release memory ref
     */
    CacheService.prototype.clear = function (key) {
        this._cache.delete(key);
    };
    /**
     * release memory all refs
     */
    CacheService.prototype.clearAll = function () {
        this._cache.clear();
    };
    /**
     * convert to json for the client
     */
    CacheService.prototype.dehydrate = function () {
        var json = {};
        this._cache.forEach(function (value, key) { return json[key] = value; });
        return json;
    };
    /**
     * convert server json into out initial state
     */
    CacheService.prototype.rehydrate = function (json) {
        var _this = this;
        Object.keys(json).forEach(function (key) {
            var _key = _this.normalizeKey(key);
            var value = json[_key];
            _this._cache.set(_key, value);
        });
    };
    /**
     * allow JSON.stringify to work
     */
    CacheService.prototype.toJSON = function () {
        return this.dehydrate();
    };
    /**
     * convert numbers into strings
     */
    CacheService.prototype.normalizeKey = function (key) {
        if (core_1.isDevMode() && this._isInvalidValue(key)) {
            throw new Error('Please provide a valid key to save in the CacheService');
        }
        return key + '';
    };
    CacheService.prototype._isInvalidValue = function (key) {
        return key === null ||
            key === undefined ||
            key === 0 ||
            key === '' ||
            typeof key === 'boolean' ||
            Number.isNaN(key);
    };
    CacheService.KEY = 'CacheService';
    CacheService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject('LRU')), 
        __metadata('design:paramtypes', [Object])
    ], CacheService);
    return CacheService;
}());
exports.CacheService = CacheService;


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var core_2 = __webpack_require__(27);
var breadcrumbs_1 = __webpack_require__(618);
var language_service_1 = __webpack_require__(3);
var BreadcrumbsService = (function () {
    function BreadcrumbsService(router, languageService, translateService, isBrowser) {
        this.router = router;
        this.languageService = languageService;
        this.translateService = translateService;
        this.isBrowser = isBrowser;
        this.homeIsInit = false;
    }
    BreadcrumbsService.prototype.setHomeBreadcrumb = function () {
        if (this.breadcrumbsList != null && this.breadcrumbsList.length > 0) {
            if (this.breadcrumbsList[0].Level == 0) {
                return;
            }
        }
        var lang = this.languageService.getShortLang();
        var homeLink = "/home";
        if (lang != null && lang != "") {
            homeLink = lang + homeLink;
        }
        else {
            homeLink = homeLink;
        }
        var bread = new breadcrumbs_1.Breadcrumbs();
        bread.BreadcrumbLink = homeLink;
        bread.BreadcrumbName = this.translateService.get("home_area_message_home")["value"];
        bread.Level = 0;
        this.breadcrumbsList.unshift(bread);
        this.homeIsInit = true;
    };
    BreadcrumbsService.prototype.setBreadcrumbs = function (breadcrumbs, type) {
        this.breadcrumbsList = [];
        if (type != "cmspage") {
            if (breadcrumbs != null && breadcrumbs.length > 0) {
                breadcrumbs.forEach(function (x) {
                    x.BreadcrumbLink = x.BreadcrumbLink.toLocaleLowerCase();
                });
            }
        }
        this.breadcrumbsList = breadcrumbs;
        // this.setHomeBreadcrumb();
    };
    BreadcrumbsService.prototype.getBreadcrumbs = function () {
        var breadcrumbs = this.breadcrumbsList;
        return breadcrumbs;
    };
    BreadcrumbsService = __decorate([
        core_1.Injectable(),
        __param(3, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _c) || Object, Boolean])
    ], BreadcrumbsService);
    return BreadcrumbsService;
    var _a, _b, _c;
}());
exports.BreadcrumbsService = BreadcrumbsService;


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Register = (function () {
    function Register() {
    }
    return Register;
}());
exports.Register = Register;
var Nation = (function () {
    function Nation() {
    }
    return Nation;
}());
exports.Nation = Nation;
var QuickRegister = (function () {
    function QuickRegister(email, emailRepeat, password, telephone, customerGroup, CF, PIVA, oldGroup) {
        if (email === void 0) { email = ''; }
        if (emailRepeat === void 0) { emailRepeat = ''; }
        if (password === void 0) { password = ''; }
        if (telephone === void 0) { telephone = ''; }
        if (customerGroup === void 0) { customerGroup = '5'; }
        if (CF === void 0) { CF = ''; }
        if (PIVA === void 0) { PIVA = ''; }
        if (oldGroup === void 0) { oldGroup = '5'; }
        this.EmailRegister = '';
        this.EmailRepeat = '';
        this.Password = '';
        this.PartitaIva = '';
        this.CodiceFiscale = '';
        this.Telephone = '';
        this.CustomerGroup = '5';
        this.info_privacy = '';
        this.IsQuickRegistered = false;
        this.CustomerGroup = customerGroup;
        this.controlFormReset(oldGroup, CF, PIVA);
        this.EmailRegister = email;
        this.EmailRepeat = emailRepeat;
        this.Password = password;
        this.Telephone = telephone;
    }
    //-- If client type is changed inside of form from societa to dita individuale, we don't want to reset a PIVA field value also
    //-- If client type is changed inside of form from privato to associazione, we don't want to reset a CF field value also
    QuickRegister.prototype.controlFormReset = function (oldGroup, CF, PIVA) {
        if (((this.CustomerGroup === '5' || this.CustomerGroup === '6') && (oldGroup === '5' || oldGroup === '6')))
            this.PartitaIva = PIVA;
        else
            this.PartitaIva = '';
        if (((this.CustomerGroup === '4' || this.CustomerGroup === '7') && (oldGroup === '4' || oldGroup === '7')))
            this.CodiceFiscale = CF;
        else
            this.CodiceFiscale = '';
    };
    return QuickRegister;
}());
exports.QuickRegister = QuickRegister;


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Company = (function () {
    function Company() {
    }
    return Company;
}());
exports.Company = Company;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Product = (function () {
    function Product() {
    }
    return Product;
}());
exports.Product = Product;
var PhotoGalleryViewModel = (function () {
    function PhotoGalleryViewModel() {
    }
    return PhotoGalleryViewModel;
}());
exports.PhotoGalleryViewModel = PhotoGalleryViewModel;
var AtachmentViewModel = (function () {
    function AtachmentViewModel() {
    }
    return AtachmentViewModel;
}());
var Category = (function () {
    function Category() {
    }
    return Category;
}());
exports.Category = Category;
var SliderViewModel = (function () {
    function SliderViewModel() {
    }
    return SliderViewModel;
}());
exports.SliderViewModel = SliderViewModel;
var MegaMenu = (function () {
    function MegaMenu() {
    }
    return MegaMenu;
}());
exports.MegaMenu = MegaMenu;


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var CheckIfExistService = (function () {
    function CheckIfExistService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        //for sending of checking type, because we are using same method on server side for all checking
        this.emailType = "email";
        this.partitaIvaType = "partitaIva";
        this.codiceFiscaleType = "codiceFiscale";
    }
    CheckIfExistService.prototype.checkIfEmailExistsInDb = function (value) {
        var url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.emailType).replace('{value}', value);
        return this._api.get(url);
    };
    CheckIfExistService.prototype.checkIfPartitaIvaExistsInDb = function (value) {
        var url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.partitaIvaType).replace('{value}', value);
        return this._api.get(url);
    };
    CheckIfExistService.prototype.checkIfCodiceFiscaleExistsInDb = function (value) {
        var url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.codiceFiscaleType).replace('{value}', value);
        return this._api.get(url);
    };
    CheckIfExistService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], CheckIfExistService);
    return CheckIfExistService;
    var _a, _b, _c;
}());
exports.CheckIfExistService = CheckIfExistService;


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var OrderPaymentService = (function () {
    function OrderPaymentService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
    }
    OrderPaymentService.prototype.setOrderAsPayed = function (orderId) {
        var url = this.mappings.Web_Api_Set_Order_As_Payed;
        var orderID = {
            OrderId: parseInt(orderId)
        };
        return this._api.post(url, orderID);
    };
    OrderPaymentService.prototype.CheckIsOrderPayedUnicredit = function (orderId) {
        var url = this.mappings.Web_Api_Check_Is_Order_Payed_Unicredit.replace('{orderId}', orderId.toString());
        return this._api.post(url);
    };
    OrderPaymentService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], OrderPaymentService);
    return OrderPaymentService;
    var _a, _b, _c;
}());
exports.OrderPaymentService = OrderPaymentService;


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var RecoverPasswordService = (function () {
    function RecoverPasswordService(_api, language, _cache, mappings, cartService, authService) {
        this._api = _api;
        this.language = language;
        this._cache = _cache;
        this.mappings = mappings;
        this.cartService = cartService;
        this.authService = authService;
    }
    RecoverPasswordService.prototype.recoverPasswordRequest = function (email) {
        email = email.toLowerCase();
        var lang = this.language.getLongLang();
        return this._api.post(this.mappings.Web_Api_Recover_Password, { Email: email, Lang: lang })
            .do(function (result) { return result; })
            .share();
    };
    RecoverPasswordService.prototype.getRecoverPasswordData = function (lang) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Recover_Password_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    RecoverPasswordService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _c) || Object, (typeof (_d = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
    ], RecoverPasswordService);
    return RecoverPasswordService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.RecoverPasswordService = RecoverPasswordService;


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
//System
var mapping_1 = __webpack_require__(10);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var ConfigurationService = (function () {
    function ConfigurationService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
    }
    ConfigurationService.prototype.getConfiguration = function (lang) {
        var url = this.mappings.Web_Api_Get_Configuration.replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    //Return the routes for a given language
    ConfigurationService.prototype.getRoutes = function (lang) {
        var url = this.mappings.Web_Api_Get_Routes.replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    ConfigurationService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], ConfigurationService);
    return ConfigurationService;
    var _a, _b, _c;
}());
exports.ConfigurationService = ConfigurationService;


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var CryptoService = (function () {
    function CryptoService() {
    }
    CryptoService.prototype.encryptNumber = function (param) {
        var prefix = "xyZ";
        var sufix = "xpNw";
        var output = "";
        try {
            if (param != null) {
                var newNumber = param + 1264;
                output = prefix + newNumber.toString() + sufix;
            }
        }
        catch (Exception) {
            throw Exception;
        }
        return output;
    };
    CryptoService.prototype.decryptNumber = function (encryptedString) {
        var output = -1;
        try {
            if (encryptedString != null || encryptedString != "") {
                var stringWithoutPrefix = encryptedString.substring(3, encryptedString.length);
                var stringwithoutSufix = stringWithoutPrefix.substring(0, stringWithoutPrefix.length - 4);
                output = Number(stringwithoutSufix) - 1264;
            }
        }
        catch (Exception) {
            throw Exception;
        }
        return output;
    };
    CryptoService.prototype.decryptString = function (text) {
        text = text.substring(4, text.length);
        text = text.substring(0, text.length - 4);
        var decryptedText = '';
        for (var _i = 0, text_1 = text; _i < text_1.length; _i++) {
            var c = text_1[_i];
            var unicode = c.charCodeAt(0);
            unicode -= 5;
            decryptedText += String.fromCharCode(unicode);
        }
        return decryptedText;
    };
    CryptoService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], CryptoService);
    return CryptoService;
}());
exports.CryptoService = CryptoService;


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var NodeLoggerService = (function () {
    function NodeLoggerService(isNode) {
        this.isNode = isNode;
        this.isLogActive = false; //Defines if the log is active or not
        this.logFilepath = "src/assets/log.txt"; //logfile
    }
    NodeLoggerService.prototype.AddLogWithTime = function (mex) {
        if (this.isNode) {
            if (this.isLogActive == false) {
                return;
            }
            var fs = __webpack_require__(429);
            var dateObj = new Date();
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            var day = dateObj.getDate();
            var hour = dateObj.getHours();
            var minutes = dateObj.getMinutes();
            var seconds = dateObj.getSeconds();
            var milliseconds = dateObj.getMilliseconds();
            var dateStr = day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds + ":" + milliseconds;
            //Prepending date to message
            mex = dateStr + ": " + mex + "\n";
            fs.appendFile('src/assets/log.txt', mex, 'utf8', function (err) {
                if (err) {
                }
                else {
                }
            });
        }
    };
    NodeLoggerService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject('isNode')), 
        __metadata('design:paramtypes', [Boolean])
    ], NodeLoggerService);
    return NodeLoggerService;
}());
exports.NodeLoggerService = NodeLoggerService;


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var PaypalService = (function () {
    function PaypalService() {
        this.isPaypalScriptLoaded = false;
        this.isError = false;
        this.errMessage = "";
    }
    PaypalService.prototype.loadPaypalService = function (externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction) {
        var _this = this;
        if (UsePaypalProduction === void 0) { UsePaypalProduction = true; }
        //-- Load paypal script if it is not already loaded, else only render a paypal button
        if (!this.isPaypalScriptLoaded) {
            this.loadExternalScript(externalScriptLink).then(function () {
                _this.renderPaypalBtn(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction);
            });
        }
        else {
            this.renderPaypalBtn(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction);
        }
    };
    PaypalService.prototype.loadExternalScript = function (scriptUrl) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var scriptElement = document.createElement('script');
            scriptElement.src = scriptUrl;
            scriptElement.onload = resolve;
            document.body.appendChild(scriptElement);
            _this.isPaypalScriptLoaded = true;
        });
    };
    PaypalService.prototype.renderPaypalBtn = function (externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction) {
        var styleObj = this.getPaypalBtnStyle(paypalBtnStyle);
        paypal.Button.render({
            env: UsePaypalProduction ? 'production' : 'sandbox',
            /* Show the buyer a 'Pay Now' button in the checkout flow */
            commit: true,
            locale: 'it_IT',
            style: styleObj,
            /* payment() is called when the button is clicked */
            payment: function () {
                /* Make a call to your server to set up the payment */
                return paypal.request.post(createPaypalPaymentAPI, data)
                    .then(function (response) {
                    return response.id;
                });
            },
            /* onAuthorize() is called when the buyer approves the payment */
            onAuthorize: function (orderData, actions) {
                var _this = this;
                //-- Generating of execute payment object that we need on server side
                var executePaymentObj = {
                    paymentID: orderData.paymentID,
                    payerID: orderData.payerID,
                    intent: orderData.intent,
                    orderID: orderData.orderID,
                    paymentToken: orderData.paymentToken,
                    returnUrl: orderData.returnUrl,
                    CustomerId: data.CustomerId,
                    //-- This is our orderId paypal also returns property with same name, so we renamed our OrderId property
                    CustomerOrderId: data.OrderId,
                    Lang: data.Lang
                };
                /* Make a call to your server to execute the payment */
                return paypal.request.post(executePaypalPaymentAPI, executePaymentObj)
                    .then(function (res) {
                    _this.isError = res.IsError;
                    if (!res.IsError)
                        _this.isError = false;
                    _this.errMessage = res.message;
                    if (!res.message)
                        _this.errMessage = "";
                    if (_this.isError) {
                        window.location.href = orderData.returnUrl + "&orderId=" + executePaymentObj.CustomerOrderId + "&isError=" + _this.isError + "&message=" + _this.errMessage;
                    }
                    else {
                        window.location.href = orderData.returnUrl + "&orderId=" + executePaymentObj.CustomerOrderId + "&isError=" + _this.isError;
                    }
                }).catch(function (err) {
                    window.location.href = orderData.returnUrl + "&orderId=" + executePaymentObj.CustomerOrderId + "&isError=true&message=" + err.message;
                });
            }
        }, '#paypal-btn');
    };
    PaypalService.prototype.getPaypalBtnStyle = function (paypalBtnStyle) {
        var styleObj = {};
        if (paypalBtnStyle) {
            var height = this.getPaypalBtnHeight(paypalBtnStyle.PaypalButtonHeight);
            styleObj = {
                color: paypalBtnStyle.PaypalButtonColor || 'gold',
                shape: paypalBtnStyle.PaypalButtonShape || 'rect',
                label: paypalBtnStyle.PaypalButtonLabel || 'paypal',
                height: height || 40,
                tagline: paypalBtnStyle.PaypalButtonTagline || false,
                size: paypalBtnStyle.PaypalButtonSize || 'responsive'
            };
        }
        else {
            styleObj = {
                color: 'gold',
                shape: 'rect',
                label: 'paypal',
                height: 40,
                tagline: false,
                size: "responsive"
            };
        }
        return styleObj;
    };
    PaypalService.prototype.getPaypalBtnHeight = function (paypalButtonHeight) {
        var retVal = 40;
        if (paypalButtonHeight) {
            if (paypalButtonHeight === 'small')
                retVal = 30;
            else if (paypalButtonHeight === 'large')
                retVal = 50;
        }
        return retVal;
    };
    PaypalService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], PaypalService);
    return PaypalService;
}());
exports.PaypalService = PaypalService;


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var auth_service_1 = __webpack_require__(9);
var mapping_1 = __webpack_require__(10);
var currency_service_1 = __webpack_require__(29);
var language_service_1 = __webpack_require__(3);
var shopping_cart_service_1 = __webpack_require__(20);
var CategoryService = (function () {
    function CategoryService(_api, _cache, currencyService, mappings, authService, languageService, ShoppingCartService) {
        this._api = _api;
        this._cache = _cache;
        this.currencyService = currencyService;
        this.mappings = mappings;
        this.authService = authService;
        this.languageService = languageService;
        this.ShoppingCartService = ShoppingCartService;
    }
    CategoryService.prototype.getCategory = function (categoryId, lang) {
        //Reading userId
        var customerId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        var cartId = this.ShoppingCartService.getCartId();
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Category_Details
            .replace('{categoryId}', categoryId.toString())
            .replace('{lang}', lang)
            .replace('{customerid}', customerId)
            .replace('{currency}', curr)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    CategoryService.prototype.getCatalogCategoriesData = function (lang) {
        var cartId = this.ShoppingCartService.getCartId();
        var curr = this.currencyService.getCurrency();
        var customerId = this.authService.getCurrentUserId();
        var url = this.mappings.Web_Api_Get_Catalog_Categories_Data.replace('{lang}', lang).replace('{currency}', curr).replace('{userid}', customerId).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    CategoryService.prototype.getCategoryByUrl = function (lang, seoUrl) {
        //Reading userId
        var customerId = this.authService.GetUserId();
        var curr = this.currencyService.getCurrency();
        var cartId = this.ShoppingCartService.getCartId();
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Category_By_Url
            .replace('{lang}', lang)
            .replace('{customerid}', customerId)
            .replace('{currency}', curr)
            .replace('{seoUrl}', seoUrl)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    CategoryService.prototype.getCategoryInfo = function (parameters) {
        return this._api.post(this.mappings.Web_Api_Post_Send_Category_Info_Request, parameters);
    };
    CategoryService.prototype.getCategoryPriceData = function (categoryId) {
        //Reading userId
        var customerId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Catalog_Categories_Price_Data
            .replace('{categoryId}', categoryId.toString())
            .replace('{customerid}', customerId)
            .replace('{lang}', lang)
            .replace('{currency}', curr);
        return this._api.get(url);
    };
    CategoryService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _c) || Object, (typeof (_d = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _g) || Object])
    ], CategoryService);
    return CategoryService;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.CategoryService = CategoryService;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var auth_service_1 = __webpack_require__(9);
var mapping_1 = __webpack_require__(10);
var currency_service_1 = __webpack_require__(29);
var language_service_1 = __webpack_require__(3);
var SearchService = (function () {
    function SearchService(_api, _cache, currencyService, mappings, authService, languageService) {
        this._api = _api;
        this._cache = _cache;
        this.currencyService = currencyService;
        this.mappings = mappings;
        this.authService = authService;
        this.languageService = languageService;
        this.queryText = "";
    }
    SearchService.prototype.getCategoriesAndProducts = function (query, startRow, endRow) {
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Product_And_Categories
            .replace('{startRowIndex}', startRow)
            .replace('{maxRows}', endRow)
            .replace('{lang}', lang)
            .replace('{query}', query);
        var key = url;
        return this._api.get(url);
    };
    SearchService.prototype.getQueryValue = function () {
        var response = this.query;
        return response;
    };
    SearchService.prototype.setQueryValue = function (newQuery) {
        this.query = newQuery;
    };
    SearchService.prototype.setQueryPlainTextValue = function (newQuery) {
        this.queryText = newQuery;
    };
    SearchService.prototype.getQueryPlainTextValue = function () {
        var response = this.queryText;
        return response;
    };
    SearchService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _c) || Object, (typeof (_d = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object])
    ], SearchService);
    return SearchService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.SearchService = SearchService;


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var mapping_1 = __webpack_require__(10);
var api_service_1 = __webpack_require__(13);
var CurrencyService = (function () {
    function CurrencyService(_api, mappings) {
        this._api = _api;
        this.mappings = mappings;
        this.currencyVal = "";
    }
    CurrencyService.prototype.getCurrency = function () {
        var param = '$';
        switch (param) {
            case '$': return 'USD';
            case '€': return 'EUR';
            default: return 'EUR';
        }
    };
    CurrencyService.prototype.getCurrencyBackend = function () {
        var url = this.mappings.Web_Api_Get_DefaultCurrency;
        return this._api.get(url);
    };
    CurrencyService.prototype.getDefaultCurrency = function () {
        return this.currencyVal;
    };
    CurrencyService.prototype.setDefaultCurrency = function (currency) {
        this.currencyVal = currency;
    };
    CurrencyService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object])
    ], CurrencyService);
    return CurrencyService;
    var _a, _b;
}());
exports.CurrencyService = CurrencyService;


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
var application_service_1 = __webpack_require__(128);
var LanguageService = (function () {
    function LanguageService(translate, appService) {
        this.translate = translate;
        this.appService = appService;
        this.lang = this.translate.currentLang;
    }
    LanguageService.prototype.getLongLang = function () {
        var lang = 'it-IT';
        switch (this.lang) {
            case 'it':
                lang = 'it-IT';
                break;
            case 'en':
                lang = 'en-GB';
                break;
            case 'al':
                lang = 'sq-AL';
                break;
            case 'de':
                lang = 'de-DE';
                break;
            case 'sl':
                lang = 'sl-SI';
                break;
            case 'hr':
                lang = 'hr-HR';
                break;
            case 'pt':
                lang = 'pt-PT';
                break;
            case 'es':
                lang = 'es-ES';
                break;
        }
        return lang;
    };
    LanguageService.prototype.getShortLang = function () {
        return this.lang;
    };
    //Return an object containing all the information for the current language (eg. code, lable, icon etc.)
    LanguageService.prototype.getCurrentLanguage = function () {
        var result = new LanguageObj();
        switch (this.lang) {
            case "it":
        }
        return result;
    };
    LanguageService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof application_service_1.ApplicationService !== 'undefined' && application_service_1.ApplicationService) === 'function' && _b) || Object])
    ], LanguageService);
    return LanguageService;
    var _a, _b;
}());
exports.LanguageService = LanguageService;
var LanguageObj = (function () {
    function LanguageObj() {
    }
    return LanguageObj;
}());
exports.LanguageObj = LanguageObj;


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var TemplateService = (function () {
    function TemplateService(_api, _cache, mappings, language, cache, cartService, authService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.language = language;
        this.cache = cache;
        this.cartService = cartService;
        this.authService = authService;
    }
    TemplateService.prototype.getThankYouPagePaypalInfo = function (componentType, id) {
        var currentLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Information_ThankYouPage_Paypal_Url
            .replace('{type}', componentType)
            .replace('{orderid}', id)
            .replace('{lang}', currentLang)
            .replace('{cartid}', cartId)
            .replace('{userid}', customerId);
        return this._api.get(url);
    };
    TemplateService.prototype.getThankYouPagOnlineInfo = function (componentType, id) {
        var currentLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Information_ThankYouPage_PagOnline_Url
            .replace('{type}', componentType)
            .replace('{orderid}', id)
            .replace('{lang}', currentLang)
            .replace('{cartid}', cartId)
            .replace('{userid}', customerId);
        return this._api.get(url);
    };
    TemplateService.prototype.getThankYouNexiInfo = function (componentType, id, messaggio, data, orario) {
        var currentLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        //remove special char
        messaggio = messaggio.replace('%2B', ' ');
        messaggio = messaggio.replace('+', ' ');
        var url = this.mappings.Web_Api_Get_Information_ThankYouPage_Nexi_Url
            .replace('{type}', componentType)
            .replace('{orderid}', id)
            .replace('{messaggio}', messaggio)
            .replace('{data}', data)
            .replace('{orario}', orario)
            .replace('{lang}', currentLang)
            .replace('{cartid}', cartId)
            .replace('{userid}', customerId);
        return this._api.get(url);
    };
    TemplateService.prototype.getThankYouBancaSellaInfo = function (componentType, id, messaggio) {
        var currentLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        //remove special char
        var url = this.mappings.Web_Api_Get_Information_ThankYouPage_BancaSella_Url
            .replace('{type}', componentType)
            .replace('{orderid}', id)
            .replace('{messaggio}', messaggio)
            .replace('{lang}', currentLang)
            .replace('{cartid}', cartId)
            .replace('{userid}', customerId);
        return this._api.get(url);
    };
    /**
     * return the html template for a given component
    */
    TemplateService.prototype.getComponentTemplate = function (componentType) {
        var currentLang = this.language.getLongLang();
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Template_Url
            .replace('{type}', componentType)
            .replace('{lang}', currentLang)
            .replace('{templatebuilderid}', templateBuilderId);
        return this._api.get(url);
    };
    TemplateService.prototype.getComponentTemplatePageNotFound = function (componentType) {
        var currentLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Template_Url_Page_Not_Found
            .replace('{type}', componentType)
            .replace('{lang}', currentLang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        ;
        return this._api.get(url);
    };
    TemplateService.prototype.getHeadFootData = function (templateBuilderId) {
        var _this = this;
        var currentLang = this.language.getLongLang();
        //reading template builder id
        if (templateBuilderId == undefined || templateBuilderId == "undefined") {
            templateBuilderId = "0";
        }
        var url = this.mappings.Web_Api_Get_Head_Foot_Data
            .replace('{lang}', currentLang)
            .replace('{templatebuilderid}', templateBuilderId);
        return this._api.get(url).do(function (json) {
            _this.cache.clear(url);
        });
    };
    TemplateService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object, (typeof (_g = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _g) || Object])
    ], TemplateService);
    return TemplateService;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.TemplateService = TemplateService;


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(7);
var dom_adapter_1 = __webpack_require__(32);
var router_1 = __webpack_require__(12);
var template_service_1 = __webpack_require__(35);
var cache_service_1 = __webpack_require__(21);
var mapping_1 = __webpack_require__(10);
var routes_service_1 = __webpack_require__(5);
var router_2 = __webpack_require__(12);
var currency_service_1 = __webpack_require__(29);
var auth_service_1 = __webpack_require__(9);
var AppComponent = (function () {
    function AppComponent(template, document, isNode, cache, mappings, router, authService, route, currency, routesService) {
        var _this = this;
        this.template = template;
        this.document = document;
        this.isNode = isNode;
        this.cache = cache;
        this.mappings = mappings;
        this.router = router;
        this.authService = authService;
        this.route = route;
        this.currency = currency;
        this.routesService = routesService;
        this._dom = dom_adapter_1.getDOM();
        this.subManager = new Subscription_1.Subscription();
        var sub = router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        var currencysub = currency.getCurrencyBackend().subscribe(function (result) {
            currency.setDefaultCurrency(result);
        });
        this.subManager.add(sub);
        this.subManager.add(currencysub);
    }
    // Shows and hides the loading spinner during RouterEvent changes
    AppComponent.prototype.navigationInterceptor = function (event) {
        if (event instanceof router_2.NavigationStart) {
            this.routesService.showPageLoader();
        }
        if (event instanceof router_1.NavigationEnd) {
            var templateBuilderId = this.route.snapshot.queryParams["tempBuildId"];
            //console.log(templateBuilderId, "templateBuilderId")
            if (templateBuilderId != "undefined" && templateBuilderId != undefined && templateBuilderId != "0") {
                this.authService.setTemplBuilderId(templateBuilderId);
            }
            else {
                templateBuilderId = this.authService.getTemplBuilderId();
            }
            this._ngOnInit(templateBuilderId);
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof router_2.NavigationCancel) {
            this.routesService.hidePageLoader();
        }
        if (event instanceof router_2.NavigationError) {
            this.routesService.hidePageLoader();
        }
    };
    AppComponent.prototype.ngOnInit = function () {
    };
    AppComponent.prototype._ngOnInit = function (templateBuilderId) {
        var _this = this;
        if (!this.isNode) {
            return;
        }
        var templateSub = this.template.getHeadFootData(templateBuilderId)
            .subscribe(function (headFootData) {
            //Dynamically adding head css, js to the page (head.html)
            _this.appendHtmlString(_this.document.head, headFootData.HeadTemplateHtml);
            //Dynamically adding head css, js to the page (foot.html)
            _this.appendHtmlString(_this.document.body, headFootData.FootTemplateHtml);
        });
        this.subManager.add(templateSub);
    };
    AppComponent.prototype.appendHtmlString = function (el, template) {
        var div = this._dom.createElement('div');
        this._dom.setInnerHTML(div, template);
        this._dom.insertAllBefore(el.lastChild, this._dom.childNodes(div));
    };
    AppComponent.prototype.clearMemory = function () {
        this._dom = null;
        this.subManager.unsubscribe();
        this.cache.clearAll();
        this.document = null;
    };
    AppComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.clearMemory();
    };
    AppComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            selector: 'app',
            template: __webpack_require__(640)
        }),
        __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
        __param(2, core_1.Inject('isNode')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _a) || Object, Object, Boolean, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _g) || Object, (typeof (_h = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _h) || Object])
    ], AppComponent);
    return AppComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.AppComponent = AppComponent;


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var breadcrumbs_service_1 = __webpack_require__(22);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var seo_service_1 = __webpack_require__(11);
var cms_component_service_1 = __webpack_require__(8);
//Models
var news_list_1 = __webpack_require__(412);
//Services
var language_service_1 = __webpack_require__(3);
var article_service_1 = __webpack_require__(126);
var component_helper_service_1 = __webpack_require__(4);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var helper_service_1 = __webpack_require__(48);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var ArticleCategoryComponent = (function () {
    function ArticleCategoryComponent(_compiler, componentHelper, _elementRef, articleService, languageService, route, router, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.articleService = articleService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.articleCategory = new news_list_1.ArticleCategory();
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    ArticleCategoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var lang = this.languageService.getLongLang();
        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        var routeSub = this.route.params.subscribe(function (params) {
            var id = params['id'];
            var pageNumber = params['page'];
            var startRowIndex = 0;
            var maxRows = 15;
            if (pageNumber == undefined) {
                pageNumber = 0;
                startRowIndex = pageNumber * maxRows;
            }
            else if (pageNumber < 0) {
                pageNumber = 0;
                startRowIndex = pageNumber * maxRows;
            }
            else {
                startRowIndex = (pageNumber - 1) * maxRows;
            }
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            if (id !== undefined) {
                var categoryId_1 = id;
                var categorySubId = _this.articleService.getCategoryArticleById(categoryId_1, lang, startRowIndex, maxRows)
                    .subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetArticleSuccess(result, pageNumber, maxRows, header, categoryId_1);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeArticleCategory, categoryId_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(categorySubId);
            }
            else {
                var url = _this.router.url;
                var pageNumber_1 = params['page'];
                if (pageNumber_1 != undefined) {
                    url = url.slice(0, url.lastIndexOf('/'));
                }
                else {
                    pageNumber_1 = 0;
                }
                var categorySubUrl = _this.articleService.getArticleCategoryByUrl(lang, url, startRowIndex, maxRows).subscribe(function (result) {
                    if (_this.isBrowser) {
                        _this.onGetArticleSuccess(result, pageNumber_1, maxRows, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeArticleCategory, result.CategoryDetails.Id);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(categorySubUrl);
            }
        });
        this.subManager.add(routeSub);
    };
    ArticleCategoryComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    ArticleCategoryComponent.prototype.onGetArticleSuccess = function (result, currentPage, maxRows, header, categoryId) {
        ////Creating sub-component with the returned information
        var subComponent = this.createSubComponent(result, currentPage, maxRows, header, categoryId);
        ////Injecting created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    };
    ArticleCategoryComponent.prototype.createSubComponent = function (result, currentPage, maxRows, header, categoryId) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, scriptService, helperService, isBrowser, _elementRef, languageService, articleService, routesService, router, breadcrumbsService) {
                this.seoService = seoService;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.languageService = languageService;
                this.articleService = articleService;
                this.routesService = routesService;
                this.router = router;
                this.breadcrumbsService = breadcrumbsService;
                this.articleCategory = result.CategoryDetails;
                this.seoInfo = result.SeoInformation;
                this.blogs = result.ArticleCategoryList;
                this.pageIsInit = false;
                this.lang = this.languageService.getLongLang();
                this.categoryId = 0;
                this.startRowIndex = 0;
                this.maxRows = maxRows;
                this.blogCategoryPageName = [];
                this.blogCategoryPageNumber = [];
                this.blogPageName = [];
                this.homePageName = [];
                this.currentPageNumber = currentPage;
                this.disablePreviousPage = false;
                this.disableNextPage = false;
                this.numberOfPages = Math.ceil(result.NumberOfArticles / this.maxRows);
                this.pages = this.createRange(this.numberOfPages);
                this.zeroPage = 0;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.currentPageNumber == 0) {
                    this.zeroPage = 1;
                }
                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    this.disablePreviousPage = true;
                }
                else if (this.currentPageNumber == this.numberOfPages) {
                    this.disableNextPage = true;
                }
                this.articleCategories = result.ArticleCategories;
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.homePageName = this.routesService.getRoutePath('HOME');
                if (categoryId != undefined) {
                    this.blogCategoryPageName = this.routesService.getRoutePath('ArticleCategoryPage');
                    this.blogCategoryPageNumber = this.routesService.getRoutePath('ArticleCategoryPageWithPaging');
                }
                else {
                    this.blogCategoryPageName.push(this.router.url);
                }
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.createRange = function (number) {
                var items = [];
                for (var i = 1; i <= number; i++) {
                    items.push(i);
                }
                return items;
            };
            ChildComponent.prototype.showClickedPage = function (index) {
                var page = index + 1;
                var url;
                if (categoryId != undefined) {
                    url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', page.toString());
                }
                else {
                    if (this.currentPageNumber == 0) {
                        url = this.blogCategoryPageName + "/" + page.toString();
                    }
                    else {
                        url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + page.toString();
                    }
                }
                this.router.navigate([url]);
            };
            ChildComponent.prototype.showPreviousPage = function () {
                var previousPage = this.currentPageNumber - 1;
                if (previousPage > 0) {
                    var url = void 0;
                    if (categoryId != undefined) {
                        url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', previousPage.toString());
                    }
                    else {
                        if (this.currentPageNumber == 0) {
                            url = this.blogCategoryPageName + "/" + previousPage.toString();
                        }
                        else {
                            url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + previousPage.toString();
                        }
                    }
                    this.router.navigate([url]);
                }
            };
            ChildComponent.prototype.showNextPage = function () {
                var page = Number(this.currentPageNumber);
                if (this.currentPageNumber == 0) {
                    page = 1;
                }
                var nextPage = page + 1;
                var url;
                if (nextPage <= this.numberOfPages) {
                    if (categoryId != undefined) {
                        url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', nextPage.toString());
                    }
                    else {
                        if (this.currentPageNumber == 0) {
                            url = this.blogCategoryPageName + "/" + nextPage.toString();
                        }
                        else {
                            url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + nextPage.toString();
                        }
                    }
                    this.router.navigate([url]);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(3, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _b) || Object, (typeof (_c = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _c) || Object, Boolean, (typeof (_d = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _f) || Object, (typeof (_g = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _j) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        }());
        return ChildComponent;
    };
    ArticleCategoryComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
    ], ArticleCategoryComponent);
    return ArticleCategoryComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.ArticleCategoryComponent = ArticleCategoryComponent;


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Service
var article_service_1 = __webpack_require__(126);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var BlogPageComponent = (function () {
    function BlogPageComponent(_compiler, componentHelper, _elementRef, articleService, languageService, activatedRoute, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.articleService = articleService;
        this.languageService = languageService;
        this.activatedRoute = activatedRoute;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.categoryId = 0;
        this.startRowIndex = 0;
        this.maxRows = 15;
        this.currentPageNumber = 0;
        this.subManager = new Subscription_1.Subscription();
    }
    BlogPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var paramsSub = this.activatedRoute.params.subscribe(function (params) {
            _this.currentPageNumber = params['page'];
            if (_this.currentPageNumber == undefined) {
                _this.currentPageNumber = 1;
                _this.startRowIndex = (_this.currentPageNumber - 1) * _this.maxRows;
            }
            else if (_this.currentPageNumber < 1) {
                _this.currentPageNumber = 1;
                _this.startRowIndex = (_this.currentPageNumber - 1) * _this.maxRows;
            }
            else {
                _this.startRowIndex = (_this.currentPageNumber - 1) * _this.maxRows;
            }
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            var blogSub = _this.articleService.getBlogData(_this.lang, _this.startRowIndex, _this.maxRows).subscribe(function (result) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                if (_this.isBrowser) {
                    //Creating subcomponent whith the blog information to inject
                    var subComponent = _this.createSubComponent(result, _this.currentPageNumber, _this.maxRows, header);
                    //injecting created component (OK)
                    _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                }
                else {
                    //-- Get head and body scripts
                    _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.blogHomeId);
                    //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                    _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                    _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                }
            });
            _this.subManager.add(blogSub);
        });
        this.subManager.add(paramsSub);
    };
    BlogPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    BlogPageComponent.prototype.createSubComponent = function (result, currentPage, maxRows, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, helperService, languageService, articleService, routesService, router, activatedRoute, breadcrumbsService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.languageService = languageService;
                this.articleService = articleService;
                this.routesService = routesService;
                this.router = router;
                this.activatedRoute = activatedRoute;
                this.breadcrumbsService = breadcrumbsService;
                this.blogs = result.ArticleCategoryList;
                this.seoInfo = result.SeoInformation;
                this.company = result.Company;
                this.pageIsInit = false;
                this.lang = this.languageService.getLongLang();
                this.categoryId = 0;
                this.startRowIndex = 0;
                this.maxRows = maxRows;
                this.blogPageName = [];
                this.blogPageNumber = [];
                this.numberOfPages = Math.ceil(result.NumberOfArticles / this.maxRows);
                this.pages = this.createRange(this.numberOfPages);
                this.currentPageNumber = currentPage;
                this.disableNextPage = false;
                this.disablePreviousPage = false;
                this.homePageName = [];
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.articleCategories = result.ArticleCategories;
                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    this.disablePreviousPage = true;
                }
                else if (this.currentPageNumber == this.numberOfPages) {
                    this.disableNextPage = true;
                }
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.blogPageNumber = this.routesService.getRoutePath('BLOG_WITH_PAGINATION');
                this.homePageName = this.routesService.getRoutePath('HOME');
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            //PAGINATION START************************************************************
            ChildComponent.prototype.createRange = function (number) {
                var items = [];
                for (var i = 1; i <= number; i++) {
                    items.push(i);
                }
                return items;
            };
            ChildComponent.prototype.showClickedPage = function (index) {
                var page = index + 1;
                var url = this.blogPageNumber[0].replace(':page', page.toString());
                this.router.navigate([url]);
            };
            ChildComponent.prototype.showPreviousPage = function () {
                var previousPage = this.currentPageNumber - 1;
                if (previousPage > 0) {
                    var url = this.blogPageNumber[0].replace(':page', previousPage.toString());
                    this.router.navigate([url]);
                }
            };
            ChildComponent.prototype.showNextPage = function () {
                var nextPage = Number(this.currentPageNumber) + 1;
                if (nextPage <= this.numberOfPages) {
                    var url = this.blogPageNumber[0].replace(':page', nextPage.toString());
                    this.router.navigate([url]);
                }
            };
            //PAGINATION END************************************************************
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _f) || Object, (typeof (_g = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _j) || Object, (typeof (_k = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _k) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        }());
        return ChildComponent;
    };
    BlogPageComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(7, core_1.Inject('isBrowser')),
        __param(10, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, Object, (typeof (_k = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _k) || Object])
    ], BlogPageComponent);
    return BlogPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.BlogPageComponent = BlogPageComponent;


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var breadcrumbs_service_1 = __webpack_require__(22);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var language_service_1 = __webpack_require__(3);
var article_service_1 = __webpack_require__(126);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var cms_component_service_1 = __webpack_require__(8);
var news_list_1 = __webpack_require__(412);
var newsletter_service_1 = __webpack_require__(84);
var routes_service_1 = __webpack_require__(5);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var ArticleComponent = (function () {
    function ArticleComponent(_elementRef, _compiler, componentHelper, languageService, router, route, articleService, templateService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._elementRef = _elementRef;
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this.languageService = languageService;
        this.router = router;
        this.route = route;
        this.articleService = articleService;
        this.templateService = templateService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.newsDetails = new news_list_1.NewsDetails();
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    ArticleComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var lang = this.languageService.getLongLang();
        var paramSub = this.route.params.subscribe(function (params) {
            var id = params['id'];
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            //Reading id from url
            //If id is set, then the page is retrived by id, else by url
            if (id !== undefined) {
                var Id_1 = id;
                var subArticleId = _this.articleService.getArticleDetails(Id_1, lang).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeArticle, Id_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.HeaderImage);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(subArticleId);
            }
            else {
                var url = _this.router.url;
                var subArticleUrl = _this.articleService.getArticleByUrl(lang, url).subscribe(function (result) {
                    if (_this.isBrowser) {
                        _this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeArticle, result.Id);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.HeaderImage);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(subArticleUrl);
            }
        });
        this.subManager.add(paramSub);
    };
    ArticleComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    ArticleComponent.prototype.onGetPageSuccess = function (newsResult, header) {
        ////Creating sub-component with the returned information
        var subComponent = this.createSubComponent(newsResult, header);
        ////Injecting dynamically created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    };
    ArticleComponent.prototype.createSubComponent = function (newsObj, header) {
        if (newsObj.Id == 0) {
            var templateSub = this.templateService.getComponentTemplate("newsletterConfirmationTemplate").subscribe(function (result) {
                newsObj.TemplateHtml = result;
            });
            this.subManager.add(templateSub);
        }
        var ChildComponent = (function () {
            function ChildComponent(seoService, isBrowser, _elementRef, scriptService, helperService, newsletterService, routesService, articleService, languageService, breadcrumbsService) {
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.newsletterService = newsletterService;
                this.routesService = routesService;
                this.articleService = articleService;
                this.languageService = languageService;
                this.breadcrumbsService = breadcrumbsService;
                this.newsDetails = newsObj;
                this.slidesNews = newsObj.SliderImages;
                this.pageIsInit = false;
                this.seoInfo = newsObj.SeoInformation;
                this.model = {
                    Email: "",
                    Checkbox: false
                };
                this.privacyPageNameArticle = this.routesService.getRoutePath('INFO PRIVACY');
                this.lang = this.languageService.getLongLang();
                this.categoryId = 0;
                this.startRowIndex = 0;
                this.maxRows = 999999;
                this.blogPageName = [];
                this.homePageName = [];
                this.breadcrumbs = newsObj.BreadcrumbsInfo;
                this.subManager = new Subscription_1.Subscription();
                this.footerData = newsObj.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.articleCategories = newsObj.ArticleCategories;
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.homePageName = this.routesService.getRoutePath('HOME');
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                this.setupSocialNetworks();
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                layoutTheme.initCarousel();
                layoutTheme.initLightbox();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.setupSocialNetworks = function () {
                var shareurl = window.location.href;
                var title = this.newsDetails.Title;
                var text = encodeURI(title);
                /********************************** SET THIS PART DYNAMICALY **************************************** */
                //setting twitter profile name 
                var companyTwitterProfile = "DynamicsoftSrl";
                //setting linkedin profile name
                var companyLinkedinProfile = "DynamicsoftSrl";
                /**************************************************************************************************** */
                //encoded current page
                var currentPage = encodeURI(shareurl);
                //sharing of current page on Facebook
                $('.fbsharelink').click(function () {
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + shareurl + '&t=' + document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                    return false;
                });
                //sharing of current page on LinkedIn
                $('.linkedinsharelink').click(function () {
                    window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + shareurl + '&title=' + document.title +
                        '&summary=' + text + '&source=' + companyLinkedinProfile, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                });
                //sharing of currentpage on Twitter
                $('.twitter-share-button').click(function () {
                    window.open('https://twitter.com/intent/tweet?text=' + text + '&url=' + currentPage + '&via=' + companyTwitterProfile, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                });
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerNewslatterArticle = true;
                if (form) {
                    var subNewsletter = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(function (result) {
                        if (result == "-1") {
                            _this.alreadySubscribedArticle = true;
                            _this.successfullySubscribedArticle = false;
                            _this.spinnerNewslatterArticle = false;
                        }
                        else {
                            _this.alreadySubscribedArticle = false;
                            _this.successfullySubscribedArticle = true;
                            _this.spinnerNewslatterArticle = false;
                        }
                    });
                    this.subManager.add(subNewsletter);
                }
                else {
                    this.spinnerNewslatterArticle = false;
                }
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: newsObj.TemplateHtml
                }),
                __param(1, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _d) || Object, (typeof (_e = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _g) || Object, (typeof (_h = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _h) || Object, (typeof (_j = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _j) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        }());
        return ChildComponent;
    };
    ArticleComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(9, core_1.Inject('isBrowser')),
        __param(12, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _a) || Object, (typeof (_b = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _b) || Object, (typeof (_c = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _g) || Object, (typeof (_h = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _h) || Object, (typeof (_j = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _j) || Object, Boolean, (typeof (_k = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _k) || Object, (typeof (_l = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _l) || Object, Object, (typeof (_m = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _m) || Object])
    ], ArticleComponent);
    return ArticleComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
}());
exports.ArticleComponent = ArticleComponent;


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//System
var core_1 = __webpack_require__(0);
//Services
var search_service_1 = __webpack_require__(263);
var component_helper_service_1 = __webpack_require__(4);
var routes_service_1 = __webpack_require__(5);
var router_1 = __webpack_require__(12);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var SearchComponent = (function () {
    function SearchComponent(_compiler, componentHelper, _elementRef, searchService, cmsComponentService, activatedRoute, isBrowser, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.searchService = searchService;
        this.cmsComponentService = cmsComponentService;
        this.activatedRoute = activatedRoute;
        this.isBrowser = isBrowser;
        this.scriptService = scriptService;
        this.startRow = 0;
        this.endRow = 10;
        this.subManager = new Subscription_1.Subscription();
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        var paramSub = this.activatedRoute.params.subscribe(function (params) {
            var decodedQuery = params['query'];
            var decoded = decodeURIComponent(decodedQuery);
            _this.query = encodeURIComponent(decoded);
            _this.currentPageNumber = params['page'];
            if (_this.currentPageNumber == undefined) {
                _this.currentPageNumber = 1;
                _this.startRow = (_this.currentPageNumber - 1) * _this.endRow;
            }
            else if (_this.currentPageNumber < 1) {
                _this.currentPageNumber = 1;
                _this.startRow = (_this.currentPageNumber - 1) * _this.endRow;
            }
            else {
                _this.startRow = (_this.currentPageNumber - 1) * _this.endRow;
            }
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            var catAndProdSub = _this.searchService.getCategoriesAndProducts(_this.query, _this.startRow, _this.endRow).subscribe(function (result) {
                _this.SearchResult = result;
                if (_this.isBrowser) {
                    // Creating subcomponent whith the selected template to inject
                    var subComponent = _this.createSubComponent(header, _this.SearchResult, _this.query, _this.currentPageNumber, _this.endRow);
                    //injecting created component (OK)
                    _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                }
                else {
                    //Eventually retrieving the script to append
                    if (_this.currentPageNumber == 0 || _this.currentPageNumber == 1) {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.SearchPageId);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.SearchWithPagingPageId);
                    }
                }
            }, function (err) { return _this.handleSearchError(); });
            _this.subManager.add(catAndProdSub);
        });
        this.subManager.add(paramSub);
    };
    SearchComponent.prototype.handleSearchError = function () {
        var _this = this;
        this.query = null;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        this.searchService.getCategoriesAndProducts(this.query, this.startRow, this.endRow).subscribe(function (result) {
            _this.SearchResult = result;
            if (_this.isBrowser) {
                // Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(header, _this.SearchResult, _this.query, _this.currentPageNumber, _this.endRow);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //Eventually retrieving the script to append
                if (_this.currentPageNumber == 0 || _this.currentPageNumber == 1) {
                    //-- Get head and body scripts
                    _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.SearchPageId);
                }
                else {
                    //-- Get head and body scripts
                    _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.SearchWithPagingPageId);
                }
            }
        });
    };
    SearchComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    SearchComponent.prototype.createSubComponent = function (header, SearchResult, query, currentPage, endRow) {
        var ChildComponent = (function () {
            function ChildComponent(isBrowser, routesService, searchService, router, seoService, scriptService, _elementRef) {
                this.isBrowser = isBrowser;
                this.routesService = routesService;
                this.searchService = searchService;
                this.router = router;
                this.seoService = seoService;
                this.scriptService = scriptService;
                this._elementRef = _elementRef;
                this.seoInfo = SearchResult.SeoInformation;
                this.pageIsInit = false;
                this.defaultImageUrl = "/global_app/img/noimage.jpg";
                this.redirectUrlNone = "javascript:void(0)";
                //pagination
                this.query = query;
                this.currentPageNumber = currentPage;
                this.disablePreviousPage = false;
                this.disableNextPage = false;
                this.numberOfPages = Math.ceil(SearchResult.NumberOfResults / endRow);
                this.searchResultsPage = [];
                this.searchResultsPageWithPagination = [];
                this.pages = this.createRange(this.numberOfPages);
                this.numberOfResult = SearchResult.NumberOfResults;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                if (SearchResult.SearchModelList != null) {
                    this.searchResults = SearchResult.SearchModelList;
                }
                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    this.disablePreviousPage = true;
                }
                else if (this.currentPageNumber == this.numberOfPages) {
                    this.disableNextPage = true;
                }
                this.searchResultsPage = this.routesService.getRoutePath('SEARCH - RESULTS');
                this.searchResultsPageWithPagination = this.routesService.getRoutePath('SEARCH RESULTS - PAGINATION');
                if (this.searchResults != null && this.searchResults != undefined) {
                    for (var i = 0; i < this.searchResults.length; i++) {
                        //setting of default image if image url is not defined
                        if (this.searchResults[i].ImageUrl == null || this.searchResults[i].ImageUrl == "") {
                            this.searchResults[i].ImageUrl = this.defaultImageUrl;
                        }
                        //setting of url href not to do nothing if url is not defined
                        if (this.searchResults[i].RedirectUrl == null || this.searchResults[i].RedirectUrl == "") {
                            this.searchResults[i].RedirectUrl = this.redirectUrlNone;
                        }
                    }
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            //Pagination start
            ChildComponent.prototype.createRange = function (number) {
                var items = [];
                for (var i = 1; i <= number; i++) {
                    items.push(i);
                }
                return items;
            };
            ChildComponent.prototype.showClickedPage = function (index) {
                var page = index + 1;
                var url = this.searchResultsPageWithPagination[0]
                    .replace(':query', query)
                    .replace(':page', page.toString());
                this.router.navigate([url]);
            };
            ChildComponent.prototype.showPreviousPage = function () {
                var previousPage = this.currentPageNumber - 1;
                if (previousPage > 0) {
                    var url = this.searchResultsPageWithPagination[0]
                        .replace(':query', query)
                        .replace(':page', previousPage.toString());
                    this.router.navigate([url]);
                }
            };
            ChildComponent.prototype.showNextPage = function () {
                var nextPage = Number(this.currentPageNumber) + 1;
                if (nextPage <= this.numberOfPages) {
                    var url = this.searchResultsPageWithPagination[0]
                        .replace(':query', query)
                        .replace(':page', nextPage.toString());
                    this.router.navigate([url]);
                }
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: SearchResult.TemplateHtml
                }),
                __param(0, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [Boolean, (typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _d) || Object, (typeof (_e = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _f) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f;
        }());
        return ChildComponent;
    };
    SearchComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            selector: "",
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _g) || Object])
    ], SearchComponent);
    return SearchComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.SearchComponent = SearchComponent;


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var customerscanvas_service_1 = __webpack_require__(43);
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var routes_service_1 = __webpack_require__(5);
var cms_component_service_1 = __webpack_require__(8);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
//Services
var newsletter_service_1 = __webpack_require__(84);
var Subscription_1 = __webpack_require__(2);
var cache_service_1 = __webpack_require__(21);
var platform_browser_1 = __webpack_require__(7);
var angular2_meta_1 = __webpack_require__(99);
var currency_service_1 = __webpack_require__(29);
var Observable_1 = __webpack_require__(1);
var language_service_1 = __webpack_require__(3);
var HomeComponent = (function () {
    function HomeComponent(_compiler, componentHelper, _elementRef, cmsComponentService, isBrowser, seo, renderer, scriptService, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.scriptService = scriptService;
        this.document = document;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
        this._compiler.clearCache();
    }
    HomeComponent.prototype.requestDataFromMultipleSources = function () {
        var response1 = this.cmsComponentService.getHeaderData();
        var response2 = this.cmsComponentService.getSideMenuData();
        var response3 = this.cmsComponentService.getproductHilightpromo();
        var response4 = this.cmsComponentService.getHomePageDataOptimized();
        // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
        return Observable_1.Observable.forkJoin([response1, response2, response3, response4]);
    };
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        var homePageInfo;
        var header;
        var SideMenu;
        var promo;
        var highlith;
        var fork = this.requestDataFromMultipleSources().subscribe(function (result) {
            header = result[0];
            if (result[1].Categories) {
                header.Categories = result[1].Categories;
                SideMenu = result[1];
            }
            if (result[2].Promotions) {
                promo = result[2].Promotions;
            }
            if (result[2].Highlights) {
                highlith = result[2].Highlights;
            }
            if (result[3].SeoInformation) {
                result[3].SeoInformation.ShortDescription = result[3].ShortDescription ? result[3].ShortDescription : '';
                result[3].SeoInformation.LongDescription = result[3].LongDescription ? result[3].LongDescription : '';
            }
            if (SideMenu) {
                result[3].SideMenuData = SideMenu;
            }
            if (promo) {
                result[3].Promotions = promo;
            }
            if (highlith) {
                result[3].Highlights = highlith;
            }
            if (_this.isBrowser) {
                homePageInfo = result[3];
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(homePageInfo, header);
                //let subComponent = this.createSubComponent(homePageInfo);
                _this._elementRef.clear();
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result[3], _this.scriptService.typeSystemPage, _this.scriptService.homeId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result[3].SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result[3].SeoInformation);
            }
        });
        this.subManager.add(fork);
    };
    HomeComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
        // this.cache.clearAll();
    };
    //Creates component to inject
    //private createSubComponent(homePageInfo: any) {
    HomeComponent.prototype.createSubComponent = function (homePageInfo, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, seoService, isBrowser, _elementRef, scriptService, helperService, currency, languageService, newsletterService, componentHelper, cache, canvasService, metaService) {
                this.routesService = routesService;
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.currency = currency;
                this.languageService = languageService;
                this.newsletterService = newsletterService;
                this.componentHelper = componentHelper;
                this.cache = cache;
                this.canvasService = canvasService;
                this.metaService = metaService;
                this.homeIsInit = false;
                this.productsPageName = [];
                this.promotionsPageName = [];
                this.categories = homePageInfo.Categories;
                this.highlights = homePageInfo.Highlights;
                this.promotions = homePageInfo.Promotions;
                this.seoInfo = homePageInfo.SeoInformation;
                this.articles = homePageInfo.ArticleCategoryList;
                //private headerData: any = homePageInfo.HeaderData;
                this.headerData = header;
                this.footerData = homePageInfo.FooterData;
                this.sideMenuData = homePageInfo.SideMenuData;
                this.sliderData = homePageInfo.SliderData;
                //newsletter subsciption
                this.newsletterSubmitted = false;
                this.privacySubmitted = false;
                this.alreadySubscribed = false;
                this.successfullySubscribed = false;
                this.spinnerNewslatter = false;
                this.lang = this.languageService.getShortLang();
                this.model = {
                    Email: "",
                    CheckboxSubscribe: false
                };
                this.subManager = new Subscription_1.Subscription();
            }
            // private breadcrumbs : Breadcrumbs[] = homePageInfo.BreadcrumbsInfo;
            ChildComponent.prototype.ngOnInit = function () {
                // setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.sideMenuData.Categories = this.headerData.Categories;
                this.productsPageName = this.routesService.getRoutePath('CATALOGO PRODOTTI (HOME)');
                this.promotionsPageName = this.routesService.getRoutePath('CATALOGO - PRODOTTI IN OFFERTA');
            };
            ChildComponent.prototype.filteraArticleOfType = function (type, numReturn) {
                var count = 1;
                var result = new Array();
                var res = this.articles.filter(function (x) { return x.Code_Category == type; });
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var item = res_1[_i];
                    if (count > numReturn) {
                        return result;
                    }
                    result.push(item);
                    count++;
                }
                return result;
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerNewslatter = true;
                if (form) {
                    var newsSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(function (result) {
                        if (result == "-1") {
                            _this.alreadySubscribed = true;
                            _this.successfullySubscribed = false;
                            _this.spinnerNewslatter = false;
                        }
                        else {
                            _this.alreadySubscribed = false;
                            _this.successfullySubscribed = true;
                            _this.spinnerNewslatter = false;
                        }
                    });
                    this.subManager.add(newsSub);
                }
                else {
                    this.spinnerNewslatter = false;
                }
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.homeIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                //layoutTheme.initCarousel();
                layoutTheme.initAnimate();
                //Eventually retrieving the script to append
                // if (this.seoInfo.HasScripts == true) {
                //     this.scriptService.appendHomeScript(this._elementRef.element.nativeElement);
                // }
                this.homeIsInit = true;
            };
            ChildComponent.prototype.nullifyAllReferences = function () {
                homePageInfo = null;
                this.productsPageName = null;
                this.promotionsPageName = null;
                this.categories = null;
                this.articles = null;
                this.highlights = null;
                this.promotions = null;
                this.seoInfo = null;
                this.headerData = null;
                this.footerData = null;
                this.sideMenuData = null;
                this.sliderData = null;
                this.model.CheckboxSubscribe = null;
                this.model.Email = null;
            };
            ChildComponent.prototype.doSomething = function () {
                this.nullifyAllReferences();
                this.subManager.unsubscribe();
                this.componentHelper.clearMemory();
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.nullifyAllReferences();
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: homePageInfo.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, (typeof (_e = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _e) || Object, (typeof (_f = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _f) || Object, (typeof (_g = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _g) || Object, (typeof (_h = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _h) || Object, (typeof (_j = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _j) || Object, (typeof (_k = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _k) || Object, (typeof (_l = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _l) || Object, (typeof (_m = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _m) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        }());
        return ChildComponent;
    };
    HomeComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(4, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _f) || Object, (typeof (_g = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _g) || Object, Object])
    ], HomeComponent);
    return HomeComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.HomeComponent = HomeComponent;


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
var breadcrumbs_service_1 = __webpack_require__(22);
//System
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var platform_browser_1 = __webpack_require__(7);
var dom_adapter_1 = __webpack_require__(32);
//Services
var component_helper_service_1 = __webpack_require__(4);
var cms_content_service_1 = __webpack_require__(413);
var language_service_1 = __webpack_require__(3);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var cms_component_service_1 = __webpack_require__(8);
var cms_menu_list_service_1 = __webpack_require__(414);
var routes_service_1 = __webpack_require__(5);
var CmsPageComponent = (function () {
    function CmsPageComponent(_compiler, componentHelper, _elementRef, cmsContentService, route, languageService, router, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsContentService = cmsContentService;
        this.route = route;
        this.languageService = languageService;
        this.router = router;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    CmsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var longLangCode = this.languageService.getLongLang();
        var shortLangCode = this.languageService.getShortLang();
        var subParams = this.route.params.subscribe(function (params) {
            var id = params['id'];
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            //Reading id from url
            //If id is set, then the page is retrived by id, else by url
            if (id !== undefined) {
                var pageId_1 = '' + id;
                var cmsIdSub = _this.cmsContentService.getCmsPageById(longLangCode, pageId_1).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCmsPage, pageId_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.TopImage);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(cmsIdSub);
            }
            else {
                var url = _this.router.url;
                var cmsUrlSub = _this.cmsContentService.getCmsPageByUrl(longLangCode, url).subscribe(function (result) {
                    if (_this.isBrowser) {
                        _this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCmsPage, result.IdLevel);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.TopImage);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(cmsUrlSub);
            }
        });
        this.subManager.add(subParams);
    };
    CmsPageComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    CmsPageComponent.prototype.onGetPageSuccess = function (cmsResult, header) {
        //Creating subcomponent whith the object get from server
        var subComponent = this.createSubComponent(cmsResult, header);
        //injecting created component
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    };
    //Creates component to inject 
    CmsPageComponent.prototype.createSubComponent = function (cmsPageObj, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, document, isBrowser, _elementRef, scriptService, helperService, cmsMenuListService, languageService, routesService, breadcrumbsService) {
                this.seoService = seoService;
                this.document = document;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.cmsMenuListService = cmsMenuListService;
                this.languageService = languageService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this._dom = dom_adapter_1.getDOM();
                this.cmspage = cmsPageObj;
                this.seoInfo = cmsPageObj.SeoInformation;
                this.pageIsInit = false;
                this.menuItems = [];
                this.headerData = header;
                this.footerData = cmsPageObj.footerData;
                this.lang = this.languageService.getLongLang();
                this.breadcrumbs = [];
                //private breadcrumbs: Breadcrumbs[] = cmsPageObj.BreadcrumbsInfo;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var paramPage = "cmspage";
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = cmsPageObj.BreadcrumbsInfo;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.isBrowser == true) {
                    setTimeout(function (x) { return _this.menuItems = cmsPageObj.menuItems; }, 1);
                }
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: cmsPageObj.TemplateHtml
                }),
                __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, Object, Boolean, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _d) || Object, (typeof (_e = typeof cms_menu_list_service_1.CmsMenuListService !== 'undefined' && cms_menu_list_service_1.CmsMenuListService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _g) || Object, (typeof (_h = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    CmsPageComponent = __decorate([
        core_1.Component({
            template: "",
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_content_service_1.CmsContentService !== 'undefined' && cms_content_service_1.CmsContentService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
    ], CmsPageComponent);
    return CmsPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.CmsPageComponent = CmsPageComponent;


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//Service
var seo_service_1 = __webpack_require__(11);
var cookie_policy_service_1 = __webpack_require__(419);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var CookiePolicyComponent = (function () {
    function CookiePolicyComponent(_compiler, componentHelper, _elementRef, languageService, cookiePolicyService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.cookiePolicyService = cookiePolicyService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    CookiePolicyComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var cookieSub = this.cookiePolicyService.getCookiePolicyData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.cookiesId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(cookieSub);
    };
    CookiePolicyComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    CookiePolicyComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.configuration = result.ConfigurationInfo;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.footerData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml,
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e;
        }());
        return ChildComponent;
    };
    CookiePolicyComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof cookie_policy_service_1.CookiePolicyService !== 'undefined' && cookie_policy_service_1.CookiePolicyService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], CookiePolicyComponent);
    return CookiePolicyComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.CookiePolicyComponent = CookiePolicyComponent;


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
//Service
var faq_service_1 = __webpack_require__(415);
var language_service_1 = __webpack_require__(3);
var company_service_1 = __webpack_require__(129);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var platform_browser_1 = __webpack_require__(7);
var FaqComponent = (function () {
    function FaqComponent(_compiler, componentHelper, _elementRef, faqlistService, languageService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.faqlistService = faqlistService;
        this.languageService = languageService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    FaqComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var faqSub = this.faqlistService.getFaqData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the faq data to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.faqsId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(faqSub);
    };
    FaqComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    FaqComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(companyService, _elementRef, seoService, isBrowser, scriptService, routesService, breadcrumbsService) {
                this.companyService = companyService;
                this._elementRef = _elementRef;
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.faqlist = result.FaqList;
                this.footerData = result.footerData;
                this.headerData = header;
                this.pageIsInit = false;
                this.seoInfo = result.SeoInformation;
                this.breadcrumbs = result.BreadcrumbsInfo;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                layoutTheme.initToggle();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(3, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _c) || Object, Boolean, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _f) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f;
        }());
        return ChildComponent;
    };
    FaqComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof faq_service_1.FaqListService !== 'undefined' && faq_service_1.FaqListService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], FaqComponent);
    return FaqComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.FaqComponent = FaqComponent;


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var language_service_1 = __webpack_require__(3);
var info_request_service_1 = __webpack_require__(416);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var cms_component_service_1 = __webpack_require__(8);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var info_request_1 = __webpack_require__(619);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var InfoRequestComponent = (function () {
    function InfoRequestComponent(_compiler, componentHelper, _elementRef, languageService, infoRequestService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.infoRequestService = infoRequestService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    InfoRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        var templateHtml;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var infoSub = this.infoRequestService.getInfoRequestData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //templateHtml = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.infoRequestId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(infoSub);
    };
    InfoRequestComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    InfoRequestComponent.prototype.createSubComponent = function (componentInfo, header) {
        var ChildComponent = (function () {
            function ChildComponent(infoRequestService, seoService, router, _elementRef, scriptService, isBrowser, routesService, breadcrumbsService) {
                this.infoRequestService = infoRequestService;
                this.seoService = seoService;
                this.router = router;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.company = componentInfo.Company;
                this.pageIsInit = false;
                this.spinnerContact = false;
                this.breadcrumbs = componentInfo.BreadcrumbsInfo;
                this.footerData = componentInfo.footerData;
                this.headerData = header;
                this.subManager = new Subscription_1.Subscription();
                this.seoInfo = componentInfo.SeoInformation;
            }
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerContact = true;
                if (form.valid) {
                    var infoSub = this.infoRequestService.sendInfoRequest(this.model).subscribe(function (result) {
                        if (result) {
                            _this.infoRequestSuccess = true;
                            _this.infoRequestFailed = false;
                            _this.spinnerContact = false;
                        }
                        else {
                            _this.infoRequestFailed = true;
                            _this.infoRequestSuccess = false;
                            _this.spinnerContact = false;
                        }
                    });
                    this.subManager.add(infoSub);
                }
                else {
                    this.infoRequestFailed = true;
                    this.infoRequestSuccess = false;
                    this.spinnerContact = false;
                }
            };
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.model = new info_request_1.InfoRequest();
                this.model.Where = "motoriDiRicerca";
                this.configuration = componentInfo.ConfigurationInfo;
            };
            ChildComponent.prototype.initMap = function () {
                if (google == undefined || google == null || !google) {
                    this.initMap();
                }
                else {
                    var geocoder = new google.maps.Geocoder();
                    var street = this.company.StreetAddress.replace(",", "");
                    var address = street + " - " + this.company.PostalCode + ", " + this.company.City + " (" + this.company.Province + ")";
                    var htmlCode = "<strong>" + this.company.Name + "</strong><br>" + address + "<br> <strong>Telefono:</strong> " + this.company.Phone;
                    geocoder.geocode({ 'address': address }, function (results, status) {
                        var initLongitude = results[0].geometry.location.lng();
                        var initLatitude = results[0].geometry.location.lat();
                        var mapMarkers = [{
                                address: address,
                                html: htmlCode,
                                icon: {
                                    image: "/global_app/writefolder/img/pin.png",
                                    iconsize: [100, 100],
                                    iconanchor: [50, 100]
                                },
                                popup: true
                            }];
                        // Map Initial Location
                        // Map Extended Settings
                        var mapSettings = {
                            controls: {
                                draggable: true,
                                panControl: true,
                                zoomControl: true,
                                mapTypeControl: true,
                                scaleControl: true,
                                streetViewControl: true,
                                overviewMapControl: true
                            },
                            scrollwheel: false,
                            markers: mapMarkers,
                            latitude: initLatitude,
                            longitude: initLongitude,
                            zoom: 18
                        };
                        var map = $("#map").gMap(mapSettings);
                        // Map Center At
                        var mapCenterAt = function (options, e) {
                            e.preventDefault();
                            $("#map").gMap("centerAt", options);
                        };
                    });
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                //this.initMap();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: componentInfo.TemplateHtml
                }),
                __param(5, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof info_request_service_1.InfoRequestService !== 'undefined' && info_request_service_1.InfoRequestService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _d) || Object, (typeof (_e = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    InfoRequestComponent = __decorate([
        core_1.Component({
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof info_request_service_1.InfoRequestService !== 'undefined' && info_request_service_1.InfoRequestService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], InfoRequestComponent);
    return InfoRequestComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.InfoRequestComponent = InfoRequestComponent;


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Service
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var newsletter_service_1 = __webpack_require__(84);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var NewsletterConfirmationPageComponent = (function () {
    function NewsletterConfirmationPageComponent(_compiler, componentHelper, _elementRef, languageService, newsletterService, isBrowser, seo, renderer, cmsComponentService, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.newsletterService = newsletterService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.cmsComponentService = cmsComponentService;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    NewsletterConfirmationPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var templateHtml;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var newsConfirmSub = this.newsletterService.getNewsletterConfirmationPageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.subscriptionConfirmationId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(newsConfirmSub);
    };
    NewsletterConfirmationPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    NewsletterConfirmationPageComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService, newsletterService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.newsletterService = newsletterService;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.headerData = header;
                //newsletter subscription
                this.newsletterSubmitted = false;
                this.privacySubmitted = false;
                this.alreadySubscribed = false;
                this.successfullySubscribed = false;
                this.spinnerNewslatter = false;
                this.model = {
                    Email: "",
                    CheckboxSubscribe: false
                };
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object, (typeof (_f = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _f) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f;
        }());
        return ChildComponent;
    };
    NewsletterConfirmationPageComponent = __decorate([
        core_1.Component({
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], NewsletterConfirmationPageComponent);
    return NewsletterConfirmationPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.NewsletterConfirmationPageComponent = NewsletterConfirmationPageComponent;


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Service
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var newsletter_service_1 = __webpack_require__(84);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var NewsletterPageComponent = (function () {
    function NewsletterPageComponent(_compiler, componentHelper, _elementRef, languageService, newsletterService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.newsletterService = newsletterService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    NewsletterPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var templateHtml;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var newsPageSub = this.newsletterService.getNewsletterPageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.subscriptionId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(newsPageSub);
    };
    NewsletterPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    NewsletterPageComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService, newsletterService, router) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.newsletterService = newsletterService;
                this.router = router;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.headerData = header;
                //newsletter subscription
                this.newsletterSubmitted = false;
                this.privacySubmitted = false;
                this.alreadySubscribed = false;
                this.successfullySubscribed = false;
                this.spinnerNewslatter = false;
                this.model = {
                    Email: "",
                    CheckboxSubscribe: false
                };
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerNewslatter = true;
                if (form) {
                    var newsSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(function (result) {
                        if (result == "-1") {
                            _this.alreadySubscribed = true;
                            _this.successfullySubscribed = false;
                            _this.spinnerNewslatter = false;
                        }
                        else {
                            var newsletterCompletePage = _this.routesService.getRoutePath('NEWSLETTER - CONFIRMATION')[0];
                            _this.router.navigate([newsletterCompletePage]);
                            _this.alreadySubscribed = false;
                            _this.successfullySubscribed = true;
                            _this.spinnerNewslatter = false;
                        }
                    }, function (err) {
                        console.log(err);
                    });
                    this.subManager.add(newsSub);
                }
                else {
                    this.spinnerNewslatter = false;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object, (typeof (_f = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    NewsletterPageComponent = __decorate([
        core_1.Component({
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], NewsletterPageComponent);
    return NewsletterPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.NewsletterPageComponent = NewsletterPageComponent;


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Service
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var privacy_policy_service_1 = __webpack_require__(421);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PrivacyPolicyComponent = (function () {
    function PrivacyPolicyComponent(_compiler, componentHelper, _elementRef, languageService, privacyPolicyService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.privacyPolicyService = privacyPolicyService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    PrivacyPolicyComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var privacySub = this.privacyPolicyService.getPrivacyPolicyData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result information  to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.privacyPolicyId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(privacySub);
    };
    PrivacyPolicyComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    PrivacyPolicyComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.configuration = result.ConfigurationInfo;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.footerData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e;
        }());
        return ChildComponent;
    };
    PrivacyPolicyComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof privacy_policy_service_1.PrivacyPolicyService !== 'undefined' && privacy_policy_service_1.PrivacyPolicyService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PrivacyPolicyComponent);
    return PrivacyPolicyComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PrivacyPolicyComponent = PrivacyPolicyComponent;


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Service
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var purchase_condition_service_1 = __webpack_require__(422);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PurchaseConditionComponent = (function () {
    function PurchaseConditionComponent(_compiler, componentHelper, _elementRef, languageService, purchaseConditionService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.purchaseConditionService = purchaseConditionService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    PurchaseConditionComponent.prototype.ngOnInit = function () {
        var _this = this;
        var templateHtml;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var conditionSub = this.purchaseConditionService.getPurchaseConditionServiceData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.purchaseConditionsId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(conditionSub);
    };
    PurchaseConditionComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    PurchaseConditionComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.configuration = result.ConfigurationInfo;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.footerData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e;
        }());
        return ChildComponent;
    };
    PurchaseConditionComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof purchase_condition_service_1.PurchaseConditionService !== 'undefined' && purchase_condition_service_1.PurchaseConditionService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PurchaseConditionComponent);
    return PurchaseConditionComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PurchaseConditionComponent = PurchaseConditionComponent;


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var seo_service_1 = __webpack_require__(11);
var shopping_cart_service_1 = __webpack_require__(20);
var breadcrumbs_service_1 = __webpack_require__(22);
//Angular
var core_1 = __webpack_require__(0);
var cms_component_service_1 = __webpack_require__(8);
//System
var mapping_1 = __webpack_require__(10);
//Services
var component_helper_service_1 = __webpack_require__(4);
var company_service_1 = __webpack_require__(129);
var routes_service_1 = __webpack_require__(5);
var script_service_1 = __webpack_require__(14);
//Models
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var CartEmptyPageComponent = (function () {
    function CartEmptyPageComponent(_compiler, componentHelper, _elementRef, cartService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cartService = cartService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
    }
    CartEmptyPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var emptyCartSub = this.cartService.getEmptyCartPageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                var EmptyCartData = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(EmptyCartData, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.cartEmptyId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(emptyCartSub);
    };
    CartEmptyPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    CartEmptyPageComponent.prototype.createSubComponent = function (EmptyCartData, header) {
        var ChildComponent = (function () {
            function ChildComponent(companyService, mappings, _elementRef, routesService, scriptService, isBrowser, breadcrumbsService, seoService) {
                this.companyService = companyService;
                this.mappings = mappings;
                this._elementRef = _elementRef;
                this.routesService = routesService;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.breadcrumbsService = breadcrumbsService;
                this.seoService = seoService;
                this.userLoginImg = this.mappings.UserLoginImg_Url;
                this.pageIsInit = false;
                this.seoInfo = EmptyCartData.SeoInformation;
                this.breadcrumbs = EmptyCartData.BreadcrumbsInfo;
                this.footerData = EmptyCartData.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: EmptyCartData.TemplateHtml
                }),
                __param(5, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _f) || Object, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    CartEmptyPageComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, Object, (typeof (_h = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _h) || Object])
    ], CartEmptyPageComponent);
    return CartEmptyPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.CartEmptyPageComponent = CartEmptyPageComponent;


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var cms_component_service_1 = __webpack_require__(8);
//Models
var Subscription_1 = __webpack_require__(2);
var seo_service_1 = __webpack_require__(11);
var platform_browser_1 = __webpack_require__(7);
var NotFoundPageComponent = (function () {
    function NotFoundPageComponent(_compiler, componentHelper, _elementRef, templateService, cmsComponentService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    NotFoundPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var notFoundSub = this.templateService.getComponentTemplatePageNotFound("notfoundPageTemplate").subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        }, 
        //setting 404 page status code
        function (err) {
            if (!_this.isBrowser)
                return;
            //converting response to json
            var response = err.json();
            //Creating subcomponent whith the selected template to inject                
            var subComponent = _this.createSubComponent(response.TemplateHtml, header);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(notFoundSub);
    };
    NotFoundPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    NotFoundPageComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(isBrowser, routesService) {
                this.isBrowser = isBrowser;
                this.routesService = routesService;
                this.pageIsInit = false;
                this.headerClass = false;
                this.footerData = result.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
            };
            ChildComponent.prototype.setAutoHeightAndWeightToLogo = function () {
                this.headerClass = $("div").hasClass("header-logo");
                if (this.headerClass == false) {
                }
                else {
                    $(".header-logo").attr("style", "height:auto!important");
                    $(".header-logo").attr("style", "width:auto!important");
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.setAutoHeightAndWeightToLogo();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result
                }),
                __param(0, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [Boolean, (typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a;
        }());
        return ChildComponent;
    };
    NotFoundPageComponent = __decorate([
        core_1.Component({
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, Object])
    ], NotFoundPageComponent);
    return NotFoundPageComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.NotFoundPageComponent = NotFoundPageComponent;


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var cms_component_service_1 = __webpack_require__(8);
var core_2 = __webpack_require__(27);
var routes_service_1 = __webpack_require__(5);
var Subscription_1 = __webpack_require__(2);
var seo_service_1 = __webpack_require__(11);
var platform_browser_1 = __webpack_require__(7);
var OfflinePageComponent = (function () {
    function OfflinePageComponent(_compiler, componentHelper, _elementRef, cmsComponentService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    OfflinePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var offlinePageData;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var offlineSub = this.cmsComponentService.getOfflinePageData().subscribe(function (result) {
            offlinePageData = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(offlinePageData, header);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(offlineSub);
    };
    OfflinePageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    OfflinePageComponent.prototype.createSubComponent = function (pageData, header) {
        var ChildComponent = (function () {
            function ChildComponent(translateService, routesService, isBrowser) {
                this.translateService = translateService;
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this.company = pageData.Company;
                this.pageIsInit = false;
                this.OfflineMessage = pageData.OfflineMessage;
                this.footerData = pageData.footerData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: pageData.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object, Boolean])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    OfflinePageComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')),
        __param(7, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _f) || Object, Object])
    ], OfflinePageComponent);
    return OfflinePageComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OfflinePageComponent = OfflinePageComponent;


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
//Angular
var core_1 = __webpack_require__(0);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var template_service_1 = __webpack_require__(35);
var router_1 = __webpack_require__(12);
var routes_service_1 = __webpack_require__(5);
var core_2 = __webpack_require__(27);
var seo_service_1 = __webpack_require__(11);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var shopping_cart_service_1 = __webpack_require__(20);
var bootbox_service_1 = __webpack_require__(40);
var cookie_service_1 = __webpack_require__(60);
var api_service_1 = __webpack_require__(13);
var messages_service_1 = __webpack_require__(130);
var mapping_1 = __webpack_require__(10);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var ClientAreaOrderListComponent = (function () {
    function ClientAreaOrderListComponent(_compiler, componentHelper, _elementRef, templateService, authService, router, clientAreaService, cmsComponentService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.authService = authService;
        this.router = router;
        this.clientAreaService = clientAreaService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaOrderListComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.authService.GetData().isAuthenticated || this.authService.GetData().isAuthenticated === undefined) {
            this.router.navigate([""]);
        }
        else {
            var ClientAreaOrderListTemplate_1;
            var userId = this.authService.GetUserId();
            var showAll = "-1";
            var registrationConfirmation = void 0;
            var header_1;
            var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header_1 = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header_1.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            this.subManager.add(headDataSub);
            var orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, showAll, showAll, showAll, showAll).subscribe(function (result) {
                ClientAreaOrderListTemplate_1 = result;
                // Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(ClientAreaOrderListTemplate_1, header_1);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            });
            this.subManager.add(orderListSub);
        }
    };
    ClientAreaOrderListComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ClientAreaOrderListComponent.prototype.createSubComponent = function (ClientAreaOrderListTemplate, header) {
        var ChildComponent = (function () {
            function ChildComponent(cookie, clientAreaService, router, authService, routesService, apiService, messagesService, mappings, cartService, currency, languageService, translateService, bootboxService, isBrowser, seoService, breadcrumbsService, scriptService) {
                this.cookie = cookie;
                this.clientAreaService = clientAreaService;
                this.router = router;
                this.authService = authService;
                this.routesService = routesService;
                this.apiService = apiService;
                this.messagesService = messagesService;
                this.mappings = mappings;
                this.cartService = cartService;
                this.currency = currency;
                this.languageService = languageService;
                this.translateService = translateService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.breadcrumbsService = breadcrumbsService;
                this.scriptService = scriptService;
                this.pageIsInit = false;
                this.rows = [];
                this.rowsRiorder = [];
                this.columns = [];
                this.status = "0";
                this.orderNumber = "";
                this.lang = this.languageService.getLongLang();
                this.shortLang = this.languageService.getShortLang();
                this.modalTitle = "MESSAGES:";
                this.modalBody = "";
                this.numberOfMessages = 0;
                this.bodyMod = [];
                this.isSettedFilter = false;
                this.load = true;
                this.loadReorder = true;
                //checking if invoices and multiple shipment modules are active
                this.multipleShipmentActive = ClientAreaOrderListTemplate.isActiveMultipleShipment;
                this.breadcrumbs = ClientAreaOrderListTemplate.BreadcrumbsInfo;
                //Routes for menu-tabs
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.isActiveInvoicesModule = ClientAreaOrderListTemplate.isActiveInvoicesModule;
                this.isCatalogPrivateActive = ClientAreaOrderListTemplate.isCatalogPrivateActive;
                this.isRiordinaActive = ClientAreaOrderListTemplate.isRiordinaActive;
                this.italianLang = {
                    "sProcessing": "Attendere...",
                    "sLengthMenu": "Visualizza _MENU_ record per pagina",
                    "sZeroRecords": "Niente trovato",
                    "sInfo": "Mostra _START_ a _END_ di _TOTAL_ record",
                    "sInfoEmpty": "Non ci sono record",
                    "sInfoFiltered": "(filtrato da _MAX_ record totali)",
                    "sInfoPostFix": "",
                    "sUrl": "",
                    "oPaginate": {
                        "sPrevious": "«",
                        "sNext": "»"
                    }
                };
                this.englishLang = {
                    "oPaginate": {
                        "sPrevious": "«",
                        "sNext": "»"
                    }
                };
                this.subManager = new Subscription_1.Subscription();
                this.footerData = ClientAreaOrderListTemplate.FooterData;
                this.headerData = header;
            }
            //translating of header columns titles
            ChildComponent.prototype.translateTableColumnTitle = function (columnTitle) {
                var translation = this.translateService.get(columnTitle)["value"];
                return translation;
            };
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.multipleShipmentActive == false && this.isRiordinaActive == false) {
                    this.columns = [
                        { title: '' },
                        { title: this.translateTableColumnTitle("Jobname") },
                        { title: this.translateTableColumnTitle("OrderNumber") },
                        { title: this.translateTableColumnTitle("OrderDate") },
                        { title: this.translateTableColumnTitle("PriceTotalCell") },
                        { title: this.translateTableColumnTitle("Status") },
                        { title: this.translateTableColumnTitle("FileVerification") },
                        { title: this.translateTableColumnTitle("Payment") },
                        { title: this.translateTableColumnTitle("Shipment") },
                        { title: '' },
                        { title: '' },
                    ];
                }
                else if (this.isRiordinaActive == false) {
                    this.columns = [
                        { title: '' },
                        { title: this.translateTableColumnTitle("Jobname") },
                        { title: this.translateTableColumnTitle("OrderNumber") },
                        { title: this.translateTableColumnTitle("OrderDate") },
                        { title: this.translateTableColumnTitle("PriceTotalCell") },
                        { title: this.translateTableColumnTitle("Status") },
                        { title: this.translateTableColumnTitle("FileVerification") },
                        { title: this.translateTableColumnTitle("Payment") },
                        { title: '' },
                        { title: '' },
                    ];
                }
                else {
                    this.columns = [
                        { title: '' },
                        { title: this.translateTableColumnTitle("Jobname") },
                        { title: this.translateTableColumnTitle("OrderNumber") },
                        { title: this.translateTableColumnTitle("OrderDate") },
                        { title: this.translateTableColumnTitle("PriceCell") },
                        { title: this.translateTableColumnTitle("Status") },
                        { title: this.translateTableColumnTitle("FileVerification") },
                        { title: this.translateTableColumnTitle("Payment") },
                        { title: '' },
                        { title: '' },
                        { title: '' },
                    ];
                }
                //getting of Datatable data
                this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;
                this.load = false;
                this.loadReorder = false;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                if (this.shortLang == 'en') {
                    this.currentLang = this.englishLang;
                }
                else {
                    this.currentLang = this.italianLang;
                }
                //initialization of datatable
                $('#datatable').DataTable({
                    searching: false,
                    ordering: false,
                    sDom: 'Rlfrtlip',
                    oLanguage: this.currentLang
                });
                //hiding of first 'per page' section, because we added it on the bottom of the table
                $('.dataTables_length').not(':eq(1)').hide();
                //initialization of datetime picker from and to
                $('#fromDate').datetimepicker({
                    locale: this.shortLang,
                    format: 'DD/MM/YYYY'
                });
                $('#toDate').datetimepicker({
                    locale: this.shortLang,
                    useCurrent: false,
                    format: 'DD/MM/YYYY'
                });
                $("#fromDate").on("dp.change", function (e) {
                    $('#toDate').data("DateTimePicker").minDate(e.date);
                });
                $("#toDate").on("dp.change", function (e) {
                    $('#fromDate').data("DateTimePicker").maxDate(e.date);
                });
                this.pageIsInit = true;
            };
            ChildComponent.prototype.onClick = function (indexRow, columnName) {
                var indexColumn;
                var orderId = this.rows[indexRow].OrderId;
                if (columnName == undefined) {
                    var orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE')[0];
                    orderDetailsPage = orderDetailsPage.replace(':id', orderId.toString());
                    this.router.navigate([orderDetailsPage]);
                }
                else if (columnName == 'Upload') {
                    var loginRoute = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
                    loginRoute = loginRoute.replace(":id", orderId);
                    loginRoute = loginRoute.replace(":pagefrom", "section_upload");
                    this.router.navigate([loginRoute]);
                }
                else if (columnName == 'OrderNotesCell') {
                    var order = this.rows[indexRow];
                    //Reading only the messsages for the selected order
                    this.bodyMod = order.OrderNoteList;
                    this.numberOfMessages = this.bodyMod.length;
                    //The modal is showed only if there are messages
                    if (this.bodyMod.length > 0) {
                        var userId = this.authService.GetUserId();
                        var params = {
                            CustomerId: userId.toString(),
                            OrderId: orderId.toString(),
                            Lang: this.lang
                        };
                        //setting messages as read
                        var messReadSub = this.messagesService.setMessagesAsRead(params)
                            .subscribe(function (result) { });
                        this.subManager.add(messReadSub);
                        this.showModal();
                        //reseting of value of OrderNoteList
                        order.OrderNoteList = [];
                    }
                }
                else if (columnName == "Reorder") {
                    var orderId_1 = this.rows[indexRow].OrderId;
                    this.getRiOrdersList(orderId_1);
                }
            };
            ChildComponent.prototype.messagesDetails = function (orderId) {
                $("#messagesModal").modal("hide");
                var id = orderId;
                var orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
                orderDetailsPage = orderDetailsPage.replace(':id', id.toString()).replace(':pagefrom', "section_comunicazioni");
                this.router.navigate([orderDetailsPage]);
                return true;
            };
            ChildComponent.prototype.showModal = function () {
                $("#messagesModal").modal("show");
            };
            ChildComponent.prototype.hideModal = function () {
                $('#basic').modal('hide');
                this.bodyMod = [];
            };
            ChildComponent.prototype.getOrdersList = function (userId, dateFrom, dateTo, orderNumber, orderStatus) {
                var _this = this;
                this.load = true;
                var orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, dateFrom, dateTo, orderNumber, orderStatus)
                    .subscribe(function (result) {
                    _this.rows = result.ClientAreaOrderList;
                    _this.load = false;
                    _this.resetTable(_this.rows);
                });
                this.subManager.add(orderListSub);
            };
            //destroying of current context of table and creating a new one with new data
            ChildComponent.prototype.resetTable = function (tableData) {
                $('#datatable').DataTable().destroy();
                var currentLang = this.currentLang;
                setTimeout(function () {
                    $('#datatable').DataTable({
                        data: this.rows,
                        searching: false,
                        ordering: false,
                        sDom: 'Rlfrtlip',
                        oLanguage: currentLang
                    });
                }, 0);
                setTimeout(function () { $('.dataTables_length').not(':eq(1)').hide(); }, 0);
            };
            ChildComponent.prototype.resetFilter = function () {
                this.from = "";
                this.to = "";
                $('#fromDate').val("");
                $('#toDate').val("");
                this.status = "0";
                this.orderNumber = "";
                if (this.isSettedFilter == true) {
                    this.isSettedFilter = false;
                    //this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;
                    var userId = this.authService.GetUserId();
                    var showAll = "-1";
                    this.getOrdersList(userId, showAll, showAll, showAll, showAll);
                }
            };
            ChildComponent.prototype.filterOrdersList = function () {
                this.isSettedFilter = true;
                var orderStatus;
                var numberOfOrder;
                var userId = this.authService.GetUserId();
                this.from = $('#fromDate').val();
                this.to = $('#toDate').val();
                var dateFrom = this.changeDate(this.from);
                var dateTo = this.changeDate(this.to);
                if (dateFrom == "") {
                    dateFrom = "-1";
                }
                if (dateTo == "") {
                    dateTo = "-1";
                }
                if (dateFrom == "Invalid date" || null) {
                    dateFrom = "-1";
                }
                if (dateTo == "Invalid date" || null) {
                    dateTo = "-1";
                }
                if (this.status == "0") {
                    orderStatus = "-1";
                }
                else {
                    orderStatus = this.status;
                }
                if (this.orderNumber == "") {
                    numberOfOrder = "-1";
                }
                else {
                    numberOfOrder = this.orderNumber;
                }
                ;
                this.getOrdersList(userId, dateFrom, dateTo, numberOfOrder, orderStatus);
            };
            ChildComponent.prototype.changeDate = function (stringDate) {
                var date = stringDate.replace(/\//g, "-");
                return date;
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.showModalRiordina = function (orderId) {
                this.getRiOrdersList(orderId);
            };
            ChildComponent.prototype.hideModalRiordina = function () {
                $("#ReorderModal").modal("hide");
            };
            ChildComponent.prototype.resetTableReorder = function () {
                var currentLang = this.currentLang;
                $("#ReorderModal").modal("show");
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
            };
            ChildComponent.prototype.riordina = function () {
                var _this = this;
                //let valueReorderList: Array<{ QuantityID: number, ProductID: number, tipoCalcolo: string, DateID: number, tipoProdotto: string, CustomerID: string, CartID: string, Language: string, Currency: string }> = [];
                var valueReorderList = [];
                //this.cartService.setCartId(cart.CartId)
                var selectedCount = $('input[name="selectAllItems"]:checked').length;
                var selectedCountCheck = 0;
                var stringInputCheck = "";
                if (selectedCount > 0) {
                    var CustomerID = this.cartService.getCustomerId();
                    var CartID = this.cartService.getCartId();
                    var Language = this.cartService.getLang();
                    var Currency = this.currency.getCurrency();
                    $('.disableInputReorder').attr('disabled', true);
                    this.loadReorder = true;
                    $('input[name="selectAllItems"]:checked').each(function (index, element) {
                        var id = parseInt(element.id.replace("check_", ""));
                        stringInputCheck = 'input[name="priceresult_' + id + '"]:checked';
                        $(stringInputCheck).each(function (index, elementcheck) {
                            var ProductID = parseInt($(elementcheck).attr("prodId"));
                            var QuantityID = parseInt($(elementcheck).attr("rowidcalcolo"));
                            var LavID = $(elementcheck).attr("rowidcalcolo");
                            var tipoCalcolo = $(elementcheck).attr("tipocalcolo");
                            var DateID = parseInt($(elementcheck).attr("idDay"));
                            var tipoProdotto = $(elementcheck).attr("tipoprodotto");
                            valueReorderList.push({ CartID: CartID, CustomerID: CustomerID, Language: Language, ProductID: ProductID, LavID: LavID, DateID: DateID, Currency: Currency, tipoProdotto: tipoProdotto, tipoCalcolo: tipoCalcolo });
                        });
                    });
                    var lenghtReorderList = valueReorderList.length;
                    if (lenghtReorderList > 0) {
                        var riorderListSub = this.cartService.addProductRiorderToCart(valueReorderList)
                            .subscribe(function (result) {
                            _this.cartService.updateCart(result);
                            _this.hideModalRiordina();
                            $('.disableInputReorder').removeAttr('disabled');
                            _this.bootboxService.i18nAlert("productAddedToCart");
                            _this.loadReorder = false;
                        }, function (err) {
                            $('.disableInputReorder').removeAttr('disabled');
                            _this.bootboxService.i18nAlert("errorMex");
                            _this.loadReorder = false;
                        });
                        this.subManager.add(riorderListSub);
                    }
                    else {
                        this.bootboxService.alertForRiorderFail("reorder_seleziona_almeno_una_qta");
                        $('.disableInputReorder').removeAttr('disabled');
                        this.loadReorder = false;
                    }
                }
                else {
                    this.bootboxService.alertForRiorderFail("reorder_seleziona_almeno_una_riga");
                }
            };
            ChildComponent.prototype.getRiOrdersList = function (orderId) {
                var _this = this;
                this.loadReorder = true;
                var riorderListSub = this.clientAreaService.getClientAreaRiorderList(orderId)
                    .subscribe(function (result) {
                    _this.rowsRiorder = result;
                    _this.loadReorder = false;
                    //initialization of datatable
                    _this.resetTableReorder();
                });
                this.subManager.add(riorderListSub);
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translateService.get(label, this.translateService).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.calculatePrice = function (idRow, index) {
                var _this = this;
                var qta = $('#riga_' + idRow).val();
                var riga = this.rowsRiorder[index];
                if (riga != null && qta > 0) {
                    this.loadReorder = true;
                    $('.disableInputReorder').attr('disabled', true);
                    var newQta = "&NumCopie=" + qta + "&";
                    var newQtaOther = "&str_qt=" + qta + "&";
                    var OldQta = "&NumCopie=" + riga.Quantity + "&";
                    var OldQtaOther = "&str_qt=" + riga.Quantity + "&";
                    var queryLavorazione2 = riga.LavorazioneQuery.replace(OldQta, newQta);
                    var queryLavorazione3 = queryLavorazione2.replace(OldQtaOther, newQtaOther);
                    var substring = queryLavorazione3.indexOf("&Datetime");
                    var queryLavorazione = queryLavorazione3.slice(0, substring);
                    queryLavorazione += "&orderid=" + riga.OrderId;
                    queryLavorazione += "&orderlavid=" + riga.IdRow;
                    if (queryLavorazione.indexOf("sezione=") != -1) {
                        var riorderListSub = this.clientAreaService.CalculatePriceRiorder(queryLavorazione, riga.ProdId)
                            .subscribe(function (result) {
                            //console.log(result)
                            switch (result.resultType) {
                                case "calcolato_wizard_scontistica":
                                    _this.showPriceCalcolatoScontistica(idRow, result.TablePriceList, result.resultType, riga.ProdId, result.RowId, riga.TipoProdotto);
                                    break;
                                case "calcolato_wizard":
                                case "calcolato_wizard_altro_prodotto":
                                    _this.showPriceCalcolato(idRow, result, result.resultType, riga.ProdId, result.RowId);
                                    break;
                            }
                            //this.rowsRiorder = result;
                            _this.loadReorder = false;
                        });
                        this.subManager.add(riorderListSub);
                        var getRiorderCart = this.cartService.getRiorderCart()
                            .subscribe(function (cart) {
                            var cartIdOld = _this.cartService.getCartId();
                            if (cartIdOld == "0") {
                                _this.cartService.setCartId(cart.CartID);
                            }
                        });
                        this.subManager.add(getRiorderCart);
                    }
                }
                else {
                    $('#Prezzo_' + idRow).html("");
                }
            };
            ChildComponent.prototype.showPriceCalcolatoScontistica = function (idRow, result, type, prodId, rowIdCalcolo, rowTipoProdotto) {
                $('#Prezzo_' + idRow).html("");
                var html = "";
                var resultFiltered = result.filter(function (x) { return x.Price != -1; });
                var lenghtRes = resultFiltered.length - 1;
                resultFiltered.forEach(function (price, index) {
                    if (price.Price != -1) {
                        html += "<div>";
                        if (lenghtRes == index) {
                            html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "_" + price.QuantityId + "\" value=\"0\"  tipoprodotto=\"" + rowTipoProdotto + "\" tipocalcolo=\"" + type + "\"  prodId=\"" + prodId + "\" rowidcalcolo=\"" + rowIdCalcolo + "\"  idDay=\"" + price.QuantityId + "\" required checked>";
                        }
                        else {
                            html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "_" + price.QuantityId + "\" value=\"0\"  tipoprodotto=\"" + rowTipoProdotto + "\" tipocalcolo=\"" + type + "\"  rowidcalcolo=\"" + rowIdCalcolo + "\" prodId=\"" + prodId + "\" idDay=\"" + price.QuantityId + "\" required>";
                        }
                        html += "<label class=\"riordinaLabel\" for=\"" + rowIdCalcolo + "_" + price.QuantityId + "\">" + price.DayName + " " + price.DayNumber + " - " + price.Currency + " " + price.StrPrice + "</label>";
                        html += "</div>";
                    }
                });
                $('#Prezzo_' + idRow).html(html);
                $('.disableInputReorder').removeAttr('disabled');
            };
            ChildComponent.prototype.showPriceCalcolato = function (idRow, price, type, prodId, rowIdCalcolo) {
                $('#Prezzo_' + idRow).html("");
                var html = "";
                html += "<div>";
                html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "\" value=\"0\"  tipocalcolo=\"" + type + "\"  rowidcalcolo=\"" + rowIdCalcolo + "\" prodId=\"" + prodId + "\" checked required>";
                html += "<label class=\"riordinaLabel\" for=\"" + rowIdCalcolo + "\">" + price.Currency + " " + price.Imponibile + "</label>";
                html += "</div>";
                $('#Prezzo_' + idRow).html(html);
                $('.disableInputReorder').removeAttr('disabled');
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            __decorate([
                core_1.Input(), 
                __metadata('design:type', Object)
            ], ChildComponent.prototype, "clientModel", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: ClientAreaOrderListTemplate.TemplateHtml
                }),
                __param(0, core_1.Inject('CookieService')),
                __param(13, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _a) || Object, (typeof (_b = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _f) || Object, (typeof (_g = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _g) || Object, (typeof (_h = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _h) || Object, (typeof (_j = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _j) || Object, (typeof (_k = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _k) || Object, (typeof (_l = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _l) || Object, (typeof (_m = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _m) || Object, (typeof (_o = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _o) || Object, Boolean, (typeof (_p = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _p) || Object, (typeof (_q = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _q) || Object, (typeof (_r = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _r) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        }());
        return ChildComponent;
    };
    ClientAreaOrderListComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object])
    ], ClientAreaOrderListComponent);
    return ClientAreaOrderListComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.ClientAreaOrderListComponent = ClientAreaOrderListComponent;


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Models
var inventory_1 = __webpack_require__(254);
//Services
var category_service_1 = __webpack_require__(262);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var shopping_cart_service_1 = __webpack_require__(20);
var bootbox_service_1 = __webpack_require__(40);
var seo_service_1 = __webpack_require__(11);
var routes_service_1 = __webpack_require__(5);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var breadcrumbs_service_1 = __webpack_require__(22);
var platform_browser_1 = __webpack_require__(7);
var cms_component_service_1 = __webpack_require__(8);
var currency_service_1 = __webpack_require__(29);
var CategoryComponent = (function () {
    function CategoryComponent(_compiler, _elementRef, componentHelper, categoryService, languageService, route, router, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this._elementRef = _elementRef;
        this.componentHelper = componentHelper;
        this.categoryService = categoryService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.category = new inventory_1.Category();
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    CategoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var lang = this.languageService.getLongLang();
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        var paramSub = this.route.params.subscribe(function (params) {
            var id = params['id'];
            if (id !== undefined) {
                var categoryId_1 = id;
                var catIdSub = _this.categoryService.getCategory(categoryId_1, lang).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetCategorySuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogCategory, categoryId_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(catIdSub);
            }
            else {
                var seoUrl = _this.router.url;
                var catUrlSub = _this.categoryService.getCategoryByUrl(lang, seoUrl).subscribe(function (result) {
                    if (_this.isBrowser) {
                        _this.onGetCategorySuccess(result, header);
                    }
                    else {
                        if (result.SeoInformation) {
                            result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                            result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                        }
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogCategory, result.Id);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(catUrlSub);
            }
        });
        this.subManager.add(paramSub);
    };
    CategoryComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    CategoryComponent.prototype.onGetCategorySuccess = function (categoryResult, header) {
        if (categoryResult.Active != true) {
            //Creating sub-component with the returned information
            var subComponent = this.createSubComponentRedirect();
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            //Creating sub-component with the returned information
            var subComponent = this.createSubComponent(categoryResult, header);
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    };
    CategoryComponent.prototype.createSubComponentRedirect = function () {
        var ChildComponent = (function () {
            function ChildComponent(router, routesService) {
                this.router = router;
                this.routesService = routesService;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var notFoundPage = this.routesService.getRoutePath('NOT - FOUND');
                this.router.navigate(notFoundPage);
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: ""
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    CategoryComponent.prototype.createSubComponent = function (categoryObj, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, cartService, bootboxService, routesService, isBrowser, scriptService, _elementRef, helperService, currency, categoryService, languageService, breadcrumbsService) {
                this.seoService = seoService;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this._elementRef = _elementRef;
                this.helperService = helperService;
                this.currency = currency;
                this.categoryService = categoryService;
                this.languageService = languageService;
                this.breadcrumbsService = breadcrumbsService;
                this.category = categoryObj;
                this.categories = categoryObj.SubCategories;
                this.products = categoryObj.SubProducts;
                this.prodottiCorrelati = categoryObj.ProductCorrelati;
                this.showProdottiCorrelati = false;
                this.headerData = header;
                this.footerData = categoryObj.footerData;
                this.loginPageName = [];
                this.registerPageName = [];
                this.pageIsInit = false;
                this.seoInfo = categoryObj.SeoInformation;
                this.spinnerForm = false;
                this.contactFormSent = false;
                this.contactFormFailed = false;
                this.showSpinner = true;
                this.showTable = true;
                this.model = {
                    Company: "",
                    Name: "",
                    Lastname: "",
                    Email: "",
                    Amount: "",
                    Mobile: "",
                    Message: "",
                    Lang: "",
                    options: 0
                };
                this.lang = this.languageService.getLongLang();
                this.breadcrumbs = [];
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = categoryObj.BreadcrumbsInfo;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.loginPageName = this.routesService.getRoutePath('LOGIN');
                this.registerPageName = this.routesService.getRoutePath('REGISTRAZIONE');
                if (this.prodottiCorrelati.length > 0) {
                    this.showProdottiCorrelati = true;
                }
                this.configuration = categoryObj.Configuration;
                if (this.isBrowser == true) {
                    //if type of category is matrix, get prices
                    if (categoryObj.TipoVisualizzazione == "matrice") {
                        var catPriceSub = this.categoryService.getCategoryPriceData(categoryObj.Id)
                            .subscribe(function (result) {
                            _this.category.PriceData = result;
                            _this.showSpinner = false;
                        });
                        this.subManager.add(catPriceSub);
                    }
                }
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.contactFormSent = false;
                this.contactFormFailed = false;
                this.spinnerForm = true;
                this.model.Lang = this.languageService.getLongLang();
                if (form.valid && this.model.options == 1) {
                    this.model.Amount = this.model.Amount.toString();
                    var catInfoSub = this.categoryService.getCategoryInfo(this.model)
                        .subscribe(function (result) {
                        if (result == true) {
                            _this.spinnerForm = false;
                            _this.contactFormSent = true;
                        }
                        else {
                            _this.spinnerForm = false;
                            _this.contactFormFailed = true;
                        }
                    });
                    this.subManager.add(catInfoSub);
                }
                else {
                    this.spinnerForm = false;
                }
            };
            ChildComponent.prototype.showedFileBoxWizard = function () {
                var result = true;
                if (this.category.IdWizardMaster <= 0) {
                    result = false;
                }
                else {
                    if (this.category.ManageAttachmentWizard == "Combinazioni") {
                        result = false;
                    }
                }
                return result;
            };
            ChildComponent.prototype.addMatrixCommercialeProductToCart = function (productId, quantityId, IsHour) {
                var _this = this;
                var addToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "altro", IsHour).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(addToCartSub);
            };
            ChildComponent.prototype.addMatrixEditoriaProductToCart = function (productId, quantityId, IsHour) {
                var _this = this;
                var addMatEdToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "editoria", IsHour).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(addMatEdToCartSub);
            };
            ChildComponent.prototype.addMatrixProductToCart = function (productId, quantityId, IsHour) {
                var _this = this;
                var addMatToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "altro", IsHour).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(addMatToCartSub);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                layoutTheme.initCarousel();
                layoutTheme.initLightbox();
                setTimeout(function (x) { return layoutTheme.initThumbGallery(); }, 1);
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                if (this.seoInfo.H3.includes("<iframe")) {
                    $('#containerVideo').html(this.seoInfo.H3);
                }
                this.pageIsInit = true;
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: categoryObj.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _b) || Object, (typeof (_c = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _f) || Object, (typeof (_g = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _g) || Object, (typeof (_h = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _h) || Object, (typeof (_j = typeof category_service_1.CategoryService !== 'undefined' && category_service_1.CategoryService) === 'function' && _j) || Object, (typeof (_k = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _k) || Object, (typeof (_l = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _l) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        }());
        return ChildComponent;
    };
    CategoryComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _c) || Object, (typeof (_d = typeof category_service_1.CategoryService !== 'undefined' && category_service_1.CategoryService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
    ], CategoryComponent);
    return CategoryComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.CategoryComponent = CategoryComponent;


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var breadcrumbs_service_1 = __webpack_require__(22);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var product_service_1 = __webpack_require__(132);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var routes_service_1 = __webpack_require__(5);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var cms_component_service_1 = __webpack_require__(8);
//Models
var inventory_1 = __webpack_require__(254);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var OtherProductComponent = (function () {
    function OtherProductComponent(_compiler, componentHelper, _elementRef, productService, languageService, route, router, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.productService = productService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.product = new inventory_1.Product();
        this.subManager = new Subscription_1.Subscription();
    }
    OtherProductComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var lang = this.languageService.getLongLang();
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        var paramsSub = this.route.params.subscribe(function (params) {
            var id = params['id'];
            if (id !== undefined) {
                var productId_1 = id;
                var productByIdSub = _this.productService.getProductDetails(productId_1, "altroProdotto", lang).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetProductSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogOtherProduct, productId_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.Thumbnail);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(productByIdSub);
            }
            else {
                var url = _this.router.url;
                var productByUrlSub = _this.productService.getProductDetailsBySeoUrl(lang, url).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetProductSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogOtherProduct, result.Id);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.Thumbnail);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(productByUrlSub);
            }
        });
        this.subManager.add(paramsSub);
    };
    OtherProductComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    OtherProductComponent.prototype.onGetProductSuccess = function (productResult, header) {
        if (productResult.Active != true) {
            //Creating sub-component with the returned information
            var subComponent = this.createSubComponentRedirect();
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            var subComponent = this.createSubComponent(productResult, header);
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    };
    OtherProductComponent.prototype.createSubComponentRedirect = function () {
        var ChildComponent = (function () {
            function ChildComponent(router, routesService) {
                this.router = router;
                this.routesService = routesService;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var notFoundPage = this.routesService.getRoutePath('NOT - FOUND');
                this.router.navigate(notFoundPage);
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: ""
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    OtherProductComponent.prototype.createSubComponent = function (otherproductObj, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, routesService, isBrowser, _elementRef, scriptService, currency, helperService, breadcrumbsService) {
                this.seoService = seoService;
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.currency = currency;
                this.helperService = helperService;
                this.breadcrumbsService = breadcrumbsService;
                this.product = otherproductObj;
                this.seoInfo = otherproductObj.SeoInformation;
                this.loginPageName = [];
                this.registerPageName = [];
                this.pageIsInit = false;
                this.breadcrumbs = [];
                this.prodottiCorrelati = otherproductObj.ProductCorrelati;
                this.showProdottiCorrelati = false;
                this.footerData = otherproductObj.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = otherproductObj.BreadcrumbsInfo;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.prodottiCorrelati.length > 0) {
                    this.showProdottiCorrelati = true;
                }
                this.loginPageName = this.routesService.getRoutePath('LOGIN');
                this.registerPageName = this.routesService.getRoutePath('REGISTRAZIONE');
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.shareOnFacebook = function () {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            };
            ChildComponent.prototype.shareOnTwitter = function () {
                window.open('https://twitter.com/intent/tweet?&url=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            };
            ChildComponent.prototype.showedFileBox = function () {
                var result = true;
                if (this.product.ManageAttachment == "Combinazioni") {
                    result = false;
                }
                return result;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                layoutTheme.initCarousel();
                layoutTheme.initLightbox();
                setTimeout(function (x) { return layoutTheme.initThumbGallery(); }, 1);
                if (this.seoInfo.H3.includes("<iframe")) {
                    $('#containerVideo').html(this.seoInfo.H3);
                }
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: otherproductObj.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, (typeof (_e = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _e) || Object, (typeof (_f = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _f) || Object, (typeof (_g = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    OtherProductComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof product_service_1.ProductService !== 'undefined' && product_service_1.ProductService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
    ], OtherProductComponent);
    return OtherProductComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.OtherProductComponent = OtherProductComponent;


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var angular2_meta_1 = __webpack_require__(99);
var core_1 = __webpack_require__(0);
//Angular
var core_2 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var product_service_1 = __webpack_require__(132);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var shopping_cart_service_1 = __webpack_require__(20);
var bootbox_service_1 = __webpack_require__(40);
var routes_service_1 = __webpack_require__(5);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
//Models
var inventory_1 = __webpack_require__(254);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var ProductDetailsComponent = (function () {
    function ProductDetailsComponent(_elementRef, _compiler, componentHelper, productService, languageService, route, router, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._elementRef = _elementRef;
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this.productService = productService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.product = new inventory_1.Product();
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    ProductDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Reading Language information
        var lang = this.languageService.getLongLang();
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        var paramsSub = this.route.params.subscribe(function (params) {
            var id = params['id'];
            if (id !== undefined) {
                var productId_1 = id;
                var prodByIdSub = _this.productService.getProductDetails(productId_1, "prodotti", lang).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetProductSuccess(result, id, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogProduct, productId_1);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.Thumbnail);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(prodByIdSub);
            }
            else {
                var seoUrl = _this.router.url;
                var prodByUrlSub = _this.productService.getProductDetailsBySeoUrl(lang, seoUrl).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        _this.onGetProductSuccess(result, id, header);
                    }
                    else {
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeCatalogProduct, result.Id);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation, result.Thumbnail);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(prodByUrlSub);
            }
        });
        this.subManager.add(paramsSub);
    };
    ProductDetailsComponent.prototype.ngOnDestroy = function () {
        this.subManager.unsubscribe();
    };
    ProductDetailsComponent.prototype.onGetProductSuccess = function (productDetails, productId, header) {
        if (productDetails.Active != true || productDetails.isProductPrivateActiveAndShow != true) {
            //Creating sub-component with the returned information
            var subComponent = this.createSubComponentRedirect();
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            var subComponent = this.createSubComponent(productDetails, productId, header);
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    };
    ProductDetailsComponent.prototype.createSubComponentRedirect = function () {
        var ChildComponent = (function () {
            function ChildComponent(router, routesService) {
                this.router = router;
                this.routesService = routesService;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var notFoundPage = this.routesService.getRoutePath('NOT - FOUND');
                this.router.navigate(notFoundPage);
            };
            ChildComponent = __decorate([
                core_2.Component({
                    template: ""
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    ProductDetailsComponent.prototype.createSubComponent = function (productObj, productId, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, cartService, bootboxService, routesService, isBrowser, _elementRef, scriptService, currency, helperService, productService, languageService, breadcrumbsService, metaService) {
                this.seoService = seoService;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.currency = currency;
                this.helperService = helperService;
                this.productService = productService;
                this.languageService = languageService;
                this.breadcrumbsService = breadcrumbsService;
                this.metaService = metaService;
                this.showSpinner = true;
                this.showSpinnerClick = false;
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.product = new inventory_1.Product();
                this.loginPageName = [];
                this.registerPageName = [];
                this.facebookShareUrl = "";
                this.pageIsInit = false;
                this.seoInfo = productObj.SeoInformation;
                this.breadcrumbs = [];
                this.prodottiCorrelati = productObj.ProductCorrelati;
                this.showProdottiCorrelati = false;
                this.footerData = productObj.FooterData;
                this.headerData = header;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = productObj.BreadcrumbsInfo;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                var lang = this.languageService.getLongLang();
                this.product = productObj;
                if (this.prodottiCorrelati.length > 0) {
                    this.showProdottiCorrelati = true;
                }
                // this.product.HeaderData = header;
                if (this.isBrowser) {
                    if (!this.product.IsWizard) {
                        var productId_2 = this.product.Id;
                        var pricesSub = this.productService.getPriceData(productId_2, lang).subscribe(function (response) {
                            _this.product.PriceData = response;
                            _this.showSpinner = false;
                        });
                        this.subManager.add(pricesSub);
                    }
                }
                //console.log(this.product)
                this.loginPageName = this.routesService.getRoutePath('LOGIN');
                this.registerPageName = this.routesService.getRoutePath('REGISTRAZIONE');
            };
            ChildComponent.prototype.showedFileBox = function () {
                var result = true;
                if (this.product.ManageAttachment == "Combinazioni") {
                    result = false;
                }
                return result;
            };
            ChildComponent.prototype.shareOnFacebook = function () {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            };
            ChildComponent.prototype.shareOnTwitter = function () {
                window.open('https://twitter.com/intent/tweet?&url=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            };
            ChildComponent.prototype.addStaticProductToCart = function (quantityId) {
                var _this = this;
                var productId = this.product.Id;
                this.showSpinnerClick = true;
                var staticProdSub = this.cartService.addStaticProductToCart(productId, quantityId, "D").subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.showSpinnerClick = false;
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(staticProdSub);
            };
            ChildComponent.prototype.addStaticProductScontisticaToCart = function (dayId, quantityId, isHour) {
                var _this = this;
                var productId = this.product.Id;
                this.showSpinnerClick = true;
                var colType = isHour == true ? "H" : "D";
                var statProdScontSub = this.cartService.addStaticProductScontisticaToCart(productId, quantityId, dayId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.showSpinnerClick = false;
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(statProdScontSub);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isPriceDiscounted = function (price, priceDiscounted) {
                var priceInt = parseFloat(price);
                var priceDiscountedInt = parseFloat(priceDiscounted);
                var result = false;
                if (priceDiscountedInt < priceInt) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                layoutTheme.initCarousel();
                layoutTheme.initLightbox();
                setTimeout(function (x) { return layoutTheme.initThumbGallery(); }, 1);
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                if (this.seoInfo.H3.includes("<iframe")) {
                    $('#containerVideo').html(this.seoInfo.H3);
                }
                this.pageIsInit = true;
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_2.Component({
                    template: productObj.TemplateHtml
                }),
                __param(4, core_2.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _b) || Object, (typeof (_c = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof core_2.ViewContainerRef !== 'undefined' && core_2.ViewContainerRef) === 'function' && _e) || Object, (typeof (_f = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _f) || Object, (typeof (_g = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _g) || Object, (typeof (_h = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _h) || Object, (typeof (_j = typeof product_service_1.ProductService !== 'undefined' && product_service_1.ProductService) === 'function' && _j) || Object, (typeof (_k = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _k) || Object, (typeof (_l = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _l) || Object, (typeof (_m = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _m) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        }());
        return ChildComponent;
    };
    ProductDetailsComponent = __decorate([
        core_2.Component({
            changeDetection: core_2.ChangeDetectionStrategy.Default,
            encapsulation: core_2.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_2.Inject('isBrowser')),
        __param(11, core_2.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_2.ViewContainerRef !== 'undefined' && core_2.ViewContainerRef) === 'function' && _a) || Object, (typeof (_b = typeof core_2.Compiler !== 'undefined' && core_2.Compiler) === 'function' && _b) || Object, (typeof (_c = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _c) || Object, (typeof (_d = typeof product_service_1.ProductService !== 'undefined' && product_service_1.ProductService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
    ], ProductDetailsComponent);
    return ProductDetailsComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.ProductDetailsComponent = ProductDetailsComponent;


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var category_service_1 = __webpack_require__(262);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var ProductPageListComponent = (function () {
    function ProductPageListComponent(_compiler, componentHelper, _elementRef, categoryService, languageService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.categoryService = categoryService;
        this.languageService = languageService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    ProductPageListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var categoriesSub = this.categoryService.getCatalogCategoriesData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the catalog catgories information to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.productsCatalogId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(categoriesSub);
    };
    ProductPageListComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ProductPageListComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, isBrowser, _elementRef, scriptService, helperService, routesService, currency, breadcrumbsService) {
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.routesService = routesService;
                this.currency = currency;
                this.breadcrumbsService = breadcrumbsService;
                this.columns = 4;
                this.pageIsInit = false;
                this.seoInfo = result.SeoInformation;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.category == null) {
                    this.items = result.CatalogCategories;
                }
                else {
                    this.items = this.category.SubCategories;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(1, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _f) || Object, (typeof (_g = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    ProductPageListComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof category_service_1.CategoryService !== 'undefined' && category_service_1.CategoryService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], ProductPageListComponent);
    return ProductPageListComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.ProductPageListComponent = ProductPageListComponent;


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var language_service_1 = __webpack_require__(3);
var product_service_1 = __webpack_require__(132);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var PromotionsComponent = (function () {
    function PromotionsComponent(_compiler, componentHelper, _elementRef, productService, languageService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.productService = productService;
        this.languageService = languageService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    PromotionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var promotionsSub = this.productService.getProductsPromotionsData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the promotion page information to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.promotionsId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(promotionsSub);
    };
    PromotionsComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, isBrowser, _elementRef, scriptService, helperService, currency, routesService, breadcrumbsService) {
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.helperService = helperService;
                this.currency = currency;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.footerData = result.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.category == null) {
                    //Reading data from server
                    this.items = result.ProductPromotionList;
                }
                else {
                    this.items = this.category.SubProducts;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.imageTitle = function (imgPath) {
                var imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(1, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof helper_service_1.HelperService !== 'undefined' && helper_service_1.HelperService) === 'function' && _d) || Object, (typeof (_e = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    PromotionsComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof product_service_1.ProductService !== 'undefined' && product_service_1.ProductService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PromotionsComponent);
    return PromotionsComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PromotionsComponent = PromotionsComponent;


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var component_helper_service_1 = __webpack_require__(4);
var shopping_cart_service_1 = __webpack_require__(20);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var client_area_service_1 = __webpack_require__(62);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var bootbox_service_1 = __webpack_require__(40);
var script_service_1 = __webpack_require__(14);
var breadcrumbs_service_1 = __webpack_require__(22);
var cart_1 = __webpack_require__(178);
var cart_2 = __webpack_require__(178);
var cart_3 = __webpack_require__(178);
var validation_service_1 = __webpack_require__(131);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var CartCashComponent = (function () {
    function CartCashComponent(_compiler, componentHelper, _elementRef, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
    }
    CartCashComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var cmsSub = this.cmsComponentService.getShoppingCartCashData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.cartCashId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(cmsSub);
    };
    CartCashComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    CartCashComponent.prototype.createSubComponent = function (shoppingCartCashData, header) {
        var ChildComponent = (function () {
            function ChildComponent(router, shoppingCartService, languageService, authService, clientAreaService, routesService, seoService, bootboxService, isBrowser, _elementRef, scriptService, breadcrumbsService, validationService) {
                this.router = router;
                this.shoppingCartService = shoppingCartService;
                this.languageService = languageService;
                this.authService = authService;
                this.clientAreaService = clientAreaService;
                this.routesService = routesService;
                this.seoService = seoService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.breadcrumbsService = breadcrumbsService;
                this.validationService = validationService;
                this.currentAddress = new cart_3.CartAddressModel();
                this.carrello = shoppingCartCashData.ShoppingCart;
                this.selectedAddress = new cart_3.CartAddressModel();
                this.selectedPayment = new cart_1.CartPaymentModel();
                this.selectedShipment = new cart_2.CartShipmentModel();
                this.voucherCode = "";
                this.showValidationLabels = false;
                this.cartCashAccepted = false;
                this.selectedTipoSpedizione = "";
                this.lang = this.languageService.getLongLang();
                this.isVoucherValid = false;
                this.isVoucherInvalid = false;
                this.isVoucherApplied = false;
                this.disableButtonCart = false;
                this.spinnerCartCash = false;
                this.footerData = shoppingCartCashData.footerData;
                this.headerData = header;
                this.pageIsOnDestroy = false;
                this.seoInfo = shoppingCartCashData.SeoInformation;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.carrelloPageName = [];
                this.userId = this.authService.GetUserId();
                this.configuration = shoppingCartCashData.ConfigurationInfo;
                this.breadcrumbs = shoppingCartCashData.BreadcrumbsInfo;
                this.spinnerCart = false;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                //console.log(shoppingCartCashData)
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.shoppingCartService.initCart(this.carrello);
                if (this.shoppingCartService.isCartValid() == false) {
                    //this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                    window.open(this.routesService.getRoutePath('CARRELLO'), "_self");
                }
                else {
                    this.checkTipoSpedizione();
                    //Reading selected payment method
                    var payments = this.carrello.Payments;
                    var count = payments.length;
                    for (var i = 0; i < count; i++) {
                        var payment = payments[i];
                        if (payment.Selected == true) {
                            this.selectedPayment = payment;
                        }
                    }
                    //Reading selected shipment method
                    var shipments = this.carrello.Shipments;
                    count = shipments.length;
                    for (var i = 0; i < count; i++) {
                        var shipment = shipments[i];
                        if (shipment.Selected == true) {
                            this.selectedShipment = shipment;
                        }
                    }
                    //Reading selected address
                    var address = this.carrello.CurrentAddress;
                    var completeAddress = address.Address;
                    var lastIndex = completeAddress.lastIndexOf(" ");
                    var addressStreet = "";
                    var addressNumber = "";
                    if (lastIndex > -1) {
                        addressStreet = completeAddress.slice(0, lastIndex);
                        addressNumber = completeAddress.slice(lastIndex, completeAddress.length);
                    }
                    if (address != null) {
                        this.currentAddress.Id = address.Id;
                        this.currentAddress.Address = lastIndex > -1 ? addressStreet : address.Address;
                        this.currentAddress.City = address.City;
                        this.currentAddress.Recipient = address.Recipient;
                        this.currentAddress.Province = address.Province;
                        this.currentAddress.Phone = address.Phone;
                        this.currentAddress.ZipCode = address.ZipCode;
                        this.currentAddress.Mobile = address.Mobile;
                        this.currentAddress.CustomerID = this.userId;
                        this.currentAddress.Language = this.lang;
                        this.currentAddress.AddressNumber = lastIndex > -1 ? addressNumber : "";
                    }
                    this.carrelloPageName = this.routesService.getRoutePath('CARRELLO');
                }
            };
            ChildComponent.prototype.checkTipoSpedizione = function () {
                if (this.carrello.Products.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    var tipoSped = this.carrello.Products.filter(function (item, i, arr) { return arr.findIndex(function (t) { return t.TipoTrasporto === item.TipoTrasporto; }) === i; });
                    var TipoTrasportoShipmentToFilter = "S";
                    if (tipoSped.length == 1) {
                        TipoTrasportoShipmentToFilter = tipoSped[0].TipoTrasporto;
                    }
                    if (this.selectedTipoSpedizione == "") {
                        this.selectedTipoSpedizione = TipoTrasportoShipmentToFilter;
                    }
                }
            };
            //validation of phone numbers, disable writing any characters in input except of numbers
            ChildComponent.prototype.validatePhone = function (event) {
                this.validationService.validatePhoneNumber(event);
            };
            //adding all scripts and elements connected to address verification feature                
            ChildComponent.prototype.addAddressVerificationScripts = function (addressKey) {
                var suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                var address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                var jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";
                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            };
            //removing all scripts and elements connected to address verification feature                            
            ChildComponent.prototype.removeAddressVerificationScripts = function (addressKey) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");
                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            };
            ChildComponent.prototype.checkAddressValidation = function () {
                this.currentAddress.Province = $("#Prov").val();
                this.currentAddress.ZipCode = $("#Cap").val();
                this.currentAddress.City = $("#City").val();
            };
            ChildComponent.prototype.setAddressValue = function () {
                var streetTypeId = $("#streetTypeId").val();
                var street = $("#Address").val();
                this.currentAddress.Address = street;
                if (streetTypeId != null && streetTypeId != "") {
                    if (!this.currentAddress.Address.startsWith(streetTypeId)) {
                        this.currentAddress.Address = streetTypeId + " " + street;
                    }
                }
                else {
                    this.currentAddress.Address = street;
                }
            };
            ChildComponent.prototype.updateCartAddress = function () {
                var _this = this;
                //concating address street and number
                var model = this.currentAddress;
                var currentStreet = model.Address;
                model.Address = this.currentAddress.Address.trim() + " " + this.currentAddress.AddressNumber.replace(/\s/g, "");
                var cartSub = this.shoppingCartService.setAddress(model).subscribe(function (result) {
                    _this.shoppingCartService.updateCart(result);
                    _this.carrello = _this.shoppingCartService.getCart();
                    if (result == false) {
                        _this.bootboxService.i18nAlert("errorMex");
                    }
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(cartSub);
                model.Address = currentStreet;
            };
            ChildComponent.prototype.changeAddress = function (addressId) {
                //Reading selected address
                // let addresses = this.carrello.Addresses;
                // let count = addresses.length;
                var _this = this;
                // var addressVal = $('#idSelectedAdress option:selected').text();
                // console.log(addressVal)
                this.carrello.Addresses.filter(function (x) { return x.Id == addressId; }).forEach(function (address) {
                    var completeAddress = address.Address;
                    var lastIndex = completeAddress.lastIndexOf(" ");
                    var addressStreet = "";
                    var addressNumber = "";
                    if (lastIndex > -1) {
                        addressStreet = completeAddress.slice(0, lastIndex);
                        addressNumber = completeAddress.slice(lastIndex, completeAddress.length);
                    }
                    if (address.Id == addressId) {
                        _this.currentAddress.Id = address.Id;
                        _this.currentAddress.Address = lastIndex > -1 ? addressStreet : address.Address;
                        _this.currentAddress.City = address.City;
                        _this.currentAddress.Recipient = address.Recipient;
                        _this.currentAddress.Province = address.Province;
                        _this.currentAddress.Phone = address.Phone;
                        _this.currentAddress.ZipCode = address.ZipCode;
                        _this.currentAddress.Mobile = address.Mobile;
                        _this.currentAddress.CustomerID = _this.userId;
                        _this.currentAddress.Language = _this.lang;
                        _this.currentAddress.AddressNumber = lastIndex > -1 ? addressNumber : "";
                    }
                });
                //concating address street and number to one property "Address"
                var model = this.currentAddress;
                model.Address = this.currentAddress.Address.trim() + " " + this.currentAddress.AddressNumber.replace(/\s/g, "");
                var currentStreet = model.Address;
                var shopCartSub = this.shoppingCartService.setAddress(model).subscribe(function (result) {
                    if (result == null || result == undefined) {
                        _this.bootboxService.i18nAlert("errorMex");
                    }
                    else {
                        _this.shoppingCartService.updateCart(result);
                        _this.carrello = _this.shoppingCartService.getCart();
                    }
                }, function (err) {
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(shopCartSub);
                //reverting address text to previous value after sending request                
                var lastIndex = currentStreet.lastIndexOf(" ");
                var addressStreet = currentStreet;
                if (lastIndex > -1) {
                    addressStreet = currentStreet.slice(0, lastIndex);
                }
                model.Address = addressStreet;
            };
            ;
            ChildComponent.prototype.setJobName = function (rowId, jobName) {
                var _this = this;
                if (jobName != "") {
                    var jobNameSub = this.shoppingCartService.setJobName(rowId, jobName).subscribe(function (result) {
                        if (result == false) {
                            _this.bootboxService.i18nAlert("errorMex");
                        }
                    }, function (err) {
                        _this.bootboxService.i18nAlert("errorMex");
                    });
                    this.subManager.add(jobNameSub);
                }
            };
            ChildComponent.prototype.applyVoucher = function (coupon) {
                var _this = this;
                if (this.voucherCode != null && this.voucherCode.trim().length > 0) {
                    this.spinnerCartCash = true;
                    var voucherSub = this.shoppingCartService.applyVoucher(this.voucherCode).subscribe(function (result) {
                        if (result.CartID != null) {
                            _this.shoppingCartService.updateCart(result);
                            _this.carrello = _this.shoppingCartService.getCart();
                            _this.isVoucherValid = true;
                            _this.isVoucherInvalid = false;
                            _this.isVoucherApplied = true;
                            _this.voucherCode = "";
                        }
                        else {
                            _this.isVoucherValid = false;
                            _this.isVoucherInvalid = true;
                        }
                        _this.spinnerCartCash = false;
                    }, function (err) {
                        _this.bootboxService.i18nAlert("errorMex");
                        _this.spinnerCartCash = false;
                    });
                    this.subManager.add(voucherSub);
                }
            };
            ;
            ChildComponent.prototype.showModal = function () {
                this.disableButtonCart = false;
                this.spinnerCartCash = false;
                this.showValidationLabels = true;
                //JobNames
                var validProducts = true;
                var count = this.carrello.Products.length;
                for (var i = 0; i < count; i++) {
                    var product = this.carrello.Products[i];
                    //If one of the jobnames are not set then the validation fails
                    if (product.JobName != null && product.JobName.trim().length == 0) {
                        validProducts = false;
                        break;
                    }
                }
                var validAddress = true;
                if (validProducts == false || this.cartCashAccepted == false || !validAddress) {
                    return;
                }
                $("#cartCashModal").modal("show");
            };
            ChildComponent.prototype.hideModal = function () {
                $('#cartCashModal').modal('hide');
                this.disableButtonCart = false;
            };
            ChildComponent.prototype.confirmOrder = function () {
                var _this = this;
                this.disableButtonCart = true;
                this.spinnerCartCash = true;
                //Checking if all fields are valid
                var confirmOrderSub = this.shoppingCartService.confirmOrder().subscribe(function (result) {
                    if (result > 0) {
                        _this.shoppingCartService.clearCartAfterConfirmation();
                        _this.OrderId = result;
                        _this.hideModal();
                        //Reading link of the page
                        var cartOrderDetailPageUrl = _this.routesService.getRoutePath('CARRELLO ORDINE')[0];
                        //Removing system parameter (id)
                        cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', '');
                        //Adding Order Id parameter
                        cartOrderDetailPageUrl += _this.OrderId;
                        //this.spinnerCartCash = false;
                        //this.router.navigate([cartOrderDetailPageUrl]);
                        window.open(cartOrderDetailPageUrl, "_self");
                    }
                    else {
                        _this.hideModal();
                        _this.spinnerCartCash = false;
                        _this.bootboxService.i18nAlert("errorMex");
                    }
                }, function (err) {
                    _this.hideModal();
                    _this.spinnerCartCash = false;
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(confirmOrderSub);
            };
            ;
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                setTimeout(function () {
                    var altezza = $("#footer").outerHeight();
                    var margintop = parseInt($("#footer").css('margin-top'));
                    var paddingntop = parseInt($("#footer").css('padding-top'));
                    altezza += margintop;
                    altezza += paddingntop;
                    var altezza1 = $(".footerplus").outerHeight() || 0;
                    var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                    var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                    altezza += altezza1;
                    altezza += margintop1;
                    altezza += paddingntop1;
                    var altezzaHead = $(".header-body").outerHeight();
                    var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                    var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                    altezzaHead += margintopHead;
                    altezzaHead += paddingntopHead;
                    $("#resumeCartTotal").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                    $("#resumeCartTotal-sticky-wrapper").height(0);
                    this.pageIsInit = true;
                }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                if (shoppingCartCashData.isActiveAddressVerificationModule) {
                    var addressVerificationKey = shoppingCartCashData.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);
                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }
                this.subManager.unsubscribe();
                //this method is removing all scripts and elements connected to address verification feature
                var addressVerificationKey = shoppingCartCashData.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);
                this.pageIsOnDestroy = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: shoppingCartCashData.TemplateHtml
                }),
                __param(8, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _j) || Object, (typeof (_k = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _k) || Object, (typeof (_l = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _l) || Object, (typeof (_m = typeof validation_service_1.ValidationService !== 'undefined' && validation_service_1.ValidationService) === 'function' && _m) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        }());
        return ChildComponent;
    };
    CartCashComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')),
        __param(7, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _f) || Object, Object, (typeof (_g = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _g) || Object])
    ], CartCashComponent);
    return CartCashComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.CartCashComponent = CartCashComponent;


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var component_helper_service_1 = __webpack_require__(4);
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var breadcrumbs_service_1 = __webpack_require__(22);
var core_2 = __webpack_require__(27);
var md5_1 = __webpack_require__(279);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var paypal_service_1 = __webpack_require__(261);
var mapping_1 = __webpack_require__(10);
var CartSubmittedComponent = (function () {
    function CartSubmittedComponent(_compiler, componentHelper, _elementRef, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
    }
    CartSubmittedComponent.prototype.ngOnInit = function () {
        var _this = this;
        //Depending on the type of the list, a different template is used
        var orderId;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //Reading order id from url
        //If id is set, then the information is retrived by id, else the not found page is showed
        var paramsSub = this.route.params.subscribe(function (params) {
            var templateHtml;
            var id = params['id'];
            if (id !== undefined) {
                orderId = id;
                var cartSub = _this.cmsComponentService.getShoppingCartSubmittedData(orderId).subscribe(function (result) {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    if (_this.isBrowser) {
                        //Creating subcomponent whith the selected template to inject
                        var subComponent = _this.createSubComponent(result, header);
                        //injecting created component (OK)
                        _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                    }
                    else {
                        var scriptId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.cartSubmittedId, orderId);
                        //-- Get head and body scripts
                        _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, scriptId);
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                        _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
                    }
                });
                _this.subManager.add(cartSub);
            }
        });
        this.subManager.add(paramsSub);
    };
    CartSubmittedComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    CartSubmittedComponent.prototype.createSubComponent = function (cartSubmittedData, header) {
        var ChildComponent = (function () {
            function ChildComponent(router, clientAreaService, languageService, authService, routesService, seoService, isBrowser, _elementRef, scriptService, breadcrumbsService, translateService, sanitizer, paypalService, mappings) {
                this.router = router;
                this.clientAreaService = clientAreaService;
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.breadcrumbsService = breadcrumbsService;
                this.translateService = translateService;
                this.sanitizer = sanitizer;
                this.paypalService = paypalService;
                this.mappings = mappings;
                this.footerData = cartSubmittedData.footerData;
                this.headerData = header;
                this.areaClientiName = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.authentication = this.authService.GetData();
                this.clientArea = cartSubmittedData.OrderDetail;
                this.seoInfo = cartSubmittedData.SeoInformation;
                this.pageIsInit = false;
                this.language = this.languageService.getShortLang();
                this.selectedTipoSpedizione = "";
                //cripted orderID with Md5
                this.criptedOrderID = md5_1.Md5.hashStr(this.clientArea.OrderId.toString());
                this.isTipologiaPagamentoBonifico = cartSubmittedData.OrderDetail.isTipologiaPagamentoBonifico ? cartSubmittedData.OrderDetail.isTipologiaPagamentoBonifico : false;
                this.numeroTrnInvalid = false;
                this.numeroCroInvalid = false;
                this.bonificoUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cartSubmittedData.BonificoUploadUrl);
                this.bonificoUploadedFiles = cartSubmittedData.OrderDetail.BonificoUploadedFilesNames;
                this.pageIsAfterViewInit = false;
                this.breadcrumbs = cartSubmittedData.BreadcrumbsInfo;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                //adding http before link because paypal redirection doesn't work without paypal
                this.paymentUrl = this.clientArea.PaymentDoneUrl + this.criptedOrderID;
                //url that the user will be redirected to after paying of order via paypal
                this.paymentCompleteUrl = this.paymentUrl.replace('{lang}', this.language);
                this.clientArea.CurrencyCode = "EUR";
                if (this.clientArea.OrderId == 0) {
                    this.router.navigate(this.routesService.getRoutePath('HOME'));
                }
                this.checkTipoSpedizione();
            };
            ChildComponent.prototype.checkTipoSpedizione = function () {
                if (this.clientArea.ProcessingOrderList.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    var tipoSped = this.clientArea.ProcessingOrderList.filter(function (item, i, arr) { return arr.findIndex(function (t) { return t.TipoTrasporto === item.TipoTrasporto; }) === i; });
                    var TipoTrasportoShipmentToFilter = "S";
                    if (tipoSped.length == 1) {
                        TipoTrasportoShipmentToFilter = tipoSped[0].TipoTrasporto;
                    }
                    if (this.selectedTipoSpedizione == "") {
                        this.selectedTipoSpedizione = TipoTrasportoShipmentToFilter;
                    }
                }
            };
            ChildComponent.prototype.confirmBonificoDetails = function () {
                var _this = this;
                // trim value before sending it to a server
                this.clientArea.BonificoTrn = this.clientArea.BonificoTrn.trim();
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.updateBonificoPaymentDetails(cartSubmittedData.OrderDetail.OrderId, this.clientArea.BonificoCro, this.clientArea.BonificoTrn)
                    .subscribe(function (x) {
                    //hiding of loading panel after we get all data we need
                    _this.routesService.hidePageLoader();
                    _this.hideBonificoModal();
                }, function (err) {
                });
            };
            // validate NumeroTrn input
            ChildComponent.prototype.checkNumeroTrn = function (inputText) {
                inputText = inputText.trim();
                if (inputText.length < 31) {
                    this.numeroTrnInvalid = false;
                }
                else {
                    this.numeroTrnInvalid = true;
                }
            };
            // validate NumeroCro input
            ChildComponent.prototype.checkNumeroCro = function (inputNumber) {
                if (inputNumber < 99999999999) {
                    this.numeroCroInvalid = false;
                }
                else {
                    this.numeroCroInvalid = true;
                }
            };
            // getting uploaded files for this order and showing it inside of bonifico modal
            ChildComponent.prototype.getBonificoUploadedFiles = function () {
                var _this = this;
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.getBonificoUploadedFiles(cartSubmittedData.OrderDetail.OrderId).subscribe(function (x) {
                    _this.bonificoUploadedFiles = x;
                    //hiding of loading panel after we get all data we need
                    _this.routesService.hidePageLoader();
                });
            };
            ChildComponent.prototype.showBonificoModal = function () {
                $("#bonificoModal").modal("show");
            };
            ChildComponent.prototype.hideBonificoModal = function () {
                $("#bonificoModal").modal("hide");
            };
            ChildComponent.prototype.orderDetailsRedirect = function () {
                //Reading link of the page
                var cartOrderDetailPageUrl = this.routesService.getRoutePath('AREA CLIENTI - ORDINE')[0];
                //Removing system parameter (id)
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', '');
                //Adding Order Id parameter
                cartOrderDetailPageUrl += this.clientArea.OrderId;
                //this.router.navigate([cartOrderDetailPageUrl]);
                window.open(cartOrderDetailPageUrl, "_self");
            };
            ChildComponent.prototype.fileUploadRedirect = function () {
                //Reading link of the page
                var cartOrderDetailPageUrl = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
                //Removing system parameter (id)
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', this.clientArea.OrderId);
                cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':pagefrom', 'section_upload');
                //this.router.navigate([cartOrderDetailPageUrl]);
                window.open(cartOrderDetailPageUrl, "_self");
            };
            ChildComponent.prototype.payWithPaypal = function () {
                var paypalText = "pay_with_paypal";
                var translatePaypal = this.translateService.get(paypalText)["value"];
                var formHtml = '<form ngNoForm action=\"' + this.clientArea.GatewayUrl + '\" method="post" target="_top" class="m0" name="paypalForm" id=\'paypalForm\'>' +
                    '<input type="hidden" name="cmd" value="_xclick">' +
                    '<input type="hidden" name="business"  value=\"' + this.clientArea.GatewayAccount + '\">' +
                    '<input type="hidden" name="item_name"  value=\"' + this.clientArea.OrderNumber + '\">' +
                    '<input type="hidden" name="currency_code" value=\"' + this.clientArea.CurrencyCode + '\">' +
                    '<input type="hidden" name="amount" value=\"' + this.clientArea.TotalCost + '\">' +
                    '<input type="hidden" name="item_number"  value=\"' + this.clientArea.OrderId + '\">' +
                    '<input type="hidden" name="return" value=\"' + this.paymentCompleteUrl + '\">' +
                    '<input type="hidden" name="rm" value="2">' +
                    '<button (click)="payWithPaypal()" *ngIf="clientArea.PaymentDoneUrl != null" class="btn btn-primary  btn-lg" type="button"' +
                    'id="paypal-button-container" name="paypal-button-container" style="width:100%">' +
                    '<i class="fa fa-credit-card"></i> ' + translatePaypal +
                    '</button>' +
                    '</form>';
                //replacing form with values from field because of security reasons - if somebody change html content
                var completePaypalForm = $("#completePaypalFormId").html(formHtml);
                $('#paypalForm').submit();
            };
            ChildComponent.prototype.payWithNexi = function () {
                var NexiForm = $("#completeNexiFormId").html();
                var NexiText = "pay_with_nexi";
                var translateNexi = this.translateService.get(NexiText)["value"];
                var formHtml = '<form ngNoForm action=\"' + this.clientArea.NexiModel.requestUrl + '\" method="post" target="_top" class="m0" name="nexiForm" id=\'nexiForm\'>' +
                    '<input type="hidden" name="alias"  value=\"' + this.clientArea.NexiModel.alias + '\"/>' +
                    '<input type="hidden" name="importo"  value=\"' + this.clientArea.NexiModel.importo + '\"/>' +
                    '<input type="hidden" name="divisa"  value=\"' + this.clientArea.NexiModel.divisa + '\"/>' +
                    '<input type="hidden" name="codTrans" value=\"' + this.clientArea.NexiModel.codTrans + '\"/>' +
                    '<input type="hidden" name="url" value=\"' + this.clientArea.NexiModel.url + '\"/>' +
                    '<input type="hidden" name="url_back"  value=\"' + this.clientArea.NexiModel.url_back_ultimoStepCarrello + '\"/>' +
                    '<input type="hidden" name="mac" value=\"' + this.clientArea.NexiModel.mac + '\"/>' +
                    '<input type="hidden" name="tipo_servizio" value="paga_1click"/>' +
                    '<input type="hidden" name="num_contratto" value=\"' + this.clientArea.NexiModel.num_contratto + '\"/>';
                if (this.clientArea.NexiModel.gruppo != null && this.clientArea.NexiModel.gruppo != "") {
                    formHtml += '<input type="hidden" name="gruppo" value=\"' + this.clientArea.NexiModel.gruppo + '\"/>';
                }
                formHtml += '</form>' + NexiForm;
                // formHtml += '</form> <button (click)="payWithNexi()" class="btn btn-primary btn-lg w100" type="button" id="nexi-button-container" name="nexi-button-container">' +
                // '<i class="fa fa-credit-card"></i> ' + translateNexi +
                // '</button>';
                //replacing form with values from field because of security reasons - if somebody change html content
                var completeNexiForm = $("#completeNexiFormId").html(formHtml);
                $('#nexiForm').submit();
            };
            ChildComponent.prototype.payWithBancaSella = function () {
                axerve.lightBox.open(this.clientArea.BancaSellaModel.payload.paymentID, this.clientArea.BancaSellaModel.payload.paymentToken, this.callback);
            };
            ChildComponent.prototype.callback = function (result) {
                if (result.responseURL != null && result.responseURL != undefined && result.responseURL != "") {
                    window.open(result.responseURL, "_self");
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsAfterViewInit) {
                    return;
                }
                if (this.clientArea.PaymentType == 'BancaSella' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00') {
                    axerve.lightBox.shop = this.clientArea.BancaSellaModel.payload.shopId;
                }
                //-- If these conditions are not fulfilled, we are not gonna load paypal script, because there is no paypal payment option in the current order.
                if (this.clientArea.PaymentType == 'Paypal' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00' && this.clientArea.IsNewPaypalIntegration) {
                    var userId = this.authService.GetUserId();
                    var params = {
                        CustomerId: userId.toString(),
                        OrderId: this.clientArea.OrderId.toString(),
                        Lang: this.languageService.getLongLang()
                    };
                    //-- Load paypal service and render a button for paypal payment
                    this.paypalService.loadPaypalService(this.mappings.Paypal_JS_Lirary_Url, this.mappings.Web_Api_Create_Paypal_Payment, this.mappings.Web_Api_Execute_Paypal_Payment, params, this.clientArea.PaypalButtonStyle, this.clientArea.UsePaypalProduction);
                }
                this.pageIsAfterViewInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: cartSubmittedData.TemplateHtml
                }),
                __param(6, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _g) || Object, (typeof (_h = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _h) || Object, (typeof (_j = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _j) || Object, (typeof (_k = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _k) || Object, (typeof (_l = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _l) || Object, (typeof (_m = typeof paypal_service_1.PaypalService !== 'undefined' && paypal_service_1.PaypalService) === 'function' && _m) || Object, (typeof (_o = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _o) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        }());
        return ChildComponent;
    };
    CartSubmittedComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, Object, (typeof (_h = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _h) || Object])
    ], CartSubmittedComponent);
    return CartSubmittedComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.CartSubmittedComponent = CartSubmittedComponent;


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var register_service_1 = __webpack_require__(98);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var component_helper_service_1 = __webpack_require__(4);
var shopping_cart_service_1 = __webpack_require__(20);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var core_2 = __webpack_require__(27);
var bootbox_service_1 = __webpack_require__(40);
var script_service_1 = __webpack_require__(14);
var breadcrumbs_service_1 = __webpack_require__(22);
var user_login_1 = __webpack_require__(73);
var company_1 = __webpack_require__(253);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var cookie_1 = __webpack_require__(85);
var platform_browser_1 = __webpack_require__(7);
var CartComponent = (function () {
    function CartComponent(_compiler, componentHelper, _elementRef, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
    }
    CartComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isChangeShipment = false;
        var paramsSub = this.route.queryParams.subscribe(function (params) {
            var isChangeShipmentParam = params['isChangeShipment'];
            if (isChangeShipmentParam != undefined) {
                isChangeShipment = isChangeShipmentParam;
            }
        });
        this.subManager.add(paramsSub);
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var cartDataSub = this.cmsComponentService.getShoppingCartData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, header, isChangeShipment);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var scriptId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.cartId, result.ShoppingCart.CartID);
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, scriptId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(cartDataSub);
    };
    CartComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    CartComponent.prototype.createSubComponent = function (shoppingCartData, header, isChangeShipment) {
        var ChildComponent = (function () {
            function ChildComponent(router, shoppingCartService, languageService, authService, routesService, seoService, translate, bootboxService, isBrowser, _elementRef, scriptService, breadcrumbsService, registerService, canvasService, cookie) {
                var _this = this;
                this.router = router;
                this.shoppingCartService = shoppingCartService;
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.seoService = seoService;
                this.translate = translate;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.breadcrumbsService = breadcrumbsService;
                this.registerService = registerService;
                this.canvasService = canvasService;
                this.cookie = cookie;
                // model = {
                //     selectedPayment: new CartPaymentModel(),
                //     selectedShipment: new CartShipmentModel(),
                //     selectedPickUp: new CartShipmentModel(),
                //     selectedDelivery: new CartShipmentModel()
                // }
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.carrello = shoppingCartData.ShoppingCart;
                this.items = this.carrello.Payments;
                this.selectedPaymentId = 0;
                this.selectedShipmentId = 0;
                this.locations = new Array();
                this.footerData = shoppingCartData.footerData;
                this.headerData = header;
                this.userLogin = user_login_1.UserLogin;
                this.lang = this.languageService.getLongLang();
                this.company = new company_1.Company();
                this.authentication = this.authService.GetData();
                this.userId = this.authService.GetUserId();
                this.cartId = 0;
                this.voucherCode = "";
                this.isVoucherValid = false;
                this.isVoucherInvalid = false;
                this.isVoucherApplied = false;
                this.hasPickUpActive = false;
                this.hasShipmentActive = false;
                this.hasDeliveryActive = false;
                this.seoInfo = shoppingCartData.SeoInformation;
                this.disableModalCartButtons = false;
                this.spinnerCart = false;
                this.breadcrumbs = shoppingCartData.BreadcrumbsInfo;
                this.showProceedBtn = true;
                this.parentWidgetData = shoppingCartData.CanvasInfo;
                this.mapZoom = shoppingCartData.MapZoom;
                this.clickedProductId = 0;
                this.selectedTipoSpedizione = "";
                this.trasportoLabel = "";
                this.ritiroLabel = "";
                this.consegnaLabel = "";
                this.subManager = new Subscription_1.Subscription();
                this.countInitMap = 0;
                this.cartStep1 = true;
                this.cartStep2 = false;
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        shoppingCartService.setIfProductIsCanvasEdited(true);
                        // get row id of edited element
                        var productId_1 = _this.clickedProductId;
                        // get data which we get from customer canvas and saved in a cart service
                        var canvasData_1 = shoppingCartService.getCustomizationCanvasData();
                        canvasData_1["RowIdPrev"] = productId_1;
                        if (canvasData_1 && productId_1 && canvasData_1.status == "success") {
                            var updateCanvas = canvasService.updatePrevCanvasInfo(canvasData_1).subscribe(function (x) {
                                var objectToUpdateStateId = _this.carrello.Products.find(function (obj) {
                                    return obj.Id === productId_1;
                                });
                                objectToUpdateStateId.CanvasStateId = canvasData_1.stateId;
                            });
                            _this.subManager.add(updateCanvas);
                        }
                        // reset editor view
                        shoppingCartService.resetCanvasData();
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                this.trasportoLabel = this.getLabel('tipoTrasporto_shipment');
                this.ritiroLabel = this.getLabel('tipoTrasporto_pickup');
                this.consegnaLabel = this.getLabel('tipoTrasporto_delivery');
                this.TipiSpedizione = [{
                        valore: this.trasportoLabel,
                        chiave: "S",
                        isVisible: true
                    }, {
                        valore: this.ritiroLabel,
                        chiave: "P",
                        isVisible: true
                    }, {
                        valore: this.consegnaLabel,
                        chiave: "D",
                        isVisible: true
                    }];
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (shoppingCartData.UserData != null) {
                    this.isCompletedRegistration = shoppingCartData.UserData.IsCompletedRegistration;
                    this.userData = shoppingCartData.UserData;
                }
                if (this.carrello.Products.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    this.shoppingCartService.updateCart(this.carrello);
                    var userData = this.authService.GetData();
                    this.isUserAuthenticated = userData.isAuthenticated;
                    this.carrello.Payments = this.carrello.Payments.sort(function (a, b) { return a.OrderSort - b.OrderSort; });
                    for (var _i = 0, _a = this.carrello.Payments; _i < _a.length; _i++) {
                        var payment = _a[_i];
                        if (payment.Selected == true) {
                            this.selectedPaymentId = payment.Id;
                            break;
                        }
                    }
                    this.hasPickUpActive = this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == 'P'; }).length > 0 ? true : false;
                    this.hasShipmentActive = this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == 'S'; }).length > 0 ? true : false;
                    this.hasDeliveryActive = this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == 'D'; }).length > 0 ? true : false;
                    this.checkTipoSpedizione();
                    this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == 'P'; }).forEach(function (element) {
                        var item = [element.Name, parseFloat(element.Latitudine), parseFloat(element.Longitudine), element.Id];
                        _this.locations.push(item);
                    });
                }
                if (this.userData != undefined && this.userData != null) {
                    if (this.userData.Id_User_Group != 4) {
                        if ((this.userData.CodiceDestinatarioSDL == "" || this.userData.CodiceDestinatarioSDL == "0000000" || this.userData.CodiceDestinatarioSDL == undefined) && (this.userData.PecEmail == "" || this.userData.PecEmail == undefined)) {
                            this.showProceedBtn = false;
                        }
                    }
                }
                if (isChangeShipment) {
                    this.cartStep1 = false;
                    this.cartStep2 = true;
                }
            };
            ChildComponent.prototype.scroll = function (id) {
                var el = document.getElementById(id);
                if (el != null) {
                    el.scrollIntoView();
                }
            };
            ChildComponent.prototype.gotoToStep1Cart = function () {
                this.cartStep1 = true;
                this.cartStep2 = false;
            };
            ChildComponent.prototype.gotoToStep2Cart = function () {
                this.cartStep1 = false;
                this.cartStep2 = true;
            };
            ChildComponent.prototype.changeTipoSpedizioneValue = function (valore) {
                if (this.selectedTipoSpedizione == valore) {
                    return;
                }
                this.selectedTipoSpedizione = valore;
                if (valore == 'P') {
                    this.initMap(this);
                }
                this.checkTipoSpedizione(true);
            };
            ChildComponent.prototype.checkTipoSpedizione = function (isUpdate, isRemovingCart) {
                var _this = this;
                if (isUpdate === void 0) { isUpdate = false; }
                if (isRemovingCart === void 0) { isRemovingCart = false; }
                if (this.carrello.Products.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    var tipoSped = this.carrello.Products.filter(function (item, i, arr) { return arr.findIndex(function (t) { return t.TipoTrasporto === item.TipoTrasporto; }) === i; });
                    var TipoTrasportoShipmentToFilter = "S";
                    if (tipoSped.length == 1) {
                        TipoTrasportoShipmentToFilter = tipoSped[0].TipoTrasporto;
                    }
                    if (this.selectedTipoSpedizione == "") {
                        this.selectedTipoSpedizione = TipoTrasportoShipmentToFilter;
                    }
                    var showAllType = true;
                    var haveRowTime = this.carrello.Products.filter(function (x) { return x.DeliveryTime != ""; });
                    if (haveRowTime.length > 0) {
                        showAllType = false;
                    }
                    //console.log("hasDeliveryActive = "+this.hasDeliveryActive)
                    //console.log("hasPickUpActive = "+this.hasPickUpActive)
                    //console.log("hasShipmentActive = "+this.hasShipmentActive)
                    this.TipiSpedizione.forEach(function (tipoSped) {
                        tipoSped.isVisible = true;
                        if (showAllType == false && (tipoSped.chiave == "S")) {
                            tipoSped.isVisible = false;
                        }
                        if (_this.hasDeliveryActive == false && (tipoSped.chiave == "D")) {
                            tipoSped.isVisible = false;
                        }
                        if (_this.hasPickUpActive == false && (tipoSped.chiave == "P")) {
                            tipoSped.isVisible = false;
                        }
                        if (_this.hasShipmentActive == false && (tipoSped.chiave == "S")) {
                            tipoSped.isVisible = false;
                        }
                    });
                    if (isUpdate) {
                        this.shipmentToShow = this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == _this.selectedTipoSpedizione && x.DefaultShipment == true; });
                        this.selectRadioShipment(this.shipmentToShow[0].Id);
                    }
                    else {
                        this.shipmentToShow = this.carrello.Shipments.sort(function (a, b) { return a.Sort - b.Sort; }).filter(function (x) { return x.TipoTrasporto == _this.selectedTipoSpedizione; });
                        if (this.shipmentToShow.filter(function (x) { return x.Selected == true; }).length > 0) {
                            this.selectedShipmentId = this.shipmentToShow.filter(function (x) { return x.Selected == true; })[0].Id;
                        }
                        else {
                            if (isRemovingCart) {
                                if (this.selectedShipmentId > 0) {
                                    var shipmentToSelect = this.shipmentToShow.filter(function (x) { return x.Id == _this.selectedShipmentId; });
                                    if (shipmentToSelect.length > 0) {
                                        this.selectedShipmentId = 0;
                                        this.selectRadioShipment(shipmentToSelect[0].Id, false, true);
                                    }
                                    else {
                                        this.selectRadioShipment(this.shipmentToShow[0].Id, false, true);
                                    }
                                }
                                else {
                                    var shipentToSelect = this.shipmentToShow[0].Id;
                                    if (this.shipmentToShow.filter(function (x) { return x.DefaultShipment == true; }).length > 0) {
                                        shipentToSelect = this.shipmentToShow[0].Id;
                                    }
                                    this.selectRadioShipment(shipentToSelect, false, true);
                                }
                            }
                            else {
                                var shipentToSelect = this.shipmentToShow[0].Id;
                                if (this.shipmentToShow.filter(function (x) { return x.DefaultShipment == true; }).length > 0) {
                                    shipentToSelect = this.shipmentToShow[0].Id;
                                }
                                this.selectRadioShipment(this.shipmentToShow[0].Id);
                            }
                        }
                    }
                }
            };
            ChildComponent.prototype.openCanvasEditor = function (product) {
                this.clickedProductId = product.Id;
                if (shoppingCartData.CanvasInfo.CanvasUrl) {
                    // we have a state id, because product is already edited, so we kept it's state id in a database
                    var isStateId = true;
                    var canvasConfigData = this.setCanvasConfig(product);
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function (product) {
                var canvasConfigData = {
                    CanvasUrl: shoppingCartData.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: shoppingCartData.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: shoppingCartData.CanvasInfo.CustomerCanvasUserName,
                    CanvasStateId: product.CanvasStateId,
                    Watermark: shoppingCartData.CanvasInfo.WatermarkText,
                    CanvasApiKey: shoppingCartData.CanvasInfo.ApiKey
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                if (shoppingCartData.CanvasInfo && shoppingCartData.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = shoppingCartData.CanvasInfo.IsActiveCanvasModule;
                }
                toShow = isModuleActive && this.isUserAuthenticated ? true : false;
                return toShow;
            };
            // customers canvas state module is active and current product has canvasStateId defined, then send a request to delete a state from customers canvas server
            ChildComponent.prototype.removeCustomersCanvasState = function () {
                if (this.toShowCanvasButton() && this.selectedProduct.CanvasStateId) {
                    var canvasConfigData = this.setCanvasConfig(this.selectedProduct);
                    this.canvasService.deleteCustomerCanvasState(canvasConfigData)
                        .subscribe(function (x) { return x; }, function (err) {
                        console.log(err);
                    });
                }
            };
            ChildComponent.prototype.goRegistrationPage = function () {
                //-- If this parameter is inside of cookie, it means that user used quick registration feature
                var quickRegistration = this.cookie.get("IsQuickRegistered");
                if (quickRegistration && Boolean(quickRegistration)) {
                    var navigationExtras = {
                        queryParams: { 'quickRegistration': true }
                    };
                    var registerRoute = this.routesService.getRoutePath('REGISTRAZIONE_PAGE_FROM')[0];
                    registerRoute = registerRoute.replace(":pagefrom", "cart");
                    registerRoute += "?quickRegistration=true";
                    window.open(registerRoute, "_self");
                }
                else {
                    if (this.isCompletedRegistration == false) {
                        this.registerService.setFacebookLoginData(this.userData);
                        var registerRoute = this.routesService.getRoutePath('REGISTRAZIONE_PAGE_FROM')[0];
                        registerRoute = registerRoute.replace(":pagefrom", "cart");
                        this.router.navigate([registerRoute]);
                    }
                    else {
                        this.router.navigate(this.routesService.getRoutePath('REGISTRAZIONE'));
                    }
                }
            };
            ;
            ChildComponent.prototype.goLoginPage = function () {
                var loginRoute = this.routesService.getRoutePath('LOGIN_PAGE_FROM')[0];
                loginRoute = loginRoute.replace(":pagefrom", "cart");
                this.router.navigate([loginRoute]);
            };
            ;
            ChildComponent.prototype.goToConfirmPurchasePage = function () {
                if (this.selectedPaymentId == 0) {
                    this.bootboxService.i18nAlert("selectPayment", 'pagamento');
                }
                else if (this.selectedShipmentId == 0) {
                    this.bootboxService.i18nAlert("selectPayment", 'pagamento');
                }
                else {
                    //this.router.navigateByUrl(this.routesService.getRoutePath('ACQUISTO - CASSA'));
                    window.open(this.routesService.getRoutePath('ACQUISTO - CASSA'), "_self");
                }
            };
            ChildComponent.prototype.goToModifyProfile = function () {
                this.router.navigate(this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI'));
            };
            ChildComponent.prototype.saveCart = function () {
                var _this = this;
                var saveCartSub = this.shoppingCartService.saveCart(this.userId, this.cartId, this.selectedPaymentId, this.selectedShipmentId).subscribe(function (result) {
                    //this.router.navigate(this.routesService.getRoutePath('ACQUISTO - CASSA'));
                    window.open(_this.routesService.getRoutePath('ACQUISTO - CASSA'), "_self");
                });
                this.subManager.add(saveCartSub);
            };
            ChildComponent.prototype.selectRadioPayment = function (paymentId) {
                if (this.selectedPaymentId != paymentId) {
                    this.selectedPaymentId = paymentId;
                    this.setPayment(paymentId);
                }
            };
            ChildComponent.prototype.setPayment = function (paymentId) {
                var _this = this;
                this.spinnerCart = true;
                var paymentSub = this.shoppingCartService.setPayment(paymentId).subscribe(function (result) {
                    _this.bootboxService.i18nAlert("selectedPayment", 'pagamento');
                    _this.shoppingCartService.updateCart(result);
                    _this.carrello = _this.shoppingCartService.getCart();
                    _this.carrello.Payments = _this.carrello.Payments.sort(function (a, b) { return a.OrderSort - b.OrderSort; });
                    _this.spinnerCart = false;
                });
                this.subManager.add(paymentSub);
            };
            ChildComponent.prototype.selectRadioShipment = function (shipmentId, isOnMap, isOnRemove) {
                if (isOnMap === void 0) { isOnMap = false; }
                if (isOnRemove === void 0) { isOnRemove = false; }
                if (this.selectedShipmentId != shipmentId) {
                    this.selectedShipmentId = shipmentId;
                    this.setShipment(shipmentId, isOnMap, isOnRemove);
                }
            };
            ChildComponent.prototype.setShipment = function (shipmentId, isOnMap, isOnRemove) {
                var _this = this;
                if (isOnMap === void 0) { isOnMap = false; }
                if (isOnRemove === void 0) { isOnRemove = false; }
                this.spinnerCart = true;
                var shipmentSub = this.shoppingCartService.setShipment(shipmentId).subscribe(function (result) {
                    if (!isOnRemove) {
                        _this.bootboxService.i18nAlert("selectedShipment", 'spedizione');
                    }
                    _this.shoppingCartService.updateCart(result);
                    _this.carrello = _this.shoppingCartService.getCart();
                    if (!isOnMap) {
                        _this.SelectValueMap(_this);
                    }
                    _this.checkTipoSpedizione();
                    _this.spinnerCart = false;
                });
                this.subManager.add(shipmentSub);
            };
            ChildComponent.prototype.removeFromCart = function () {
                var _this = this;
                this.disableModalCartButtons = true;
                this.spinnerCart = true;
                var removeCartSub = this.shoppingCartService.removeFromCart(this.idOfProduct).subscribe(function (result) {
                    _this.shoppingCartService.updateCart(result);
                    _this.carrello = _this.shoppingCartService.getCart();
                    _this.spinnerCart = false;
                    _this.disableModalCartButtons = false;
                    _this.removeCustomersCanvasState();
                    _this.checkTipoSpedizione(false, true);
                    if (_this.carrello.Products != null && _this.carrello.Products.length == 0) {
                        _this.router.navigate(_this.routesService.getRoutePath('EMPTY CART PAGE'));
                    }
                });
                this.subManager.add(removeCartSub);
                this.hideModal();
            };
            ChildComponent.prototype.showModal = function (product) {
                this.disableModalCartButtons = false;
                this.idOfProduct = product.Id;
                this.selectedProduct = product;
                $("#cartModal").modal("show");
            };
            ChildComponent.prototype.hideModal = function () {
                $('#cartModal').modal('hide');
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                setTimeout(function () {
                    var altezza = $("#footer").outerHeight();
                    var margintop = parseInt($("#footer").css('margin-top'));
                    var paddingntop = parseInt($("#footer").css('padding-top'));
                    altezza += margintop;
                    altezza += paddingntop;
                    var altezza1 = $(".footerplus").outerHeight() || 0;
                    var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                    var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                    altezza += altezza1;
                    altezza += margintop1;
                    altezza += paddingntop1;
                    var altezzaHead = $(".header-body").outerHeight();
                    //console.log(".header-body = " + altezzaHead)
                    var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                    var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                    altezzaHead += margintopHead;
                    altezzaHead += paddingntopHead;
                    $("#resumeCartTotal").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                    $("#resumeCartTotal-sticky-wrapper").height(0);
                    this.pageIsInit = true;
                }, 1);
            };
            ChildComponent.prototype.applyVoucher = function (coupon) {
                var _this = this;
                if (this.voucherCode != null && this.voucherCode.trim().length > 0) {
                    this.spinnerCart = true;
                    var voucherSub = this.shoppingCartService.applyVoucher(this.voucherCode).subscribe(function (result) {
                        if (result.CartID != null) {
                            _this.shoppingCartService.updateCart(result);
                            _this.carrello = _this.shoppingCartService.getCart();
                            _this.isVoucherValid = true;
                            _this.isVoucherInvalid = false;
                            _this.isVoucherApplied = true;
                            _this.voucherCode = "";
                        }
                        else {
                            _this.isVoucherValid = false;
                            _this.isVoucherInvalid = true;
                        }
                        _this.spinnerCart = false;
                    }, function (err) {
                        _this.bootboxService.i18nAlert("errorMex");
                        _this.spinnerCart = false;
                    });
                    this.subManager.add(voucherSub);
                }
            };
            ;
            ChildComponent.prototype.setJobName = function (rowId, jobName) {
                var _this = this;
                if (jobName != "") {
                    var jobNameSub = this.shoppingCartService.setJobName(rowId, jobName).subscribe(function (result) {
                        if (result == false) {
                            _this.bootboxService.i18nAlert("errorMex");
                        }
                    }, function (err) {
                        _this.bootboxService.i18nAlert("errorMex");
                    });
                    this.subManager.add(jobNameSub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                this.pageIsInitAfter = true;
                this.initMap(this);
            };
            ChildComponent.prototype.initMap = function (those) {
                if (those.locations.length > 0 && those.locations != null) {
                    if (google == undefined || google == null || !google) {
                        if (those.countInitMap > 3) {
                            $("#map").hide();
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            return;
                        }
                        those.countInitMap++;
                        those.initMap(those);
                    }
                    else {
                        if (those.locations[0][1] == "" || those.locations[0][1] == undefined || those.locations[0][1] == null || isNaN(those.locations[0][1])) {
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            $("#map").hide();
                            return;
                        }
                        var pt = new google.maps.LatLng(those.locations[0][1], those.locations[0][2]);
                        var map = new google.maps.Map(document.getElementById('map'), {
                            zoom: those.mapZoom,
                            center: pt,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        });
                        map.setCenter(pt);
                        those.map = map;
                        var infowindow = new google.maps.InfoWindow();
                        var marker, i;
                        for (i = 0; i < those.locations.length; i++) {
                            if (those.locations[i][1] == "" || those.locations[i][1] == undefined || those.locations[i][1] == null || isNaN(those.locations[i][1])) {
                                $("#map").hide();
                                if ($("#listOfShipments").hasClass("col-md-4")) {
                                    $("#listOfShipments").removeClass("col-md-4");
                                    $("#listOfShipments").addClass("col-md-12");
                                }
                                continue;
                            }
                            else if (those.locations[i][2] == "" || those.locations[i][2] == undefined || those.locations[i][2] == null || isNaN(those.locations[i][2])) {
                                $("#map").hide();
                                if ($("#listOfShipments").hasClass("col-md-4")) {
                                    $("#listOfShipments").removeClass("col-md-4");
                                    $("#listOfShipments").addClass("col-md-12");
                                }
                                continue;
                            }
                            marker = new google.maps.Marker({
                                position: new google.maps.LatLng(those.locations[i][1], those.locations[i][2]),
                                map: map
                            });
                            if (those.selectedShipmentId == those.locations[i][3]) {
                                infowindow.setContent(those.locations[i][0]);
                                infowindow.open(map, marker);
                            }
                            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                                return function () {
                                    infowindow.setContent(those.locations[i][0]);
                                    infowindow.open(map, marker);
                                    those.selectRadioShipment(those.locations[i][3], true);
                                    those.scroll(those.locations[i][3]);
                                };
                            })(marker, i));
                        }
                        those.selectInfoWindow = infowindow;
                    }
                }
                else {
                    return;
                }
            };
            ChildComponent.prototype.SelectValueMap = function (those) {
                if (those.locations.length > 0 && those.locations != null) {
                    if (google == undefined || google == null || !google) {
                        if (those.countInitMap > 3) {
                            $("#map").hide();
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            return;
                        }
                        those.countInitMap++;
                        those.SelectValueMap(those);
                    }
                    else {
                        if (those.selectInfoWindow != "" && those.selectInfoWindow != undefined && those.selectInfoWindow != null) {
                            those.selectInfoWindow.close();
                            var infowindow = new google.maps.InfoWindow();
                            those.selectInfoWindow = infowindow;
                            var marker, i;
                            for (i = 0; i < those.locations.length; i++) {
                                if (those.locations[i][1] == "" || those.locations[i][1] == undefined || those.locations[i][1] == null || isNaN(those.locations[i][1])) {
                                    $("#map").hide();
                                    if ($("#listOfShipments").hasClass("col-md-4")) {
                                        $("#listOfShipments").removeClass("col-md-4");
                                        $("#listOfShipments").addClass("col-md-12");
                                    }
                                    continue;
                                }
                                else if (those.locations[i][2] == "" || those.locations[i][2] == undefined || those.locations[i][2] == null || isNaN(those.locations[i][2])) {
                                    $("#map").hide();
                                    if ($("#listOfShipments").hasClass("col-md-4")) {
                                        $("#listOfShipments").removeClass("col-md-4");
                                        $("#listOfShipments").addClass("col-md-12");
                                    }
                                    continue;
                                }
                                else {
                                    marker = new google.maps.Marker({
                                        position: new google.maps.LatLng(parseFloat(those.locations[i][1]), parseFloat(those.locations[i][2])),
                                        map: those.map
                                    });
                                    if (those.selectedShipmentId == those.locations[i][3]) {
                                        infowindow.setContent(those.locations[i][0]);
                                        infowindow.open(those.map, marker);
                                    }
                                    google.maps.event.addListener(marker, 'click', (function (marker, i) {
                                        return function () {
                                            infowindow.setContent(those.locations[i][0]);
                                            infowindow.open(those.map, marker);
                                            those.selectRadioShipment(those.locations[i][3], true);
                                            those.scroll(those.locations[i][3]);
                                        };
                                    })(marker, i));
                                }
                            }
                            those.selectInfoWindow = infowindow;
                        }
                    }
                }
                else {
                    return;
                }
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: shoppingCartData.TemplateHtml
                }),
                __param(8, core_1.Inject('isBrowser')),
                __param(14, core_1.Inject('CookieService')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _j) || Object, (typeof (_k = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _k) || Object, (typeof (_l = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _l) || Object, (typeof (_m = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _m) || Object, (typeof (_o = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _o) || Object, (typeof (_p = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _p) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        }());
        return ChildComponent;
    };
    CartComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, Object, (typeof (_h = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _h) || Object])
    ], CartComponent);
    return CartComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.CartComponent = CartComponent;


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
//Angular
var core_1 = __webpack_require__(0);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var router_1 = __webpack_require__(12);
var routes_service_1 = __webpack_require__(5);
var template_service_1 = __webpack_require__(35);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
//Models
var cookie_service_1 = __webpack_require__(60);
var mapping_1 = __webpack_require__(10);
var core_2 = __webpack_require__(27);
var seo_service_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var Observable_1 = __webpack_require__(1);
var ClientAreaCatalogPrivateComponent = (function () {
    function ClientAreaCatalogPrivateComponent(_compiler, componentHelper, _elementRef, templateService, clientAreaService, cmsComponentService, authService, router, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.clientAreaService = clientAreaService;
        this.cmsComponentService = cmsComponentService;
        this.authService = authService;
        this.router = router;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaCatalogPrivateComponent.prototype.requestDataFromMultipleSources = function (UserId) {
        var response1 = this.cmsComponentService.getHeaderData();
        var response2 = this.cmsComponentService.getSideMenuData();
        var response4 = this.clientAreaService.getClientAreaCatalogPrivate(UserId);
        // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
        return Observable_1.Observable.forkJoin([response1, response2, response4]);
    };
    ClientAreaCatalogPrivateComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        if (this.isBrowser) {
            var UserId_1 = this.authService.GetUserId();
            var PageInfo_1;
            var header_1;
            var SideMenu_1;
            var fork = this.requestDataFromMultipleSources(UserId_1).subscribe(function (result) {
                //console.log(result)
                header_1 = result[0];
                if (result[1].Categories) {
                    header_1.Categories = result[1].Categories;
                    SideMenu_1 = result[1];
                }
                if (SideMenu_1) {
                    result[2].SideMenuData = SideMenu_1;
                }
                if (UserId_1 !== undefined) {
                    PageInfo_1 = result[2];
                    //Creating subcomponent whith the selected template to inject
                    var subComponent = _this.createSubComponent(PageInfo_1, UserId_1, header_1);
                    _this._elementRef.clear();
                    //injecting created component (OK)
                    _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                }
                else {
                    var orderNotFoundSub = _this.templateService.getComponentTemplate("notfoundPageTemplate").subscribe(function (result) {
                        PageInfo_1 = result;
                        //Creating subcomponent whith the selected template to inject
                        var subComponent = _this.createSubComponent(PageInfo_1, UserId_1, header_1);
                        //injecting created component (OK)
                        _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                    });
                    _this.subManager.add(orderNotFoundSub);
                }
            });
            this.subManager.add(fork);
        }
    };
    ClientAreaCatalogPrivateComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ClientAreaCatalogPrivateComponent.prototype.createSubComponent = function (template, orderId, header) {
        var ChildComponent = (function () {
            function ChildComponent(languageService, authService, routesService, cookie, router, isBrowser, seoService, currency, translateService, breadcrumbsService, mappings, scriptService) {
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.cookie = cookie;
                this.router = router;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.currency = currency;
                this.translateService = translateService;
                this.breadcrumbsService = breadcrumbsService;
                this.mappings = mappings;
                this.scriptService = scriptService;
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.isActiveInvoicesModule = template.isActiveInvoicesModule;
                this.isCatalogPrivateActive = template.isCatalogPrivateActive;
                this.footerData = template.footerData;
                this.headerData = header;
                this.pageIsInit = false;
                this.pageIsAfterViewInit = false;
                this.sideMenuData = template.SideMenuData;
                this.breadcrumbs = template.BreadcrumbsInfo;
                this.subManager = new Subscription_1.Subscription();
                this.products = template.ProductPrivateList;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                this.sideMenuData.Categories = this.headerData.Categories;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsAfterViewInit) {
                    return;
                }
                this.pageIsAfterViewInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: template.TemplateHtml
                }),
                __param(3, core_1.Inject('CookieService')),
                __param(5, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _c) || Object, (typeof (_d = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _g) || Object, (typeof (_h = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _h) || Object, (typeof (_j = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _j) || Object, (typeof (_k = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _k) || Object, (typeof (_l = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _l) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        }());
        return ChildComponent;
    };
    ClientAreaCatalogPrivateComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(8, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, (typeof (_g = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _k) || Object, Object])
    ], ClientAreaCatalogPrivateComponent);
    return ClientAreaCatalogPrivateComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.ClientAreaCatalogPrivateComponent = ClientAreaCatalogPrivateComponent;


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
//Angular
var core_1 = __webpack_require__(0);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var messages_service_1 = __webpack_require__(130);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
//Models
var client_area_1 = __webpack_require__(97);
var router_1 = __webpack_require__(12);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var ClientAreaHomeComponent = (function () {
    function ClientAreaHomeComponent(_compiler, componentHelper, _elementRef, clientAreaService, router, authService, cmsComponentService, isBrowser, seo, renderer, scriptService, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.clientAreaService = clientAreaService;
        this.router = router;
        this.authService = authService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.scriptService = scriptService;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        //console.log(this.authService.GetData().isAuthenticated)
        if (!this.authService.GetData().isAuthenticated || this.authService.GetData().isAuthenticated === undefined) {
            this.router.navigate([""]);
        }
        var userId = this.authService.GetUserId();
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var clientDetailsSub = this.clientAreaService.getDetailsClientArea(userId).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the catalog catgories information to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.userAreaId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(clientDetailsSub);
    };
    ClientAreaHomeComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ClientAreaHomeComponent.prototype.createSubComponent = function (ClientAreaHomeTemplate, header) {
        var ChildComponent = (function () {
            function ChildComponent(languageService, router, authService, routesService, messagesService, isBrowser, seoService, currency, breadcrumbsService, scriptService) {
                this.languageService = languageService;
                this.router = router;
                this.authService = authService;
                this.routesService = routesService;
                this.messagesService = messagesService;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.currency = currency;
                this.breadcrumbsService = breadcrumbsService;
                this.scriptService = scriptService;
                this.footerData = ClientAreaHomeTemplate.FooterData;
                this.headerData = header;
                this.clientArea = new client_area_1.ClientAreaDetails();
                this.lang = this.languageService.getLongLang();
                this.messagesList = [];
                this.numberOfMessages = 0;
                this.bodyMod = [];
                this.lastOrderDetailsPage = "";
                this.userName = "";
                this.pageIsInit = false;
                //checking if invoices module is active
                this.isActiveInvoicesModule = ClientAreaHomeTemplate.isActiveInvoicesModule;
                this.isCatalogPrivateActive = ClientAreaHomeTemplate.isCatalogPrivateActive;
                this.breadcrumbs = ClientAreaHomeTemplate.BreadcrumbsInfo;
                //Routes for menu-tabs
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.userName = this.authService.GetData().username;
                this.clientArea = ClientAreaHomeTemplate.ClientAreaDetails;
                this.messagesList = this.clientArea.OrderNoteList;
                this.numberOfMessages = this.clientArea.NewNoteOrdersCount;
                //getting of the link for details page of latest order
                this.lastOrderId = String(this.clientArea["LastOrderId"]);
                var url = this.routesService.getRoutePath("AREA CLIENTI - ORDINE")[0];
                this.lastOrderDetailsPage = url.replace(':id', this.lastOrderId);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.showModal = function () {
                var userId = this.authService.GetUserId();
                var params = {
                    CustomerId: userId,
                    OrderId: "0",
                    Lang: this.lang
                };
                var setMessSub = this.messagesService.setMessagesAsRead(params)
                    .subscribe(function (result) { });
                this.subManager.add(setMessSub);
                $("#messagesModal").modal("show");
                this.bodyMod = [];
            };
            ChildComponent.prototype.hideModal = function () {
                $('#basic').modal('hide');
                this.numberOfMessages = 0;
            };
            ChildComponent.prototype.messagesDetails = function (orderId) {
                $("#messagesModal").modal("hide");
                var id = orderId;
                var orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
                orderDetailsPage = orderDetailsPage.replace(':id', id.toString()).replace(':pagefrom', "section_comunicazioni");
                this.router.navigate([orderDetailsPage]);
                return true;
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: ClientAreaHomeTemplate.TemplateHtml
                }),
                __param(5, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _g) || Object, (typeof (_h = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _h) || Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        }());
        return ChildComponent;
    };
    ClientAreaHomeComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(7, core_1.Inject('isBrowser')),
        __param(11, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, (typeof (_k = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _k) || Object, Object])
    ], ClientAreaHomeComponent);
    return ClientAreaHomeComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.ClientAreaHomeComponent = ClientAreaHomeComponent;


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
//Angular
var core_1 = __webpack_require__(0);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var router_1 = __webpack_require__(12);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var cookie_service_1 = __webpack_require__(60);
var api_service_1 = __webpack_require__(13);
var messages_service_1 = __webpack_require__(130);
var mapping_1 = __webpack_require__(10);
var core_2 = __webpack_require__(27);
var seo_service_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var currency_service_1 = __webpack_require__(29);
var ClientAreaInvoicesComponent = (function () {
    function ClientAreaInvoicesComponent(_compiler, componentHelper, _elementRef, authService, router, clientAreaService, cmsComponentService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.authService = authService;
        this.router = router;
        this.clientAreaService = clientAreaService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaInvoicesComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        var ClientAreaInvoicesListTemplate;
        var userId = this.authService.GetUserId();
        var showAll = "-1";
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var invoicesSub = this.clientAreaService.getClientAreaInvoicesList(userId, showAll, showAll, showAll).subscribe(function (result) {
            ClientAreaInvoicesListTemplate = result;
            if (ClientAreaInvoicesListTemplate.isActiveInvoicesModule) {
                // Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(ClientAreaInvoicesListTemplate, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var subComponent = _this.redirectToHomepage(ClientAreaInvoicesListTemplate);
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
        });
        this.subManager.add(invoicesSub);
    };
    ClientAreaInvoicesComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //if invoices module is not active, then redirect to homepage
    ClientAreaInvoicesComponent.prototype.redirectToHomepage = function (ClientAreaInvoicesListTemplate) {
        var ChildComponent = (function () {
            function ChildComponent(router) {
                this.router = router;
            }
            ChildComponent.prototype.ngOnInit = function () {
                this.router.navigate([""]);
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: ClientAreaInvoicesListTemplate.TemplateHtml
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a;
        }());
        return ChildComponent;
    };
    ClientAreaInvoicesComponent.prototype.createSubComponent = function (ClientAreaInvoicesListTemplate, header) {
        var ChildComponent = (function () {
            function ChildComponent(cookie, clientAreaService, router, authService, routesService, apiService, messagesService, mappings, currency, languageService, translateService, isBrowser, seoService, breadcrumbsService, scriptService) {
                this.cookie = cookie;
                this.clientAreaService = clientAreaService;
                this.router = router;
                this.authService = authService;
                this.routesService = routesService;
                this.apiService = apiService;
                this.messagesService = messagesService;
                this.mappings = mappings;
                this.currency = currency;
                this.languageService = languageService;
                this.translateService = translateService;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.breadcrumbsService = breadcrumbsService;
                this.scriptService = scriptService;
                this.pageIsInit = false;
                this.rows = [];
                this.columns = [];
                //filter fields
                this.documentTypeSelect = "-1";
                this.orderNumber = "";
                this.invoiceNumber = "";
                this.lang = this.languageService.getLongLang();
                this.shortLang = this.languageService.getShortLang();
                this.load = true;
                this.footerData = ClientAreaInvoicesListTemplate.footerData;
                this.headerData = header;
                //Routes for menu-tabs
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.isActiveInvoicesModule = ClientAreaInvoicesListTemplate.isActiveInvoicesModule;
                this.isCatalogPrivateActive = ClientAreaInvoicesListTemplate.isCatalogPrivateActive;
                this.breadcrumbs = ClientAreaInvoicesListTemplate.BreadcrumbsInfo;
                this.italianLang = {
                    "sProcessing": "Attendere...",
                    "sLengthMenu": "Visualizza _MENU_ record per pagina",
                    "sZeroRecords": "Niente trovato",
                    "sInfo": "Mostra _START_ a _END_ di _TOTAL_ record",
                    "sInfoEmpty": "Non ci sono record",
                    "sInfoFiltered": "(filtrato da _MAX_ record totali)",
                    "sInfoPostFix": "",
                    "sUrl": "",
                    "oPaginate": {
                        "sPrevious": "«",
                        "sNext": "»"
                    }
                };
                this.englishLang = {
                    "oPaginate": {
                        "sPrevious": "«",
                        "sNext": "»"
                    }
                };
                this.subManager = new Subscription_1.Subscription();
            }
            //translating of header columns titles
            ChildComponent.prototype.translateTableColumnTitle = function (columnTitle) {
                var translation = this.translateService.get(columnTitle)["value"];
                return translation;
            };
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.columns = [
                    { title: this.translateTableColumnTitle("OrderNumberInvoice") },
                    { title: this.translateTableColumnTitle("InvoiceNumberInvoice") },
                    { title: this.translateTableColumnTitle("CreationDateInvoice") },
                    { title: this.translateTableColumnTitle("TotalPriceInvoice") },
                    { title: this.translateTableColumnTitle("DocumentTypeInvoice") },
                    { title: this.translateTableColumnTitle("Download") }
                ];
                //getting of Datatable data
                this.rows = ClientAreaInvoicesListTemplate.ClientAreaInvoicesList;
                this.load = false;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                if (this.shortLang == 'it') {
                    this.currentLang = this.italianLang;
                }
                else {
                    this.currentLang = this.englishLang;
                }
                //initialization of datatable
                $('#datatable').DataTable({
                    searching: false,
                    ordering: false,
                    sDom: 'Rlfrtlip',
                    oLanguage: this.currentLang
                });
                //hiding of first 'per page' section, because we added it on the bottom of the table
                $('.dataTables_length').not(':eq(1)').hide();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.getInvoicesList = function (userId, orderNumber, invoiceNumber, documentType) {
                var _this = this;
                var showAll = "-1";
                this.load = true;
                var invoicesSub = this.clientAreaService.getClientAreaInvoicesList(userId, orderNumber, invoiceNumber, documentType)
                    .subscribe(function (result) {
                    _this.rows = result.ClientAreaInvoicesList;
                    _this.load = false;
                    _this.resetTable(_this.rows);
                });
                this.subManager.add(invoicesSub);
            };
            //destroying of current context of table and creating a new one with new data
            ChildComponent.prototype.resetTable = function (tableData) {
                $('#datatable').DataTable().destroy();
                var currentLang = this.currentLang;
                setTimeout(function () {
                    $('#datatable').DataTable({
                        data: this.rows,
                        searching: false,
                        ordering: false,
                        sDom: 'Rlfrtlip',
                        oLanguage: currentLang
                    });
                }, 0);
                setTimeout(function () { $('.dataTables_length').not(':eq(1)').hide(); }, 0);
            };
            ChildComponent.prototype.resetFilter = function () {
                this.rows = ClientAreaInvoicesListTemplate.ClientAreaInvoicesList;
                this.orderNumber = "";
                this.invoiceNumber = "";
                this.documentTypeSelect = "-1";
                this.resetTable(this.rows);
            };
            ChildComponent.prototype.filterInvoicesList = function () {
                var showAll = "-1";
                var userId = this.authService.GetUserId();
                //checking if inputs for filtering are empty, if they are, set them to "show all", which is '-1' value
                var filterOrderNumber = this.orderNumber != "" ? this.orderNumber : showAll;
                var filterInvoiceNumber = this.invoiceNumber != "" ? this.invoiceNumber : showAll;
                //if all fields are empty, then don't send request to a server, but set rows value to start
                if (filterOrderNumber == showAll && filterInvoiceNumber == showAll && this.documentTypeSelect == showAll) {
                    this.resetFilter();
                }
                else {
                    this.getInvoicesList(userId, filterOrderNumber, filterInvoiceNumber, this.documentTypeSelect);
                }
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            __decorate([
                core_1.Input(), 
                __metadata('design:type', Object)
            ], ChildComponent.prototype, "clientModel", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: ClientAreaInvoicesListTemplate.TemplateHtml
                }),
                __param(0, core_1.Inject('CookieService')),
                __param(11, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _a) || Object, (typeof (_b = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _f) || Object, (typeof (_g = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _g) || Object, (typeof (_h = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _h) || Object, (typeof (_j = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _j) || Object, (typeof (_k = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _k) || Object, (typeof (_l = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _l) || Object, Boolean, (typeof (_m = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _m) || Object, (typeof (_o = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _o) || Object, (typeof (_p = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _p) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        }());
        return ChildComponent;
    };
    ClientAreaInvoicesComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(7, core_1.Inject('isBrowser')),
        __param(10, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, Object])
    ], ClientAreaInvoicesComponent);
    return ClientAreaInvoicesComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.ClientAreaInvoicesComponent = ClientAreaInvoicesComponent;


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var cache_service_1 = __webpack_require__(21);
var ComponentHelperService = (function () {
    function ComponentHelperService(cache) {
        this.cache = cache;
    }
    //Inject a component in the viewContainer
    ComponentHelperService.prototype.injectComponent = function (compiler, containterRef, componentToInject) {
        var _this = this;
        var DynamicModule = (function () {
            function DynamicModule() {
            }
            DynamicModule = __decorate([
                core_1.NgModule({
                    imports: [shared_module_1.SharedModule],
                    declarations: [componentToInject]
                }), 
                __metadata('design:paramtypes', [])
            ], DynamicModule);
            return DynamicModule;
        }());
        compiler.compileModuleAndAllComponentsAsync(DynamicModule)
            .then(function (moduleWithFactories) {
            _this.compFactory = moduleWithFactories.componentFactories.find(function (x) { return x.componentType === componentToInject; });
            //from v5 - slow and brings in a lot of code. This line of code affects ram performance negatively
            //https://angular.io/api/core/ReflectiveInjector
            //const injector = ReflectiveInjector.fromResolvedProviders([], containterRef.parentInjector);
            //Clearing current content before injecting new one
            // containterRef.clear();
            //containterRef.createComponent(compFactory, 0, injector);
            _this.cmpRef = containterRef.createComponent(_this.compFactory, 0);
            compiler.clearCache();
            moduleWithFactories = null;
        });
    };
    ComponentHelperService.prototype.clearMemory = function () {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
        this.compFactory = null;
        this.cache.clearAll();
    };
    ComponentHelperService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _a) || Object])
    ], ComponentHelperService);
    return ComponentHelperService;
    var _a;
}());
exports.ComponentHelperService = ComponentHelperService;


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var core_2 = __webpack_require__(27);
var routes_service_1 = __webpack_require__(5);
var BootboxService = (function () {
    function BootboxService(translate, router, routesService, activatedRoute) {
        this.translate = translate;
        this.router = router;
        this.routesService = routesService;
        this.activatedRoute = activatedRoute;
    }
    BootboxService.prototype.i18nAlert = function (key, val) {
        if (val === void 0) { val = ''; }
        var mex = this.getLabel(key);
        if (val == '') {
            var procededToBuy = this.getLabel('continua_gli_acqisti');
            var goToCart = this.getLabel('header_two_cart_button_go_cart');
            var res = void 0;
            var bot_1 = this;
            bootbox.dialog({
                message: mex,
                backdrop: true,
                buttons: {
                    confirm: {
                        label: procededToBuy
                    },
                    cancel: {
                        label: goToCart,
                        callback: function () {
                            bot_1.navigateToCart();
                        },
                        className: 'btn btn-primary'
                    }
                }
            });
        }
        else {
            bootbox.alert({
                message: mex,
                backdrop: true,
            });
        }
    };
    BootboxService.prototype.alertReorderDone = function (key, val) {
        if (val === void 0) { val = ''; }
        var mex = this.getLabel(key);
        if (val == '') {
            var procededToBuy = this.getLabel('continua_gli_acqisti');
            var goToCart = this.getLabel('header_two_cart_button_go_cart');
            var res = void 0;
            var bot_2 = this;
            bootbox.dialog({
                message: mex,
                backdrop: true,
                buttons: {
                    confirm: {
                        label: procededToBuy
                    },
                    cancel: {
                        label: goToCart,
                        callback: function () {
                            bot_2.navigateToCart();
                        },
                        className: 'btn btn-primary'
                    }
                }
            });
        }
        else {
            bootbox.alert({
                message: mex,
                backdrop: true,
            });
        }
    };
    BootboxService.prototype.alertForRiorderFail = function (key) {
        var mex = this.getLabel(key);
        bootbox.alert({
            message: mex,
            backdrop: true,
        });
    };
    BootboxService.prototype.navigateToCart = function () {
        var Url = this.routesService.getRoutePath('CARRELLO')[0];
        //this.router.navigate([Url]);
        window.open(Url, "_self");
    };
    BootboxService.prototype.getLabel = function (label) {
        var message;
        this.translate.get(label, this.translate).subscribe(function (res) {
            message = res;
        });
        return message;
    };
    BootboxService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
    ], BootboxService);
    return BootboxService;
    var _a, _b, _c, _d;
}());
exports.BootboxService = BootboxService;


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var template_service_1 = __webpack_require__(35);
var seo_service_1 = __webpack_require__(11);
var messages_service_1 = __webpack_require__(130);
var routes_service_1 = __webpack_require__(5);
var cookie_service_1 = __webpack_require__(60);
var breadcrumbs_service_1 = __webpack_require__(22);
var core_2 = __webpack_require__(27);
//Models
var user_login_1 = __webpack_require__(73);
var client_area_1 = __webpack_require__(97);
var client_area_2 = __webpack_require__(97);
var client_area_3 = __webpack_require__(97);
var cms_component_service_1 = __webpack_require__(8);
//import * as moment from 'moment'
var platform_browser_1 = __webpack_require__(7);
var md5_1 = __webpack_require__(279);
var Subscription_1 = __webpack_require__(2);
var paypal_service_1 = __webpack_require__(261);
var mapping_1 = __webpack_require__(10);
var currency_service_1 = __webpack_require__(29);
var ClientAreaOrderDetailsComponent = (function () {
    function ClientAreaOrderDetailsComponent(_compiler, componentHelper, _elementRef, templateService, route, clientAreaService, cmsComponentService, authService, router, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.route = route;
        this.clientAreaService = clientAreaService;
        this.cmsComponentService = cmsComponentService;
        this.authService = authService;
        this.router = router;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.clientArea = new client_area_1.ClientAreaOrderDetails();
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaOrderDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        var subComponentTemplateUrl;
        var orderId = 0;
        var orderRowId = 0;
        var paramsSub = this.route.params.subscribe(function (params) {
            var templateHtml;
            var id = params['id'];
            var header;
            var headDataSub = _this.cmsComponentService.getHeaderData().subscribe(function (result) {
                header = result;
                var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
                    }
                });
                _this.subManager.add(SideMenuData);
            });
            _this.subManager.add(headDataSub);
            if (id !== undefined) {
                orderId = id;
                var UserId = _this.authService.GetUserId();
                var orderIdSub = _this.clientAreaService.getClientAreaOrderDetails(UserId, orderId).subscribe(function (result) {
                    templateHtml = result;
                    //Creating subcomponent whith the selected template to inject
                    var subComponent = _this.createSubComponent(templateHtml, orderId, header);
                    //injecting created component (OK)
                    _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                });
                _this.subManager.add(orderIdSub);
            }
            else {
                var orderNotFoundSub = _this.templateService.getComponentTemplate("notfoundPageTemplate").subscribe(function (result) {
                    templateHtml = result;
                    //Creating subcomponent whith the selected template to inject
                    var subComponent = _this.createSubComponent(templateHtml, orderId, header);
                    //injecting created component (OK)
                    _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                });
                _this.subManager.add(orderNotFoundSub);
            }
        });
        this.subManager.add(paramsSub);
    };
    ClientAreaOrderDetailsComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ClientAreaOrderDetailsComponent.prototype.createSubComponent = function (template, orderId, header) {
        var ChildComponent = (function () {
            function ChildComponent(clientAreaService, languageService, authService, routesService, cookie, router, activatedRoute, sanitizer, messagesService, isBrowser, seoService, currency, translateService, breadcrumbsService, paypalService, mappings, scriptService) {
                this.clientAreaService = clientAreaService;
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.cookie = cookie;
                this.router = router;
                this.activatedRoute = activatedRoute;
                this.sanitizer = sanitizer;
                this.messagesService = messagesService;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.currency = currency;
                this.translateService = translateService;
                this.breadcrumbsService = breadcrumbsService;
                this.paypalService = paypalService;
                this.mappings = mappings;
                this.scriptService = scriptService;
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.isActiveInvoicesModule = template.isActiveInvoicesModule;
                this.isCatalogPrivateActive = template.isCatalogPrivateActive;
                this.model = {
                    ProcessOrder: "",
                    processingSubject: "",
                    Description: ""
                };
                this.footerData = template.footerData;
                this.headerData = header;
                this.clientArea = new client_area_1.ClientAreaOrderDetails();
                this.selectedTipoSpedizione = "";
                this.clientAreaList = new Array();
                this.userLogin = user_login_1.UserLogin;
                this.orderProcessMessageList = [];
                this.message = new client_area_3.ClientAreaProcessingOrders();
                this.lang = this.languageService.getLongLang();
                this.authentication = this.authService.GetData();
                this.userName = this.authentication.username;
                this.userId = this.authService.GetUserId();
                this.idord = new client_area_3.ClientAreaProcessingOrders();
                this.upload = "";
                this.info = "active";
                this.comunicazioni = "";
                this.noMessages = false;
                this.checkValues = false;
                this.waitingDetails = false;
                this.pageIsInit = false;
                this.pageIsAfterViewInit = false;
                this.showSpinnerClick = false;
                //checking if multiple shipment module is active
                this.multipleShipmentActive = template.isActiveMultipleShipment;
                this.isTipologiaPagamentoBonifico = template.ClientAreaOrderDetails.isTipologiaPagamentoBonifico ? template.ClientAreaOrderDetails.isTipologiaPagamentoBonifico : false;
                this.numeroTrnInvalid = false;
                this.numeroCroInvalid = false;
                this.startTrnValue = template.ClientAreaOrderDetails.BonificoTrn;
                this.startCroValue = template.ClientAreaOrderDetails.BonificoCro;
                this.bonificoUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(template.BonificoUploadUrl);
                this.bonificoUploadedFiles = template.ClientAreaOrderDetails.BonificoUploadedFilesNames;
                this.breadcrumbs = template.BreadcrumbsInfo;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                if (this.breadcrumbs != null) {
                    var len = this.breadcrumbs.length;
                    var nameLast = this.breadcrumbs[len - 1].BreadcrumbName;
                    var translatedName = this.translateTableColumnTitle(nameLast);
                    this.breadcrumbs[len - 1].BreadcrumbName = translatedName;
                }
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.waitingDetails = false;
                //if user from the page order list clicked on email
                var routeParamsSub = this.activatedRoute.params.subscribe(function (params) {
                    if (params["pagefrom"] == "section_upload") {
                        _this.upload = "active";
                        _this.info = "";
                        _this.comunicazioni = "";
                    }
                    else if (params["pagefrom"] == "section_comunicazioni") {
                        _this.comunicazioni = "active";
                        _this.upload = "";
                        _this.info = "";
                        var orderId_1 = params["id"];
                        _this.setMessagesAsRead(orderId_1);
                    }
                    _this.waitingDetails = true;
                    _this.clientArea = template.ClientAreaOrderDetails;
                    _this.clientArea.CurrencyCode = "EUR";
                    var language = _this.languageService.getShortLang();
                    //cripted orderID with Md5
                    _this.criptedOrderID = md5_1.Md5.hashStr(_this.clientArea.OrderId.toString());
                    if (_this.clientArea.OrderNoteList.length > 0) {
                        _this.noMessages = false;
                    }
                    else {
                        _this.noMessages = true;
                    }
                    //url that the user will be redirected to after paying of order via paypal
                    _this.paymentCompleteUrl = _this.clientArea.PaymentDoneUrl + _this.criptedOrderID;
                    var paymentUrl = _this.clientArea.PaymentDoneUrl + _this.criptedOrderID;
                    _this.paymentCompleteUrl = paymentUrl.replace('{lang}', language);
                    if (_this.clientArea.NexiModel != null) {
                        if (_this.clientArea.NexiModel.url_back_dettaglioOrdine != null) {
                            _this.clientArea.NexiModel.url_back_dettaglioOrdine = _this.clientArea.NexiModel.url_back_dettaglioOrdine.replace('{lang}', language);
                        }
                    }
                    //getting of link for upload files on order details page
                    for (var _i = 0, _a = _this.clientArea.ProcessingOrderList; _i < _a.length; _i++) {
                        var process = _a[_i];
                        process.FileUploadSecuredUrl = _this.sanitizer.bypassSecurityTrustResourceUrl(process.FileUploadUrl);
                        process.PreflightUploadSecuredUrl = _this.sanitizer.bypassSecurityTrustResourceUrl(process.PreflightUploadUrl);
                    }
                });
                this.subManager.add(routeParamsSub);
                if (this.clientArea.TrackingUrl != '' && this.clientArea.TrackingUrl != null) {
                    if (this.clientArea.TrackingUrl.indexOf("http://") == -1 && this.clientArea.TrackingUrl.indexOf("https://") == -1) {
                        this.clientArea.TrackingUrl = "http://" + this.clientArea.TrackingUrl;
                    }
                }
                this.checkTipoSpedizione();
            };
            ChildComponent.prototype.checkTipoSpedizione = function () {
                var tipoSped = this.clientArea.ProcessingOrderList.filter(function (item, i, arr) { return arr.findIndex(function (t) { return t.TipoTrasporto === item.TipoTrasporto; }) === i; });
                var TipoTrasportoShipmentToFilter = "S";
                if (tipoSped.length == 1) {
                    TipoTrasportoShipmentToFilter = tipoSped[0].TipoTrasporto;
                }
                if (this.selectedTipoSpedizione == "") {
                    this.selectedTipoSpedizione = TipoTrasportoShipmentToFilter;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //changing style of status bar(under detail order number) depending on multiple shipment module
                if (this.multipleShipmentActive == true) {
                    $("#paymentStatusBar").addClass('col-md-5').addClass('tabs-style').removeClass('col-md-3').removeClass('tabs-styleNoAfter');
                }
                else {
                    $("#paymentStatusBar").addClass('col-md-3').addClass('tabs-styleNoAfter').removeClass('col-md-5').removeClass('tabs-style');
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsAfterViewInit) {
                    return;
                }
                if (this.clientArea.PaymentType == 'BancaSella' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00') {
                    axerve.lightBox.shop = this.clientArea.BancaSellaModel.payload.shopId;
                }
                //-- If these conditions are not fulfilled, we are not gonna load paypal script, because there is no paypal payment option in the current order.
                if (this.clientArea.PaymentType == 'Paypal' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00' && this.clientArea.IsNewPaypalIntegration) {
                    var userId = this.authService.GetUserId();
                    var params = {
                        CustomerId: userId.toString(),
                        OrderId: orderId.toString(),
                        Lang: this.lang,
                    };
                    //-- Load paypal service and render a button for paypal payment
                    this.paypalService.loadPaypalService(this.mappings.Paypal_JS_Lirary_Url, this.mappings.Web_Api_Create_Paypal_Payment, this.mappings.Web_Api_Execute_Paypal_Payment, params, this.clientArea.PaypalButtonStyle, this.clientArea.UsePaypalProduction);
                }
                this.pageIsAfterViewInit = true;
            };
            ChildComponent.prototype.confirmBonificoDetails = function () {
                var _this = this;
                // trim value before sending it to a server
                this.clientArea.BonificoTrn = this.clientArea.BonificoTrn.trim();
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.updateBonificoPaymentDetails(orderId, this.clientArea.BonificoCro, this.clientArea.BonificoTrn)
                    .subscribe(function (x) {
                    _this.startTrnValue = _this.clientArea.BonificoTrn;
                    _this.startCroValue = _this.clientArea.BonificoCro;
                    //hiding of loading panel after we get all data we need
                    _this.routesService.hidePageLoader();
                    _this.hideBonificoModal();
                }, function (err) {
                    _this.clientArea.BonificoTrn = _this.startTrnValue;
                    _this.clientArea.BonificoCro = _this.startCroValue;
                });
            };
            // validate NumeroTrn input
            ChildComponent.prototype.checkNumeroTrn = function (inputText) {
                inputText = inputText.trim();
                if (inputText.length < 31) {
                    this.numeroTrnInvalid = false;
                }
                else {
                    this.numeroTrnInvalid = true;
                }
            };
            // validate NumeroCro input
            ChildComponent.prototype.checkNumeroCro = function (inputNumber) {
                if (inputNumber < 99999999999) {
                    this.numeroCroInvalid = false;
                }
                else {
                    this.numeroCroInvalid = true;
                }
            };
            // getting uploaded files for this order and showing it inside of bonifico modal
            ChildComponent.prototype.getBonificoUploadedFiles = function () {
                var _this = this;
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.getBonificoUploadedFiles(orderId).subscribe(function (x) {
                    _this.bonificoUploadedFiles = x;
                    //hiding of loading panel after we get all data we need
                    _this.routesService.hidePageLoader();
                });
            };
            ChildComponent.prototype.showBonificoModal = function () {
                $("#bonificoModal").modal("show");
            };
            ChildComponent.prototype.hideBonificoModal = function () {
                $("#bonificoModal").modal("hide");
                this.clientArea.BonificoTrn = this.startTrnValue;
                this.clientArea.BonificoCro = this.startCroValue;
            };
            //translating of header columns titles
            ChildComponent.prototype.translateTableColumnTitle = function (columnTitle) {
                var translation = this.translateService.get(columnTitle)["value"];
                return translation;
            };
            ChildComponent.prototype.payWithPaypal = function () {
                var paypalText = "pay_with_paypal";
                var translatePaypal = this.translateService.get(paypalText)["value"];
                var formHtml = '<form ngNoForm action=\"' + this.clientArea.GatewayUrl + '\" method="post" target="_top" class="m0" name="paypalForm" id=\'paypalForm\'>' +
                    '<input type="hidden" name="cmd" value="_xclick">' +
                    '<input type="hidden" name="business"  value=\"' + this.clientArea.GatewayAccount + '\">' +
                    '<input type="hidden" name="item_name"  value=\"' + this.clientArea.OrderNumber + '\">' +
                    '<input type="hidden" name="currency_code" value=\"' + this.clientArea.CurrencyCode + '\">' +
                    '<input type="hidden" name="amount" value=\"' + this.clientArea.TotalCost + '\">' +
                    '<input type="hidden" name="item_number"  value=\"' + this.clientArea.OrderId + '\">' +
                    '<input type="hidden" name="return" value=\"' + this.paymentCompleteUrl + '\">' +
                    '<input type="hidden" name="rm" value="2">' +
                    '<button (click)="payWithPaypal()" class="btn btn-primary btn-lg" type="button" id="paypal-button-container" name="paypal-button-container">' +
                    '<i class="fa fa-credit-card"></i> ' + translatePaypal +
                    '</button>' +
                    '</form>';
                //replacing form with values from field because of security reasons - if somebody change html content
                var completePaypalForm = $("#completePaypalFormId").html(formHtml);
                $('#paypalForm').submit();
            };
            ChildComponent.prototype.payWithNexi = function () {
                var NexiForm = $("#completeNexiFormId").html();
                var NexiText = "pay_with_nexi";
                var translateNexi = this.translateService.get(NexiText)["value"];
                var formHtml = '<form ngNoForm action=\"' + this.clientArea.NexiModel.requestUrl + '\" method="post" target="_top" class="m0" name="nexiForm" id=\'nexiForm\'>' +
                    '<input type="hidden" name="alias"  value=\"' + this.clientArea.NexiModel.alias + '\"/>' +
                    '<input type="hidden" name="importo"  value=\"' + this.clientArea.NexiModel.importo + '\"/>' +
                    '<input type="hidden" name="divisa"  value=\"' + this.clientArea.NexiModel.divisa + '\"/>' +
                    '<input type="hidden" name="codTrans" value=\"' + this.clientArea.NexiModel.codTrans + '\"/>' +
                    '<input type="hidden" name="url" value=\"' + this.clientArea.NexiModel.url + '\"/>' +
                    '<input type="hidden" name="url_back"  value=\"' + this.clientArea.NexiModel.url_back_ultimoStepCarrello + '\"/>' +
                    '<input type="hidden" name="mac" value=\"' + this.clientArea.NexiModel.mac + '\"/>' +
                    '<input type="hidden" name="tipo_servizio" value="paga_1click"/>' +
                    '<input type="hidden" name="num_contratto" value=\"' + this.clientArea.NexiModel.num_contratto + '\"/>';
                if (this.clientArea.NexiModel.gruppo != null && this.clientArea.NexiModel.gruppo != "") {
                    formHtml += '<input type="hidden" name="gruppo" value=\"' + this.clientArea.NexiModel.gruppo + '\"/>';
                }
                formHtml += '</form>' + NexiForm;
                // formHtml += '</form> <button (click)="payWithNexi()" class="btn btn-primary btn-lg w100" type="button" id="nexi-button-container" name="nexi-button-container">' +
                // '<i class="fa fa-credit-card"></i> ' + translateNexi +
                // '</button>';
                //replacing form with values from field because of security reasons - if somebody change html content
                var completeNexiForm = $("#completeNexiFormId").html(formHtml);
                $('#nexiForm').submit();
            };
            ChildComponent.prototype.payWithBancaSella = function () {
                axerve.lightBox.open(this.clientArea.BancaSellaModel.payload.paymentID, this.clientArea.BancaSellaModel.payload.paymentToken, this.callback);
            };
            ChildComponent.prototype.callback = function (result) {
                if (result.responseURL != null && result.responseURL != undefined && result.responseURL != "") {
                    window.open(result.responseURL, "_self");
                }
            };
            ChildComponent.prototype.setMessagesAsRead = function (orderId) {
                var userId = this.authService.GetUserId();
                var params = {
                    CustomerId: userId.toString(),
                    OrderId: orderId.toString(),
                    Lang: this.lang
                };
                this.messagesService.setMessagesAsRead(params);
            };
            ChildComponent.prototype.showModal = function () {
                $("#confirmModal").modal("show");
            };
            ChildComponent.prototype.hideModal = function () {
                $('#confirmModal').modal('hide');
            };
            //Canceling of orders with status in coda
            ChildComponent.prototype.cancelOrders = function () {
                var _this = this;
                var userId = this.userId;
                var cancelOrdSub = this.clientAreaService.cancelOrders(userId, orderId)
                    .subscribe(function (response) {
                    if (response == true) {
                        _this.clientArea.Status = 4;
                    }
                });
                this.subManager.add(cancelOrdSub);
                this.hideModal();
            };
            ChildComponent.prototype.isDisabled = function (form) {
                var res = false;
                if (form.valid && this.model.ProcessOrder !== "") {
                    return true;
                }
                else {
                    return res;
                }
            };
            //sending of the message from the order details order
            ChildComponent.prototype.processMessage = function () {
                var _this = this;
                this.showSpinnerClick = true;
                var postMessageSub = this.clientAreaService.postClientAreaSendProcessOrderMessageint(this.userId, orderId, parseInt(this.model.ProcessOrder), this.clientArea.OrderNumber, this.clientArea.UserCreated, this.model.processingSubject, this.model.Description, this.lang)
                    .subscribe(function (result) {
                    if (_this.clientArea.OrderProcessMessageList == undefined || _this.clientArea.OrderProcessMessageList == null) {
                        _this.clientArea.OrderProcessMessageList = [];
                    }
                    _this.clientArea.OrderProcessMessageList.push(new client_area_2.ClientAreaOrderProcessMessages(), { "CreatedBy": _this.clientArea.UserCreated, "StringDateCreated": result, "Description": _this.model.Description, "From": 2, "Subject": _this.model.processingSubject });
                    _this.noMessages = false;
                    _this.checkValues = false;
                    _this.model.ProcessOrder = "";
                    _this.model.processingSubject = "";
                    _this.model.Description = "";
                    _this.showSpinnerClick = false;
                });
                this.subManager.add(postMessageSub);
            };
            ChildComponent.prototype.refreshProcessFiles = function (process) {
                var processFilesSub = this.clientAreaService.getProcessOrderFiles(process.Id, orderId).subscribe(function (result) {
                    result.ListOfFiles.forEach(function (element) {
                        if (element.Size.endsWith("byte")) {
                            element.Size = element.Size.substring(0, element.Size.length - 3);
                        }
                    });
                    process.FileState = result.FileState;
                    process.Files = result.ListOfFiles;
                });
                this.subManager.add(processFilesSub);
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: template.TemplateHtml
                }),
                __param(4, core_1.Inject('CookieService')),
                __param(9, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _h) || Object, (typeof (_j = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _j) || Object, Boolean, (typeof (_k = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _k) || Object, (typeof (_l = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _l) || Object, (typeof (_m = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _m) || Object, (typeof (_o = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _o) || Object, (typeof (_p = typeof paypal_service_1.PaypalService !== 'undefined' && paypal_service_1.PaypalService) === 'function' && _p) || Object, (typeof (_q = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _q) || Object, (typeof (_r = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _r) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        }());
        return ChildComponent;
    };
    ClientAreaOrderDetailsComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(9, core_1.Inject('isBrowser')),
        __param(12, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, (typeof (_h = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, Boolean, (typeof (_k = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _k) || Object, (typeof (_l = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _l) || Object, Object])
    ], ClientAreaOrderDetailsComponent);
    return ClientAreaOrderDetailsComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.ClientAreaOrderDetailsComponent = ClientAreaOrderDetailsComponent;


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var script_service_1 = __webpack_require__(14);
var validation_service_1 = __webpack_require__(131);
//Angular
var core_1 = __webpack_require__(0);
//Services
var client_area_service_1 = __webpack_require__(62);
var language_service_1 = __webpack_require__(3);
var component_helper_service_1 = __webpack_require__(4);
var auth_service_1 = __webpack_require__(9);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
//Models
var client_area_1 = __webpack_require__(97);
var client_area_2 = __webpack_require__(97);
var register_1 = __webpack_require__(252);
var company_1 = __webpack_require__(253);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var ClientAreaProfileComponent = (function () {
    function ClientAreaProfileComponent(_compiler, componentHelper, _elementRef, clientAreaService, router, authService, cmsComponentService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.clientAreaService = clientAreaService;
        this.router = router;
        this.authService = authService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.authentication = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.subManager = new Subscription_1.Subscription();
    }
    ClientAreaProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        var templateHtmlUserProfile;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var userProfileSub = this.clientAreaService.getUserAreaProfile(this.userId).subscribe(function (result) {
            templateHtmlUserProfile = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(templateHtmlUserProfile, header);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(userProfileSub);
    };
    ClientAreaProfileComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    ClientAreaProfileComponent.prototype.createSubComponent = function (userProfile, header) {
        var ChildComponent = (function () {
            function ChildComponent(clientAreaService, languageService, authService, routesService, isBrowser, seoService, breadcrumbsService, validationService, scriptService) {
                this.clientAreaService = clientAreaService;
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this.seoService = seoService;
                this.breadcrumbsService = breadcrumbsService;
                this.validationService = validationService;
                this.scriptService = scriptService;
                this.onCreate = new core_1.EventEmitter();
                this.model = {
                    UserId: 0,
                    Address: "",
                    City: "",
                    Prov: "",
                    Cap: "",
                    CompanyName: "",
                    Piva: "",
                    TaxCode: "",
                    Name: "",
                    SubName: "",
                    Telephone: "",
                    Mobile: "",
                    CF: "",
                    PecEmail: "",
                    CodiceDestinatario: "",
                    CurrentPassword: "",
                    Password: "",
                    PasswordRepeat: "",
                    AddressRadio: "",
                    Language: "",
                    AddressNumber: "",
                    DefaultAddress: 999999
                };
                this.modelAddAndRemoveAddress = {
                    UserId: "",
                    AddressId: ""
                };
                this.footerData = userProfile.footerData;
                this.headerData = header;
                this.clientAreaProfile = new client_area_1.ClientAreaUserProfile();
                this.addresses = [];
                this.clientAddress = new client_area_2.ClientAreaUserAddress();
                this.company = new company_1.Company();
                this.register = new register_1.Register();
                this.authentication = this.authService.GetData();
                this.isExist = [];
                this.pageIsInit = false;
                this.userId = this.authService.GetUserId();
                this.decryptedUserId = this.authService.GetDecryptedUserId();
                this.user = userProfile.ClientAreaUserProfile;
                this.userGroup = this.user.UserGroup;
                this.showSpinnerClick = false;
                this.breadcrumbs = userProfile.BreadcrumbsInfo;
                this.pageIsOnDestroy = false;
                this.areaClientiHome = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.areaClientiOrdini = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
                this.areaChangeProfile = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
                this.areaClientiInvoices = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
                this.areaClientiCatalogoRiservato = this.routesService.getRoutePath('RESERVED - CATALOG');
                this.isActiveInvoicesModule = userProfile.isActiveInvoicesModule;
                this.isCatalogPrivateActive = userProfile.isCatalogPrivateActive;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                this.clientAreaProfile = this.user;
                //spliting address street and number
                var address = this.clientAreaProfile.Address;
                var lastIndex = -1;
                if (address) {
                    lastIndex = address.lastIndexOf(" ");
                }
                var addressStreet = "";
                var addressNumber = "";
                if (lastIndex > -1) {
                    addressStreet = address.slice(0, lastIndex);
                    addressNumber = address.slice(lastIndex, address.length).trim();
                }
                this.model.CompanyName = this.user.CompanyName;
                this.model.Piva = this.user.Piva;
                this.model.TaxCode = this.user.TaxCode;
                this.model.Name = this.user.ContactFirstName;
                this.model.SubName = this.user.ContactLastName;
                this.model.Address = addressStreet;
                this.model.AddressNumber = addressNumber;
                this.model.City = this.user.City;
                this.model.Prov = this.user.AreaCode;
                this.model.Cap = this.user.ZipCode;
                this.model.Telephone = this.user.ContactPhone;
                this.model.DefaultAddress = this.user.DefaultAddressId;
                this.model.Mobile = this.user.ContactMobile;
                this.model.PecEmail = this.user.PecEmail;
                this.model.CodiceDestinatario = this.user.CodiceDestinatario;
                this.id1 = this.user.DefaultAddressId;
                for (var key in this.clientAreaProfile.Addresses) {
                    this.isExist[this.clientAreaProfile.Addresses[key].AddressId] = true;
                }
                // if user group is 4, pec email and cod. destinatario are not required
                if (this.userGroup == 4) {
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                if (userProfile.isActiveAddressVerificationModule) {
                    var addressVerificationKey = userProfile.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);
                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.isCodDestRequired = function () {
                var retVal = false;
                if (this.userGroup != "4") {
                    if (this.model.PecEmail == "" || this.model.PecEmail == undefined) {
                        retVal = true;
                    }
                }
                return retVal;
            };
            ChildComponent.prototype.isPecEmailRequired = function () {
                var retVal = false;
                if (this.userGroup != "4") {
                    if (this.model.CodiceDestinatario == "" || this.model.CodiceDestinatario == undefined) {
                        retVal = true;
                    }
                }
                return retVal;
            };
            //adding all scripts and elements connected to address verification feature                
            ChildComponent.prototype.addAddressVerificationScripts = function (addressKey) {
                var suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                var address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                var jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";
                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            };
            //removing all scripts and elements connected to address verification feature                            
            ChildComponent.prototype.removeAddressVerificationScripts = function (addressKey) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");
                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            };
            ChildComponent.prototype.checkAddressValidation = function () {
                this.model.Prov = $("#Prov").val();
                this.model.Cap = $("#Cap").val();
                this.model.City = $("#City").val();
            };
            //validation of phone numbers, disable writing any characters in input except of numbers
            ChildComponent.prototype.validatePhone = function (event) {
                this.validationService.validatePhoneNumber(event);
            };
            ChildComponent.prototype.setAddressValue = function () {
                var streetTypeId = $("#streetTypeId").val();
                var street = $("#Address").val();
                if (streetTypeId != null && streetTypeId != "") {
                    this.model.Address = streetTypeId + " " + street;
                }
                else {
                    this.model.Address = street;
                }
                var cap = $("#Cap").val();
                this.model.Cap = cap;
            };
            ChildComponent.prototype.changeUserProfile = function (valid, model) {
                var _this = this;
                model.UserId = this.authService.GetUserId();
                var street = this.model.Address;
                //concating of address street and number to one model field
                this.model.Address = this.model.Address + " " + this.model.AddressNumber.replace(/\s/g, "");
                this.showSpinnerClick = true;
                var updateProfileSub = this.clientAreaService.updateUserProfile(model).subscribe(function (result) {
                    if (result) {
                        // show success message
                        _this.updateSuccessful = true;
                        _this.updateFailed = false;
                    }
                    else {
                        // show error message
                        _this.updateSuccessful = false;
                        _this.updateFailed = true;
                    }
                    _this.model.Address = street;
                    _this.showSpinnerClick = false;
                });
                this.subManager.add(updateProfileSub);
            };
            ;
            ChildComponent.prototype.showModal = function (index, item) {
                $("#editProfileModal").modal("show");
                this.index = index;
                this.item = item;
            };
            ChildComponent.prototype.hideModal = function () {
                $('#editProfileModal').modal('hide');
            };
            ChildComponent.prototype.addNewAddress = function () {
                var _this = this;
                this.modelAddAndRemoveAddress.UserId = this.userId;
                var newAddressSub = this.clientAreaService.addNewAddress(this.modelAddAndRemoveAddress).subscribe(function (result) {
                    _this.clientAreaProfile.Addresses.push(result);
                    var userProfileSub = _this.clientAreaService.getUserAreaProfile(_this.userId).subscribe(function (result) {
                        _this.clientAreaProfile = result.ClientAreaUserProfile;
                        _this.model.CompanyName = result.ClientAreaUserProfile.CompanyName;
                        _this.model.Piva = result.ClientAreaUserProfile.Piva;
                        _this.model.TaxCode = result.ClientAreaUserProfile.TaxCode;
                        _this.model.Name = result.ClientAreaUserProfile.ContactFirstName;
                        _this.model.SubName = result.ClientAreaUserProfile.ContactLastName;
                        _this.model.Address = result.ClientAreaUserProfile.Address;
                        _this.model.City = result.ClientAreaUserProfile.City;
                        _this.model.Prov = result.ClientAreaUserProfile.AreaCode;
                        _this.model.Cap = result.ClientAreaUserProfile.ZipCode;
                        _this.model.Telephone = result.ClientAreaUserProfile.ContactPhone;
                        _this.model.DefaultAddress = result.ClientAreaUserProfile.DefaultAddressId;
                        _this.model.Mobile = result.ClientAreaUserProfile.ContactMobile;
                        _this.model.PecEmail = result.ClientAreaUserProfile.PecEmail;
                        _this.model.CodiceDestinatario = result.ClientAreaUserProfile.CodiceDestinatario;
                        _this.id1 = result.ClientAreaUserProfile.DefaultAddressId;
                        for (var key in _this.clientAreaProfile.Addresses) {
                            _this.isExist[_this.clientAreaProfile.Addresses[key].AddressId] = true;
                        }
                    });
                    _this.subManager.add(userProfileSub);
                });
                this.subManager.add(newAddressSub);
            };
            ChildComponent.prototype.SubmitPassword = function (model) {
                var _this = this;
                model.UserId = this.userId;
                this.showSpinnerClick = true;
                var updatePassSub = this.clientAreaService.updateUserPassword(model).subscribe(function (result) {
                    if (result == true) {
                        _this.changePasswordSuccessful = true;
                        _this.changePasswordFailed = false;
                    }
                    else {
                        // show error message
                        _this.changePasswordSuccessful = false;
                        _this.changePasswordFailed = true;
                    }
                    _this.showSpinnerClick = false;
                });
                this.subManager.add(updatePassSub);
            };
            ChildComponent.prototype.setDefaultAddress = function (index, item) {
                this.clientAreaProfile.DefaultAddressId = 0;
                for (var _i = 0, _a = this.clientAreaProfile.Addresses; _i < _a.length; _i++) {
                    var address = _a[_i];
                    if (address.AddressId === this.clientAreaProfile.Addresses[index].AddressId) {
                        this.clientAreaProfile.DefaultAddressId = address.AddressId;
                    }
                    this.id1 = this.clientAreaProfile.DefaultAddressId;
                }
            };
            ;
            ChildComponent.prototype.resetAddress = function () {
                for (var _i = 0, _a = this.clientAreaProfile.Addresses; _i < _a.length; _i++) {
                    var address = _a[_i];
                    this.clientAreaProfile.DefaultAddressId = 0;
                    this.id1 = 0;
                }
                ;
            };
            ;
            ChildComponent.prototype.updateUserAddresses = function (model, valid, item) {
                var _this = this;
                this.showSpinnerClick = true;
                var updateAddressSub = this.clientAreaService.updateAddresses(this.clientAreaProfile.Addresses, this.userId, this.clientAreaProfile.DefaultAddressId)
                    .subscribe(function (result) {
                    var defaultFound = false;
                    if (result) {
                        for (var _i = 0, _a = _this.clientAreaProfile.Addresses; _i < _a.length; _i++) {
                            var address = _a[_i];
                            if (_this.clientAreaProfile.DefaultAddressId > 0) {
                                _this.clientAreaProfile.DefaultAddressId = address.AddressId;
                                defaultFound = true;
                            }
                        }
                        _this.updateAddressFailed = false;
                        _this.updateAddressSuccessful = true;
                    }
                    else {
                        _this.updateAddressFailed = true;
                        _this.updateAddressSuccessful = false;
                    }
                    if (defaultFound == false) {
                        _this.clientAreaProfile.DefaultAddressId = 0;
                    }
                    _this.showSpinnerClick = false;
                });
                this.subManager.add(updateAddressSub);
            };
            ;
            ChildComponent.prototype.removeAddress = function () {
                var _this = this;
                this.modelAddAndRemoveAddress.UserId = this.userId;
                this.modelAddAndRemoveAddress.AddressId = this.item.AddressId;
                var removeAddressSub = this.clientAreaService.removeAddress(this.modelAddAndRemoveAddress).subscribe(function (result) {
                    _this.clientAreaProfile.Addresses.splice(_this.index, 1);
                    try {
                        _this.isExist[_this.item.AddressId] = false;
                        _this.model.DefaultAddress = 0;
                        _this.id1 = 0;
                        _this.resetAddress();
                        _this.hideModal();
                    }
                    catch (exception) { }
                });
                this.subManager.add(removeAddressSub);
            };
            ;
            ChildComponent.prototype.isDisabled = function (form) {
                var res = false;
                if (form.valid && this.model.Password.length >= 4 && this.model.Password.length <= 10 && this.model.Password == this.model.PasswordRepeat) {
                    return true;
                }
                else {
                    return res;
                }
            };
            ChildComponent.prototype.getClassforMenuClientArea = function () {
                var result;
                if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
                    result = "col-md-3 col-sm-3";
                }
                else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                    result = "col-md-3 col-sm-3";
                }
                else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                    result = "col-md-4 col-sm-4";
                }
                return result;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }
                //this method is removing all scripts and elements connected to address verification feature
                var addressVerificationKey = userProfile.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);
                this.subManager.unsubscribe();
                this.pageIsOnDestroy = true;
            };
            __decorate([
                core_1.Output(), 
                __metadata('design:type', Object)
            ], ChildComponent.prototype, "onCreate", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: userProfile.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _e) || Object, (typeof (_f = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _f) || Object, (typeof (_g = typeof validation_service_1.ValidationService !== 'undefined' && validation_service_1.ValidationService) === 'function' && _g) || Object, (typeof (_h = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    ClientAreaProfileComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(7, core_1.Inject('isBrowser')),
        __param(10, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof client_area_service_1.ClientAreaService !== 'undefined' && client_area_service_1.ClientAreaService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, Object])
    ], ClientAreaProfileComponent);
    return ClientAreaProfileComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.ClientAreaProfileComponent = ClientAreaProfileComponent;


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//System
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
var language_service_1 = __webpack_require__(3);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PaymentBancaSellaConfirmationComponent = (function () {
    function PaymentBancaSellaConfirmationComponent(_compiler, componentHelper, _elementRef, templateService, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
    }
    PaymentBancaSellaConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var id = 0;
        var Status = "";
        var paramsSub = this.route.queryParams.subscribe(function (params) {
            id = params['orderid'];
            Status = params['Status'];
        });
        this.subManager.add(paramsSub);
        var orderCheckout;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var thankYouSub = this.templateService.getThankYouBancaSellaInfo("orderBancaSellaPageTemplate", id, Status).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                orderCheckout = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(orderCheckout, id, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var typeId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.ThankYouNexiId, id);
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, typeId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(thankYouSub);
    };
    PaymentBancaSellaConfirmationComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject
    PaymentBancaSellaConfirmationComponent.prototype.createSubComponent = function (orderCheckout, OrderId, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, seoService, _elementRef, scriptService, isBrowser, activatedRoute, languageService, translate) {
                this.routesService = routesService;
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.activatedRoute = activatedRoute;
                this.languageService = languageService;
                this.translate = translate;
                this.success = false;
                this.errorMessage = "";
                this.failed = false;
                this.serverError = false;
                this.orderId = OrderId;
                this.seoInfo = orderCheckout.SeoInformation;
                this.pageIsInit = false;
                this.createScript = 0;
                this.subManager = new Subscription_1.Subscription();
                this.footerData = orderCheckout.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                if (this.isBrowser == false) {
                    return;
                }
                if (orderCheckout.result == false) {
                    this.success = false;
                    this.failed = true;
                    this.serverError = false;
                    this.errorMessage = this.getLabel('impossibile_pagare_ordine');
                    this.createScript = -1;
                }
                else {
                    this.success = true;
                    this.failed = false;
                    this.serverError = false;
                    this.createScript = 1;
                }
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                //Eventually retrieving the script to append
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: orderCheckout.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    PaymentBancaSellaConfirmationComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PaymentBancaSellaConfirmationComponent);
    return PaymentBancaSellaConfirmationComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PaymentBancaSellaConfirmationComponent = PaymentBancaSellaConfirmationComponent;


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
var language_service_1 = __webpack_require__(3);
var md5_1 = __webpack_require__(279);
var order_payment_service_1 = __webpack_require__(256);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PaymentConfirmationComponent = (function () {
    function PaymentConfirmationComponent(_compiler, componentHelper, _elementRef, templateService, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
        this.paramsObj = {};
        this.isNewPaypalImplementation = false;
    }
    PaymentConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var id = '0';
        var orderCheckout;
        var paramsSub = this.route.params.subscribe(function (params) {
            id = params['orderid'] || 0;
        });
        var sub = this.route
            .queryParams
            .subscribe(function (params) {
            if (id == '0') {
                id = params['orderId'] ? md5_1.Md5.hashStr(params['orderId']).toString() : '0';
                _this.isNewPaypalImplementation = true;
            }
            else {
                _this.isNewPaypalImplementation = false;
            }
            _this.paramsObj = params;
        });
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var thankYouSub = this.templateService.getThankYouPagePaypalInfo("orderCheckoutPageTemplate", id).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                orderCheckout = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(orderCheckout, _this.paramsObj, _this.isNewPaypalImplementation, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var typeId = '';
                //-- Get Payment Confirmation row id + '_' + orderId, so we can use it for getting scripts
                if (_this.isNewPaypalImplementation) {
                    var OrderId = _this.paramsObj['orderId'];
                    typeId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.ThankYouPagePaypalId, OrderId);
                }
                else {
                    typeId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.ThankYouPagePaypalId, id);
                }
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, typeId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(paramsSub);
        this.subManager.add(sub);
        this.subManager.add(thankYouSub);
    };
    PaymentConfirmationComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject
    PaymentConfirmationComponent.prototype.createSubComponent = function (orderCheckout, urlParams, isNewPaypalImplementation, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, seoService, _elementRef, scriptService, isBrowser, activatedRoute, languageService, orderPaymentService, route) {
                this.routesService = routesService;
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.activatedRoute = activatedRoute;
                this.languageService = languageService;
                this.orderPaymentService = orderPaymentService;
                this.route = route;
                this.success = false;
                this.failed = false;
                this.serverError = false;
                this.seoInfo = orderCheckout.SeoInformation;
                this.pageIsInit = false;
                this.subManager = new Subscription_1.Subscription();
                this.createScript = 0;
                this.footerData = orderCheckout.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                if (this.isBrowser == false) {
                    return;
                }
                //-- If paypal payment is implemented on new way, at this point, the order is already set as paid, else we need to set it
                if (isNewPaypalImplementation) {
                    this.orderId = urlParams['orderId'];
                    if (urlParams.isError.toLowerCase() === 'true') {
                        this.failed = true;
                        this.success = false;
                        this.serverError = false;
                        this.createScript = -1;
                    }
                    else {
                        this.failed = false;
                        this.success = true;
                        this.serverError = false;
                        this.createScript = 1;
                    }
                }
                else {
                    var sub = this.route.queryParams.subscribe(function (parameters) {
                        _this.orderId = parameters['item_number'] || 0;
                        _this.hashedOrderId = md5_1.Md5.hashStr(_this.orderId);
                        var paramsRouteSub = _this.activatedRoute.params.subscribe(function (params) {
                            _this.encryptedOrder = params['orderid'] || 0;
                        });
                        _this.subManager.add(paramsRouteSub);
                        //Checking of order and set it as paid
                        if (parameters['st'] == "Completed" && _this.encryptedOrder == _this.hashedOrderId) {
                            _this.setOrderAsPaid();
                        }
                        else {
                            _this.failed = true;
                            _this.success = false;
                        }
                    });
                }
            };
            ChildComponent.prototype.setOrderAsPaid = function () {
                var _this = this;
                var orderPaySub = this.orderPaymentService.setOrderAsPayed(this.orderId)
                    .subscribe(function (result) {
                    if (result == 1) {
                        _this.success = true;
                        _this.failed = false;
                        _this.serverError = false;
                        _this.createScript = 1;
                    }
                    else if (result == -1) {
                        _this.success = false;
                        _this.failed = true;
                        _this.serverError = false;
                        _this.createScript = -1;
                    }
                    else {
                        _this.success = false;
                        _this.failed = false;
                        _this.serverError = true;
                        _this.createScript = -1;
                    }
                });
                this.subManager.add(orderPaySub);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: orderCheckout.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof order_payment_service_1.OrderPaymentService !== 'undefined' && order_payment_service_1.OrderPaymentService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    PaymentConfirmationComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PaymentConfirmationComponent);
    return PaymentConfirmationComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PaymentConfirmationComponent = PaymentConfirmationComponent;


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//System
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
var language_service_1 = __webpack_require__(3);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PaymentNexiConfirmationComponent = (function () {
    function PaymentNexiConfirmationComponent(_compiler, componentHelper, _elementRef, templateService, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
    }
    PaymentNexiConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var id = 0;
        var messaggio = "";
        var data = "";
        var orario = "";
        var paramsSub = this.route.queryParams.subscribe(function (params) {
            id = params['orderid'];
            messaggio = params['messaggio'];
            data = params['data'];
            orario = params['orario'];
        });
        this.subManager.add(paramsSub);
        var orderCheckout;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var thankYouSub = this.templateService.getThankYouNexiInfo("ordernexiPageTemplate", id, messaggio, data, orario).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                orderCheckout = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(orderCheckout, id, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var typeId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.ThankYouNexiId, id);
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, typeId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(thankYouSub);
    };
    PaymentNexiConfirmationComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject
    PaymentNexiConfirmationComponent.prototype.createSubComponent = function (orderCheckout, OrderId, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, seoService, _elementRef, scriptService, isBrowser, activatedRoute, languageService, translate) {
                this.routesService = routesService;
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.activatedRoute = activatedRoute;
                this.languageService = languageService;
                this.translate = translate;
                this.success = false;
                this.errorMessage = "";
                this.failed = false;
                this.serverError = false;
                this.orderId = OrderId;
                this.seoInfo = orderCheckout.SeoInformation;
                this.pageIsInit = false;
                this.createScript = 0;
                this.subManager = new Subscription_1.Subscription();
                this.footerData = orderCheckout.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                if (this.isBrowser == false) {
                    return;
                }
                if (orderCheckout.result == false) {
                    this.success = false;
                    this.failed = true;
                    this.serverError = false;
                    this.errorMessage = this.getLabel('impossibile_pagare_ordine');
                    this.createScript = -1;
                }
                else {
                    this.success = true;
                    this.failed = false;
                    this.serverError = false;
                    this.createScript = 1;
                }
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                //Eventually retrieving the script to append
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: orderCheckout.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _g) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    PaymentNexiConfirmationComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PaymentNexiConfirmationComponent);
    return PaymentNexiConfirmationComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PaymentNexiConfirmationComponent = PaymentNexiConfirmationComponent;


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//System
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var cms_component_service_1 = __webpack_require__(8);
var router_1 = __webpack_require__(12);
var language_service_1 = __webpack_require__(3);
var order_payment_service_1 = __webpack_require__(256);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var PaymentUnicreditConfirmationComponent = (function () {
    function PaymentUnicreditConfirmationComponent(_compiler, componentHelper, _elementRef, templateService, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
    }
    PaymentUnicreditConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var id = 0;
        var paramsSub = this.route.params.subscribe(function (params) {
            id = params['orderid'];
        });
        this.subManager.add(paramsSub);
        var orderCheckout;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        //console.log("sono qui")
        var thankYouSub = this.templateService.getThankYouPagOnlineInfo("orderUnicreditPageTemplate", id).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                orderCheckout = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(orderCheckout, id, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                var typeId = _this.scriptService.getSystemPageRowId_OrderId(_this.scriptService.ThankYouPagePagOnlineId, id);
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, typeId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(thankYouSub);
    };
    PaymentUnicreditConfirmationComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject
    PaymentUnicreditConfirmationComponent.prototype.createSubComponent = function (orderCheckout, OrderId, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, seoService, _elementRef, scriptService, isBrowser, activatedRoute, languageService, translate, orderPaymentService) {
                this.routesService = routesService;
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.isBrowser = isBrowser;
                this.activatedRoute = activatedRoute;
                this.languageService = languageService;
                this.translate = translate;
                this.orderPaymentService = orderPaymentService;
                this.success = false;
                this.errorMessage = "";
                this.failed = false;
                this.serverError = false;
                this.orderId = OrderId;
                this.seoInfo = orderCheckout.SeoInformation;
                this.pageIsInit = false;
                this.createScript = 0;
                //subManager = new Subscription();
                this.resultPagOnline = orderCheckout.resultPagOnline;
                this.footerData = orderCheckout.FooterData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                if (this.isBrowser == false) {
                    return;
                }
                if (this.orderId == -1) {
                    this.success = false;
                    this.failed = true;
                    this.serverError = false;
                    this.errorMessage = this.getLabel('impossibile_pagare_ordine');
                    this.createScript = -1;
                }
                else {
                    //setting order as paid                                
                    //let checkPaymentSub = this.orderPaymentService.CheckIsOrderPayedUnicredit(this.orderId)
                    //.subscribe(result => {
                    var res = this.resultPagOnline.split("|");
                    if (res[0] == "1") {
                        this.success = true;
                        this.failed = false;
                        this.serverError = false;
                        this.createScript = 1;
                    }
                    else if (res[0] == "-1") {
                        this.success = false;
                        this.failed = true;
                        this.serverError = false;
                        this.errorMessage = res[1];
                        this.createScript = -1;
                    }
                    else {
                        this.success = false;
                        this.failed = false;
                        this.serverError = true;
                        this.errorMessage = res[1];
                        this.createScript = -1;
                    }
                }
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                //Eventually retrieving the script to append
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                //this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: orderCheckout.TemplateHtml
                }),
                __param(4, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, (typeof (_g = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof order_payment_service_1.OrderPaymentService !== 'undefined' && order_payment_service_1.OrderPaymentService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    PaymentUnicreditConfirmationComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], PaymentUnicreditConfirmationComponent);
    return PaymentUnicreditConfirmationComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.PaymentUnicreditConfirmationComponent = PaymentUnicreditConfirmationComponent;


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var user_login_1 = __webpack_require__(73);
var validation_service_1 = __webpack_require__(131);
var login_service_1 = __webpack_require__(179);
//Angular
var core_1 = __webpack_require__(0);
var component_helper_service_1 = __webpack_require__(4);
var check_existence_service_1 = __webpack_require__(255);
var rxjs_1 = __webpack_require__(265);
var routes_service_1 = __webpack_require__(5);
var router_1 = __webpack_require__(12);
var register_1 = __webpack_require__(252);
var language_service_1 = __webpack_require__(3);
var configuration_service_1 = __webpack_require__(258);
var company_service_1 = __webpack_require__(129);
var cookie_1 = __webpack_require__(85);
var auth_service_1 = __webpack_require__(9);
var header_service_1 = __webpack_require__(127);
var company_1 = __webpack_require__(253);
var QuickRegistrationComponent = (function () {
    function QuickRegistrationComponent(_compiler, componentHelper, _elementRef, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.isBrowser = isBrowser;
    }
    QuickRegistrationComponent.prototype.ngOnInit = function () {
        if (!this.isBrowser)
            return;
        if (this.parentWidgetData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentWidgetData, this.companyInfo);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    };
    QuickRegistrationComponent.prototype.createSubComponent = function (quickRegistrationData, companyInfo) {
        var ChildComponent = (function () {
            function ChildComponent(isBrowser, loginService, checkExists, router, routesService, activeRoute, languageService, companyService, configurationService, cookie, validationService, authService, headerService) {
                this.isBrowser = isBrowser;
                this.loginService = loginService;
                this.checkExists = checkExists;
                this.router = router;
                this.routesService = routesService;
                this.activeRoute = activeRoute;
                this.languageService = languageService;
                this.companyService = companyService;
                this.configurationService = configurationService;
                this.cookie = cookie;
                this.validationService = validationService;
                this.authService = authService;
                this.headerService = headerService;
                this.pageIsInit = false;
                //-- Email controls
                this.isEmailValid = false;
                this.emailExists = false;
                //-- Partita iva controls
                this.isPivaValid = false;
                this.pivaExists = false;
                //-- Codice Fiscale controls
                this.isCFValid = false;
                this.CFExists = false;
                this.pageFrom = "";
                this.load = false;
                this.subManager = new rxjs_1.Subscription();
                this.modelRegistration = new register_1.QuickRegister();
                this.lang = this.languageService.getLongLang();
                this.company = companyInfo;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var paramsSub = this.activeRoute.params.subscribe(function (params) {
                    var paramPageFrom = params['pagefrom'];
                    if (paramPageFrom !== undefined) {
                        _this.pageFrom = paramPageFrom;
                    }
                });
                this.subManager.add(paramsSub);
                //-- Get configuration from server
                this.setConfiguration();
            };
            ChildComponent.prototype.finishQuickRegistration = function () {
                var _this = this;
                this.load = true;
                //-- After submiting form, we are disabling a button until we get a response
                this.submitButton.nativeElement.disabled = true;
                var quickRegisterUserObj = this.setQuickRegisterObject();
                //-- Save quick registration user info in cookies so we can reuse it later
                this.cookie.putObject("QuickRegisterUser", quickRegisterUserObj);
                var isQuickRegister = true;
                this.cookie.put('IsQuickRegistered', isQuickRegister.toString());
                var sendInfoSub = this.loginService.quickRegister(this.modelRegistration)
                    .subscribe(function (response) {
                    _this.load = false;
                    _this.hideModalQuickRegistration();
                    if (response.Id_User_Dettail > 0 && response.Active) {
                        var name = response.Name ? response.Name : response.Email;
                        _this.authService.Login(response.Id_User_Dettail, name);
                    }
                    if (response.IsCompletedRegistration == false) {
                        if (response.Active) {
                            var user = new user_login_1.UserLogin();
                            user.isAuthenticated = true;
                            user.username = response.Name ? response.Name : response.Email;
                            //-- Call service to update header info, to set a logged in user
                            _this.headerService.setLoggedInUser(user);
                            //-- Hide quick registration component even after user is logged in, because we want to show an additional dialog modal
                            _this.headerService.setToShowQuickRegistration(true);
                            _this.showQuickRegistrationSuccessModal();
                        }
                    }
                    else if (_this.pageFrom == "cart") {
                        _this.router.navigate(_this.routesService.getRoutePath('CARRELLO'));
                    }
                    else {
                        _this.router.navigate(_this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));
                    }
                });
                this.subManager.add(sendInfoSub);
            };
            ChildComponent.prototype.setQuickRegisterObject = function () {
                var quickRegisterObj = {
                    QuickEmailUser: this.modelRegistration.EmailRegister.trim(),
                    QuickPartitaIva: this.modelRegistration.PartitaIva.trim(),
                    QuickCodiceFiscale: this.modelRegistration.CodiceFiscale.trim(),
                    QuickClientType: this.modelRegistration.CustomerGroup.trim(),
                    QuickTelephone: this.modelRegistration.Telephone.trim(),
                };
                return quickRegisterObj;
            };
            ChildComponent.prototype.quickRegister = function () {
                if (this.isEmailValid) {
                    this.hideModalQuickRegistrationEmail();
                    this.showModalQuickRegistration();
                }
            };
            //-- Checking after changing of focus if the email entered in form already exists in database
            ChildComponent.prototype.checkEmail = function (form) {
                var _this = this;
                if (form.controls.EmailRegister.valid) {
                    var checkEmailSub = this.checkExists.checkIfEmailExistsInDb(this.modelRegistration.EmailRegister)
                        .subscribe(function (result) {
                        if (result == 1) {
                            _this.isEmailValid = true;
                            _this.emailExists = false;
                        }
                        else {
                            _this.isEmailValid = false;
                            _this.emailExists = true;
                        }
                    });
                    this.subManager.add(checkEmailSub);
                }
                else {
                    this.isEmailValid = false;
                    this.emailExists = false;
                }
            };
            //-- Checking after changing of focus if the partita iva entered in form already exists in database
            ChildComponent.prototype.checkPiva = function (field) {
                var _this = this;
                if (field.valid) {
                    if (!field.value || !field.value.trim())
                        return;
                    this.checkExists.checkIfPartitaIvaExistsInDb(this.modelRegistration.PartitaIva)
                        .subscribe(function (result) {
                        if (result == 1) {
                            _this.isPivaValid = true;
                            _this.pivaExists = false;
                        }
                        else {
                            if (_this.modelRegistration.CustomerGroup !== '7') {
                                _this.isPivaValid = false;
                                _this.pivaExists = true;
                            }
                            else {
                                _this.isPivaValid = true;
                                _this.pivaExists = false;
                            }
                        }
                    });
                }
                else {
                    if (this.modelRegistration.CustomerGroup !== '7') {
                        this.isPivaValid = false;
                        this.pivaExists = false;
                    }
                    else {
                        this.isPivaValid = true;
                        this.pivaExists = false;
                    }
                }
            };
            //-- Checking after changing of focus if the codice fiscale entered in form already exists in database
            ChildComponent.prototype.checkCF = function (field) {
                var _this = this;
                if (!field.valid) {
                    this.isPivaValid = false;
                    this.pivaExists = false;
                }
                //-- Check if the CF already exists only when group is privato
                if (this.modelRegistration.CustomerGroup === '4') {
                    if (field.valid) {
                        this.checkExists.checkIfCodiceFiscaleExistsInDb(this.modelRegistration.CodiceFiscale)
                            .subscribe(function (result) {
                            {
                                if (result == 1) {
                                    _this.isCFValid = true;
                                    _this.CFExists = false;
                                }
                                else {
                                    _this.isCFValid = false;
                                    _this.CFExists = true;
                                }
                            }
                        });
                    }
                }
                else {
                    this.isCFValid = true;
                    this.CFExists = false;
                }
            };
            //validation of phone numbers, disable writing any characters in input except of numbers
            ChildComponent.prototype.validatePhone = function (event) {
                this.validationService.validatePhoneNumber(event);
            };
            ChildComponent.prototype.setConfiguration = function () {
                var _this = this;
                this.configurationService.getConfiguration(this.lang).subscribe(function (resultConfiguration) {
                    var companySub = _this.companyService.getCompany().subscribe(function (resultCompany) {
                        {
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}').join(resultCompany.Name);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}').join(resultCompany.StreetAddress);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}').join(resultCompany.PostalCode);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}').join(resultCompany.City);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}').join(resultCompany.Province);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}').join(resultCompany.Phone);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}').join(resultCompany.Email);
                            }
                        }
                        _this.configuration = resultConfiguration;
                    });
                    _this.subManager.add(companySub);
                });
            };
            ChildComponent.prototype.onCustomerGroupChange = function (value) {
                this.setValuesOnCustomerGroupChange();
                this.modelRegistration.CustomerGroup = value;
                if (this.modelRegistration.CustomerGroup == '4' || this.modelRegistration.CustomerGroup == '7') {
                    this.isPivaValid = true;
                }
                else {
                    this.isCFValid = true;
                }
            };
            ChildComponent.prototype.saveOldGroup = function () {
                this.oldGroup = this.modelRegistration.CustomerGroup;
            };
            ChildComponent.prototype.setValuesOnCustomerGroupChange = function () {
                this.modelRegistration = new register_1.QuickRegister(this.modelRegistration.EmailRegister, this.modelRegistration.EmailRepeat, this.modelRegistration.Password, this.modelRegistration.Telephone, this.modelRegistration.CustomerGroup, this.modelRegistration.CodiceFiscale, this.modelRegistration.PartitaIva, this.oldGroup);
            };
            ChildComponent.prototype.resetForm = function () {
                this.modelRegistration = new register_1.QuickRegister(this.modelRegistration.EmailRegister);
            };
            //-- Hiding and showing corresponding modals
            ChildComponent.prototype.showModalQuickRegistration = function () {
                this.showModal('quickRegistrationModal');
            };
            ChildComponent.prototype.hideModalQuickRegistration = function () {
                this.hideModal('quickRegistrationModal');
                this.modelRegistration.EmailRegister = '';
                this.resetForm();
            };
            ChildComponent.prototype.showModalQuickRegistrationEmail = function () {
                this.showModal('quickRegistrationEmailModal');
            };
            ChildComponent.prototype.showQuickRegistrationSuccessModal = function () {
                this.showModal('quickRegistrationSuccessModal');
            };
            ChildComponent.prototype.hideQuickRegistrationSuccessModal = function () {
                this.hideModal('quickRegistrationSuccessModal');
                //-- Hide quick registration component
                this.headerService.setToShowQuickRegistration(false);
            };
            ChildComponent.prototype.hideModalQuickRegistrationEmailAndResetEmail = function () {
                this.hideModalQuickRegistrationEmail();
                this.modelRegistration.EmailRegister = '';
            };
            ChildComponent.prototype.hideModalQuickRegistrationEmail = function () {
                this.hideModal('quickRegistrationEmailModal');
            };
            ChildComponent.prototype.showModal = function (modalId) {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                document.querySelector('#header').style.zIndex = '1041';
                $("#" + modalId).modal("show");
            };
            ChildComponent.prototype.hideModal = function (modalId) {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                document.querySelector('#header').style.zIndex = '1041';
                $("#" + modalId).modal("hide");
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                this.pageIsInit = true;
            };
            __decorate([
                core_1.ViewChild('submitButton'), 
                __metadata('design:type', (typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object)
            ], ChildComponent.prototype, "submitButton", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: quickRegistrationData.TemplateHtml
                }),
                __param(0, core_1.Inject('isBrowser')),
                __param(9, core_1.Inject('CookieService')), 
                __metadata('design:paramtypes', [Boolean, (typeof (_b = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _b) || Object, (typeof (_c = typeof check_existence_service_1.CheckIfExistService !== 'undefined' && check_existence_service_1.CheckIfExistService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _g) || Object, (typeof (_h = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _h) || Object, (typeof (_j = typeof configuration_service_1.ConfigurationService !== 'undefined' && configuration_service_1.ConfigurationService) === 'function' && _j) || Object, (typeof (_k = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _k) || Object, (typeof (_l = typeof validation_service_1.ValidationService !== 'undefined' && validation_service_1.ValidationService) === 'function' && _l) || Object, (typeof (_m = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _m) || Object, (typeof (_o = typeof header_service_1.HeaderService !== 'undefined' && header_service_1.HeaderService) === 'function' && _o) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], QuickRegistrationComponent.prototype, "parentWidgetData", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', (typeof (_a = typeof company_1.Company !== 'undefined' && company_1.Company) === 'function' && _a) || Object)
    ], QuickRegistrationComponent.prototype, "companyInfo", void 0);
    QuickRegistrationComponent = __decorate([
        core_1.Component({
            selector: "dy-quick-register",
            template: ""
        }),
        __param(3, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_b = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _b) || Object, (typeof (_c = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _d) || Object, Boolean])
    ], QuickRegistrationComponent);
    return QuickRegistrationComponent;
    var _a, _b, _c, _d;
}());
exports.QuickRegistrationComponent = QuickRegistrationComponent;


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var validation_service_1 = __webpack_require__(131);
var cookie_service_1 = __webpack_require__(60);
//Angular
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var mapping_1 = __webpack_require__(10);
//Services
var register_service_1 = __webpack_require__(98);
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var company_service_1 = __webpack_require__(129);
var configuration_service_1 = __webpack_require__(258);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
//Models
var register_1 = __webpack_require__(252);
var Subscription_1 = __webpack_require__(2);
var check_existence_service_1 = __webpack_require__(255);
var auth_service_1 = __webpack_require__(9);
var login_service_1 = __webpack_require__(179);
var platform_browser_1 = __webpack_require__(7);
var core_2 = __webpack_require__(27);
var RegisterComponent = (function () {
    function RegisterComponent(_compiler, componentHelper, _elementRef, languageService, registerService, route, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.registerService = registerService;
        this.route = route;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var isQuickRegistration = this.route.snapshot.queryParams["quickRegistration"] || false;
        var registerSub = this.registerService.getRegisterPageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                if (!result.IsActiveQuickRegistration) {
                    isQuickRegistration = false;
                }
                //Creating subcomponent whith the register result information to inject
                var subComponent = _this.createSubComponent(result, isQuickRegistration, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.userRegistrationId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(registerSub);
    };
    RegisterComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    RegisterComponent.prototype.createSubComponent = function (result, isQuickRegistrationActive, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, registerService, languageService, router, mappings, checkExists, isBrowser, _elementRef, scriptService, companyService, configurationService, routesService, translate, breadcrumbsService, _compiler, route, validationService, cookie, authService, loginService) {
                this.seoService = seoService;
                this.registerService = registerService;
                this.languageService = languageService;
                this.router = router;
                this.mappings = mappings;
                this.checkExists = checkExists;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.companyService = companyService;
                this.configurationService = configurationService;
                this.routesService = routesService;
                this.translate = translate;
                this.breadcrumbsService = breadcrumbsService;
                this._compiler = _compiler;
                this.route = route;
                this.validationService = validationService;
                this.cookie = cookie;
                this.authService = authService;
                this.loginService = loginService;
                this.siteKey = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
                this.theme = "light";
                this.seoInfo = result.SeoInformation;
                this.emailError = false;
                this.passwordError = false;
                this.success = false;
                this.load = false;
                this.validEmail = "";
                this.pageIsInit = false;
                this.pageIsOnDestroy = false;
                this.showEmailInvalid = false;
                this.showPivaInvalid = false;
                this.showCFInvalid = false;
                this.isValidCodDest = "";
                this.isValidPecEmail = "";
                this.isRequiredPecEmail = true;
                this.isQuickRegistration = isQuickRegistrationActive;
                this.quickRegisteredUser = null;
                this.lang = this.languageService.getLongLang();
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.registerViaFbData = this.registerService.getFacebookLoginData();
                this.disableFbDataFields = false;
                this.cartRoute = this.routesService.getRoutePath('CARRELLO');
                this.homepageRoute = this.routesService.getRoutePath('HOME');
                this.pageFrom = "";
                this.subManager = new Subscription_1.Subscription();
                this.footerData = result.footerData;
                this.headerData = header;
                this.nationCode = "";
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                var paramsSub = this.route.params.subscribe(function (params) {
                    var paramPageFrom = params['pagefrom'];
                    if (paramPageFrom !== undefined) {
                        _this.pageFrom = paramPageFrom;
                    }
                });
                this.subManager.add(paramsSub);
                this.nationList = result.nationList;
                this.model = new register_1.Register();
                this.customerTypeList = result.UserTypes;
                this.onNationTypeChange(result.DefaultNation);
                this.model.CustomerGroup = "5";
                this.model.CustomerType = "";
                this.model.PecEmail = "";
                this.model.CodiceDestinatario = "";
                //-- If the user used quick registration feature, we can get it's data from the cookies
                if (this.isQuickRegistration) {
                    this.quickRegisteredUser = this.cookie.getObject("QuickRegisterUser");
                    this.setModelDataFromCookies();
                }
                this.showEmailInvalid = false;
                if (this.registerViaFbData) {
                    this.model.CustomerGroup = "4";
                    this.setModelDataFromFb(this.registerViaFbData);
                }
                this.isCodDestRequired();
                this.isPecEmailRequired();
                this.configurationService.getConfiguration(this.lang).subscribe(function (resultConfiguration) {
                    var companySub = _this.companyService.getCompany().subscribe(function (resultCompany) {
                        {
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}').join(resultCompany.Name);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}').join(resultCompany.StreetAddress);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}').join(resultCompany.PostalCode);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}').join(resultCompany.City);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}').join(resultCompany.Province);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}').join(resultCompany.Phone);
                            }
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}').join(resultCompany.Email);
                            }
                        }
                        _this.configuration = resultConfiguration;
                    });
                    _this.subManager.add(companySub);
                });
            };
            ;
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.isItalyNation = function () {
                var result = false;
                if (this.model.Nation == 8494) {
                    result = true;
                }
                else {
                    if (this.model.CustomerGroup != "5" && this.model.CustomerGroup != "4") {
                        this.onCustomerGroupChange("5");
                    }
                }
                return result;
            };
            ChildComponent.prototype.isPrivateCustomer = function () {
                var result = false;
                if (this.model.CustomerGroup == "4") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setModelDataFromCookies = function () {
                if (!this.quickRegisteredUser)
                    return;
                this.model.EmailRegister = this.quickRegisteredUser['QuickEmailUser'];
                this.model.EmailRepeat = this.quickRegisteredUser['QuickEmailUser'];
                this.model.CustomerGroup = this.quickRegisteredUser['QuickClientType'];
                this.model.Telephone = this.quickRegisteredUser['QuickTelephone'];
                var isQuickRegistered = this.cookie.get("IsQuickRegistered") ? Boolean(this.cookie.get("IsQuickRegistered")) : false;
                this.model.IsQuickRegistered = isQuickRegistered;
                //-- If customer group is privato or associazione, then CF was already set during registration, else Partita Iva was set
                if (this.model.CustomerGroup === '4' || this.model.CustomerGroup === '7') {
                    this.model.CF = this.quickRegisteredUser['QuickCodiceFiscale'];
                }
                else {
                    this.model.Piva = this.quickRegisteredUser['QuickPartitaIva'];
                }
            };
            ChildComponent.prototype.disableFieldsFilledFromFbData = function () {
                this.disableFbDataFields = true;
            };
            ChildComponent.prototype.setModelDataFromFb = function (reg) {
                this.model.Name = reg.Name;
                this.model.SubName = reg.SubName;
                this.model.EmailRegister = reg.Email;
                this.model.EmailRepeat = reg.Email;
                this.model.Password = reg.Password;
                this.model.PasswordRepeat = reg.Password;
                this.disableFieldsFilledFromFbData();
            };
            //adding all scripts and elements connected to address verification feature                
            ChildComponent.prototype.addAddressVerificationScripts = function (addressKey) {
                var suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                var address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                var jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";
                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            };
            //removing all scripts and elements connected to address verification feature                            
            ChildComponent.prototype.removeAddressVerificationScripts = function (addressKey) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");
                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            };
            ChildComponent.prototype.checkAddressValidation = function () {
                this.model.Prov = $("#Prov").val();
                this.model.Cap = $("#Cap").val();
                this.model.City = $("#City").val();
            };
            ChildComponent.prototype.setAddressValue = function () {
                var streetTypeId = $("#streetTypeId").val();
                var street = $("#Address").val();
                if (streetTypeId != null && streetTypeId != "") {
                    this.model.Address = streetTypeId + " " + street;
                }
                else {
                    this.model.Address = street;
                }
            };
            ChildComponent.prototype.isDisabled = function (form) {
                var res = false;
                if (this.disableFbDataFields) {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat && this.model.Password == this.model.PasswordRepeat) {
                        res = true;
                    }
                    else {
                        res = false;
                    }
                }
                else if (this.isQuickRegistration && this.quickRegisteredUser) {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat) {
                        res = true;
                    }
                    else {
                        res = false;
                    }
                }
                else {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat && this.model.Password == this.model.PasswordRepeat
                        && this.emailValid == true && this.showCFInvalid == false) {
                        if (this.model.CustomerGroup != '4') {
                            if (this.showPivaInvalid == false) {
                                res = true;
                            }
                            else {
                                res = false;
                            }
                        }
                        else {
                            res = true;
                        }
                    }
                    else {
                        res = false;
                    }
                }
                return res;
            };
            //checking after changing of focus if the email entered in form already exists in database
            ChildComponent.prototype.checkEmail = function (form) {
                var _this = this;
                var email = this.model.EmailRegister;
                if (form.controls.EmailRegister.valid) {
                    if (this.disableFbDataFields == false) {
                        var checkEmailSub = this.checkExists.checkIfEmailExistsInDb(email)
                            .subscribe(function (result) {
                            _this.showEmailInvalid = false;
                            if (result == 1) {
                                _this.emailValid = true;
                                _this.validEmail = "ng-valid";
                            }
                            else {
                                _this.emailValid = false;
                                _this.validEmail = "ng-invalid";
                                _this.showEmailInvalid = true;
                            }
                        });
                        this.subManager.add(checkEmailSub);
                    }
                }
                else {
                    this.emailValid = false;
                    this.validEmail = "ng-invalid";
                    this.showEmailInvalid = false;
                }
            };
            //checking after changing of focus if the partita iva entered in form already exists in database
            ChildComponent.prototype.checkPiva = function (field) {
                var _this = this;
                var piva = this.model.Piva;
                if (field.valid) {
                    if (!field.value || !field.value.trim())
                        return;
                    if (this.disableFbDataFields == false) {
                        this.checkExists.checkIfPartitaIvaExistsInDb(piva)
                            .subscribe(function (result) {
                            _this.showPivaInvalid = false;
                            if (result == 1) {
                                _this.showPivaInvalid = false;
                            }
                            else {
                                if (_this.model.CustomerGroup !== '7') {
                                    _this.showPivaInvalid = true;
                                }
                            }
                        });
                    }
                }
                else {
                    if (this.model.CustomerGroup !== '7') {
                        this.showPivaInvalid = true;
                    }
                }
            };
            //checking after changing of focus if the codice fiscale entered in form already exists in database
            ChildComponent.prototype.checkCF = function (field) {
                var _this = this;
                var CF = this.model.CF;
                //-- Check if the CF already exists only when group is privato
                if (this.model.CustomerGroup === '4') {
                    if (field.valid) {
                        if (this.disableFbDataFields == false) {
                            this.checkExists.checkIfCodiceFiscaleExistsInDb(CF)
                                .subscribe(function (result) {
                                _this.showCFInvalid = false;
                                if (result == 1) {
                                    _this.showCFInvalid = false;
                                }
                                else {
                                    _this.showCFInvalid = true;
                                }
                            });
                        }
                    }
                    else {
                        this.showCFInvalid = true;
                    }
                }
                else {
                    this.showCFInvalid = false;
                }
            };
            ChildComponent.prototype.onSubmit = function () {
                var _this = this;
                //after submiting form, we are disabling a button until we get a response
                this.submitButton.nativeElement.disabled = true;
                this.load = true;
                this.model.Language = this.languageService.getLongLang();
                //converting CAP field to string
                this.model.Cap = this.model.Cap.toString();
                //concating of address street and number to one model field
                this.model.Address = this.model.Address + " " + this.model.AddressNumber.replace(/\s/g, "");
                if (this.registerViaFbData != null && this.registerViaFbData != undefined) {
                    this.model.IsCompletedRegistration = false;
                }
                var sendInfoSub = this.registerService.sendInfoRequest(this.model)
                    .subscribe(function (result) {
                    if (result["selected"]) {
                        if (_this.isQuickRegistration) {
                            var authSub = _this.loginService.authentificateUser(_this.model.EmailRegister, _this.model.Name, _this.model.Name).subscribe(function (response) {
                                _this.cookie.remove('QuickRegisterUser');
                                _this.cookie.remove('IsQuickRegistered');
                                _this.authService.Login(response.Id_User_Dettail, response.Name);
                                _this.navigateToCorespondingPage();
                            });
                        }
                        else {
                            _this.navigateToCorespondingPage();
                        }
                    }
                    else {
                        _this.emailError = false;
                        _this.passwordError = false;
                        _this.isRegisterFailed = true;
                        _this.load = false;
                        _this.success = false;
                    }
                });
                this.subManager.add(sendInfoSub);
            };
            ChildComponent.prototype.navigateToCorespondingPage = function () {
                if (this.pageFrom == "cart") {
                    this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                }
                else {
                    var registrationCompletePage = this.routesService.getRoutePath('REGISTRATION - COMPLETE')[0];
                    this.router.navigate([registrationCompletePage]);
                    this.emailError = false;
                    this.passwordError = false;
                    this.isRegisterFailed = false;
                    this.load = false;
                    this.success = true;
                }
            };
            ChildComponent.prototype.setVerified = function (data) {
                this.isCaptchaInvalid = data;
            };
            ChildComponent.prototype.onCustomerTypeChange = function (value) {
                this.model.CustomerType = value;
            };
            ChildComponent.prototype.onNationTypeChange = function (value) {
                this.model.Nation = value;
                this.nationCode = this.nationList.filter(function (x) { return x.Id == value; })[0].Code;
                this.onCustomerGroupChange(this.model.CustomerGroup);
            };
            ChildComponent.prototype.onCustomerGroupChange = function (value) {
                var currentModel = this.model;
                this.model = new register_1.Register();
                this.model.CustomerGroup = value;
                if (this.registerViaFbData != null && this.registerViaFbData != undefined) {
                    this.setModelDataFromFb(this.registerViaFbData);
                }
                this.model.Nation = currentModel.Nation;
                this.model.CustomerType = currentModel.CustomerType;
                this.model.Telephone = currentModel.Telephone;
                this.model.Mobile = currentModel.Mobile;
                this.model.EmailRegister = currentModel.EmailRegister;
                this.model.EmailRepeat = currentModel.EmailRepeat;
                this.model.PecEmail = currentModel.PecEmail;
                if (value === '4') {
                    this.model.CodiceDestinatario = "0000000";
                }
                else {
                    if (this.isItalyNation() == false) {
                        this.model.CodiceDestinatario = "0000000";
                    }
                    else {
                        console.log("qui");
                        this.model.CodiceDestinatario = "";
                    }
                }
            };
            ChildComponent.prototype.isCodDestRequired = function () {
                var retVal = false;
                //console.log(this.model.CodiceDestinatario)
                if (this.model.CustomerGroup != "4" && this.isItalyNation()) {
                    if (this.model.PecEmail == "" || this.model.PecEmail == undefined) {
                        retVal = true;
                    }
                    if (this.model.CodiceDestinatario == "" || this.model.CodiceDestinatario == undefined) {
                        this.isRequiredPecEmail = true;
                    }
                    else {
                        this.isRequiredPecEmail = false;
                    }
                }
                return retVal;
            };
            ChildComponent.prototype.isPecEmailRequired = function () {
                var retVal = false;
                if (this.model.CustomerGroup != "4" && this.isItalyNation()) {
                    if (this.model.CodiceDestinatario == "" || this.model.CodiceDestinatario == undefined) {
                        retVal = true;
                    }
                }
                return retVal;
            };
            //validation of phone numbers, disable writing any characters in input except of numbers
            ChildComponent.prototype.validatePhone = function (event) {
                this.validationService.validatePhoneNumber(event);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                if (result.isActiveAddressVerificationModule) {
                    var addressVerificationKey = result.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);
                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }
                //this method is removing all scripts and elements connected to address verification feature
                var addressVerificationKey = result.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);
                this.subManager.unsubscribe();
                // this.registerService.setFacebookLoginData(null);
                this.pageIsOnDestroy = true;
            };
            __decorate([
                core_1.ViewChild('submitButton'), 
                __metadata('design:type', (typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object)
            ], ChildComponent.prototype, "submitButton", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(6, core_1.Inject('isBrowser')),
                __param(17, core_1.Inject('CookieService')), 
                __metadata('design:paramtypes', [(typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, (typeof (_c = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _f) || Object, (typeof (_g = typeof check_existence_service_1.CheckIfExistService !== 'undefined' && check_existence_service_1.CheckIfExistService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _h) || Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object, (typeof (_k = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _k) || Object, (typeof (_l = typeof configuration_service_1.ConfigurationService !== 'undefined' && configuration_service_1.ConfigurationService) === 'function' && _l) || Object, (typeof (_m = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _m) || Object, (typeof (_o = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _o) || Object, (typeof (_p = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _p) || Object, (typeof (_q = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _q) || Object, (typeof (_r = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _r) || Object, (typeof (_s = typeof validation_service_1.ValidationService !== 'undefined' && validation_service_1.ValidationService) === 'function' && _s) || Object, (typeof (_t = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _t) || Object, (typeof (_u = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _u) || Object, (typeof (_v = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _v) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        }());
        return ChildComponent;
    };
    RegisterComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(7, core_1.Inject('isBrowser')),
        __param(10, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, Object, (typeof (_k = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _k) || Object])
    ], RegisterComponent);
    return RegisterComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.RegisterComponent = RegisterComponent;


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var register_service_1 = __webpack_require__(98);
//Angular
var core_1 = __webpack_require__(0);
//Service
var component_helper_service_1 = __webpack_require__(4);
var seo_service_1 = __webpack_require__(11);
var language_service_1 = __webpack_require__(3);
var script_service_1 = __webpack_require__(14);
var routes_service_1 = __webpack_require__(5);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var RegistrationConfirmationPageComponent = (function () {
    function RegistrationConfirmationPageComponent(_compiler, componentHelper, _elementRef, languageService, registerService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.languageService = languageService;
        this.registerService = registerService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    RegistrationConfirmationPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var templateHtml;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var registrationDoneSub = this.registerService.getRegistrationCompletePageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.registrationCompletePageId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(registrationDoneSub);
    };
    RegistrationConfirmationPageComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    RegistrationConfirmationPageComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(seoService, _elementRef, isBrowser, scriptService, routesService, breadcrumbsService, registerService) {
                this.seoService = seoService;
                this._elementRef = _elementRef;
                this.isBrowser = isBrowser;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.registerService = registerService;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                //newsletter subscription
                this.newsletterSubmitted = false;
                this.privacySubmitted = false;
                this.alreadySubscribed = false;
                this.successfullySubscribed = false;
                this.spinnerNewslatter = false;
                this.pageIsOnDestroy = false;
                this.registerViaFbData = this.registerService.getFacebookLoginData();
                this.isRegisteredViaFacebook = false;
                this.footerData = result.footerData;
                this.headerData = header;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                if (this.registerViaFbData != null && this.registerViaFbData != undefined) {
                    this.isRegisteredViaFacebook = true;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }
                this.registerService.setFacebookLoginData(null);
                this.pageIsOnDestroy = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _e) || Object, (typeof (_f = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _f) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f;
        }());
        return ChildComponent;
    };
    RegistrationConfirmationPageComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object, (typeof (_e = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], RegistrationConfirmationPageComponent);
    return RegistrationConfirmationPageComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.RegistrationConfirmationPageComponent = RegistrationConfirmationPageComponent;


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var cms_component_service_1 = __webpack_require__(8);
//Models
var router_1 = __webpack_require__(12);
var register_service_1 = __webpack_require__(98);
var Subscription_1 = __webpack_require__(2);
var seo_service_1 = __webpack_require__(11);
var platform_browser_1 = __webpack_require__(7);
var RegistrationConfirmationComponent = (function () {
    function RegistrationConfirmationComponent(_compiler, componentHelper, _elementRef, cmsComponentService, templateService, isBrowser, seo, renderer, document) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.templateService = templateService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
    }
    RegistrationConfirmationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var registrationConfirmation;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var compTemplateSub = this.templateService.getComponentTemplate("registrationConfirmationPageTemplate").subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                registrationConfirmation = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(registrationConfirmation, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(compTemplateSub);
    };
    RegistrationConfirmationComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject
    RegistrationConfirmationComponent.prototype.createSubComponent = function (registrationConfirmation, header) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, isBrowser, activatedRoute, registerService) {
                this.routesService = routesService;
                this.isBrowser = isBrowser;
                this.activatedRoute = activatedRoute;
                this.registerService = registerService;
                this.success = false;
                this.failed = false;
                this.active = false;
                this.pageIsInit = false;
                this.headerData = header;
                this.footerData = registrationConfirmation.FooterData;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                if (this.isBrowser == false) {
                    return;
                }
                var paramsSub = this.activatedRoute.params.subscribe(function (params) {
                    var userId = params['userid'];
                    _this.checkActivation(userId);
                });
                this.subManager.add(paramsSub);
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
            };
            ChildComponent.prototype.checkActivation = function (userId) {
                var _this = this;
                var confirmRegSub = this.registerService.confirmationRegistration(userId)
                    .subscribe(function (response) {
                    if (response == "1") {
                        _this.success = true;
                    }
                    else if (response == "-1") {
                        _this.active = true;
                    }
                    else {
                        _this.failed = true;
                    }
                });
                this.subManager.add(confirmRegSub);
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: registrationConfirmation
                }),
                __param(1, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _c) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c;
        }());
        return ChildComponent;
    };
    RegistrationConfirmationComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ''
        }),
        __param(5, core_1.Inject('isBrowser')),
        __param(8, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, (typeof (_e = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _e) || Object, Boolean, (typeof (_f = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object, Object])
    ], RegistrationConfirmationComponent);
    return RegistrationConfirmationComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.RegistrationConfirmationComponent = RegistrationConfirmationComponent;


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var register_service_1 = __webpack_require__(98);
var cookie_service_1 = __webpack_require__(60);
var api_service_1 = __webpack_require__(13);
//Angular
var core_1 = __webpack_require__(0);
//System
var mapping_1 = __webpack_require__(10);
//Service
var component_helper_service_1 = __webpack_require__(4);
var login_service_1 = __webpack_require__(179);
var auth_service_1 = __webpack_require__(9);
var routes_service_1 = __webpack_require__(5);
var script_service_1 = __webpack_require__(14);
var router_1 = __webpack_require__(12);
var recover_password_service_1 = __webpack_require__(257);
var cms_component_service_1 = __webpack_require__(8);
var breadcrumbs_service_1 = __webpack_require__(22);
var seo_service_1 = __webpack_require__(11);
var angular2_meta_1 = __webpack_require__(99);
var header_service_1 = __webpack_require__(127);
var user_login_1 = __webpack_require__(73);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var UserLoginComponent = (function () {
    function UserLoginComponent(_compiler, componentHelper, _elementRef, cmsService, seo, document, renderer, isBrowser, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsService = cmsService;
        this.seo = seo;
        this.document = document;
        this.renderer = renderer;
        this.isBrowser = isBrowser;
        this.scriptService = scriptService;
        this.subManager = new Subscription_1.Subscription();
    }
    UserLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        var loginData;
        var header;
        var headDataSub = this.cmsService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        // this.templateService.getComponentTemplate("userLoginPageTemplate").subscribe(result =>
        var loginSub = this.cmsService.getLoginPageData().subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                loginData = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(loginData, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.loginId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(loginSub);
    };
    UserLoginComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    UserLoginComponent.prototype.createSubComponent = function (loginData, header) {
        var ChildComponent = (function () {
            function ChildComponent(mappings, loginService, _elementRef, authService, scriptService, routesService, router, route, seoService, recoverPasswordService, isBrowser, breadcrumbsService, api, cookie, registerService, headerService, metaService) {
                this.mappings = mappings;
                this.loginService = loginService;
                this._elementRef = _elementRef;
                this.authService = authService;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.router = router;
                this.route = route;
                this.seoService = seoService;
                this.recoverPasswordService = recoverPasswordService;
                this.isBrowser = isBrowser;
                this.breadcrumbsService = breadcrumbsService;
                this.api = api;
                this.cookie = cookie;
                this.registerService = registerService;
                this.headerService = headerService;
                this.metaService = metaService;
                this.breadcrumbs = loginData.BreadcrumbsInfo;
                this.footerData = loginData.footerData;
                this.headerData = header;
                this.countFb = 0;
                this.showSpinnerClick = false;
                this.userLoginUrl = this.mappings.UserLoginImg_Url;
                this.pageFrom = "";
                this.emailError = false;
                this.passwordError = false;
                this.seoInfo = loginData.SeoInformation;
                this.emailErrorRecover = false;
                this.pageIsInit = false;
                this.constructorIsInit = false;
                this.isActiveFacebookModule = loginData.isActiveFacebookModule;
                this.model = {
                    Email: "",
                    Password: ""
                };
                this.modelRecover = {
                    Email: ""
                };
                this.subManager = new Subscription_1.Subscription();
                if (!this.isBrowser || this.constructorIsInit) {
                    return;
                }
                this.constructorIsInit = true;
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                setTimeout(function (x) { return _this.breadcrumbsService.setBreadcrumbs(_this.breadcrumbs); }, 1);
                var paramsSub = this.route.params.subscribe(function (params) {
                    var paramPageFrom = params['pagefrom'];
                    if (paramPageFrom !== undefined) {
                        _this.pageFrom = paramPageFrom;
                    }
                });
                this.subManager.add(paramsSub);
            };
            ChildComponent.prototype.onFacebookLoginClick = function () {
                var _this = this;
                FB.login(function (result) {
                    _this.getUserInfoFromFb();
                }, { scope: 'email' });
                this.getUserFromFb();
            };
            ChildComponent.prototype.getUserFromFb = function () {
                var _this = this;
                var email = this.cookie.get("emailFbUser");
                var firstName = this.cookie.get("firstNameFbUser");
                var lastName = this.cookie.get("lastNameFbUser");
                if (email != undefined && firstName != undefined && lastName != undefined) {
                    var authSub = this.loginService.authentificateUser(email, firstName, lastName).subscribe(function (response) {
                        _this.cookie.remove("emailFbUser");
                        _this.cookie.remove("firstNameFbUser");
                        _this.cookie.remove("lastNameFbUser");
                        // if(response.Active)
                        // {
                        _this.authService.Login(response.Id_User_Dettail, response.Name);
                        // }                        
                        if (response.IsCompletedRegistration == false) {
                            if (response.Active) {
                                _this.registerService.setFacebookLoginData(response);
                                //update after login the header information
                                var user = new user_login_1.UserLogin();
                                user.isAuthenticated = true;
                                user.username = response.Name ? response.Name : _this.model.Email;
                                _this.headerService.setLoggedInUser(user);
                                _this.router.navigate(_this.routesService.getRoutePath('REGISTRAZIONE'));
                            }
                            else {
                                _this.userNotActive = false;
                                _this.userNotFound = false;
                            }
                        }
                        else if (_this.pageFrom == "cart") {
                            //update after login the header information
                            var user = new user_login_1.UserLogin();
                            user.isAuthenticated = true;
                            user.username = response.Name ? response.Name : _this.model.Email;
                            _this.headerService.setLoggedInUser(user);
                            //this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                            window.open(_this.routesService.getRoutePath('CARRELLO'), "_self");
                        }
                        else {
                            _this.router.navigate(_this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));
                        }
                    });
                    this.subManager.add(authSub);
                }
                else {
                    setTimeout(function (x) { return _this.getUserFromFb(); }, 200);
                }
            };
            ChildComponent.prototype.getUserInfoFromFb = function () {
                FB.api('/me?fields=first_name,last_name,email', function (result) {
                    if (result && !result.error) {
                        var email = result.email;
                        var firstName = result.first_name;
                        var lastName = result.last_name;
                        document.cookie = "emailFbUser=" + email + ";";
                        document.cookie = "firstNameFbUser=" + firstName + ";";
                        document.cookie = "lastNameFbUser=" + lastName + ";";
                    }
                    else {
                        console.log(result.error);
                    }
                });
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                if (form.valid) {
                    this.showSpinnerClick = true;
                    this.emailError = false;
                    this.passwordError = false;
                    var loginDataSub = this.loginService.sendLoginRequest(this.model.Email, this.model.Password).subscribe(function (result) {
                        if (result.Id_User_Dettail > 0) {
                            if (result.Active) {
                                _this.authService.Login(result.Id_User_Dettail, result.Name);
                                //update after login the header information
                                var user = new user_login_1.UserLogin();
                                user.isAuthenticated = true;
                                user.username = result.Name ? result.Name : _this.model.Email;
                                _this.headerService.setLoggedInUser(user);
                                if (_this.pageFrom == "cart") {
                                    //this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                                    window.open(_this.routesService.getRoutePath('CARRELLO'), "_self");
                                }
                                else {
                                    _this.router.navigate(_this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));
                                }
                            }
                            else {
                                _this.userNotActive = false;
                                _this.userNotFound = false;
                            }
                        }
                        else {
                            _this.userNotActive = false;
                            _this.userNotFound = true;
                        }
                        _this.showSpinnerClick = false;
                    });
                    this.subManager.add(loginDataSub);
                }
                else if (!form.valid) {
                    if (form.form.controls.password.valid == false) {
                        this.passwordError = true;
                    }
                    else if (form.form.controls.password.valid == true) {
                        this.passwordError = false;
                    }
                    if (form.form.controls.email.valid == false) {
                        this.emailError = true;
                    }
                    else if (form.form.controls.email.valid == true) {
                        this.emailError = false;
                    }
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                var fbCode = loginData.FacebookAppID;
                this.initFacebook(fbCode);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                // Eventually retrieving the script to append
                // if (this.seoInfo.HasScripts == true) {
                //     this.scriptService.appendLoginScript(this._elementRef.element.nativeElement);
                // }
                this.pageIsInit = true;
            };
            ChildComponent.prototype.initFacebook = function (fbCode) {
                var _this = this;
                try {
                    this.countFb = this.countFb + 1;
                    FB.init({
                        appId: fbCode,
                        cookie: false,
                        xfbml: false,
                        version: 'v2.5'
                    });
                }
                catch (e) {
                    if (this.countFb <= 5) {
                        setTimeout(function (x) { return _this.initFacebook(fbCode); }, 1);
                    }
                }
            };
            ChildComponent.prototype.recoverPassword = function (form) {
                var _this = this;
                if (form.valid) {
                    this.showSpinnerClick = true;
                    this.emailErrorRecover = false;
                    var recoverPassSub = this.recoverPasswordService.recoverPasswordRequest(this.modelRecover.Email).subscribe(function (result) {
                        if (result.selected) {
                            _this.modelRecover.Email = "";
                            _this.recoverPasswordFailed = false;
                            _this.recoverPasswordSuccess = true;
                        }
                        else {
                            _this.recoverPasswordFailed = true;
                            _this.recoverPasswordSuccess = false;
                        }
                        _this.showSpinnerClick = false;
                    });
                    this.subManager.add(recoverPassSub);
                }
                else if (!form.valid) {
                    if (form.form.controls.email.valid == false) {
                        this.emailErrorRecover = true;
                    }
                }
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: loginData.TemplateHtml
                }),
                __param(10, core_1.Inject('isBrowser')),
                __param(13, core_1.Inject('CookieService')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _a) || Object, (typeof (_b = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _h) || Object, (typeof (_j = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _j) || Object, (typeof (_k = typeof recover_password_service_1.RecoverPasswordService !== 'undefined' && recover_password_service_1.RecoverPasswordService) === 'function' && _k) || Object, Boolean, (typeof (_l = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _l) || Object, (typeof (_m = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _m) || Object, (typeof (_o = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _o) || Object, (typeof (_p = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _p) || Object, (typeof (_q = typeof header_service_1.HeaderService !== 'undefined' && header_service_1.HeaderService) === 'function' && _q) || Object, (typeof (_r = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _r) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        }());
        return ChildComponent;
    };
    UserLoginComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(5, core_1.Inject(platform_browser_1.DOCUMENT)),
        __param(7, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, (typeof (_e = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _e) || Object, Object, (typeof (_f = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _g) || Object])
    ], UserLoginComponent);
    return UserLoginComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.UserLoginComponent = UserLoginComponent;


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var recover_password_service_1 = __webpack_require__(257);
var component_helper_service_1 = __webpack_require__(4);
var language_service_1 = __webpack_require__(3);
var seo_service_1 = __webpack_require__(11);
var script_service_1 = __webpack_require__(14);
var breadcrumbs_service_1 = __webpack_require__(22);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var Subscription_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(7);
var UserPasswordComponent = (function () {
    function UserPasswordComponent(_compiler, componentHelper, _elementRef, recoverPasswordService, languageService, cmsComponentService, isBrowser, seo, renderer, document, scriptService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.recoverPasswordService = recoverPasswordService;
        this.languageService = languageService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.seo = seo;
        this.renderer = renderer;
        this.document = document;
        this.scriptService = scriptService;
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    UserPasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        var header;
        var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
            header = result;
            var SideMenuData = _this.cmsComponentService.getSideMenuData().subscribe(function (result1) {
                if (result1.Categories) {
                    header.Categories = result1.Categories;
                }
            });
            _this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        var recoverPassSub = this.recoverPasswordService.getRecoverPasswordData(this.lang).subscribe(function (result) {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (_this.isBrowser) {
                //Creating subcomponent whith the result  to inject
                var subComponent = _this.createSubComponent(result, header);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                _this.scriptService.setupExternalScripts(result, _this.scriptService.typeSystemPage, _this.scriptService.userRecoverPasswordId);
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                _this.seo.setSeoMetaData(_this.document, _this.renderer, result.SeoInformation);
                _this.seo.generateSeoDomServerSide(_this.document, _this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(recoverPassSub);
    };
    UserPasswordComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    UserPasswordComponent.prototype.createSubComponent = function (result, header) {
        var ChildComponent = (function () {
            function ChildComponent(recoverPasswordService, seoService, isBrowser, _elementRef, scriptService, routesService, breadcrumbsService) {
                this.recoverPasswordService = recoverPasswordService;
                this.seoService = seoService;
                this.isBrowser = isBrowser;
                this._elementRef = _elementRef;
                this.scriptService = scriptService;
                this.routesService = routesService;
                this.breadcrumbsService = breadcrumbsService;
                this.recoverPasswordFailed = false;
                this.recoverPasswordSuccess = false;
                this.seoInfo = result.SeoInformation;
                this.pageIsInit = false;
                this.breadcrumbs = result.BreadcrumbsInfo;
                this.showSpinnerClick = false;
                this.footerData = result.footerData;
                this.headerData = header;
                this.model = {
                    Email: ""
                };
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                //this.headerData.Categories=SideMenu.Categories;
                this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs);
                //setTimeout(x => , 1);
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                if (form.valid) {
                    this.showSpinnerClick = true;
                    var recoverPassSub = this.recoverPasswordService.recoverPasswordRequest(this.model.Email).subscribe(function (result) {
                        if (result.selected) {
                            _this.recoverPasswordFailed = false;
                            _this.recoverPasswordSuccess = true;
                        }
                        else {
                            _this.recoverPasswordFailed = true;
                            _this.recoverPasswordSuccess = false;
                        }
                        _this.showSpinnerClick = false;
                    });
                    this.subManager.add(recoverPassSub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.TemplateHtml
                }),
                __param(2, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof recover_password_service_1.RecoverPasswordService !== 'undefined' && recover_password_service_1.RecoverPasswordService) === 'function' && _a) || Object, (typeof (_b = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _b) || Object, Boolean, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof breadcrumbs_service_1.BreadcrumbsService !== 'undefined' && breadcrumbs_service_1.BreadcrumbsService) === 'function' && _f) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f;
        }());
        return ChildComponent;
    };
    UserPasswordComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')),
        __param(9, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof recover_password_service_1.RecoverPasswordService !== 'undefined' && recover_password_service_1.RecoverPasswordService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean, (typeof (_g = typeof seo_service_1.SeoService !== 'undefined' && seo_service_1.SeoService) === 'function' && _g) || Object, (typeof (_h = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _h) || Object, Object, (typeof (_j = typeof script_service_1.ScriptService !== 'undefined' && script_service_1.ScriptService) === 'function' && _j) || Object])
    ], UserPasswordComponent);
    return UserPasswordComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.UserPasswordComponent = UserPasswordComponent;


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var News = (function () {
    function News() {
    }
    return News;
}());
exports.News = News;
var NewsDetails = (function () {
    function NewsDetails() {
        this.UrlRedirect = "";
    }
    return NewsDetails;
}());
exports.NewsDetails = NewsDetails;
var SliderViewModel = (function () {
    function SliderViewModel() {
    }
    return SliderViewModel;
}());
exports.SliderViewModel = SliderViewModel;
var ArticleCategory = (function () {
    function ArticleCategory() {
    }
    return ArticleCategory;
}());
exports.ArticleCategory = ArticleCategory;


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var auth_service_1 = __webpack_require__(9);
var shopping_cart_service_1 = __webpack_require__(20);
var CmsContentService = (function () {
    function CmsContentService(_api, _cache, authService, mappings, ShoppingCartService) {
        this._api = _api;
        this._cache = _cache;
        this.authService = authService;
        this.mappings = mappings;
        this.ShoppingCartService = ShoppingCartService;
    }
    //whatever domain/feature method name
    // public Web_Api_Menu_GetCmsPageById = this.Web_Api_Base_Url + "/menu/getcmsmenu/{customerid}/{lang}/{id}/{cartid}";
    CmsContentService.prototype.getCmsPageById = function (lang, pageId) {
        var customerId = this.authService.GetUserId();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Menu_GetCmsPageById
            .replace('{customerid}', customerId)
            .replace('{lang}', lang)
            .replace('{id}', pageId)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    // public Web_Api_Menu_GetCmsPageByUrl = this.Web_Api_Base_Url + "/menu/getcmspagebyurl/{customerid}/{lang}/{cartid}/{url}";
    CmsContentService.prototype.getCmsPageByUrl = function (lang, pageUrl) {
        var customerId = this.authService.GetUserId();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Menu_GetCmsPageByUrl
            .replace('{customerid}', customerId)
            .replace('{lang}', lang)
            .replace('{url}', pageUrl)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    CmsContentService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object])
    ], CmsContentService);
    return CmsContentService;
    var _a, _b, _c, _d, _e;
}());
exports.CmsContentService = CmsContentService;


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var CmsMenuListService = (function () {
    function CmsMenuListService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
    }
    CmsMenuListService.prototype.setPageUrl = function (menus) {
        for (var index in menus) {
            if (menus[index].SeoUrl != undefined &&
                menus[index].SeoUrl != null &&
                menus[index].SeoUrl != "") {
                menus[index].Url = "/" + menus[index].SeoUrl;
            }
            else {
                menus[index].Url = '/cms/' + menus[index].Id;
            }
            if (menus[index].Children !== undefined && menus[index].Children.length > 0) {
                this.setPageUrl(menus[index].Children);
            }
        }
    };
    CmsMenuListService.prototype.LoadData = function (pageId, lang) {
        var url = this.mappings.Web_Api_Get_Cms_Menu_List
            .replace('{id}', pageId)
            .replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    CmsMenuListService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], CmsMenuListService);
    return CmsMenuListService;
    var _a, _b, _c;
}());
exports.CmsMenuListService = CmsMenuListService;


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var auth_service_1 = __webpack_require__(9);
var shopping_cart_service_1 = __webpack_require__(20);
var FaqListService = (function () {
    function FaqListService(_api, _cache, mappings, ShoppingCartService, authService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.ShoppingCartService = ShoppingCartService;
        this.authService = authService;
    }
    FaqListService.prototype.getFaqData = function (lang) {
        var userid = this.authService.GetUserId();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Get_FaqData
            .replace('{lang}', lang)
            .replace('{userid}', userid)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    FaqListService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object])
    ], FaqListService);
    return FaqListService;
    var _a, _b, _c, _d, _e;
}());
exports.FaqListService = FaqListService;


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var InfoRequestService = (function () {
    function InfoRequestService(_api, _cache, mappings, cartService, authService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.cartService = cartService;
        this.authService = authService;
    }
    InfoRequestService.prototype.sendInfoRequest = function (parameters) {
        return this._api.post(this.mappings.Web_Api_Post_Send_Info_Request, parameters)
            .do(function (result) { return result; })
            .share();
    };
    InfoRequestService.prototype.getInfoRequestData = function (lang) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Info_Request_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    InfoRequestService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object])
    ], InfoRequestService);
    return InfoRequestService;
    var _a, _b, _c, _d, _e;
}());
exports.InfoRequestService = InfoRequestService;


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var SliderService = (function () {
    function SliderService(_api, _cache, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
    }
    SliderService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object])
    ], SliderService);
    return SliderService;
    var _a, _b, _c;
}());
exports.SliderService = SliderService;


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var TrustpilotService = (function () {
    function TrustpilotService(_api, _cache, mappings, languageService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.languageService = languageService;
    }
    TrustpilotService.prototype.getTrustpilotData = function (type) {
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Trustpilot_Data.replace('{type}', type).replace('{lang}', lang);
        return this._api.get(url);
    };
    TrustpilotService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _d) || Object])
    ], TrustpilotService);
    return TrustpilotService;
    var _a, _b, _c, _d;
}());
exports.TrustpilotService = TrustpilotService;


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var CookiePolicyService = (function () {
    function CookiePolicyService(_api, mappings, ShoppingCartService, authService) {
        this._api = _api;
        this.mappings = mappings;
        this.ShoppingCartService = ShoppingCartService;
        this.authService = authService;
    }
    CookiePolicyService.prototype.getCookiePolicyData = function (lang) {
        var cartId = this.ShoppingCartService.getCartId();
        var userId = this.authService.getCurrentUserId();
        var url = this.mappings.Web_Api_Get_Cookie_Policy_Data
            .replace('{lang}', lang)
            .replace('{cartid}', cartId)
            .replace('{userid}', userId);
        var key = url;
        return this._api.get(url);
    };
    CookiePolicyService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
    ], CookiePolicyService);
    return CookiePolicyService;
    var _a, _b, _c, _d;
}());
exports.CookiePolicyService = CookiePolicyService;


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var CookieOptions = (function () {
    function CookieOptions(_a) {
        var _b = _a === void 0 ? {} : _a, path = _b.path, domain = _b.domain, expires = _b.expires, secure = _b.secure;
        this.path = this.isPresent(path) ? path : null;
        this.domain = this.isPresent(domain) ? domain : null;
        this.expires = this.isPresent(expires) ? expires : null;
        this.secure = this.isPresent(secure) ? secure : false;
    }
    CookieOptions.prototype.merge = function (options) {
        return new CookieOptions({
            path: this.isPresent(options) && this.isPresent(options.path) ? options.path : this.path,
            domain: this.isPresent(options) && this.isPresent(options.domain) ? options.domain : this.domain,
            expires: this.isPresent(options) && this.isPresent(options.expires) ? options.expires : this.expires,
            secure: this.isPresent(options) && this.isPresent(options.secure) ? options.secure : this.secure,
        });
    };
    CookieOptions.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    return CookieOptions;
}());
exports.CookieOptions = CookieOptions;


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var PrivacyPolicyService = (function () {
    function PrivacyPolicyService(_api, mappings, cartService, authService) {
        this._api = _api;
        this.mappings = mappings;
        this.cartService = cartService;
        this.authService = authService;
    }
    PrivacyPolicyService.prototype.getPrivacyPolicyData = function (lang) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Privacy_Policy_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    PrivacyPolicyService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
    ], PrivacyPolicyService);
    return PrivacyPolicyService;
    var _a, _b, _c, _d;
}());
exports.PrivacyPolicyService = PrivacyPolicyService;


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var shopping_cart_service_1 = __webpack_require__(20);
var auth_service_1 = __webpack_require__(9);
var PurchaseConditionService = (function () {
    function PurchaseConditionService(_api, mappings, cartService, authService) {
        this._api = _api;
        this.mappings = mappings;
        this.cartService = cartService;
        this.authService = authService;
    }
    PurchaseConditionService.prototype.getPurchaseConditionServiceData = function (lang) {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Purchase_Condition_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        ;
        var key = url;
        return this._api.get(url);
    };
    PurchaseConditionService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
    ], PurchaseConditionService);
    return PurchaseConditionService;
    var _a, _b, _c, _d;
}());
exports.PurchaseConditionService = PurchaseConditionService;


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Components
var home_component_1 = __webpack_require__(376);
var faq_component_1 = __webpack_require__(379);
var cookie_policy_component_1 = __webpack_require__(378);
var privacy_policy_component_1 = __webpack_require__(383);
var purchase_condition_component_1 = __webpack_require__(384);
var info_request_component_1 = __webpack_require__(380);
var user_login_component_1 = __webpack_require__(410);
var user_password_component_1 = __webpack_require__(411);
var register_component_1 = __webpack_require__(407);
var cms_page_component_1 = __webpack_require__(377);
var category_component_1 = __webpack_require__(389);
var product_details_component_1 = __webpack_require__(391);
var product_page_list_component_1 = __webpack_require__(392);
var promotions_component_1 = __webpack_require__(393);
var news_page_component_1 = __webpack_require__(374);
var other_product_component_1 = __webpack_require__(390);
var blog_page_component_1 = __webpack_require__(373);
var article_category_component_1 = __webpack_require__(372);
var client_area_home_component_1 = __webpack_require__(398);
var client_area_order_list_component_1 = __webpack_require__(388);
var client_area_profile_component_1 = __webpack_require__(401);
var cart_component_1 = __webpack_require__(396);
var cart_cash_component_1 = __webpack_require__(394);
var cart_submitted_component_1 = __webpack_require__(395);
var cart_empty_page_component_1 = __webpack_require__(385);
var client_area_order_details_component_1 = __webpack_require__(400);
var client_area_catalog_private_component_1 = __webpack_require__(397);
var registration_confirmation_component_1 = __webpack_require__(409);
var offline_page_component_1 = __webpack_require__(387);
var payment_confirmation_component_1 = __webpack_require__(403);
var payment_unicredit_confirmation_component_1 = __webpack_require__(405);
var payment_nexi_confirmation_component_1 = __webpack_require__(404);
var payment_banca_sella_confirmation_component_1 = __webpack_require__(402);
var not_found_page_component_1 = __webpack_require__(386);
var search_component_1 = __webpack_require__(375);
var client_area_invoices_component_1 = __webpack_require__(399);
var newsletter_confirmation_page_component_1 = __webpack_require__(381);
var newsletter_page_component_1 = __webpack_require__(382);
var registration_complete_component_1 = __webpack_require__(408);
var quick_registration_component_1 = __webpack_require__(406);
var SysConfig = (function () {
    function SysConfig() {
    }
    SysConfig.getComponentByName = function (componentName) {
        var component;
        switch (componentName) {
            case 'HomeComponent':
                component = home_component_1.HomeComponent;
                break;
            case 'FaqComponent':
                component = faq_component_1.FaqComponent;
                break;
            case 'ClientAreaHomeComponent':
                component = client_area_home_component_1.ClientAreaHomeComponent;
                break;
            case 'PrivacyPolicyComponent':
                component = privacy_policy_component_1.PrivacyPolicyComponent;
                break;
            case 'CookiePolicyComponent':
                component = cookie_policy_component_1.CookiePolicyComponent;
                break;
            case 'PurchaseConditionComponent':
                component = purchase_condition_component_1.PurchaseConditionComponent;
                break;
            case 'InfoRequestComponent':
                component = info_request_component_1.InfoRequestComponent;
                break;
            case 'UserLoginComponent':
                component = user_login_component_1.UserLoginComponent;
                break;
            case 'UserPasswordComponent':
                component = user_password_component_1.UserPasswordComponent;
                break;
            case 'RegisterComponent':
                component = register_component_1.RegisterComponent;
                break;
            case 'CmsPageComponent':
                component = cms_page_component_1.CmsPageComponent;
                break;
            case 'CategoryComponent':
                component = category_component_1.CategoryComponent;
                break;
            case 'ProductDetailsComponent':
                component = product_details_component_1.ProductDetailsComponent;
                break;
            case 'ProductPageListComponent':
                component = product_page_list_component_1.ProductPageListComponent;
                break;
            case 'PromotionsComponent':
                component = promotions_component_1.PromotionsComponent;
                break;
            case 'ArticleComponent':
                component = news_page_component_1.ArticleComponent;
                break;
            case 'OtherProductComponent':
                component = other_product_component_1.OtherProductComponent;
                break;
            case 'BlogPageComponent':
                component = blog_page_component_1.BlogPageComponent;
                break;
            case 'ArticleCategoryComponent':
                component = article_category_component_1.ArticleCategoryComponent;
                break;
            case 'ClientAreaOrderListComponent':
                component = client_area_order_list_component_1.ClientAreaOrderListComponent;
                break;
            case 'ClientAreaInvoicesComponent':
                component = client_area_invoices_component_1.ClientAreaInvoicesComponent;
                break;
            case 'ClientAreaProfileComponent':
                component = client_area_profile_component_1.ClientAreaProfileComponent;
                break;
            case 'CartComponent':
                component = cart_component_1.CartComponent;
                break;
            case 'CartCashComponent':
                component = cart_cash_component_1.CartCashComponent;
                break;
            case 'CartSubmittedComponent':
                component = cart_submitted_component_1.CartSubmittedComponent;
                break;
            case 'CartEmptyPageComponent':
                component = cart_empty_page_component_1.CartEmptyPageComponent;
                break;
            case 'ClientAreaOrderDetailsComponent':
                component = client_area_order_details_component_1.ClientAreaOrderDetailsComponent;
                break;
            case 'ClientAreaCatalogPrivateComponent':
                component = client_area_catalog_private_component_1.ClientAreaCatalogPrivateComponent;
                break;
            case 'RegistrationConfirmationComponent':
                component = registration_confirmation_component_1.RegistrationConfirmationComponent;
                break;
            case 'PaymentConfirmationComponent':
                component = payment_confirmation_component_1.PaymentConfirmationComponent;
                break;
            case 'PaymentUnicreditConfirmationComponent':
                component = payment_unicredit_confirmation_component_1.PaymentUnicreditConfirmationComponent;
                break;
            case 'PaymentNexiConfirmationComponent':
                component = payment_nexi_confirmation_component_1.PaymentNexiConfirmationComponent;
                break;
            case 'PaymentBancaSellaConfirmationComponent':
                component = payment_banca_sella_confirmation_component_1.PaymentBancaSellaConfirmationComponent;
                break;
            case 'OfflinePageComponent':
                component = offline_page_component_1.OfflinePageComponent;
                break;
            case "NotFoundPageComponent":
                component = not_found_page_component_1.NotFoundPageComponent;
                break;
            case "SearchComponent":
                component = search_component_1.SearchComponent;
                break;
            case "NewsletterPageComponent":
                component = newsletter_page_component_1.NewsletterPageComponent;
                break;
            case "NewsletterConfirmationPageComponent":
                component = newsletter_confirmation_page_component_1.NewsletterConfirmationPageComponent;
                break;
            case "RegistrationConfirmationPageComponent":
                component = registration_complete_component_1.RegistrationConfirmationPageComponent;
                break;
            case "QuickRegistrationComponent":
                component = quick_registration_component_1.QuickRegistrationComponent;
                break;
            default:
                component = null;
        }
        return component;
    };
    SysConfig.getAllComponents = function () {
        return [
            home_component_1.HomeComponent,
            faq_component_1.FaqComponent,
            client_area_home_component_1.ClientAreaHomeComponent,
            privacy_policy_component_1.PrivacyPolicyComponent,
            cookie_policy_component_1.CookiePolicyComponent,
            purchase_condition_component_1.PurchaseConditionComponent,
            info_request_component_1.InfoRequestComponent,
            user_login_component_1.UserLoginComponent,
            user_password_component_1.UserPasswordComponent,
            register_component_1.RegisterComponent,
            cms_page_component_1.CmsPageComponent,
            category_component_1.CategoryComponent,
            product_details_component_1.ProductDetailsComponent,
            product_page_list_component_1.ProductPageListComponent,
            promotions_component_1.PromotionsComponent,
            news_page_component_1.ArticleComponent,
            other_product_component_1.OtherProductComponent,
            blog_page_component_1.BlogPageComponent,
            article_category_component_1.ArticleCategoryComponent,
            client_area_order_list_component_1.ClientAreaOrderListComponent,
            client_area_invoices_component_1.ClientAreaInvoicesComponent,
            client_area_profile_component_1.ClientAreaProfileComponent,
            cart_component_1.CartComponent,
            cart_cash_component_1.CartCashComponent,
            cart_submitted_component_1.CartSubmittedComponent,
            cart_empty_page_component_1.CartEmptyPageComponent,
            client_area_order_details_component_1.ClientAreaOrderDetailsComponent,
            client_area_catalog_private_component_1.ClientAreaCatalogPrivateComponent,
            registration_confirmation_component_1.RegistrationConfirmationComponent,
            payment_confirmation_component_1.PaymentConfirmationComponent,
            payment_unicredit_confirmation_component_1.PaymentUnicreditConfirmationComponent,
            payment_nexi_confirmation_component_1.PaymentNexiConfirmationComponent,
            payment_banca_sella_confirmation_component_1.PaymentBancaSellaConfirmationComponent,
            offline_page_component_1.OfflinePageComponent,
            not_found_page_component_1.NotFoundPageComponent,
            search_component_1.SearchComponent,
            newsletter_page_component_1.NewsletterPageComponent,
            newsletter_confirmation_page_component_1.NewsletterConfirmationPageComponent,
            registration_complete_component_1.RegistrationConfirmationPageComponent,
            quick_registration_component_1.QuickRegistrationComponent
        ];
    };
    SysConfig = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], SysConfig);
    return SysConfig;
}());
exports.SysConfig = SysConfig;


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var crypto_service_1 = __webpack_require__(259);
var core_1 = __webpack_require__(0);
var api_service_1 = __webpack_require__(13);
var common_1 = __webpack_require__(44);
var rxjs_1 = __webpack_require__(265);
var mapping_1 = __webpack_require__(10);
var http_1 = __webpack_require__(95);
var CustomersCanvasService = (function () {
    function CustomersCanvasService(_api, location, mappings, http, cryptoService) {
        this._api = _api;
        this.location = location;
        this.mappings = mappings;
        this.http = http;
        this.cryptoService = cryptoService;
        // Observable string sources
        this.isCanvasModalOpenedSource = new rxjs_1.Subject();
        this.isCanvasProductDesignApprovedSource = new rxjs_1.Subject();
        // Observable string streams
        this.isCanvasModalOpened$ = this.isCanvasModalOpenedSource.asObservable();
        this.isCanvasProductDesignApproved$ = this.isCanvasProductDesignApprovedSource.asObservable();
        this.toShowCanvasContainer = false;
        //Object containing data generated by getProofImages.
        this.approveData = null;
        //Object containing data generated by finishProductDesign.
        this.renderData = null;
        //Object containing data generated by saveProduct.
        this.saveData = null;
        this.editor = null;
        this.loadData = null;
        this.currentPage = "design";
        this.workflowPages = {};
        this.documentLinks = [""];
    }
    // Service canvas state / if it is opened or closed 
    CustomersCanvasService.prototype.setCanvasState = function (isOpened) {
        this.isCanvasModalOpenedSource.next(isOpened);
    };
    // Service canvas state / if product design is approved or not
    CustomersCanvasService.prototype.setCanvasProductDesignState = function (isApproved) {
        this.isCanvasProductDesignApprovedSource.next(isApproved);
    };
    //load a script and after it is loaded, instantiate an canvas iframe
    CustomersCanvasService.prototype.openCanvasEditor = function (canvasInfo, isStateId) {
        var _this = this;
        var canvasUrl = this.cryptoService.decryptString(canvasInfo.CanvasUrl);
        if (canvasUrl != "") {
            var canvasScript = document.querySelector('script[src=\"' + canvasUrl + '\"]');
            // set canvas state as opened, so inside of components we know when to stick and when unstick some divs
            this.setCanvasState(true);
            // if script is already loaded, don't append it again
            if (canvasScript == null) {
                var node = document.createElement('script');
                node.src = canvasUrl;
                node.setAttribute("id", "CcIframeApiScript");
                node.type = 'text/javascript';
                node.async = true;
                node.charset = 'utf-8';
                // to display canvas container
                this.toShowCanvasContainer = true;
                // after script is loaded, instantiate canvas iframe
                node.onload = function () {
                    _this.instanciateIframe(canvasInfo, isStateId);
                };
                document.getElementsByTagName('head')[0].appendChild(node);
            }
            else {
                this.instanciateIframe(canvasInfo, isStateId);
            }
        }
    };
    CustomersCanvasService.prototype.instanciateIframe = function (canvasInfo, isStateId) {
        var _this = this;
        var templateImagesFolderPath = canvasInfo.TemplateImagesFolderPath;
        var canvasUserUsername = canvasInfo.CustomerCanvasUserName;
        var watermark = canvasInfo.Watermark;
        // defining product folder path
        var productDefinition;
        if (isStateId) {
            // getting design by state id
            productDefinition = canvasInfo.CanvasStateId;
        }
        else {
            productDefinition = { surfaces: templateImagesFolderPath };
        }
        // const productDefinition = { surfaces: { designFolder: productFolderPath } };
        var editorFrame = document.getElementById("editorFrame");
        var configuration = {
            userId: canvasUserUsername,
            initialMode: "Advanced",
            watermark: {
                text: {
                    text: watermark,
                    opacity: 0.3
                }
            },
            widgets: {
                // To disable a download button when the project is in the production
                FinishButton: { mode: "Disabled" },
                GalleryDialog: {
                    defaultTabName: "User",
                    tabs: [
                        {
                            name: "User",
                            type: "user",
                            translationKey: "GalleryDialog.TAB_USER",
                            canEdit: true,
                            canUpload: true
                        },
                        {
                            name: "Public",
                            type: "public",
                            subFolderName: "",
                            translationKey: "GalleryDialog.TAB_PUBLIC",
                            canEdit: false
                        }
                    ]
                }
            }
        };
        CustomersCanvas.IframeApi.loadEditor(editorFrame, productDefinition, configuration)
            .then(function (e) {
            _this.editor = e;
        })
            .catch(function (error) {
            if (error != null) {
                _this.loadData = _this.handleError(error, "Load failed with exception: ");
            }
        });
    };
    CustomersCanvasService.prototype.saveCanvasProduct = function () {
        var _this = this;
        this.editor.saveProduct()
            .then(function (result) {
            //Saving the product state info.
            _this.saveData = result;
        })
            .catch(function (error) {
            _this.saveData = _this.handleError(error, "Save failed with exception: ");
        });
    };
    CustomersCanvasService.prototype.getImagesLinks = function (editorPage, approvePage, finishOrderPage) {
        var _this = this;
        this.workflowPages = {
            "design": { elements: editorPage },
            "approve": { elements: approvePage },
            "finish": { elements: finishOrderPage }
        };
        this.documentLinks = [];
        if (this.editor) {
            this.editor.getProofImages()
                .then(function (result) {
                //Saving proof images info.
                _this.approveData = result;
                // add all links to images to the documentLinks, because we will use that list for element manipulation later
                if (_this.approveData.proofImageUrls) {
                    _this.approveData.proofImageUrls.forEach(function (element) {
                        if (element.length > 0) {
                            _this.documentLinks.push(element[0]);
                        }
                    });
                }
                //Go to the approval page.
                _this.setupPage("approve");
                _this.setBackgroundImagesUrl();
            })
                .catch(function (error) {
                _this.approveData = _this.handleError(error, "Getting proof images failed with exception: ");
            });
        }
    };
    //img tags inside of slider are later changed to be divs with background image url property, so we need to manage that
    CustomersCanvasService.prototype.setBackgroundImagesUrl = function () {
        var sliderImageElements = $(".tp-bgimg.defaultimg");
        // because we can't use *ngFor to create as many elements as we need, we need to remove one li element if there is actually only one element we get from customer canvas(we have 2 elements in html)
        if (sliderImageElements.length > this.documentLinks.length) {
            var differenceItems = sliderImageElements.length - this.documentLinks.length;
            for (var index = 1; index <= differenceItems; index++) {
                var element = sliderImageElements[sliderImageElements.length - index];
                //remove li parent of element we found
                var parentLi = $(element).parents("li");
                $(parentLi)[0].remove();
            }
        }
        //because we can't use angular binding with slider plugin (plugin is initialized before service), we need to set url and src attributes of each slide
        if (this.documentLinks && this.documentLinks.length > 0) {
            sliderImageElements = $(".tp-bgimg.defaultimg");
            for (var index = 0; index < this.documentLinks.length; index++) {
                var link = this.documentLinks[index];
                var foundDomElement = $(sliderImageElements)[index];
                if (foundDomElement) {
                    $(foundDomElement).css('background-image', 'url(' + link + ')');
                    $(foundDomElement).attr("src", link);
                }
            }
        }
    };
    CustomersCanvasService.prototype.finishProductCustomization = function () {
        return this.editor.finishProductDesign();
    };
    CustomersCanvasService.prototype.setupPageAfterProductCustomization = function (renderData, isError) {
        if (!isError) {
            this.renderData = renderData;
        }
        else {
            this.renderData = this.handleError(renderData, "Product customization completion failed with exception: ");
        }
    };
    CustomersCanvasService.prototype.openDocumentInNewTab = function () {
        var sliderElements = $("#approvePage ul li");
        if (sliderElements.length > 0) {
            for (var index = 0; index < sliderElements.length; index++) {
                var element = sliderElements[index];
                //if element has this class, it means it is active inside of slider, so we want to open that element in a new tab
                if ($(element).hasClass("active-revslide")) {
                    window.open(this.documentLinks[index], "_blank");
                }
            }
        }
    };
    CustomersCanvasService.prototype.openNewProductInEditor = function () {
        if (this.editor != null) {
            this.editor.revertProduct();
            this.setupPage("design");
        }
    };
    CustomersCanvasService.prototype.reopenProductInEditor = function () {
        this.setupPage("design");
    };
    // set details of view we want to show and set layout properties depending on view
    CustomersCanvasService.prototype.setupPage = function (page) {
        var _this = this;
        var destPageData = this.workflowPages[page];
        if (this.workflowPages[this.currentPage]) {
            var elements = this.workflowPages[this.currentPage].elements;
            if (elements && elements.nativeElement && elements.nativeElement.id) {
                // getting id of element that needs to be hidden
                var generatedIdHide = "#" + elements.nativeElement.id;
                $(generatedIdHide).fadeOut(function () {
                    if (destPageData && destPageData.elements && destPageData.elements.nativeElement && destPageData.elements.nativeElement.id) {
                        // getting id of element that needs to be shown
                        var generatedIdShow = "#" + destPageData.elements.nativeElement.id;
                        $(generatedIdShow).show();
                        _this.currentPage = page;
                    }
                });
            }
        }
    };
    CustomersCanvasService.prototype.handleError = function (error, message) {
        console.error(message, error);
        return error;
    };
    ;
    CustomersCanvasService.prototype.updatePrevCanvasInfo = function (canvasData) {
        var url = this.mappings.Web_Api_Update_Prev_Canvas_Info;
        var params = {
            RowIdPrev: canvasData.RowIdPrev,
            CanvasStateId: canvasData.stateId,
            CanvasHiResOutputUrls: canvasData.hiResOutputUrls
        };
        return this._api.post(url, params);
    };
    // removing state from customers canvas
    CustomersCanvasService.prototype.deleteCustomerCanvasState = function (canvasInfo) {
        // const apiKey = '01b3ecc6-6423-4684-b469-f258afa87100';
        var decryptedApiKey = this.cryptoService.decryptString(canvasInfo.CanvasApiKey);
        var baseUrl = this.mappings.Canvas_Web_Api_Base_Url.replace('{apiKey}', decryptedApiKey);
        var url = baseUrl + this.mappings.Web_Api_Delete_Customers_Canvas_State;
        url = url.replace('{userId}', canvasInfo.CustomerCanvasUserName).replace('{stateId}', canvasInfo.CanvasStateId);
        var apiKeyFinal = "ApiKey_" + decryptedApiKey;
        // configure headers for creating a valid request
        var options = {};
        options.headers = new http_1.Headers();
        options.headers.append('X-CustomersCanvasAPIKey', apiKeyFinal);
        options.headers.append('Content-Type', 'application/json');
        return this.http.delete(url, options);
    };
    CustomersCanvasService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.PlatformLocation !== 'undefined' && common_1.PlatformLocation) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _d) || Object, (typeof (_e = typeof crypto_service_1.CryptoService !== 'undefined' && crypto_service_1.CryptoService) === 'function' && _e) || Object])
    ], CustomersCanvasService);
    return CustomersCanvasService;
    var _a, _b, _c, _d, _e;
}());
exports.CustomersCanvasService = CustomersCanvasService;


/***/ }),

/***/ 466:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 466;


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * THIS IS TEMPORARY TO PATCH 2.1.1+ Core bugs
 */

/* tslint:disable */
var __compiler__ = __webpack_require__(103);
var core_1 = __webpack_require__(0);
if (!core_1.__core_private__['ViewUtils']) {
    core_1.__core_private__['ViewUtils'] = core_1.__core_private__['view_utils'];
}
if (__compiler__ && __compiler__.SelectorMatcher && __compiler__.CssSelector) {
    (__compiler__).__compiler_private__ = {
        SelectorMatcher: __compiler__.SelectorMatcher,
        CssSelector: __compiler__.CssSelector
    };
}


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(228);
var router_1 = __webpack_require__(12);
var browser_1 = __webpack_require__(280); // for AoT we need to manually split universal packages
var idle_preload_1 = __webpack_require__(585);
var http_1 = __webpack_require__(95);
var core_2 = __webpack_require__(27);
var app_module_1 = __webpack_require__(594);
var shared_module_1 = __webpack_require__(86);
var cache_service_1 = __webpack_require__(21);
var node_logger_service_1 = __webpack_require__(260);
// Will be merged into @angular/platform-browser in a later release
// see https://github.com/angular/angular/pull/12322
var angular2_meta_1 = __webpack_require__(99);
var default_request_options_1 = __webpack_require__(625);
var cookie_1 = __webpack_require__(85);
var routes_service_1 = __webpack_require__(5);
var routes_browser_service_1 = __webpack_require__(628);
var api_service_1 = __webpack_require__(13);
var application_service_1 = __webpack_require__(128);
var browser_2 = __webpack_require__(629);
// import * as LRU from 'modern-lru';
function getLRU(lru) {
    // use LRU for node
    // return lru || new LRU(10);
    return lru || new Map();
}
exports.getLRU = getLRU;
function getRequest() {
    // the request object only lives on the server
    return { cookie: document.cookie };
}
exports.getRequest = getRequest;
function getResponse() {
    // the response object is sent as the index.html and lives on the server
    return {};
}
exports.getResponse = getResponse;
function TranslateStaticLoaderFactory(http, cache) {
    return new browser_2.TranslateStaticLoader(http, cache);
}
exports.TranslateStaticLoaderFactory = TranslateStaticLoaderFactory;
// TODO(gdi2290): refactor into Universal
exports.UNIVERSAL_KEY = 'UNIVERSAL_CACHE';
var MainModule = (function () {
    function MainModule(cache, nodeLogger, routes, translate) {
        this.cache = cache;
        this.nodeLogger = nodeLogger;
        this.routes = routes;
        this.translate = translate;
        // TODO(gdi2290): refactor into a lifecycle hook
        this.doRehydrate();
        this.translate.use(this.routes.getLang());
        this.routes.loadRoutes();
    }
    MainModule.prototype.doRehydrate = function () {
        var defaultValue = {};
        var serverCache = this._getCacheValue(cache_service_1.CacheService.KEY, defaultValue);
        this.cache.rehydrate(serverCache);
    };
    MainModule.prototype._getCacheValue = function (key, defaultValue) {
        // browser
        var win = window;
        if (win[exports.UNIVERSAL_KEY] && win[exports.UNIVERSAL_KEY][key]) {
            var serverCache = defaultValue;
            try {
                serverCache = JSON.parse(win[exports.UNIVERSAL_KEY][key]);
                if (typeof serverCache !== typeof defaultValue) {
                    console.log('Angular Universal: The type of data from the server is different from the default value type');
                    serverCache = defaultValue;
                }
            }
            catch (e) {
                console.log('Angular Universal: There was a problem parsing the server data during rehydrate');
                serverCache = defaultValue;
            }
            return serverCache;
        }
        else {
            console.log('Angular Universal: UNIVERSAL_CACHE is missing');
        }
        return defaultValue;
    };
    MainModule = __decorate([
        core_1.NgModule({
            bootstrap: [app_module_1.AppComponent],
            imports: [
                browser_1.UniversalModule,
                forms_1.FormsModule,
                core_2.TranslateModule.forRoot({
                    loader: {
                        provide: core_2.TranslateLoader,
                        useFactory: (TranslateStaticLoaderFactory),
                        deps: [api_service_1.ApiService, application_service_1.ApplicationService]
                    }
                }),
                router_1.RouterModule.forRoot([], { useHash: false, preloadingStrategy: idle_preload_1.IdlePreload }),
                idle_preload_1.IdlePreloadModule.forRoot(),
                shared_module_1.SharedModule.forRoot(),
                app_module_1.AppModule
            ],
            providers: [
                { provide: http_1.RequestOptions, useClass: default_request_options_1.DefaultRequestOptions },
                { provide: 'CookieService', useClass: cookie_1.CookieBrowserService },
                { provide: routes_service_1.RoutesService, useClass: routes_browser_service_1.RoutesBrowserService },
                { provide: 'isBrowser', useValue: browser_1.isBrowser },
                { provide: 'isNode', useValue: browser_1.isNode },
                { provide: 'req', useFactory: getRequest },
                { provide: 'res', useFactory: getResponse },
                { provide: 'LRU', useFactory: getLRU, deps: [] },
                node_logger_service_1.NodeLoggerService,
                cache_service_1.CacheService,
                angular2_meta_1.Meta
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _a) || Object, (typeof (_b = typeof node_logger_service_1.NodeLoggerService !== 'undefined' && node_logger_service_1.NodeLoggerService) === 'function' && _b) || Object, (typeof (_c = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object])
    ], MainModule);
    return MainModule;
    var _a, _b, _c, _d;
}());
exports.MainModule = MainModule;


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var HelperService = (function () {
    function HelperService() {
    }
    //Return the name of a file, withouth extention, from a path 
    //Eg. 
    //Input:http://www.wscprinter.it/business-cards.jpg
    //Output:business-cards
    HelperService.prototype.GetFileNameFromPath = function (filePath) {
        var fileName = "";
        if (filePath != null) {
            var split = filePath.split("/");
            if (split != null) {
                var pop = split.pop();
                if (pop != null) {
                    fileName = pop.replace(/\.[^/.]+$/, "");
                }
            }
            return fileName;
        }
    };
    HelperService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], HelperService);
    return HelperService;
}());
exports.HelperService = HelperService;


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var common_1 = __webpack_require__(44);
var core_2 = __webpack_require__(27);
var system_configuration_service_1 = __webpack_require__(423);
var cookie_1 = __webpack_require__(85);
var cache_service_1 = __webpack_require__(21);
var RoutesService = (function () {
    function RoutesService(router, translate, cookie, location, isBrowser, cache) {
        this.router = router;
        this.translate = translate;
        this.cookie = cookie;
        this.location = location;
        this.isBrowser = isBrowser;
        this.cache = cache;
        this.visiblePageLoader = false;
    }
    RoutesService.prototype.loadRoutes = function () {
    };
    RoutesService.prototype.getRoutesWithComponents = function (rawRoutes) {
        return rawRoutes.map(function (route) {
            if (route.component && 'string' === typeof route.component) {
                return Object.assign({}, route, {
                    component: system_configuration_service_1.SysConfig.getComponentByName(route.component)
                });
            }
            return route;
        });
    };
    RoutesService.prototype.getOnlyOfflineRoutes = function (rawRoutes) {
        //Keeping only the offline route
        var offlineRawRoutes = [];
        for (var _i = 0, rawRoutes_1 = rawRoutes; _i < rawRoutes_1.length; _i++) {
            var rowRoute = rawRoutes_1[_i];
            if (rowRoute.name == "OFFLINE") {
                var redirectToRoute = {
                    path: "",
                    redirectTo: rowRoute.path,
                    pathMatch: "full"
                };
                offlineRawRoutes.push(redirectToRoute);
                var offlineRoute = {
                    path: rowRoute.path,
                    component: rowRoute.component,
                    name: rowRoute.name
                };
                offlineRawRoutes.push(offlineRoute);
                var fallBackRoute = {
                    path: "**",
                    redirectTo: rowRoute.path
                };
                offlineRawRoutes.push(fallBackRoute);
                break;
            }
            else {
                continue;
            }
        }
        return offlineRawRoutes;
    };
    RoutesService.prototype.getLang = function () {
        if (!this.locales) {
            this.locales = this.cache.get('Locales');
        }
        var langFromUrl = null;
        var langFromUrlMatch;
        if (langFromUrlMatch = this.location.path().match(/^\/(\w{2})\//)) {
            langFromUrl = langFromUrlMatch[1];
        }
        var cookieLang = this.cookie.get(RoutesService.COOKIE_LANG_KEY);
        if (langFromUrl && this.locales.find(function (existLang) { return existLang === langFromUrl; })) {
            return langFromUrl;
        }
        if (cookieLang && this.locales.find(function (existLang) { return existLang === cookieLang; })) {
            return cookieLang;
        }
        var _loop_1 = function(existBrowserLang) {
            if (this_1.locales.find(function (existLang) { return existLang === existBrowserLang; })) {
                return { value: existBrowserLang };
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.browserLangs; _i < _a.length; _i++) {
            var existBrowserLang = _a[_i];
            var state_1 = _loop_1(existBrowserLang);
            if (typeof state_1 === "object") return state_1.value;
        }
        return this.locales[0];
    };
    RoutesService.prototype.getRoutes = function () {
    };
    RoutesService.prototype.getRoutePath = function (routeName) {
        var routes = this.getRoutes();
        var routePath = "";
        if (routes != undefined && routes != null) {
            routes.filter(function (x) { return x.name == routeName; }).forEach(function (route) {
                routePath = "/" + route.path;
            });
        }
        //console.log(routes);
        //console.log(routes.filter(x => x.name == routeName));
        // for (let route of routes) {
        //     //if the name of the route match the one give in input then the relative route path is returned
        //     if (route.name == routeName) {
        //         routePath = "/" + route.path;
        //         break;
        //     }
        // }
        if (routePath === "") {
            routePath = "/";
        }
        return [routePath];
    };
    RoutesService.prototype.getPage = function (routeName) {
        var routePath = "/";
        if (routeName != "" || routeName != undefined) {
            var routes = this.getRoutes();
            if (routes != undefined) {
                if (routes != undefined && routes != null) {
                    routes.filter(function (x) { return x.name == routeName; }).forEach(function (route) {
                        routePath = "/" + route.path;
                    });
                }
            }
        }
        return routePath;
    };
    RoutesService.prototype.showPageLoader = function () {
        this.visiblePageLoader = true;
    };
    RoutesService.prototype.hidePageLoader = function () {
        this.visiblePageLoader = false;
        // window.setTimeout(() =>
        // this.visiblePageLoader = false, 1)
    };
    RoutesService.COOKIE_LANG_KEY = 'CURRENT_LANG';
    RoutesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _d) || Object, Boolean, (typeof (_e = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _e) || Object])
    ], RoutesService);
    return RoutesService;
    var _a, _b, _c, _d, _e;
}());
exports.RoutesService = RoutesService;


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QuotingModel = (function () {
    function QuotingModel() {
        this.categorieCarteCount = 0;
        this.categorieCarteCopertinaCount = 0;
        this.carte1Count = 0;
        this.carte2Count = 0;
        this.colori1Count = 0;
        this.colori2Count = 0;
        this.grammature1Count = 0;
        this.grammature2Count = 0;
        this.plastificazioni1Count = 0;
        this.plastificazioni2Count = 0;
        this.piegatureCount = 0;
        this.materialiFlessibiliCount = 0;
        this.copieCount = 0;
        this.supportiRigidiCount = 0;
        this.elettrosaldatureCount = 0;
        this.tagliCount = 0;
        this.copertineCount = 0;
        this.rilegatureCount = 0;
        this.facciateCount = 0;
        this.tipologieBustaCount = 0;
        this.multiploFacciate = 0;
        this.copieIsValid = true;
        this.facciateIsValid = true;
        this.formatiIsValid = true;
        this.carte1IsValid = true;
        this.grammature1IsValid = true;
        this.carte2IsValid = true;
        this.grammature2IsValid = true;
        this.copertineIsValid = true;
        this.rilegatureIsValid = true;
        this.lavorazioniIsValid = true;
        this.taglioShowed = false;
        this.isTaglioVisible = false;
        this.copieOrder = 0;
        this.facciateOrder = 0;
        this.formatiOrder = 0;
        this.stampaInternoFronteOrder = 0;
        this.stampaInternoOrder = 0;
        this.carteInternoOrder = 0;
        this.plastificazioniInternoOrder = 0;
        this.copertineOrder = 0;
        this.stampaCopertinaFronteOrder = 0;
        this.stampaCopertinaOrder = 0;
        this.cartaCopertinaOrder = 0;
        this.plastificazioniCopertinaOrder = 0;
        this.cartoncinoOrder = 0;
        this.rilegatureOrder = 0;
        this.rifiloOrder = 0;
        this.lavorazioniAccessorieOrder = 0;
        this.piegatureIsValid = true;
        this.plastificazione1IsValid = true;
        this.plastificazione2IsValid = true;
        this.soggettiOrder = 0;
        this.soggettiIsValid = true;
        this.baseFormatoIsValid = true;
        this.baseFormatoMessage = "";
        this.altezzaFormatoIsValid = true;
        this.altezzaFormatoMessage = "";
        this.formatiMultipliIsValid = true;
        this.formatiVisual = false;
        this.stampaInternoVisual = false;
        this.carteInternoVisual = false;
        this.plastificazioniInternoVisual = false;
        this.copertineVisual = false;
        this.stampaCopertinaVisual = false;
        this.cartaCopertinaVisual = false;
        this.plastificazioniCopertinaVisual = false;
        this.rilegatureVisual = false;
        this.lavorazioniAccessorieVisual = false;
        this.piegatureVisual = false;
        this.taglioOrder = 0;
        this.taglioIsValid = true;
        this.bustaOrder = 0;
        this.bustaIsValid = true;
        this.materialeOrder = 0;
        this.materialeIsValid = true;
        this.supportoOrder = 0;
        this.supportoIsValid = true;
        this.idGruppo = 0;
        this.occhiellaturaOrder = 0;
        this.occhiellaturaIsValid = true;
        this.occhielliCount = 0;
        this.occhielliDisposizioneCount = 0;
        this.asolaOrder = 0;
        this.asolaIsValid = true;
        this.asoleCount = 0;
        this.asoleDisposizioniCount = 0;
        this.cucituraOrder = 0;
        this.cucituraIsValid = true;
        this.cucitureCount = 0;
        this.cucitureDisposizioniCount = 0;
        this.elettroOrder = 0;
        this.elettroIsValid = true;
        this.elettrosaldatureDisposizioniCount = 0;
        this.bifaccialeOrder = 0;
        this.biancoCoprenteOrder = 0;
        this.biancoCoprenteCount = 0;
        this.distanzaOcchielliIsValid = true;
        this.diametroAsolaIsValid = true;
        this.pantoniCount = 0;
        this.colori1IsValid = true;
        //Cartoncino
        this.cartoncinoIsValid = true;
        this.cartoncinoVisual = false;
        this.cartonciniCount = 0;
        this.grammatureCartoncinoIsValid = true;
        this.grammatureCartoncinoCount = 0;
        this.basePackagingIsValid = true;
        this.profonditaPackagingIsValid = true;
        this.idBasePackaging = 0;
        this.idProfonditaPackaging = 0;
        this.formatiCount = 0;
        this.gapLabel = 0;
        this.diametroInterno = 0;
        this.diametroMassimoEsterno = 0;
        this.formatiTipoLabelCount = 0;
        this.formatiTipoLabelIsValid = true;
        this.fustelleLabelCount = 0;
        this.fustellaLabelIsValid = true;
        this.avvolgimentiCount = 0;
        this.avvolgimentiIsValid = true;
        this.numEtichetteIsValid = true;
        this.numEtichette = "1";
        this.DiametroInternoAnimaEditabileLabel = false;
        this.DiametroInternoAnimaIsValid = true;
        this.DiametroMassimoEsternoAnimaEditabile = false;
        this.DiametroMassimoEsternoAnimaIsValid = true;
    }
    return QuotingModel;
}());
exports.QuotingModel = QuotingModel;
var FileCombinationModel = (function () {
    function FileCombinationModel() {
    }
    return FileCombinationModel;
}());
exports.FileCombinationModel = FileCombinationModel;
var Object = (function () {
    function Object() {
        this.isVisible = true;
    }
    return Object;
}());
exports.Object = Object;
var WizardListinoScontistica = (function () {
    function WizardListinoScontistica() {
    }
    return WizardListinoScontistica;
}());
exports.WizardListinoScontistica = WizardListinoScontistica;
var SelectObject = (function () {
    function SelectObject() {
    }
    return SelectObject;
}());
exports.SelectObject = SelectObject;
var MyVarianteMatrice = (function () {
    function MyVarianteMatrice() {
    }
    return MyVarianteMatrice;
}());
exports.MyVarianteMatrice = MyVarianteMatrice;
var MyLavorazioneAccessoria = (function () {
    function MyLavorazioneAccessoria() {
        this.isValid = false;
        this.isVisible = true;
        this.valoriCount = 0;
    }
    return MyLavorazioneAccessoria;
}());
exports.MyLavorazioneAccessoria = MyLavorazioneAccessoria;
var Regola = (function () {
    function Regola() {
    }
    return Regola;
}());
exports.Regola = Regola;
var MyLavorazioneAccessoriaReturn = (function () {
    function MyLavorazioneAccessoriaReturn() {
    }
    return MyLavorazioneAccessoriaReturn;
}());
exports.MyLavorazioneAccessoriaReturn = MyLavorazioneAccessoriaReturn;
var LavorazioniComponents = (function () {
    function LavorazioniComponents() {
        this.checkBox = 0;
        this.inputBox = 1;
        this.selectBox = 2;
    }
    return LavorazioniComponents;
}());
exports.LavorazioniComponents = LavorazioniComponents;


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var app_component_1 = __webpack_require__(371);
var home_module_1 = __webpack_require__(599);
var cms_page_module_1 = __webpack_require__(601);
var inventory_product_module_1 = __webpack_require__(616);
var inventory_category_module_1 = __webpack_require__(615);
var settings_module_1 = __webpack_require__(617);
var system_configuration_service_1 = __webpack_require__(423);
var ng2_table_1 = __webpack_require__(428);
// Need for defer included components by dynamic routing
var entryComponents = system_configuration_service_1.SysConfig.getAllComponents();
var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        core_1.NgModule({
            declarations: [app_component_1.AppComponent],
            imports: [
                shared_module_1.SharedModule,
                home_module_1.HomeModule,
                cms_page_module_1.CmsPageModule,
                inventory_product_module_1.InventoryProductModule,
                inventory_category_module_1.InventoryCategoryModule,
                settings_module_1.SettingsModule,
                ng2_table_1.Ng2TableModule,
            ],
            entryComponents: entryComponents.slice()
        }), 
        __metadata('design:paramtypes', [])
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;
var app_component_2 = __webpack_require__(371);
exports.AppComponent = app_component_2.AppComponent;


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var language_service_1 = __webpack_require__(3);
var article_service_1 = __webpack_require__(126);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var NewsListComponent = (function () {
    function NewsListComponent(_compiler, componentHelper, _elementRef, templateService, articleService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.articleService = articleService;
        this.isBrowser = isBrowser;
        this.columns = 4;
    }
    NewsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        //Depending on the type of the list, a different template is used
        var subComponentTemplateUrl;
        switch (this.newsOrientation) {
            case "newsVertical":
                subComponentTemplateUrl = "newsListVerticalPageTemplate";
                break;
            case "newsHorizontal":
                subComponentTemplateUrl = "newsListHorizontalPageTemplate";
                break;
            case "newsVerticalBanner":
                subComponentTemplateUrl = "newsListVerticalBannerPageTemplate";
                break;
            case "newsHorizontalBanner":
                subComponentTemplateUrl = "newsListHorizontalBannerHomepageTemplate";
                break;
        }
        this.articleService.getArticleList(this.category, subComponentTemplateUrl).subscribe(function (result) {
            var templateData = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(templateData, _this.items, _this.category, _this.newsOrientation, _this.headerTypeNews, _this.columns);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
    };
    NewsListComponent.prototype.createSubComponent = function (response, inputItems, inputCategory, inputNewsOrientation, inputHeaderTypeNews, inputColumns) {
        var ChildComponent = (function () {
            function ChildComponent(languageService, articleService) {
                this.languageService = languageService;
                this.articleService = articleService;
                this.items = inputItems;
                this.category = inputCategory;
                this.newsOrientation = inputNewsOrientation;
                this.headerTypeNews = inputHeaderTypeNews;
                this.lang = this.languageService.getLongLang();
                this.columns = inputColumns;
            }
            ChildComponent.prototype.ngOnInit = function () {
                this.items = response.ArticleList;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: response.TemplateHtml
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _a) || Object, (typeof (_b = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _b) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], NewsListComponent.prototype, "items", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], NewsListComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], NewsListComponent.prototype, "newsOrientation", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], NewsListComponent.prototype, "headerTypeNews", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], NewsListComponent.prototype, "columns", void 0);
    NewsListComponent = __decorate([
        core_1.Component({
            selector: "dy-article-list",
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof article_service_1.ArticleService !== 'undefined' && article_service_1.ArticleService) === 'function' && _e) || Object, Boolean])
    ], NewsListComponent);
    return NewsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.NewsListComponent = NewsListComponent;


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//System
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
//Services
var component_helper_service_1 = __webpack_require__(4);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
var auth_service_1 = __webpack_require__(9);
var newsletter_service_1 = __webpack_require__(84);
//Models
var user_login_1 = __webpack_require__(73);
var Subscription_1 = __webpack_require__(2);
var header_service_1 = __webpack_require__(127);
var language_service_1 = __webpack_require__(3);
var FooterComponent = (function () {
    function FooterComponent(_compiler, componentHelper, _elementRef, cmsComponentService, route, router, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.route = route;
        this.router = router;
        this.isBrowser = isBrowser;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        if (this.parentFooterData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentFooterData);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            var footerData_1;
            var footerSub = this.cmsComponentService.getFooterData().subscribe(function (result) {
                footerData_1 = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(footerData_1);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            });
            this.subManager.add(footerSub);
        }
    };
    FooterComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject 
    FooterComponent.prototype.createSubComponent = function (footerData) {
        var ChildComponent = (function () {
            function ChildComponent(routesService, authService, languageService, newsletterService, headerService) {
                var _this = this;
                this.routesService = routesService;
                this.authService = authService;
                this.languageService = languageService;
                this.newsletterService = newsletterService;
                this.headerService = headerService;
                this.loggedIdUser = new user_login_1.UserLogin();
                this.company = footerData.Company;
                this.isActiveQuickRegistration = footerData.IsActiveQuickRegistration;
                this.faqPageName = this.routesService.getRoutePath('FAQ');
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.cookiePageName = this.routesService.getRoutePath('INFO COOKIE');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.contactPageName = this.routesService.getRoutePath('RICHIESTA INFORMAZIONI');
                this.loginPageName = this.routesService.getRoutePath('LOGIN');
                this.passwordPageName = this.routesService.getRoutePath('RECUPERA PASSWORD');
                this.registerPageName = this.routesService.getRoutePath('REGISTRAZIONE');
                this.areaClientiPageName = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.carrelloPageName = this.routesService.getRoutePath('CARRELLO');
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.isCaptchaInvalid = true;
                this.siteKey = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
                this.theme = "light";
                this.lang = this.languageService.getShortLang();
                this.isArrayInit = false;
                this.spinnerNewslatter = false;
                this.model = {
                    Email: ""
                };
                this.subManager = new Subscription_1.Subscription();
                this.headerService.getLoggedInUser().subscribe(function (user) {
                    _this.loggedIdUser = user;
                });
            }
            ChildComponent.prototype.ngOnInit = function () {
                //setup of links, they must start with http to work properly
                var linkStart = "http://";
                var linkSecuredStart = "https://";
                if (this.company.Facebook != null) {
                    if (this.company.Facebook.indexOf(linkStart) == -1 && this.company.Facebook.indexOf(linkSecuredStart) == -1) {
                        this.company.Facebook = linkStart + this.company.Facebook;
                    }
                }
                if (this.company.Youtube != null) {
                    if (this.company.Youtube.indexOf(linkStart) == -1 && this.company.Youtube.indexOf(linkSecuredStart) == -1) {
                        this.company.Youtube = linkStart + this.company.Youtube;
                    }
                }
                if (this.company.Twitter != null) {
                    if (this.company.Twitter.indexOf(linkStart) == -1 && this.company.Twitter.indexOf(linkSecuredStart) == -1) {
                        this.company.Twitter = linkStart + this.company.Twitter;
                    }
                }
                if (this.company.Website != null) {
                    if (this.company.Website.indexOf(linkStart) == -1 && this.company.Website.indexOf(linkSecuredStart) == -1) {
                        this.company.Website = linkStart + this.company.Website;
                    }
                }
                if (this.company.Instagram != null) {
                    if (this.company.Instagram.indexOf(linkStart) == -1 && this.company.Instagram.indexOf(linkSecuredStart) == -1) {
                        this.company.Instagram = linkStart + this.company.Instagram;
                    }
                }
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerNewslatter = true;
                if (form) {
                    var newsletterSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(function (result) {
                        if (result == "-1") {
                            _this.alreadySubscribed = true;
                            _this.successfullySubscribed = false;
                            _this.spinnerNewslatter = false;
                        }
                        else {
                            _this.alreadySubscribed = false;
                            _this.successfullySubscribed = true;
                            _this.spinnerNewslatter = false;
                        }
                    });
                    this.subManager.add(newsletterSub);
                }
                else {
                    this.spinnerNewslatter = false;
                }
            };
            ChildComponent.prototype.setVerified = function (data) {
                this.isCaptchaInvalid = !data;
            };
            ChildComponent.prototype.showModalQuickRegistrationEmail = function () {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                document.querySelector('#header').style.zIndex = '1041';
                $("#quickRegistrationEmailModal").modal("show");
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: footerData.TemplateHtml
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _d) || Object, (typeof (_e = typeof header_service_1.HeaderService !== 'undefined' && header_service_1.HeaderService) === 'function' && _e) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], FooterComponent.prototype, "parentFooterData", void 0);
    FooterComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            selector: "dy-footer",
            template: ''
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, Boolean])
    ], FooterComponent);
    return FooterComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.FooterComponent = FooterComponent;


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var newsletter_service_1 = __webpack_require__(84);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var routes_service_1 = __webpack_require__(5);
var Subscription_1 = __webpack_require__(2);
var NewsletterComponent = (function () {
    function NewsletterComponent(_compiler, componentHelper, _elementRef, templateService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.isBrowser = isBrowser;
        this.subManager = new Subscription_1.Subscription();
    }
    NewsletterComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var pageTemplateSub = this.templateService.getComponentTemplate("newsletterPageTemplate").subscribe(function (result) {
            var templateHtml = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(templateHtml);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(pageTemplateSub);
    };
    NewsletterComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    NewsletterComponent.prototype.createSubComponent = function (template) {
        var ChildComponent = (function () {
            function ChildComponent(newsletterService, routesService) {
                this.newsletterService = newsletterService;
                this.routesService = routesService;
                this.isCaptchaInvalid = true;
                this.siteKey = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
                this.theme = "light";
                this.spinnerNewslatter = false;
                this.model = {
                    Email: "",
                    CheckboxFooter: false
                };
                this.privacyPageNameNewsletter = this.routesService.getRoutePath('INFO PRIVACY');
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
            };
            ChildComponent.prototype.onSubmit = function (form) {
                var _this = this;
                this.spinnerNewslatter = true;
                if (form) {
                    var newsletterSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(function (result) {
                        if (result == "-1") {
                            _this.alreadySubscribed = true;
                            _this.successfullySubscribed = false;
                            _this.spinnerNewslatter = false;
                        }
                        else {
                            _this.alreadySubscribed = false;
                            _this.successfullySubscribed = true;
                            _this.spinnerNewslatter = false;
                        }
                    });
                    this.subManager.add(newsletterSub);
                }
                else {
                    this.spinnerNewslatter = false;
                }
            };
            ChildComponent.prototype.setVerified = function (data) {
                this.isCaptchaInvalid = !data;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: template
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof newsletter_service_1.NewsletterService !== 'undefined' && newsletter_service_1.NewsletterService) === 'function' && _a) || Object, (typeof (_b = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _b) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b;
        }());
        return ChildComponent;
    };
    NewsletterComponent = __decorate([
        core_1.Component({
            selector: "dy-newsletter",
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, Boolean])
    ], NewsletterComponent);
    return NewsletterComponent;
    var _a, _b, _c, _d;
}());
exports.NewsletterComponent = NewsletterComponent;


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//System
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var cms_component_service_1 = __webpack_require__(8);
var language_service_1 = __webpack_require__(3);
var routes_service_1 = __webpack_require__(5);
var auth_service_1 = __webpack_require__(9);
var shopping_cart_service_1 = __webpack_require__(20);
var user_login_1 = __webpack_require__(73);
var search_service_1 = __webpack_require__(263);
var router_1 = __webpack_require__(12);
var router_state_1 = __webpack_require__(82);
var application_service_1 = __webpack_require__(128);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var header_service_1 = __webpack_require__(127);
var HeaderComponent = (function () {
    function HeaderComponent(_compiler, componentHelper, _elementRef, cmsComponentService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.data = {};
        this.subManager = new Subscription_1.Subscription();
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        if (this.parentHeaderData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentHeaderData);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            //let templateHtml: string;
            var headerInfo_1;
            //Instead of reading only the template, also the information to show are retrieved (eg. menu list)
            var headDataSub = this.cmsComponentService.getHeaderData().subscribe(function (result) {
                headerInfo_1 = result;
                var startDate = new Date();
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(headerInfo_1);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
                // var endDate = new Date();
                // this.nodeLogger.AddLogWithTime("injecting Header (" + diffMs + ")");
            });
            this.subManager.add(headDataSub);
        }
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //Creates component to inject 
    HeaderComponent.prototype.createSubComponent = function (headerInfo) {
        var ChildComponent = (function () {
            function ChildComponent(language, authService, cartService, isBrowser, searchService, routesService, router, appService, activatedRoute, canvasService, headerService) {
                var _this = this;
                this.language = language;
                this.authService = authService;
                this.cartService = cartService;
                this.isBrowser = isBrowser;
                this.searchService = searchService;
                this.routesService = routesService;
                this.router = router;
                this.appService = appService;
                this.activatedRoute = activatedRoute;
                this.canvasService = canvasService;
                this.headerService = headerService;
                this.headerIsInit = false;
                this.company = headerInfo.Company;
                this.menuItems = headerInfo.MenuList;
                this.megaMenuItems = headerInfo.Categories;
                this.isActiveQuickRegistration = headerInfo.IsActiveQuickRegistration;
                this.quickRegistrationData = headerInfo.QuickRegistrationData;
                this.isLazyLoadActive = headerInfo.isEnableLAzyLoad;
                this.languagesList = headerInfo.Languages;
                this.currentLanguage = {};
                this.loggedIdUser = new user_login_1.UserLogin();
                this.shoppingCart = headerInfo.CartInfo;
                this.homePageName = [];
                this.productsPageName = [];
                this.promotionsPageName = [];
                this.loginPageName = [];
                this.registerPageName = [];
                this.areaClientiName = [];
                this.carrelloPageName = [];
                this.blogPageName = [];
                this.contactPageName = [];
                this.disableModalButtons = false;
                this.spinner = false;
                this.subManager = new Subscription_1.Subscription();
                this.cartService.initCart(headerInfo.CartInfo);
                this.headerService.getLoggedInUser().subscribe(function (user) {
                    _this.loggedIdUser = user;
                });
            }
            ChildComponent.prototype.ngOnInit = function () {
                var date = new Date();
                var lang = this.language.getShortLang();
                //Setting current language info
                for (var _i = 0, _a = this.languagesList; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    if (entry.ShortCode == lang) {
                        this.currentLanguage = entry;
                        break;
                    }
                }
                this.homePageName = this.routesService.getRoutePath('HOME');
                this.productsPageName = this.routesService.getRoutePath('CATALOGO PRODOTTI (HOME)');
                this.promotionsPageName = this.routesService.getRoutePath('CATALOGO - PRODOTTI IN OFFERTA');
                this.loginPageName = this.routesService.getRoutePath('LOGIN');
                this.registerPageName = this.routesService.getRoutePath('REGISTRAZIONE');
                this.areaClientiName = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.carrelloPageName = this.routesService.getRoutePath('CARRELLO');
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.contactPageName = this.routesService.getRoutePath('RICHIESTA INFORMAZIONI');
                //setup of links, they must start with http to work properly
                var linkStart = "http://";
                var linkSecuredStart = "https://";
                if (this.company.Facebook != null) {
                    if (this.company.Facebook.indexOf(linkStart) == -1 && this.company.Facebook.indexOf(linkSecuredStart) == -1) {
                        this.company.Facebook = linkStart + this.company.Facebook;
                    }
                }
                if (this.company.Youtube != null) {
                    if (this.company.Youtube.indexOf(linkStart) == -1 && this.company.Youtube.indexOf(linkSecuredStart) == -1) {
                        this.company.Youtube = linkStart + this.company.Youtube;
                    }
                }
                if (this.company.Twitter != null) {
                    if (this.company.Twitter.indexOf(linkStart) == -1 && this.company.Twitter.indexOf(linkSecuredStart) == -1) {
                        this.company.Twitter = linkStart + this.company.Twitter;
                    }
                }
                if (this.company.Website != null) {
                    if (this.company.Website.indexOf(linkStart) == -1 && this.company.Website.indexOf(linkSecuredStart) == -1) {
                        this.company.Website = linkStart + this.company.Website;
                    }
                }
                if (this.company.Instagram != null) {
                    if (this.company.Instagram.indexOf(linkStart) == -1 && this.company.Instagram.indexOf(linkSecuredStart) == -1) {
                        this.company.Instagram = linkStart + this.company.Instagram;
                    }
                }
            };
            ChildComponent.prototype.showModal = function (product) {
                this.disableModalButtons = false;
                $("#headerModal").modal("show");
                this.productId = product.Id;
                this.selectedProduct = product;
            };
            ChildComponent.prototype.hideModal = function () {
                $('#headerModal').modal('hide');
                this.disableModalButtons = true;
            };
            // customers canvas state module is active and current product has canvasStateId defined, then send a request to delete a state from customers canvas server
            ChildComponent.prototype.removeCustomersCanvasState = function () {
                if (this.selectedProduct.isCanvasEdited && this.selectedProduct.CanvasStateId) {
                    var canvasConfigData = this.setCanvasConfig(this.selectedProduct);
                    this.canvasService.deleteCustomerCanvasState(canvasConfigData)
                        .subscribe(function (x) { return x; }, function (err) {
                        console.log(err);
                    });
                }
            };
            ChildComponent.prototype.setCanvasConfig = function (product) {
                var canvasConfigData = {
                    CanvasUrl: headerInfo.CanvasInfo.CanvasUrl,
                    CustomerCanvasUserName: headerInfo.CanvasInfo.CustomerCanvasUserName,
                    CanvasStateId: product.CanvasStateId,
                    CanvasApiKey: headerInfo.CanvasInfo.ApiKey
                };
                return canvasConfigData;
            };
            //Redirect the user to the homepage for the selected language
            ChildComponent.prototype.setLanguage = function (lang) {
                window.location.href = "/" + lang + '/home';
            };
            ChildComponent.prototype.logout = function () {
                this.authService.Logout();
            };
            ChildComponent.prototype.removeFromCart = function () {
                var _this = this;
                this.spinner = true;
                this.disableModalButtons = true;
                var removeCartSub = this.cartService.removeFromCart(this.productId).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.shoppingCart = _this.cartService.getCart();
                    _this.removeCustomersCanvasState();
                    _this.hideModal();
                    _this.spinner = false;
                });
                this.subManager.add(removeCartSub);
            };
            //getting value of search input and redirecting to search result page
            ChildComponent.prototype.getSearchResults = function (inputVal) {
                var query = "";
                inputVal = inputVal.trim();
                if (inputVal == "") {
                    return;
                }
                else {
                    this.searchService.setQueryPlainTextValue(inputVal);
                    if (inputVal != undefined) {
                        query = inputVal;
                    }
                    else {
                        var subParam = this.activatedRoute.params.subscribe(function (params) {
                            var encodedQuery = params['query'];
                            query = decodeURIComponent(encodedQuery);
                        });
                        this.subManager.add(subParam);
                    }
                }
                query = decodeURIComponent(query);
                var uriString = encodeURIComponent(query);
                this.searchService.setQueryValue(uriString);
                var searchRoute = this.routesService.getRoutePath('SEARCH - RESULTS')[0];
                searchRoute = searchRoute.replace(":query", query);
                this.router.navigate([searchRoute]);
            };
            ChildComponent.prototype.setAutoHeightAndWeightToLogo = function () {
                var headerClass = $("div").hasClass("header-logo");
                if (headerClass == false) {
                }
                else {
                    $(".header-logo").attr("style", "height:auto!important");
                    $(".header-logo").attr("style", "width:auto!important");
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.headerIsInit) {
                    return;
                }
                //setting value of search textbox to search condition value if the current page is search-result page, else, clean it's content
                var documentUrl = window.location.href;
                if (documentUrl.indexOf("search-results") != -1) {
                    var plainSearchText = this.searchService.getQueryPlainTextValue();
                    if (plainSearchText != "") {
                        $("#searchQuery").val(plainSearchText);
                    }
                    else {
                        this.activatedRoute.params.subscribe(function (params) {
                            var encodedQuery = params['query'];
                            var decodedQuery = decodeURIComponent(encodedQuery);
                            $("#searchQuery").val(decodedQuery);
                        });
                    }
                }
                else {
                    $("#searchQuery").val("");
                }
                $("#searchQuery").keyup(function (event) {
                    if (event.keyCode === 13) {
                        $("#searchQueryButton").click();
                    }
                });
                layoutTheme.initNavMenu();
                layoutTheme.initStickyHeader();
                if (this.isLazyLoadActive == true) {
                    layoutTheme.initLazy();
                }
                var config = this.appService.getConfig();
                if (config.webStoreStatus == "offline") {
                    this.setAutoHeightAndWeightToLogo();
                }
                layoutTheme.initCarousel();
                layoutTheme.initVideo();
                this.headerIsInit = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: headerInfo.TemplateHtml
                }),
                __param(3, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _c) || Object, Boolean, (typeof (_d = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof application_service_1.ApplicationService !== 'undefined' && application_service_1.ApplicationService) === 'function' && _g) || Object, (typeof (_h = typeof router_state_1.ActivatedRoute !== 'undefined' && router_state_1.ActivatedRoute) === 'function' && _h) || Object, (typeof (_j = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _j) || Object, (typeof (_k = typeof header_service_1.HeaderService !== 'undefined' && header_service_1.HeaderService) === 'function' && _k) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], HeaderComponent.prototype, "parentHeaderData", void 0);
    HeaderComponent = __decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.Default,
            encapsulation: core_1.ViewEncapsulation.Emulated,
            selector: "dy-header",
            template: ''
        }),
        __param(4, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, Boolean])
    ], HeaderComponent);
    return HeaderComponent;
    var _a, _b, _c, _d;
}());
exports.HeaderComponent = HeaderComponent;


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var home_component_1 = __webpack_require__(376);
var HomeModule = (function () {
    function HomeModule() {
    }
    HomeModule = __decorate([
        core_1.NgModule({
            imports: [],
            declarations: [
                home_component_1.HomeComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], HomeModule);
    return HomeModule;
}());
exports.HomeModule = HomeModule;


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var component_helper_service_1 = __webpack_require__(4);
var cms_component_service_1 = __webpack_require__(8);
var SideBarMenuComponent = (function () {
    function SideBarMenuComponent(_compiler, componentHelper, _elementRef, cmsComponentService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.sideType = "sideBarMenu";
    }
    SideBarMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        if (this.parentSideMenuData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentSideMenuData, this.bredcrumpInfo);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            var subComponentTemplateUrl = "sideBarMenuTemplate";
            this.cmsComponentService.getSideMenuData().subscribe(function (result) {
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(result, _this.bredcrumpInfo);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            });
        }
    };
    SideBarMenuComponent.prototype.createSubComponent = function (data, breadcrumbs) {
        var ChildComponent = (function () {
            function ChildComponent() {
                this.megaMenuItems = data.Categories;
                this.breadcrumbsList = new Array();
            }
            ChildComponent.prototype.ngOnInit = function () {
                if (breadcrumbs != null) {
                    this.breadcrumbsList = breadcrumbs;
                }
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: data.TemplateHtml
                }), 
                __metadata('design:paramtypes', [])
            ], ChildComponent);
            return ChildComponent;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SideBarMenuComponent.prototype, "sideType", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SideBarMenuComponent.prototype, "parentSideMenuData", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SideBarMenuComponent.prototype, "bredcrumpInfo", void 0);
    SideBarMenuComponent = __decorate([
        core_1.Component({
            selector: "dy-side-bar",
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _d) || Object, Boolean])
    ], SideBarMenuComponent);
    return SideBarMenuComponent;
    var _a, _b, _c, _d;
}());
exports.SideBarMenuComponent = SideBarMenuComponent;


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var cms_page_component_1 = __webpack_require__(377);
var CmsPageModule = (function () {
    function CmsPageModule() {
    }
    CmsPageModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule
            ],
            declarations: [
                cms_page_component_1.CmsPageComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CmsPageModule);
    return CmsPageModule;
}());
exports.CmsPageModule = CmsPageModule;


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shopping_cart_service_1 = __webpack_require__(20);
//Angular
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var customerscanvas_service_1 = __webpack_require__(43);
var CanvasWidgetComponent = (function () {
    function CanvasWidgetComponent(_compiler, componentHelper, _elementRef, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.isBrowser = isBrowser;
    }
    CanvasWidgetComponent.prototype.ngOnInit = function () {
        if (!this.isBrowser)
            return;
        if (this.parentWidgetData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentWidgetData);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    };
    CanvasWidgetComponent.prototype.createSubComponent = function (canvasWidgetComponent) {
        var ChildComponent = (function () {
            function ChildComponent(isBrowser, canvasService, shoppingCartService) {
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.shoppingCartService = shoppingCartService;
                this.pageIsInit = false;
            }
            ChildComponent.prototype.ngOnInit = function () { };
            // when want to finish design, to move to the second step
            ChildComponent.prototype.finishDesign = function () {
                this.canvasService.getImagesLinks(this.editorPage, this.approvePage, this.finishOrderPage);
            };
            // when close a modal with canvas editor, set state to false, so from component we can know the modal is closed
            ChildComponent.prototype.isCanvasModalOpened = function (isOpened) {
                this.canvasService.openNewProductInEditor();
                this.canvasService.setCanvasState(isOpened);
            };
            // when the product is successfully created and approved, and second step is done
            ChildComponent.prototype.finishProductCustomization = function () {
                var _this = this;
                //If the product customization has been successfully completed.
                this.canvasService.finishProductCustomization()
                    .then(function (result) {
                    // set canvas response to a property in service, so it can be available to a parent component
                    _this.shoppingCartService.setCustomizationCanvasData(result);
                    //Saving hi-res output info.
                    _this.canvasService.setupPageAfterProductCustomization(result, false);
                    /* Send notification to the service that we finished product customization, so from parent component we know it and can call method for adding to cart */
                    _this.canvasService.setCanvasProductDesignState(true);
                    _this.canvasService.openNewProductInEditor();
                })
                    .catch(function (error) {
                    _this.canvasService.setupPageAfterProductCustomization(error, true);
                });
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                layoutTheme.initSlider();
                this.pageIsInit = true;
            };
            __decorate([
                core_1.ViewChild('editorPage'), 
                __metadata('design:type', (typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object)
            ], ChildComponent.prototype, "editorPage", void 0);
            __decorate([
                core_1.ViewChild('approvePage'), 
                __metadata('design:type', (typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object)
            ], ChildComponent.prototype, "approvePage", void 0);
            __decorate([
                core_1.ViewChild('finishOrderPage'), 
                __metadata('design:type', (typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object)
            ], ChildComponent.prototype, "finishOrderPage", void 0);
            ChildComponent = __decorate([
                core_1.Component({
                    template: canvasWidgetComponent.TemplateHtml
                }),
                __param(0, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [Boolean, (typeof (_d = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], CanvasWidgetComponent.prototype, "parentWidgetData", void 0);
    CanvasWidgetComponent = __decorate([
        core_1.Component({
            selector: "customer-canvas-widget",
            template: ""
        }),
        __param(3, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, Boolean])
    ], CanvasWidgetComponent);
    return CanvasWidgetComponent;
    var _a, _b, _c;
}());
exports.CanvasWidgetComponent = CanvasWidgetComponent;


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var slider_service_1 = __webpack_require__(417);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var cms_component_service_1 = __webpack_require__(8);
var Subscription_1 = __webpack_require__(2);
var SliderWidgetComponent = (function () {
    function SliderWidgetComponent(_compiler, componentHelper, _elementRef, templateService, cmsComponentService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.subManager = new Subscription_1.Subscription();
    }
    SliderWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        if (this.parentSliderData != null) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = this.createSubComponent(this.parentSliderData);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            var sliderData_1;
            var sliderDataSub = this.cmsComponentService.getSliderData(this.type, this.id).subscribe(function (result) {
                sliderData_1 = result;
                //Creating subcomponent whith the selected template to inject
                var subComponent = _this.createSubComponent(sliderData_1);
                //injecting created component (OK)
                _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
            });
            this.subManager.add(sliderDataSub);
        }
    };
    SliderWidgetComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    //private createSubComponent(template:string, sliderId: string, sliderType: string) {
    SliderWidgetComponent.prototype.createSubComponent = function (sliderData) {
        var ChildComponent = (function () {
            function ChildComponent(sliderService, isBrowser, elementRef, renderer) {
                this.sliderService = sliderService;
                this.isBrowser = isBrowser;
                this.elementRef = elementRef;
                this.renderer = renderer;
                this.slides = sliderData.Slides;
                this.sliderIsInit = false;
                this.renderer.setElementStyle(this.elementRef.nativeElement, 'display', this.isBrowser ? 'block' : 'none');
            }
            ChildComponent.prototype.ngOnInit = function () { };
            ChildComponent.prototype.goToUrl = function (url) {
                if (url != null && url.length > 0) {
                    window.location.href = url;
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.sliderIsInit) {
                    return;
                }
                layoutTheme.initSlider();
                this.sliderIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: sliderData.TemplateHtml
                }),
                __param(1, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof slider_service_1.SliderService !== 'undefined' && slider_service_1.SliderService) === 'function' && _a) || Object, Boolean, (typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object, (typeof (_c = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _c) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SliderWidgetComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SliderWidgetComponent.prototype, "type", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SliderWidgetComponent.prototype, "parentSliderData", void 0);
    SliderWidgetComponent = __decorate([
        core_1.Component({
            selector: "dy-slider",
            template: ""
        }),
        __param(5, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, (typeof (_e = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _e) || Object, Boolean])
    ], SliderWidgetComponent);
    return SliderWidgetComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SliderWidgetComponent = SliderWidgetComponent;


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
//Angular
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var trustpilot_service_1 = __webpack_require__(418);
var TrustpilotWidgetComponent = (function () {
    function TrustpilotWidgetComponent(_compiler, componentHelper, _elementRef, isBrowser, trustpilotService) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.isBrowser = isBrowser;
        this.trustpilotService = trustpilotService;
        this.sub = new Subscription_1.Subscription();
    }
    TrustpilotWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.trustpilotType)
            this.trustpilotType = 'default';
        var trustpilotSub = this.trustpilotService.getTrustpilotData(this.trustpilotType).subscribe(function (result) {
            //-- If result is null, it means that trustpilot with given type doesn't exist, or trustpilot module is not active
            var subComponent = _this.createSubComponent(result);
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.sub.add(trustpilotSub);
    };
    TrustpilotWidgetComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    TrustpilotWidgetComponent.prototype.createSubComponent = function (trustpilotData) {
        //-- If trustpilot module is not active, we are going to set a template to empty string 
        var ChildComponent = (function () {
            function ChildComponent(isBrowser) {
                this.isBrowser = isBrowser;
                this.pageIsInit = false;
            }
            ChildComponent.prototype.ngOnInit = function () {
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                //-- Initializing trustbox
                var trustboxesRef = Array.from(document.querySelectorAll('.trustpilot-widget'));
                //-- Initialize all trustbox instances on the page
                if (trustboxesRef && trustboxesRef.length > 0)
                    trustboxesRef.forEach(function (singleTrustboxInstance) { return Trustpilot.loadFromElement(singleTrustboxInstance); });
                this.pageIsInit = true;
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: trustpilotData.TemplateHtml || ""
                }),
                __param(0, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [Boolean])
            ], ChildComponent);
            return ChildComponent;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], TrustpilotWidgetComponent.prototype, "trustpilotType", void 0);
    TrustpilotWidgetComponent = __decorate([
        core_1.Component({
            selector: "trustpilot-widget",
            template: ""
        }),
        __param(3, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, Boolean, (typeof (_d = typeof trustpilot_service_1.TrustpilotService !== 'undefined' && trustpilot_service_1.TrustpilotService) === 'function' && _d) || Object])
    ], TrustpilotWidgetComponent);
    return TrustpilotWidgetComponent;
    var _a, _b, _c, _d;
}());
exports.TrustpilotWidgetComponent = TrustpilotWidgetComponent;


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
//Services
var language_service_1 = __webpack_require__(3);
var product_service_1 = __webpack_require__(132);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var shopping_cart_service_1 = __webpack_require__(20);
var Subscription_1 = __webpack_require__(2);
var QuotingOrderTotalsComponent = (function () {
    function QuotingOrderTotalsComponent(_compiler, componentHelper, _elementRef, templateService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.isBrowser = isBrowser;
        this.subManager = new Subscription_1.Subscription();
    }
    QuotingOrderTotalsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var templateHtml;
        var orderTotalSub = this.templateService.getComponentTemplate("quotingOrderTotalsWidgetTemplate").subscribe(function (result) {
            templateHtml = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(templateHtml);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(orderTotalSub);
    };
    QuotingOrderTotalsComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    QuotingOrderTotalsComponent.prototype.createSubComponent = function (template) {
        var ChildComponent = (function () {
            function ChildComponent(productService, languageService, cartService, _elementChildRef) {
                this.productService = productService;
                this.languageService = languageService;
                this.cartService = cartService;
                this._elementChildRef = _elementChildRef;
            }
            ChildComponent.prototype.ngOnInit = function () { };
            ChildComponent = __decorate([
                core_1.Component({
                    template: template
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof product_service_1.ProductService !== 'undefined' && product_service_1.ProductService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _d) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d;
        }());
        return ChildComponent;
    };
    QuotingOrderTotalsComponent = __decorate([
        core_1.Component({
            selector: "dy-quoting-order-totals-widget",
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, Boolean])
    ], QuotingOrderTotalsComponent);
    return QuotingOrderTotalsComponent;
    var _a, _b, _c, _d;
}());
exports.QuotingOrderTotalsComponent = QuotingOrderTotalsComponent;


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var cms_component_service_1 = __webpack_require__(8);
var routes_service_1 = __webpack_require__(5);
//Models
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_constants_1 = __webpack_require__(620);
var Subscription_1 = __webpack_require__(2);
var quoting_excluding_component_1 = __webpack_require__(72);
var shared_constants_1 = __webpack_require__(621);
var quoting_model_1 = __webpack_require__(56);
var currency_service_1 = __webpack_require__(29);
var OtherProductFormComponent = (function () {
    function OtherProductFormComponent(_compiler, componentHelper, _elementRef, authService, languageService, cmsComponentService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.authService = authService;
        this.languageService = languageService;
        this.cmsComponentService = cmsComponentService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.lang = this.languageService.getLongLang();
        this.userId = this.authService.GetUserId();
        this.subManager = new Subscription_1.Subscription();
    }
    OtherProductFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser) {
            return;
        }
        //Instead of reading only the template, also the information to show are retrieved (eg. menu list)
        var otherProdSub = this.cmsComponentService.getOtherProductData(this.productId, this.userId).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.productId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(otherProdSub);
    };
    OtherProductFormComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    OtherProductFormComponent.prototype.createSubComponent = function (formInfo, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, authService, translate, routesService, currency, cartService, bootboxService, isBrowser) {
                this._quotingService = _quotingService;
                this.authService = authService;
                this.translate = translate;
                this.routesService = routesService;
                this.currency = currency;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.formData = formInfo.FormData;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.resourceId = InputresourceId;
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.resultCalculation = false;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.requestInfoSuccess = null;
                this.showErrorMessage = false;
                this.companyInformation = formInfo.CompanyInfo;
                this.isFormValid = true;
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.sumQtaMatrix = 0;
                this.totalQtaForMatrix = 0;
                this.isCalculatedProduct = false;
                this.isVisibleMatrixLav = false;
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.responseModel = new quoting_model_1.QuotingModel();
                //isapplyingrules: boolean = false;
                this.subManager = new Subscription_1.Subscription();
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.typePriceResult = "no-tax";
                this.formData.gruppi.forEach(function (group) {
                    group.varianti.forEach(function (varianti) {
                        if (varianti.tipo == 7) {
                            varianti.VarianteMatrix = _this.createMatriceObj(varianti);
                            _this.isVisibleMatrixLav = true;
                        }
                    });
                });
                this.ExcludingRules.setMacrocategory(shared_constants_1.SharedConstants.OTHER_PRODUCTS_TYPE);
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                if (!this.isDataInitialized) {
                    this.convertLogicalToViewQuotingModel();
                    this.checkValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.convertLogicalToViewQuotingModel();
                        _this.checkValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            //-- Create quoting object from form data object, because we need it for applying rules(regole)
            ChildComponent.prototype.convertLogicalToViewQuotingModel = function () {
                var _this = this;
                this.responseModel.listaRegole = this.formData.listaRegole;
                this.responseModel.calculationType = this.formData.calculationType;
                this.responseModel.companyCondizioni = this.formData.companyCondizioni;
                this.responseModel.lavorazioniAccessorie = [];
                //-- From gruppi obect get all varianti and convert it to Lavorazioni Accessorie model
                this.formData.gruppi.forEach(function (group) {
                    group.varianti.forEach(function (varianti) {
                        var lavAcc = _this.convertLogicalToViewModelVarianti(varianti);
                        _this.responseModel.lavorazioniAccessorie.push(lavAcc);
                    });
                });
            };
            //-- Convert varianti model to lavorazioni accessorie model
            ChildComponent.prototype.convertLogicalToViewModelVarianti = function (varianti) {
                var lavAcc = new quoting_model_1.MyLavorazioneAccessoria();
                lavAcc.id = varianti.id;
                lavAcc.obbligatorio = varianti.obbligatorio;
                lavAcc.tipo = varianti.tipo;
                lavAcc.description = varianti.description;
                lavAcc.hasInfo = varianti.hasInfo;
                lavAcc.showInfo = varianti.showInfo;
                lavAcc.isVisible = varianti.isVisible;
                lavAcc.image = varianti.image;
                lavAcc.value = varianti.value;
                lavAcc.valori = varianti.valori;
                lavAcc.lavorazioneCheckValue = (varianti.lavorazioneCheckValue == 'true');
                lavAcc.isCalculated = varianti.isCalculated;
                lavAcc.tipoSelezione = varianti.tipoSelezione;
                lavAcc.idVarianteMatriceOrizzontale = varianti.idVarianteMatriceOrizzontale;
                lavAcc.idVarianteMatriceVerticale = varianti.idVarianteMatriceVerticale;
                if (varianti.tipo == 7) {
                    //lavAcc.VarianteMatrix=this.createMatriceObj(varianti);
                    lavAcc.VarianteMatrix = this.formData.VarianteMatrix;
                }
                //--If type is numeric or dropdown, valore is intFormValue, else it is valore
                if (varianti.tipo == 1 || varianti.tipo == 2) {
                    lavAcc.valore = varianti.intFormValue;
                }
                else {
                    lavAcc.valore = varianti.valore;
                }
                return lavAcc;
            };
            ChildComponent.prototype.createMatriceObj = function (variante) {
                var varianteMatrice = new quoting_model_1.MyVarianteMatrice();
                varianteMatrice.VarianteVerticale = new Array();
                varianteMatrice.VarianteOrizzontale = new Array();
                this.formData.gruppi.forEach(function (group) {
                    group.varianti.forEach(function (varianti) {
                        if (variante.idVarianteMatriceVerticale == varianti.id) {
                            varianti.isMatrix = true;
                            varianti.valori.forEach(function (option) {
                                var varianteMatverticale = new quoting_model_1.MyVarianteMatrice();
                                varianteMatverticale.id = option.chiave;
                                varianteMatverticale.nome = option.valore;
                                varianteMatverticale.colore = option.colorExaForMatrix;
                                varianteMatverticale.imgPath = option.image;
                                varianteMatverticale.mostraPerVariantiMatrice = option.mostraPerVariantiMatrice;
                                varianteMatverticale.popup = "";
                                varianteMatverticale.VarianteOrizzontale = new Array();
                                group.varianti.forEach(function (varianti2) {
                                    if (variante.idVarianteMatriceOrizzontale == varianti2.id) {
                                        varianti.isMatrix = true;
                                        varianti2.valori.forEach(function (option2) {
                                            var varianteMat2 = new quoting_model_1.MyVarianteMatrice();
                                            varianteMat2.id = option2.chiave;
                                            varianteMat2.nome = option2.valore;
                                            varianteMat2.qta = 0;
                                            varianteMat2.colore = option2.colorExaForMatrix;
                                            varianteMat2.imgPath = option2.image;
                                            varianteMat2.mostraPerVariantiMatrice = option2.mostraPerVariantiMatrice;
                                            varianteMatverticale.VarianteOrizzontale.push(varianteMat2);
                                        });
                                    }
                                });
                                varianteMatrice.VarianteVerticale.push(varianteMatverticale);
                            });
                        }
                        if (variante.idVarianteMatriceOrizzontale == varianti.id) {
                            varianti.isMatrix = true;
                            varianti.valori.forEach(function (option3) {
                                var varianteMat3 = new quoting_model_1.MyVarianteMatrice();
                                varianteMat3.id = option3.chiave;
                                varianteMat3.nome = option3.valore;
                                varianteMat3.qta = 0;
                                varianteMat3.colore = option3.colorExaForMatrix;
                                varianteMat3.imgPath = option3.image;
                                varianteMat3.mostraPerVariantiMatrice = option3.mostraPerVariantiMatrice;
                                varianteMatrice.VarianteOrizzontale.push(varianteMat3);
                            });
                        }
                    });
                });
                return varianteMatrice;
            };
            ChildComponent.prototype.checkRegoleOtherProducts = function () {
                var _this = this;
                try {
                    var lavAccArray_1 = new Array();
                    this.formData.gruppi.forEach(function (group) {
                        group.varianti.forEach(function (varianti) {
                            //console.log(varianti)
                            var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                            if (varianti.tipo == "2") {
                                lav.lavorazioneId = varianti.id;
                                lav.valoreLavorazione = varianti.intFormValue;
                                lavAccArray_1.push(lav);
                            }
                        });
                    });
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("AP", "ACCESSORIA", "", "ALTRO_PRODOTTO", null, null, this.responseModel, this.formData.gruppi);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("AP", "ALTRO_PRODOTTO", this.responseModel, this.formData.gruppi);
                    //if the old value id different to the new one i call the method for update description and image
                    var count_1 = 0;
                    this.formData.gruppi.forEach(function (group) {
                        group.varianti.forEach(function (lavorazione) {
                            count_1 = 0;
                            for (var _i = 0, lavAccArray_2 = lavAccArray_1; _i < lavAccArray_2.length; _i++) {
                                var lavorazioneOld = lavAccArray_2[_i];
                                if (count_1 > 0) {
                                    continue;
                                }
                                else {
                                    if (lavorazione.tipo == "2") {
                                        if (lavorazione.isVisible == true) {
                                            if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                                if ((lavorazione.intFormValue != lavorazioneOld.valoreLavorazione)) {
                                                    _this.dropDownChange(lavorazione, true);
                                                    count_1++;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    });
                }
                catch (error) {
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.checkBoxChanged = function (lavorazione) {
                //-- Updating lavorazioniAccessorie model
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (variante.id == lavorazione.id) {
                        variante.hasInfo = lavorazione.hasInfo;
                        variante.lavorazioneCheckValue = (lavorazione.lavorazioneCheckValue == 'true');
                        variante.valore = lavorazione.intFormValue;
                        break;
                    }
                }
                this.convertLogicalToViewQuotingModel();
                this.checkValidation();
            };
            ChildComponent.prototype.dropDownChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                //this.isapplyingrules=true;
                //-- Setting option description (if there is)
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.intFormValue == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                //-- Updating lavorazioniAccessorie model
                for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                    var variante = _c[_b];
                    if (variante.id == lavorazione.id) {
                        variante.hasInfo = lavorazione.hasInfo;
                        variante.valore = lavorazione.intFormValue;
                    }
                }
                if (isrules == false) {
                    this.checkValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.intFormValue = lavorazioneId;
                this.dropDownChange(lavorazione);
            };
            ChildComponent.prototype.checkValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedProduct = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.checkRegoleOtherProducts();
                //console.log(this.isapplyingrules)
                //if (this.isapplyingrules == false) {
                this.checkForm();
                if (this.isFormValid) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
                // }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.checkForm = function () {
                var _this = this;
                if (this.isCalculationTypeCalcolato() || this.isCalculationTypeCalcolatoScontistica()) {
                    this.isFormValid = true;
                    var message = void 0;
                    var numCopie = parseInt(this.formData.quantity);
                    var minCopie = this.formData.minimo_quantita;
                    var maxCopie = this.formData.maximo_quantita;
                    if (this.formData.tipoCopie == 'libera') {
                        //Quantity
                        if (this.formData.quantity == null || numCopie <= 0) {
                            message = this.getLabel('inserisci_valore_valido');
                            this.formData.isQuantityValidated = false;
                            if (this.isFormValid == true) {
                                this.isFormValid = false;
                            }
                        }
                        else if (maxCopie == 0 || this.formData.maximo_quantita == null) {
                            if (numCopie < minCopie) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minCopie;
                                this.formData.isQuantityValidated = false;
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                            }
                            else {
                                this.formData.isQuantityValidated = true;
                                this.isFormValid = true;
                            }
                        }
                        else {
                            if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                                this.formData.isQuantityValidated = true;
                                this.isFormValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minCopie;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxCopie;
                                this.formData.isQuantityValidated = false;
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                            }
                        }
                        this.copieMessage = message;
                    }
                    else {
                        if (this.formData.idCopie == "-1") {
                            message = this.getLabel('mandatory_field');
                            this.formData.isQuantityValidated = false;
                            if (this.isFormValid == true) {
                                this.isFormValid = false;
                            }
                        }
                        else {
                            this.formData.quantity = this.formData.idCopie;
                            this.formData.isQuantityValidated = true;
                        }
                        if (this.formData.tipoCopie === 'fissa' && this.formData.copie != null) {
                            this.formData.copieCount = this.formData.copie.filter(function (x) { return x.isVisible == true; }).length;
                        }
                    }
                }
                else {
                    if (parseInt(this.formData.quantity) <= 0) {
                        this.formData.quantity = 1;
                    }
                    this.isFormValid = true;
                    this.formData.isQuantityValidated = true;
                }
                this.sumQtaMatrix = 0;
                var ismatrixPresent = false;
                //Attributes
                for (var _i = 0, _a = this.formData.gruppi; _i < _a.length; _i++) {
                    var group = _a[_i];
                    for (var _b = 0, _c = group.varianti; _b < _c.length; _b++) {
                        var attribute = _c[_b];
                        if (!attribute.isVisible) {
                            continue;
                        }
                        //-- Count all varianti options that should be visible
                        if (attribute.valori != null) {
                            attribute.valoriCount = attribute.valori.filter(function (x) { return x.isVisible == true; }).length;
                        }
                        if (attribute.tipo == 1) {
                            var message = "";
                            var qta = parseInt(attribute.intFormValue);
                            var minQta = attribute.minQtaInput;
                            var maxQta = attribute.maxQtaInput;
                            if (attribute.intFormValue == null) {
                                message = this.getLabel('inserisci_valore_valido');
                                attribute.isValidated = false;
                            }
                            else if (maxQta == 0) {
                                if (qta < minQta) {
                                    message = this.getLabel('inserisci_valore_maggiore');
                                    message += " " + minQta;
                                    attribute.isValidated = false;
                                }
                                else {
                                    attribute.isValidated = true;
                                }
                            }
                            else {
                                if ((qta >= minQta) && (qta <= maxQta)) {
                                    attribute.isValidated = true;
                                }
                                else {
                                    message = this.getLabel('inserisci_valore_compreso_tra');
                                    message += " " + minQta;
                                    message += " " + this.getLabel('inserisci_valore_compreso_e');
                                    message += " " + maxQta;
                                    attribute.isValidated = false;
                                }
                            }
                            if (attribute.isValidated == false) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                            }
                            attribute.lavorazioneMessage = message;
                        }
                        else if (attribute.tipo == 2) {
                            //The value shall be greater than zero
                            if (attribute.intFormValue < 0) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                                attribute.isValidated = false;
                            }
                            else {
                                attribute.isValidated = true;
                            }
                        }
                        else if (attribute.tipo == 5) {
                            //Width validation
                            var convertedWidth = Number(attribute.numWidthFormValue);
                            var convertedHeight = Number(attribute.numHeightFormValue);
                            var convertedDepth = Number(attribute.numDepthFormValue);
                            //Checking if it is not mandatory
                            if (attribute.obbligatorio == false) {
                                //There is no validation if the three dimentions are not set
                                if (convertedWidth == 0 && convertedHeight == 0 && convertedDepth == 0) {
                                    attribute.isWidthValidated = true;
                                    attribute.isHeightValidated = true;
                                    attribute.isDepthValidated = true;
                                    continue;
                                }
                            }
                            //Checking if it is a valid number
                            if (isNaN(convertedWidth)) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                                attribute.isWidthValidated = false;
                                attribute.widthErrorMex = "Inserisci un valore valido";
                            }
                            else {
                                if (attribute.max_base == 0) {
                                    //The value shall be greater than the minimum
                                    if (convertedWidth < attribute.min_base) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }
                                        attribute.isWidthValidated = false;
                                        attribute.widthErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_base;
                                    }
                                    else {
                                        attribute.isWidthValidated = true;
                                        attribute.widthErrorMex = "";
                                    }
                                }
                                else {
                                    //3 - minbase = 0 - maxbase N - inserisci un valore compresto tra 0 e N
                                    //4 - minbase = N - maxbase M - inserisci un valore compresto tra 0 e N
                                    if (convertedWidth < attribute.min_base || convertedWidth > attribute.max_base) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }
                                        attribute.isWidthValidated = false;
                                        attribute.widthErrorMex = "Inserisci un valore compreso tra " + attribute.min_base + " e " + attribute.max_base;
                                    }
                                    else {
                                        attribute.isWidthValidated = true;
                                        attribute.widthErrorMex = "";
                                    }
                                }
                            }
                            //Height validation
                            //Checking if it is a valid number
                            if (isNaN(convertedHeight)) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                                attribute.isHeightValidated = false;
                                attribute.heightErrorMex = "Inserisci un valore valido";
                            }
                            else {
                                if (attribute.max_altezza == 0) {
                                    //1 - min_altezza = 0 - max_altezza 0 - inserisci un valore maggiore id zero
                                    //2 - min_altezza = N - max_altezza 0 - inserisci un valore maggiore id N                      
                                    //The value shall be greater than the minimum
                                    if (convertedHeight < attribute.min_altezza) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }
                                        attribute.isHeightValidated = false;
                                        attribute.heightErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_altezza;
                                    }
                                    else {
                                        attribute.isHeightValidated = true;
                                        attribute.heightErrorMex = "";
                                    }
                                }
                                else {
                                    //3 - min_altezza = 0 - max_altezza N - inserisci un valore compresto tra 0 e N
                                    //4 - min_altezza = N - max_altezza M - inserisci un valore compresto tra 0 e N
                                    if (convertedHeight < attribute.min_altezza || convertedHeight > attribute.max_altezza) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }
                                        attribute.isHeightValidated = false;
                                        attribute.heightErrorMex = "Inserisci un valore compreso tra " + attribute.min_altezza + " e " + attribute.max_altezza;
                                    }
                                    else {
                                        attribute.isHeightValidated = true;
                                        attribute.heightErrorMex = "";
                                    }
                                }
                            }
                            //Depth
                            if (attribute.hasDepth == true) {
                                //Checking if it is a valid number
                                if (isNaN(convertedDepth)) {
                                    if (this.isFormValid == true) {
                                        this.isFormValid = false;
                                    }
                                    attribute.isDepthValidated = false;
                                    attribute.depthErrorMex = "Inserisci un valore valido";
                                }
                                else {
                                    if (attribute.max_profondita == 0) {
                                        //1 - min_profondita = 0 - max_profondita 0 - inserisci un valore maggiore id zero
                                        //2 - min_profondita = N - max_profondita 0 - inserisci un valore maggiore id N                      
                                        //The value shall be greater than the minimum
                                        if (convertedDepth < attribute.min_profondita) {
                                            if (this.isFormValid == true) {
                                                this.isFormValid = false;
                                            }
                                            attribute.isDepthValidated = false;
                                            attribute.depthErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_profondita;
                                        }
                                        else {
                                            attribute.isDepthValidated = true;
                                            attribute.depthErrorMex = "";
                                        }
                                    }
                                    else {
                                        //3 - min_profondita = 0 - max_profondita N - inserisci un valore compresto tra 0 e N
                                        //4 - min_profondita = N - max_profondita M - inserisci un valore compresto tra 0 e N
                                        if (convertedDepth < attribute.min_profondita || convertedDepth > attribute.max_profondita) {
                                            if (this.isFormValid == true) {
                                                this.isFormValid = false;
                                            }
                                            attribute.isDepthValidated = false;
                                            attribute.depthErrorMex = "Inserisci un valore compreso tra " + attribute.min_profondita + " e " + attribute.max_profondita;
                                        }
                                        else {
                                            attribute.isDepthValidated = true;
                                            attribute.depthErrorMex = "";
                                        }
                                    }
                                }
                            }
                        }
                        else if (attribute.tipo == 7) {
                            ismatrixPresent = true;
                            attribute.VarianteMatrix.VarianteVerticale.forEach(function (varianti) {
                                varianti.VarianteOrizzontale.filter(function (x) { return x.qta > 0; }).forEach(function (varianti2) {
                                    _this.sumQtaMatrix += varianti2.qta;
                                });
                            });
                        }
                    }
                }
                if (ismatrixPresent == true) {
                    if (this.formData.tipoCopie == 'libera') {
                        this.totalQtaForMatrix = this.formData.quantity;
                    }
                    else {
                        this.totalQtaForMatrix = this.formData.idCopie;
                    }
                    if (this.totalQtaForMatrix != this.sumQtaMatrix) {
                        this.formData.isQuantityMatrixValidated = false;
                        if (this.isFormValid == true) {
                            this.isFormValid = false;
                        }
                        var message = this.getLabel('matrix_message_qta');
                        message += " " + this.totalQtaForMatrix;
                        this.MatrixMessage = message;
                    }
                    else {
                        this.formData.isQuantityMatrixValidated = true;
                    }
                }
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                if (this.formData.tipoCopie != 'libera') {
                    this.model.numCopie = this.formData.idCopie;
                }
                else {
                    this.model.numCopie = this.formData.quantity;
                }
                this.model.macrocategoryWizardId = 13;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = parseInt(this.resourceId);
                this.model.lavorazioniAccessorie = new Array();
                for (var _i = 0, _a = this.formData.gruppi; _i < _a.length; _i++) {
                    var gruppo = _a[_i];
                    var _loop_1 = function(variante) {
                        if (variante.isVisible == true) {
                            var lavorazione_1 = new quoting_submit_model_1.LavorazioniAccessorieModel();
                            lavorazione_1.matrixValues = new Array();
                            //checkbox
                            if (parseInt(variante.tipo) == 0) {
                                lavorazione_1.lavorazioneId = variante.id;
                                if (variante.lavorazioneCheckValue.toString() == 'true') {
                                    lavorazione_1.valoreLavorazione = "1";
                                }
                                else {
                                    lavorazione_1.valoreLavorazione = "0";
                                }
                            }
                            else if (parseInt(variante.tipo) == 2) {
                                if (!variante.isMatrix) {
                                    if (variante.intFormValue == "0") {
                                        lavorazione_1.lavorazioneId = variante.id;
                                        lavorazione_1.valoreLavorazione = "-1";
                                    }
                                    else {
                                        lavorazione_1.lavorazioneId = variante.id;
                                        lavorazione_1.valoreLavorazione = variante.intFormValue;
                                    }
                                }
                            }
                            else if (parseInt(variante.tipo) == 1) {
                                if (variante.intFormValue != null) {
                                    lavorazione_1.lavorazioneId = variante.id;
                                    lavorazione_1.valoreLavorazione = variante.intFormValue;
                                }
                            }
                            else if (parseInt(variante.tipo) == 5) {
                                if (variante.numWidthFormValue != null) {
                                    lavorazione_1.lavorazioneId = variante.id;
                                    lavorazione_1.tipo = variante.tipo;
                                    if (variante.hasDepth == true) {
                                        lavorazione_1.numWidthFormValue = variante.numWidthFormValue;
                                        lavorazione_1.numHeightFormValue = variante.numHeightFormValue;
                                        lavorazione_1.numDepthFormValue = variante.numDepthFormValue;
                                    }
                                    else {
                                        lavorazione_1.numWidthFormValue = variante.numWidthFormValue;
                                        lavorazione_1.numHeightFormValue = variante.numHeightFormValue;
                                    }
                                }
                            }
                            else if (parseInt(variante.tipo) == 6) {
                                lavorazione_1.lavorazioneId = variante.id;
                                lavorazione_1.valoreLavorazione = variante.value;
                            }
                            else if (parseInt(variante.tipo) == 7) {
                                variante.VarianteMatrix.VarianteVerticale.forEach(function (varianti) {
                                    varianti.VarianteOrizzontale.filter(function (x) { return x.qta > 0; }).forEach(function (varianti2) {
                                        var matrix = new quoting_submit_model_2.MatrixModelCalculation();
                                        matrix.quantita = varianti2.qta;
                                        matrix.lavorazioneOrizzontaleId = varianti2.id;
                                        matrix.lavorazioneVerticaleId = varianti.id;
                                        lavorazione_1.tipo = variante.tipo;
                                        lavorazione_1.lavorazioneId = variante.id;
                                        lavorazione_1.matrixValues.push(matrix);
                                    });
                                });
                            }
                            if ((lavorazione_1.lavorazioneId != null && lavorazione_1.valoreLavorazione != "-1") || parseInt(variante.tipo) == 7) {
                                this_1.model.lavorazioniAccessorie.push(lavorazione_1);
                            }
                        }
                    };
                    var this_1 = this;
                    for (var _b = 0, _c = gruppo.varianti; _b < _c.length; _b++) {
                        var variante = _c[_b];
                        _loop_1(variante);
                    }
                    this.isDataInitialized = true;
                }
                if (this.formData.calculationType != quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO) {
                    var calculationSub_1 = this._quotingService.getCalculatedAp(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedProduct = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino() || _this.isCalculationTypeCalcolatoListino() || _this.isCalculationTypeCalcolatoListinoFornitori()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica() || _this.isCalculationTypeCalcolatoListinoScontistica() || _this.isCalculationTypeCalcolatoListinoFornitoriScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        _this.subManager.add(calculationSub_1);
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedProduct = false;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                    this.subManager.add(calculationSub_1);
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_SCONTISTICA) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO_SCONTISTICA) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoListino = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoListinoFornitori = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoListinoScontistica = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_SCONTISTICA) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoListinoFornitoriScontistica = function () {
                var retVal = false;
                if (this.formData.calculationType == quoting_constants_1.QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI_SCONTISTICA) {
                    retVal = true;
                }
                return retVal;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.DayDescriptionName = price.DayDescriptionName;
                this.resultPrice.DayDescriptionStatus = price.DayDescriptionStatus;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.addToCartApProduct = function () {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var addToCartSub = this.cartService.addApProductToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(addToCartSub);
            };
            ChildComponent.prototype.addToCartOtherProductCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addOtherProductCalcolatoScontisticaToCart(wizardId, this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addOtherProductListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addOtherProductListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addOtherProductCalcolatoListinoToCart = function (quantityId) {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addOtherProductCalcolatoListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.Varianti, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addOtherProductCalcolatoListinoScontisticaToCart = function (quantityId) {
                var _this = this;
                var wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addOtherProductCalcolatoListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.DataId, this.resultPrice.Varianti, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                setTimeout(function () {
                    $('.popovers').popover();
                }, 150);
                layoutTheme.initToggle();
                this.setPopoverVariableForMAtrix();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.setPopoverVariableForMAtrix = function () {
                for (var _i = 0, _a = this.formData.gruppi; _i < _a.length; _i++) {
                    var gruppo = _a[_i];
                    for (var _b = 0, _c = gruppo.varianti; _b < _c.length; _b++) {
                        var variante = _c[_b];
                        if (parseInt(variante.tipo) == 7) {
                            variante.VarianteMatrix.VarianteVerticale.forEach(function (varianti) {
                                varianti.popup = $('#popover_content_wrapper_' + varianti.id).html();
                            });
                        }
                    }
                }
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: formInfo.TemplateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], OtherProductFormComponent.prototype, "productId", void 0);
    OtherProductFormComponent = __decorate([
        core_1.Component({
            selector: "dy-other-product-quoting-form",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof cms_component_service_1.CmsComponentService !== 'undefined' && cms_component_service_1.CmsComponentService) === 'function' && _f) || Object, Boolean])
    ], OtherProductFormComponent);
    return OtherProductFormComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OtherProductFormComponent = OtherProductFormComponent;


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
//Angular
var core_1 = __webpack_require__(0);
//Services
var component_helper_service_1 = __webpack_require__(4);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var template_service_1 = __webpack_require__(35);
var QuotingMainComponent = (function () {
    function QuotingMainComponent(_compiler, componentHelper, _elementRef, templateService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this.templateService = templateService;
        this.isBrowser = isBrowser;
        this.subManager = new Subscription_1.Subscription();
    }
    QuotingMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var templateHtml;
        var compSub = this.templateService.getComponentTemplate("quotingMainTemplate").subscribe(function (result) {
            templateHtml = result;
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(templateHtml, _this.QResourceId, _this.QMacroCat, _this.QType);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(compSub);
    };
    QuotingMainComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    QuotingMainComponent.prototype.createSubComponent = function (template, InputresourceId, InputMacroCatId, InputTypeId) {
        var ParentComponent = (function () {
            function ParentComponent(languageService, authService) {
                this.languageService = languageService;
                this.authService = authService;
                this.QResourceId = InputresourceId;
                this.QMacroCat = InputMacroCatId;
                this.QType = InputTypeId;
                this.lang = this.languageService.getLongLang();
                this.autentification = this.authService.GetData();
            }
            ParentComponent.prototype.ngOnInit = function () {
            };
            ParentComponent = __decorate([
                core_1.Component({
                    template: template
                }), 
                __metadata('design:paramtypes', [(typeof (_a = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
            ], ParentComponent);
            return ParentComponent;
            var _a, _b;
        }());
        return ParentComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], QuotingMainComponent.prototype, "QResourceId", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], QuotingMainComponent.prototype, "QMacroCat", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], QuotingMainComponent.prototype, "QType", void 0);
    QuotingMainComponent = __decorate([
        core_1.Component({
            selector: "dy-quoting",
            template: ""
        }),
        __param(4, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _d) || Object, Boolean])
    ], QuotingMainComponent);
    return QuotingMainComponent;
    var _a, _b, _c, _d;
}());
exports.QuotingMainComponent = QuotingMainComponent;


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
///Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var quoting_submit_model_5 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardAdesiviComponent = (function () {
    function WizardAdesiviComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardAdesiviComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var wizardSub = this._quotingService.getWizardAdesiviData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(wizardSub);
    };
    WizardAdesiviComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardAdesiviComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, translate, routesService, cartService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.translate = translate;
                this.routesService = routesService;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.iShowHourForDay = false;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.formatiMultipliList = new Array();
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                if (this.responseModel.idGruppo == 6) {
                    this.ExcludingRules.setMacrocategory("ADESIVI");
                }
                else if (this.responseModel.idGruppo == 8) {
                    this.ExcludingRules.setMacrocategory("MANIFESTI");
                }
                else if (this.responseModel.idGruppo == 10) {
                    this.ExcludingRules.setMacrocategory("PANNELLI");
                }
                if (this.responseModel.isFormatiMultiliEnabled) {
                    this.aggiungiFormatoMultiplo(true);
                }
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.aggiungiFormatoMultiplo = function (firstLoad) {
                if (firstLoad === void 0) { firstLoad = false; }
                var fileObj = new quoting_submit_model_5.FormatiMultipliObj();
                var lastId = 0;
                if (this.formatiMultipliList.length > 0) {
                    lastId = this.formatiMultipliList.sort(function (x) { return x.Id; }).reverse()[0].Id;
                }
                fileObj.Id = (lastId + 1);
                fileObj.Copie = 1;
                fileObj.Width = parseFloat(this.responseModel.minimoBase + "");
                fileObj.Height = parseFloat(this.responseModel.minimoAltezza + "");
                fileObj.Name = this.getLabel('new_format');
                this.formatiMultipliList.push(fileObj);
                if (!firstLoad) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.deleteFormatoMultiplo = function (id) {
                this.formatiMultipliList.splice(this.formatiMultipliList.findIndex(function (e) { return e.Id === id; }), 1);
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.CheckRegoleAdesivi = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldMateriale = this.responseModel.idMaterialiFlessibili;
                    var oldSupporto = this.responseModel.idSupportiRigidi;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "ADESIVI", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "MATERIALE_FLESSIBILE", "", "", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "SUPPORTO_RIGIDO", "", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "ADESIVI", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "ADESIVI", idFormato, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "MATERIALE_FLESSIBILE", "", "", this.responseModel.idMaterialiFlessibili, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "SUPPORTO_RIGIDO", "", "", this.responseModel.idSupportiRigidi, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "ADESIVI", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldMateriale != this.responseModel.idMaterialiFlessibili) {
                        this.onMaterialeChange(true);
                    }
                    if (oldSupporto != this.responseModel.idSupportiRigidi) {
                        this.onSuportoChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, lavAccArray_1 = lavAccArray; _b < lavAccArray_1.length; _b++) {
                        var lavorazioneOld = lavAccArray_1[_b];
                        count = 0;
                        for (var _c = 0, _d = this.responseModel.lavorazioniAccessorie; _c < _d.length; _c++) {
                            var lavorazione = _d[_c];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                    if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                        this.lavorazioniAccessorieComboChange(lavorazione, true);
                                        count++;
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.CheckRegoleManifesti = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldMateriale = this.responseModel.idMaterialiFlessibili;
                    var oldSupporto = this.responseModel.idSupportiRigidi;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "MANIFESTI", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "MATERIALE_FLESSIBILE", "", "", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "SUPPORTO_RIGIDO", "", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "MANIFESTI", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "MANIFESTI", idFormato, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "MATERIALE_FLESSIBILE", "", "", this.responseModel.idMaterialiFlessibili, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "SUPPORTO_RIGIDO", "", "", this.responseModel.idSupportiRigidi, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "MANIFESTI", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldMateriale != this.responseModel.idMaterialiFlessibili) {
                        this.onMaterialeChange(true);
                    }
                    if (oldSupporto != this.responseModel.idSupportiRigidi) {
                        this.onSuportoChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_2 = lavAccArray; _d < lavAccArray_2.length; _d++) {
                            var lavorazioneOld = lavAccArray_2[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.CheckRegolePannelli = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldMateriale = this.responseModel.idMaterialiFlessibili;
                    var oldSupporto = this.responseModel.idSupportiRigidi;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "PANNELLI", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "MATERIALE_FLESSIBILE", "", "", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "SUPPORTO_RIGIDO", "", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "PANNELLI", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "PANNELLI", idFormato, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "PLASTIFICAZIONE", "", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "MATERIALE_FLESSIBILE", "", "", this.responseModel.idMaterialiFlessibili, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "SUPPORTO_RIGIDO", "", "", this.responseModel.idSupportiRigidi, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "PANNELLI", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldMateriale != this.responseModel.idMaterialiFlessibili) {
                        this.onMaterialeChange(true);
                    }
                    if (oldSupporto != this.responseModel.idSupportiRigidi) {
                        this.onSuportoChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, lavAccArray_3 = lavAccArray; _b < lavAccArray_3.length; _b++) {
                        var lavorazioneOld = lavAccArray_3[_b];
                        count = 0;
                        for (var _c = 0, _d = this.responseModel.lavorazioniAccessorie; _c < _d.length; _c++) {
                            var lavorazione = _d[_c];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                    if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                        this.lavorazioniAccessorieComboChange(lavorazione, true);
                                        count++;
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                if (this.responseModel.idGruppo == 6) {
                    this.CheckRegoleAdesivi();
                }
                else if (this.responseModel.idGruppo == 8) {
                    this.CheckRegoleManifesti();
                }
                else if (this.responseModel.idGruppo == 10) {
                    this.CheckRegolePannelli();
                }
                if (this.responseModel.isFormatiMultiliEnabled) {
                    //check id all data into formatimultipli list is setted
                    this.validationFormatiMultipli();
                }
                else {
                    //verify validation for all  parameters 
                    this.validationCopie();
                    if (this.responseModel.soggettiMultipli == true) {
                        this.validationSoggetti();
                    }
                    else {
                        this.responseModel.soggettiIsValid = true;
                    }
                    this.validationFormati();
                    if (this.responseModel.idFormati == "0") {
                        this.validationBaseFormati();
                        this.validationAltezzaFormati();
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.validationMateriali();
                this.validationSupporti();
                this.countPlastificazioni();
                this.validationLavorazioneAccessoria();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countPlastificazioni = function () {
                if (this.responseModel.plastificazioni1 != null) {
                    this.responseModel.plastificazioni1Count = this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        if (file.FormatId == idFormato) {
                            var fileObj = new quoting_submit_model_4.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                this.model.isFormatoMultiploEnabled = this.responseModel.isFormatiMultiliEnabled;
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idMaterialiFlessibili = this.responseModel.idMaterialiFlessibili;
                this.model.idSupportiRigidi = this.responseModel.idSupportiRigidi;
                this.model.idPlastificazioni1 = this.responseModel.idPlastificazioni1;
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                this.model.lavorazioniAccessorie = new Array();
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioneAccessoria = _a[_i];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var calcWizSub = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = true;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                    this.subManager.add(calcWizSub);
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.isFormatiMultiliEnabled) {
                    if (this.responseModel.formatiMultipliIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.materialeIsValid
                        && this.responseModel.supportoIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    if (this.responseModel.copieIsValid
                        && this.responseModel.formatiIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.baseFormatoIsValid
                        && this.responseModel.altezzaFormatoIsValid
                        && this.responseModel.soggettiIsValid
                        && this.responseModel.materialeIsValid
                        && this.responseModel.supportoIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.responseModel.numSoggetti == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.soggettiIsValid = false;
                }
                else if (numSoggetti == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.soggettiIsValid = false;
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.formatiMessage = message;
            };
            ChildComponent.prototype.validationBaseFormatiMultipli = function (baseInput) {
                var message = "";
                var base = parseFloat(baseInput);
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (base <= 0 || baseInput == "" || baseInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base < minBase)) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base < minBase) || (base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationAltezzaFormatiMultipli = function (altezzaInput) {
                var message = "";
                var altezza = parseFloat(altezzaInput);
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (altezza <= 0 || altezzaInput == "" || altezzaInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if (altezza < minAltezza) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza < minAltezza) || (altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationCopieFormatiMultipli = function (copieInput) {
                var message = "";
                var numCopie = parseInt(copieInput);
                var minCopie = this.responseModel.minimoCopie;
                var maxCopie = this.responseModel.massimoCopie;
                if (numCopie <= 0 || copieInput == "" || copieInput == null) {
                    message = this.getLabel('inserisci_valore_valido');
                }
                else if (maxCopie == 0) {
                    if (numCopie < minCopie) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + minCopie;
                    }
                }
                else {
                    if ((numCopie < minCopie) || (numCopie > maxCopie)) {
                        message = this.getLabel('inserisci_valore_compreso_tra');
                        message += " " + minCopie;
                        message += " " + this.getLabel('inserisci_valore_compreso_e');
                        message += " " + maxCopie;
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationFormatiMultipli = function () {
                var _this = this;
                this.responseModel.formatiMultipliIsValid = true;
                this.formatiMultipliList.forEach(function (x) {
                    var copieMessage = _this.validationCopieFormatiMultipli(x.Copie);
                    if (copieMessage == "") {
                        x.copieIsValid = true;
                        x.copieMessage = "";
                    }
                    else {
                        x.copieIsValid = false;
                        x.copieMessage = copieMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var heighMessage = _this.validationAltezzaFormatiMultipli(x.Height);
                    if (heighMessage == "") {
                        x.heightIsValid = true;
                        x.heightMessage = "";
                    }
                    else {
                        x.heightIsValid = false;
                        x.heightMessage = heighMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var widthMessage = _this.validationBaseFormatiMultipli(x.Width);
                    if (widthMessage == "") {
                        x.widthIsValid = true;
                        x.widthMessage = "";
                    }
                    else {
                        x.widthIsValid = false;
                        x.widthMessage = widthMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                });
            };
            ChildComponent.prototype.validationMateriali = function () {
                var message;
                if (this.responseModel.idMaterialiFlessibili == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.materialeIsValid = false;
                }
                else {
                    this.responseModel.materialeIsValid = true;
                }
                if (this.responseModel.materialiFlessibili != null) {
                    this.responseModel.materialiFlessibiliCount = this.responseModel.materialiFlessibili.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.materialeMessage = message;
            };
            ChildComponent.prototype.validationSupporti = function () {
                var message;
                if (this.responseModel.idSupportiRigidi == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.supportoIsValid = false;
                }
                else {
                    this.responseModel.supportoIsValid = true;
                }
                if (this.responseModel.supportiRigidi != null) {
                    this.responseModel.supportiRigidiCount = this.responseModel.supportiRigidi.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.supportoMessage = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var transSub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(transSub);
                return message;
            };
            ChildComponent.prototype.checkIsPlastificazioneInternoIsShowed = function () {
                var result = false;
                if (this.responseModel.plastificazioni1 != null && this.responseModel.plastificazioni1.length > 0) {
                    result = true;
                    if (this.responseModel.isPlastificazioneRequired == false) {
                        if (this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length > 0) {
                            result = true;
                        }
                        else {
                            result = false;
                        }
                    }
                }
                return result;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                    var formato = _a[_i];
                    if (formato.chiave == this.responseModel.idFormati) {
                        this.responseModel.formatoDescription = formato.descrizione;
                        this.responseModel.formatoImage = formato.image;
                        this.responseModel.formatiHasInfo = formato.hasInfo;
                        this.responseModel.formatiShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onMaterialeChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.materialiFlessibili; _i < _a.length; _i++) {
                    var materiale = _a[_i];
                    if (materiale.chiave == this.responseModel.idMaterialiFlessibili) {
                        this.responseModel.materialeDescription = materiale.descrizione;
                        this.responseModel.materialeImage = materiale.image;
                        this.responseModel.materialeHasInfo = materiale.hasInfo;
                        this.responseModel.materialeShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onMaterialeVisualChange = function (materialeId) {
                this.responseModel.idMaterialiFlessibili = materialeId;
                this.onMaterialeChange();
            };
            ChildComponent.prototype.onSuportoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.supportiRigidi; _i < _a.length; _i++) {
                    var supporto = _a[_i];
                    if (supporto.chiave == this.responseModel.idSupportiRigidi) {
                        this.responseModel.supportoDescription = supporto.descrizione;
                        this.responseModel.supportoImage = supporto.image;
                        this.responseModel.supportoHasInfo = supporto.hasInfo;
                        this.responseModel.supportoShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onSuportoVisualChange = function (supportoId) {
                this.responseModel.idSupportiRigidi = supportoId;
                this.onSuportoChange();
            };
            ChildComponent.prototype.onPlastificationInternoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.plastificazioni1; _i < _a.length; _i++) {
                    var plastification = _a[_i];
                    if (plastification.chiave == this.responseModel.idPlastificazioni1) {
                        this.responseModel.plastificazioni1Description = plastification.descrizione;
                        this.responseModel.plastificazioni1Image = plastification.image;
                        this.responseModel.plastificazioni1HasInfo = plastification.hasInfo;
                        this.responseModel.plastificazioni1ShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPlastificationInternoViasualChange = function (plastificationId) {
                this.responseModel.idPlastificazioni1 = plastificationId;
                this.onPlastificationInternoChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideMaterialeDescription = function () {
                if (this.responseModel.materialeShowInfo) {
                    this.responseModel.materialeShowInfo = false;
                }
                else {
                    this.responseModel.materialeShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideSupportoDescription = function () {
                if (this.responseModel.supportoShowInfo) {
                    this.responseModel.supportoShowInfo = false;
                }
                else {
                    this.responseModel.supportoShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationInternoDescription = function () {
                if (this.responseModel.plastificazioni1ShowInfo) {
                    this.responseModel.plastificazioni1ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni1ShowInfo = true;
                }
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var wizCalSub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(wizCalSub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var wizSconSub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(wizSconSub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var wizLisSub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(wizLisSub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var wizLisSconSub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(wizLisSconSub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardAdesiviComponent.prototype, "resourceId", void 0);
    WizardAdesiviComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-adesivi-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardAdesiviComponent);
    return WizardAdesiviComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardAdesiviComponent = WizardAdesiviComponent;


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
///Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var quoting_submit_model_5 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardBannerComponent = (function () {
    function WizardBannerComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardBannerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardBannerData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardBannerComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardBannerComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, translate, routesService, cartService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.translate = translate;
                this.routesService = routesService;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.formatiMultipliList = new Array();
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                if (this.responseModel.idGruppo == 7) {
                    this.ExcludingRules.setMacrocategory("BANNER");
                }
                else if (this.responseModel.idGruppo == 9) {
                    this.ExcludingRules.setMacrocategory("BANDIERE");
                }
                if (this.responseModel.isFormatiMultiliEnabled) {
                    this.aggiungiFormatoMultiplo(true);
                }
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.aggiungiFormatoMultiplo = function (firstLoad) {
                if (firstLoad === void 0) { firstLoad = false; }
                var fileObj = new quoting_submit_model_5.FormatiMultipliObj();
                var lastId = 0;
                if (this.formatiMultipliList.length > 0) {
                    lastId = this.formatiMultipliList.sort(function (x) { return x.Id; }).reverse()[0].Id;
                }
                fileObj.Id = (lastId + 1);
                fileObj.Copie = 1;
                fileObj.Width = parseFloat(this.responseModel.minimoBase + "");
                fileObj.Height = parseFloat(this.responseModel.minimoAltezza + "");
                fileObj.Name = this.getLabel('new_format');
                this.formatiMultipliList.push(fileObj);
                if (!firstLoad) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.deleteFormatoMultiplo = function (id) {
                this.formatiMultipliList.splice(this.formatiMultipliList.findIndex(function (e) { return e.Id === id; }), 1);
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.CheckRegoleBanner = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldMateriale = this.responseModel.idMaterialiFlessibili;
                    var oldFormato = this.responseModel.idFormati;
                    var oldAsola = this.responseModel.idAsole;
                    var oldElettro = this.responseModel.idElettrosaldature;
                    var oldOcchielli = this.responseModel.idOcchielli;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "BANNER", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "MATERIALE_FLESSIBILE", "", "", null, null, this.responseModel);
                    //Reset regole occhiellatura
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "OCCHIELLATURA", "", null, null, this.responseModel);
                    //Reset regole asola
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "ASOLA", "", null, null, this.responseModel);
                    //Reset regole elettro
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "ELETTROSALDATURA", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "BANNER", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "BANNER", idFormato, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "MATERIALE_FLESSIBILE", "", "", this.responseModel.idMaterialiFlessibili, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "OCCHIELLATURA", "", this.responseModel.idOcchielli, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "ASOLA", "", this.responseModel.idAsole, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "ELETTROSALDATURA", "", this.responseModel.idElettrosaldature, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "BANNER", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldMateriale != this.responseModel.idMaterialiFlessibili) {
                        this.onMaterialeChange(true);
                    }
                    if (oldOcchielli != this.responseModel.idOcchielli) {
                        this.onOcchielliChange(true);
                    }
                    if (oldAsola != this.responseModel.idAsole) {
                        this.onAsoleChange(true);
                    }
                    if (oldElettro != this.responseModel.idElettrosaldature) {
                        this.onElettrosaldatureChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_1 = lavAccArray; _d < lavAccArray_1.length; _d++) {
                            var lavorazioneOld = lavAccArray_1[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.checkIsAsolaIsShowed = function () {
                var result = false;
                if (this.responseModel.asole != null && this.responseModel.asole.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsCucituraIsShowed = function () {
                var result = false;
                if (this.responseModel.cuciture != null && this.responseModel.cuciture.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsElettroIsShowed = function () {
                var result = false;
                if (this.responseModel.elettrosaldature != null && this.responseModel.elettrosaldature.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsOcchielliIsShowed = function () {
                var result = false;
                if (this.responseModel.occhielli != null && this.responseModel.occhielli.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.CheckRegoleBandiere = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldMateriale = this.responseModel.idMaterialiFlessibili;
                    var oldFormato = this.responseModel.idFormati;
                    var oldAsola = this.responseModel.idAsole;
                    var oldCucitura = this.responseModel.idCuciture;
                    var oldOcchielli = this.responseModel.idOcchielli;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "BANDIERE", null, null, this.responseModel);
                    //Reset regole materialeFlessibile
                    this.ExcludingRules.ResetRegole("GF", "MATERIALE_FLESSIBILE", "", "", null, null, this.responseModel);
                    //Reset regole occhiellatura
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "OCCHIELLATURA", "", null, null, this.responseModel);
                    //Reset regole asola
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "ASOLA", "", null, null, this.responseModel);
                    //Reset regole elettro
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "CUCITURA", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "BANDIERE", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "BANDIERE", idFormato, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "MATERIALE_FLESSIBILE", "", "", this.responseModel.idMaterialiFlessibili, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "OCCHIELLATURA", "", this.responseModel.idOcchielli, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "ASOLA", "", this.responseModel.idAsole, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "CUCITURA", "", this.responseModel.idCuciture, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "BANDIERE", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldMateriale != this.responseModel.idMaterialiFlessibili) {
                        this.onMaterialeChange(true);
                    }
                    if (oldOcchielli != this.responseModel.idOcchielli) {
                        this.onOcchielliChange(true);
                    }
                    if (oldAsola != this.responseModel.idAsole) {
                        this.onAsoleChange(true);
                    }
                    if (oldCucitura != this.responseModel.idCuciture) {
                        this.onCucitureChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, lavAccArray_2 = lavAccArray; _b < lavAccArray_2.length; _b++) {
                        var lavorazioneOld = lavAccArray_2[_b];
                        count = 0;
                        for (var _c = 0, _d = this.responseModel.lavorazioniAccessorie; _c < _d.length; _c++) {
                            var lavorazione = _d[_c];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                    if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                        this.lavorazioniAccessorieComboChange(lavorazione);
                                        count++;
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.isBannerQuotingForm = function () {
                result = false;
                if (this.responseModel.idGruppo == 7) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isBandiereQuotingForm = function () {
                result = false;
                if (this.responseModel.idGruppo == 9) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                if (this.responseModel.idGruppo == 7) {
                    this.CheckRegoleBanner();
                    if (this.responseModel.elettrosaldature != null && this.responseModel.elettrosaldature.length > 0) {
                        this.validationElettro();
                    }
                    else {
                        this.responseModel.elettroIsValid = true;
                    }
                    this.responseModel.cucituraIsValid = true;
                }
                else if (this.responseModel.idGruppo == 9) {
                    this.CheckRegoleBandiere();
                    if (this.responseModel.cuciture != null && this.responseModel.cuciture.length > 0) {
                        this.validationCuciture();
                    }
                    else {
                        this.responseModel.cucituraIsValid = true;
                    }
                    this.responseModel.elettroIsValid = true;
                }
                if (this.responseModel.isFormatiMultiliEnabled) {
                    //check id all data into formatimultipli list is setted
                    this.validationFormatiMultipli();
                }
                else {
                    //verify validation for all  parameters
                    this.validationCopie();
                    if (this.responseModel.soggettiMultipli == true) {
                        this.validationSoggetti();
                    }
                    else {
                        this.responseModel.soggettiIsValid = true;
                    }
                    this.validationFormati();
                    if (this.responseModel.idFormati == "0") {
                        this.validationBaseFormati();
                        this.validationAltezzaFormati();
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                if (this.responseModel.asole != null && this.responseModel.asole.length > 0) {
                    this.validationAsole();
                    if (this.responseModel.idAsole != "0") {
                        this.validationDiametroAsole();
                    }
                    else {
                        this.responseModel.diametroAsolaIsValid = true;
                    }
                }
                else {
                    this.responseModel.diametroAsolaIsValid = true;
                    this.responseModel.asolaIsValid = true;
                }
                if (this.responseModel.occhielli != null && this.responseModel.occhielli.length > 0) {
                    this.validationOcchielli();
                    if (this.responseModel.idOcchielli != "0") {
                        this.validationDistanzaOcchielli();
                    }
                    else {
                        this.responseModel.distanzaOcchielliIsValid = true;
                    }
                }
                else {
                    this.responseModel.occhiellaturaIsValid = true;
                    this.responseModel.distanzaOcchielliIsValid = true;
                }
                this.validationMateriali();
                this.countOcchielliDisposizione();
                this.countAsoleDisposizioni();
                this.countTelettrosaldature();
                this.countTelettrosaldatureDisposizioni();
                this.countCucitureDisposizioni();
                this.validationLavorazioneAccessoria();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countOcchielliDisposizione = function () {
                if (this.responseModel.occhielliDisposizione != null) {
                    this.responseModel.occhielliDisposizioneCount = this.responseModel.occhielliDisposizione.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countAsoleDisposizioni = function () {
                if (this.responseModel.asoleDisposizioni != null) {
                    this.responseModel.asoleDisposizioniCount = this.responseModel.asoleDisposizioni.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countTelettrosaldature = function () {
                if (this.responseModel.elettrosaldature != null) {
                    this.responseModel.elettrosaldatureCount = this.responseModel.elettrosaldature.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countTelettrosaldatureDisposizioni = function () {
                if (this.responseModel.elettrosaldatureDisposizioni != null) {
                    this.responseModel.elettrosaldatureDisposizioniCount = this.responseModel.elettrosaldatureDisposizioni.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countCucitureDisposizioni = function () {
                if (this.responseModel.cucitureDisposizioni != null) {
                    this.responseModel.cucitureDisposizioniCount = this.responseModel.cucitureDisposizioni.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        if (file.FormatId == idFormato) {
                            var fileObj = new quoting_submit_model_4.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                this.model.isFormatoMultiploEnabled = this.responseModel.isFormatiMultiliEnabled;
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idMaterialiFlessibili = this.responseModel.idMaterialiFlessibili;
                this.model.idAsole = this.responseModel.idAsole;
                if (this.responseModel.idAsole != "0") {
                    this.model.disposizione_asola_id = this.responseModel.disposizione_asola_id;
                    this.model.diametro_asola = this.responseModel.diametro_asola;
                }
                this.model.idCuciture = this.responseModel.idCuciture;
                if (this.responseModel.idCuciture != "0") {
                    this.model.disposizione_cucitura_id = this.responseModel.disposizione_cucitura_id;
                }
                this.model.idElettrosaldature = this.responseModel.idElettrosaldature;
                if (this.responseModel.idElettrosaldature != "0") {
                    this.model.disposizione_elettrosaldatura_id = this.responseModel.disposizione_elettrosaldatura_id;
                }
                this.model.idOcchielli = this.responseModel.idOcchielli;
                if (this.responseModel.idOcchielli != "0") {
                    this.model.disposizione_occhielli_id = this.responseModel.disposizione_occhielli_id;
                    this.model.distanza_occhielli = this.responseModel.distanza_occhielli;
                }
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                this.model.lavorazioniAccessorie = new Array();
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioneAccessoria = _a[_i];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var sub = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = true;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                    this.subManager.add(sub);
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.isFormatiMultiliEnabled) {
                    if (this.responseModel.formatiMultipliIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.materialeIsValid
                        && this.responseModel.occhiellaturaIsValid
                        && this.responseModel.elettroIsValid
                        && this.responseModel.asolaIsValid
                        && this.responseModel.distanzaOcchielliIsValid
                        && this.responseModel.diametroAsolaIsValid
                        && this.responseModel.cucituraIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    if (this.responseModel.copieIsValid
                        && this.responseModel.formatiIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.baseFormatoIsValid
                        && this.responseModel.altezzaFormatoIsValid
                        && this.responseModel.soggettiIsValid
                        && this.responseModel.materialeIsValid
                        && this.responseModel.occhiellaturaIsValid
                        && this.responseModel.elettroIsValid
                        && this.responseModel.asolaIsValid
                        && this.responseModel.distanzaOcchielliIsValid
                        && this.responseModel.diametroAsolaIsValid
                        && this.responseModel.cucituraIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.responseModel.numSoggetti == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.soggettiIsValid = false;
                }
                else if (numSoggetti == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.soggettiIsValid = false;
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.formatiMessage = message;
            };
            ChildComponent.prototype.validationBaseFormatiMultipli = function (baseInput) {
                var message = "";
                var base = parseFloat(baseInput);
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (base <= 0 || baseInput == "" || baseInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base < minBase)) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base < minBase) || (base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationAltezzaFormatiMultipli = function (altezzaInput) {
                var message = "";
                var altezza = parseFloat(altezzaInput);
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (altezza <= 0 || altezzaInput == "" || altezzaInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if (altezza < minAltezza) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza < minAltezza) || (altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationCopieFormatiMultipli = function (copieInput) {
                var message = "";
                var numCopie = parseInt(copieInput);
                var minCopie = this.responseModel.minimoCopie;
                var maxCopie = this.responseModel.massimoCopie;
                if (numCopie <= 0 || copieInput == "" || copieInput == null) {
                    message = this.getLabel('inserisci_valore_valido');
                }
                else if (maxCopie == 0) {
                    if (numCopie < minCopie) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + minCopie;
                    }
                }
                else {
                    if ((numCopie < minCopie) || (numCopie > maxCopie)) {
                        message = this.getLabel('inserisci_valore_compreso_tra');
                        message += " " + minCopie;
                        message += " " + this.getLabel('inserisci_valore_compreso_e');
                        message += " " + maxCopie;
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationFormatiMultipli = function () {
                var _this = this;
                this.responseModel.formatiMultipliIsValid = true;
                this.formatiMultipliList.forEach(function (x) {
                    var copieMessage = _this.validationCopieFormatiMultipli(x.Copie);
                    if (copieMessage == "") {
                        x.copieIsValid = true;
                        x.copieMessage = "";
                    }
                    else {
                        x.copieIsValid = false;
                        x.copieMessage = copieMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var heighMessage = _this.validationAltezzaFormatiMultipli(x.Height);
                    if (heighMessage == "") {
                        x.heightIsValid = true;
                        x.heightMessage = "";
                    }
                    else {
                        x.heightIsValid = false;
                        x.heightMessage = heighMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var widthMessage = _this.validationBaseFormatiMultipli(x.Width);
                    if (widthMessage == "") {
                        x.widthIsValid = true;
                        x.widthMessage = "";
                    }
                    else {
                        x.widthIsValid = false;
                        x.widthMessage = widthMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                });
            };
            ChildComponent.prototype.validationMateriali = function () {
                var message;
                if (this.responseModel.idMaterialiFlessibili == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.materialeIsValid = false;
                }
                else {
                    this.responseModel.materialeIsValid = true;
                }
                if (this.responseModel.materialiFlessibili != null) {
                    this.responseModel.materialiFlessibiliCount = this.responseModel.materialiFlessibili.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.materialeMessage = message;
            };
            ChildComponent.prototype.validationOcchielli = function () {
                var message;
                if (this.responseModel.idOcchielli == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.occhiellaturaIsValid = false;
                }
                else {
                    this.responseModel.occhiellaturaIsValid = true;
                }
                if (this.responseModel.occhielli != null) {
                    this.responseModel.occhielliCount = this.responseModel.occhielli.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.occhiellaturaMessage = message;
            };
            ChildComponent.prototype.validationAsole = function () {
                var message;
                if (this.responseModel.idAsole == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.asolaIsValid = false;
                }
                else {
                    this.responseModel.asolaIsValid = true;
                }
                if (this.responseModel.asole != null) {
                    this.responseModel.asoleCount = this.responseModel.asole.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.asolaMessage = message;
            };
            ChildComponent.prototype.validationDiametroAsole = function () {
                var message;
                var diametro = parseInt(this.responseModel.diametro_asola);
                if (this.responseModel.diametro_asola == null) {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.diametroAsolaIsValid = false;
                }
                else if (diametro <= 0) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " 0";
                    this.responseModel.diametroAsolaIsValid = false;
                }
                else {
                    this.responseModel.diametroAsolaIsValid = true;
                }
                this.responseModel.diametroAsolaMessage = message;
            };
            ChildComponent.prototype.validationDistanzaOcchielli = function () {
                var message;
                var distanza = parseInt(this.responseModel.distanza_occhielli);
                if (this.responseModel.distanza_occhielli == null) {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.distanzaOcchielliIsValid = false;
                }
                else if (distanza <= 0) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " 0";
                    this.responseModel.distanzaOcchielliIsValid = false;
                }
                else {
                    this.responseModel.distanzaOcchielliIsValid = true;
                }
                this.responseModel.distanzaOcchielliMessage = message;
            };
            ChildComponent.prototype.validationElettro = function () {
                var message;
                if (this.responseModel.idElettrosaldature == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.elettroIsValid = false;
                }
                else {
                    this.responseModel.elettroIsValid = true;
                }
                this.responseModel.elettroMessage = message;
            };
            ChildComponent.prototype.validationCuciture = function () {
                var message;
                if (this.responseModel.idCuciture == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.cucituraIsValid = false;
                }
                else {
                    this.responseModel.cucituraIsValid = true;
                }
                if (this.responseModel.cuciture != null) {
                    this.responseModel.cucitureCount = this.responseModel.cuciture.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.cucituraMessage = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                    var formato = _a[_i];
                    if (formato.chiave == this.responseModel.idFormati) {
                        this.responseModel.formatoDescription = formato.descrizione;
                        this.responseModel.formatoImage = formato.image;
                        this.responseModel.formatiHasInfo = formato.hasInfo;
                        this.responseModel.formatiShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onOcchielliChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.occhielli; _i < _a.length; _i++) {
                    var occhiellatura = _a[_i];
                    if (occhiellatura.chiave == this.responseModel.idOcchielli) {
                        this.responseModel.occhiellaturaDescription = occhiellatura.descrizione;
                        this.responseModel.occhiellaturaImage = occhiellatura.image;
                        this.responseModel.occhiellaturaHasInfo = occhiellatura.hasInfo;
                        this.responseModel.occhiellaturaShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onOcchielliVisualChange = function (occhielliId) {
                this.responseModel.idOcchielli = occhielliId;
                this.onOcchielliChange();
            };
            ChildComponent.prototype.onAsoleChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.asole; _i < _a.length; _i++) {
                    var asola = _a[_i];
                    if (asola.chiave == this.responseModel.idAsole) {
                        this.responseModel.asolaDescription = asola.descrizione;
                        this.responseModel.asolaImage = asola.image;
                        this.responseModel.asolaHasInfo = asola.hasInfo;
                        this.responseModel.asolaShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onAsoleVisualChange = function (asoleId) {
                this.responseModel.idAsole = asoleId;
                this.onAsoleChange();
            };
            ChildComponent.prototype.onElettrosaldatureChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.elettrosaldature; _i < _a.length; _i++) {
                    var elettro = _a[_i];
                    if (elettro.chiave == this.responseModel.idElettrosaldature) {
                        this.responseModel.elettroDescription = elettro.descrizione;
                        this.responseModel.elettroImage = elettro.image;
                        this.responseModel.elettroHasInfo = elettro.hasInfo;
                        this.responseModel.elettroShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onElettrosaldatureVisualChange = function (elettroId) {
                this.responseModel.idElettrosaldature = elettroId;
                this.onElettrosaldatureChange();
            };
            ChildComponent.prototype.onCucitureChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.cuciture; _i < _a.length; _i++) {
                    var cucitura = _a[_i];
                    if (cucitura.chiave == this.responseModel.idCuciture) {
                        this.responseModel.cucituraDescription = cucitura.descrizione;
                        this.responseModel.cucituraImage = cucitura.image;
                        this.responseModel.cucituraHasInfo = cucitura.hasInfo;
                        this.responseModel.cucituraShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCucitureVisualChange = function (cucituraId) {
                this.responseModel.idCuciture = cucituraId;
                this.onCucitureChange();
            };
            ChildComponent.prototype.onMaterialeChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.materialiFlessibili; _i < _a.length; _i++) {
                    var materiale = _a[_i];
                    if (materiale.chiave == this.responseModel.idMaterialiFlessibili) {
                        this.responseModel.materialeDescription = materiale.descrizione;
                        this.responseModel.materialeImage = materiale.image;
                        this.responseModel.materialeHasInfo = materiale.hasInfo;
                        this.responseModel.materialeShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onMaterialeVisualChange = function (materialeId) {
                this.responseModel.idMaterialiFlessibili = materialeId;
                this.onMaterialeChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideOcchiellaturaDescription = function () {
                if (this.responseModel.occhiellaturaShowInfo) {
                    this.responseModel.occhiellaturaShowInfo = false;
                }
                else {
                    this.responseModel.occhiellaturaShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideAsolaDescription = function () {
                if (this.responseModel.asolaShowInfo) {
                    this.responseModel.asolaShowInfo = false;
                }
                else {
                    this.responseModel.asolaShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideElettrosaldatureDescription = function () {
                if (this.responseModel.elettroShowInfo) {
                    this.responseModel.elettroShowInfo = false;
                }
                else {
                    this.responseModel.elettroShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideCucitureDescription = function () {
                if (this.responseModel.cucituraShowInfo) {
                    this.responseModel.cucituraShowInfo = false;
                }
                else {
                    this.responseModel.cucituraShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideMaterialeDescription = function () {
                if (this.responseModel.materialeShowInfo) {
                    this.responseModel.materialeShowInfo = false;
                }
                else {
                    this.responseModel.materialeShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideSupportoDescription = function () {
                if (this.responseModel.supportoShowInfo) {
                    this.responseModel.supportoShowInfo = false;
                }
                else {
                    this.responseModel.supportoShowInfo = true;
                }
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardBannerComponent.prototype, "resourceId", void 0);
    WizardBannerComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-banner-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardBannerComponent);
    return WizardBannerComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardBannerComponent = WizardBannerComponent;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var currency_service_1 = __webpack_require__(29);
var auth_service_1 = __webpack_require__(9);
var QuotingService = (function () {
    function QuotingService(_api, language, currency, _cache, mappings, authService) {
        this._api = _api;
        this.language = language;
        this.currency = currency;
        this._cache = _cache;
        this.mappings = mappings;
        this.authService = authService;
    }
    QuotingService.prototype.getWizardStampaData = function (modelType, resourceId, userId, lang) {
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Stampa_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardBannerData = function (modelType, resourceId, userId, lang) {
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Banner_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardAdesiviData = function (modelType, resourceId, userId, lang) {
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Adesivi_Data.
            replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardBusteData = function (modelType, resourceId, userId, lang) {
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Buste_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardEtichetteData = function (modelType, resourceId, userId, lang) {
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Etichette_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardCommercialeData = function (modelType, resourceId, userId, lang) {
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Commerciale_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId
            .toString()).replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardEditoriaData = function (modelType, resourceId, userId, lang) {
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Wizard_Editoria_Data
            .replace('{modelType}', modelType)
            .replace('{resourceId}', resourceId.toString())
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{templatebuilderid}', templateBuilderId);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getWizardDataRequest = function (modelType, resourceId, lang) {
        var userId = this.authService.GetUserId();
        var url = this.mappings.Web_Api_Get_Wizard_Data_Address.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        var key = url;
        return this._api.get(url);
    };
    QuotingService.prototype.getCalculatedWizard = function (data) {
        data.language = this.language.getLongLang();
        data.currency = this.currency.getCurrency();
        return this._api.post(this.mappings.Web_Api_Post_Get_Wizard_Price_Estimation, data)
            .do(function (result) { return result; })
            .share();
    };
    QuotingService.prototype.getCalculatedAp = function (data) {
        data.language = this.language.getLongLang();
        data.currency = this.currency.getCurrency();
        return this._api.post(this.mappings.Web_Api_Post_Get_Ap_Price_Estimation, data)
            .do(function (result) { return result; })
            .share();
    };
    QuotingService.prototype.sendRequestInfo = function (data) {
        data.language = this.language.getLongLang();
        return this._api.post(this.mappings.Web_Api_Post_Send_Request_Info_Wizard, data)
            .do(function (result) { return result; })
            .share();
    };
    QuotingService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _c) || Object, (typeof (_d = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _d) || Object, (typeof (_e = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
    ], QuotingService);
    return QuotingService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.QuotingService = QuotingService;


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var customerscanvas_service_1 = __webpack_require__(43);
//Angular
var core_1 = __webpack_require__(0);
//System
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
//Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var currency_service_1 = __webpack_require__(29);
var WizardBusteComponent = (function () {
    function WizardBusteComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardBusteComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardBusteData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardBusteComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardBusteComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, translate, routesService, currency, cartService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.translate = translate;
                this.routesService = routesService;
                this.currency = currency;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                //blockquoting: boolean = false;
                this.resultPriceQuantity = 0;
                this.resultPriceImponibile = 0;
                this.resultPriceCurrency = this.currency.getDefaultCurrency();
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.ExcludingRules.setMacrocategory("BUSTE");
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.taglioShowed = this.responseModel.tipoTaglio;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.getTableValues = function (index) {
                this.resultPriceQuantity = this.resultPrice.TablePriceList[index].Quantity;
                this.resultPriceImponibile = this.resultPrice.TablePriceList[index].StrDiscountedPrice;
                this.resultPriceCurrency = this.resultPrice.TablePriceList[index].Currency;
            };
            ChildComponent.prototype.onStampaRetroChangeDocta = function () {
                if (this.responseModel.idColori2 == "5") {
                    this.responseModel.idColori1 = "5";
                    for (var _i = 0, _a = this.responseModel.colori1; _i < _a.length; _i++) {
                        var col = _a[_i];
                        if (col.chiave == "5") {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                else if (this.responseModel.idColori2 == "4") {
                    this.responseModel.idColori1 = "4";
                    for (var _b = 0, _c = this.responseModel.colori1; _b < _c.length; _b++) {
                        var col = _c[_b];
                        if (col.chiave == "4") {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                else if ((this.responseModel.idColori2 == "0" || this.responseModel.idColori2 == "1") && (this.responseModel.idColori1 == "5" || this.responseModel.idColori1 == "4")) {
                    this.responseModel.idColori1 = this.responseModel.idColori2;
                    for (var _d = 0, _e = this.responseModel.colori1; _d < _e.length; _d++) {
                        var col = _e[_d];
                        if (col.chiave == this.responseModel.idColori2) {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaFronteChangeDocta = function () {
                if (this.responseModel.idColori1 == "5" && (this.responseModel.idColori2 == "4" || this.responseModel.idColori2 == "1")) {
                    this.responseModel.idColori2 = "5";
                    for (var _i = 0, _a = this.responseModel.colori2; _i < _a.length; _i++) {
                        var col = _a[_i];
                        if (col.chiave == "5") {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                else if (this.responseModel.idColori1 == "4" && (this.responseModel.idColori2 == "4" || this.responseModel.idColori2 == "1")) {
                    this.responseModel.idColori2 = "4";
                    for (var _b = 0, _c = this.responseModel.colori2; _b < _c.length; _b++) {
                        var col = _c[_b];
                        if (col.chiave == "4") {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                else if ((this.responseModel.idColori1 == "0" || this.responseModel.idColori1 == "1") && (this.responseModel.idColori2 == "5" || this.responseModel.idColori2 == "4")) {
                    this.responseModel.idColori2 = this.responseModel.idColori1;
                    for (var _d = 0, _e = this.responseModel.colori2; _d < _e.length; _d++) {
                        var col = _e[_d];
                        if (col.chiave == this.responseModel.idColori1) {
                            col.selected = true;
                        }
                        else {
                            col.selected = false;
                        }
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //verify validation for all  parameters 
                this.validationCopie();
                if (this.responseModel.soggettiMultipli == true) {
                    this.validationSoggetti();
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.validationBusta();
                this.validationColori();
                this.countPantoni();
                this.validationLavorazioneAccessoria();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    //$('#quotingForm').hide();
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countPantoni = function () {
                if (this.responseModel.pantoni != null) {
                    this.responseModel.pantoniCount = this.responseModel.pantoni.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (this.responseModel.idBusta != null) {
                        var data = this.responseModel.idBusta.split("_");
                        var idBusta = data[0];
                        if (file.FormatId == idBusta) {
                            var fileObj = new quoting_submit_model_4.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = 15;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                if (this.responseModel.idBusta != "-1") {
                    this.model.idBusta = this.responseModel.idBusta;
                }
                this.model.idColori1 = this.responseModel.idColori1;
                this.model.idPantoneFronte1 = "";
                this.model.idPantoneFronte2 = "";
                this.model.idPantoneRetro1 = "";
                this.model.idPantoneRetro2 = "";
                if (this.model.idColori1 != "1" && this.model.idColori1 != "2" && this.model.idColori1 != "4" && this.model.idColori1 != "5") {
                    this.model.stampa1_colori_fronte = this.responseModel.stampa1_colori_fronte;
                    this.model.stampa1_colori_retro = this.responseModel.stampa1_colori_retro;
                }
                else if (this.model.idColori1 == "4") {
                    this.model.idPantoneFronte1 = this.responseModel.idPantoneFronte1;
                }
                else if (this.model.idColori1 == "5") {
                    this.model.idPantoneFronte1 = this.responseModel.idPantoneFronte1;
                    this.model.idPantoneFronte2 = this.responseModel.idPantoneFronte2;
                }
                this.model.idColori2 = this.responseModel.idColori2;
                if (this.model.idColori2 == "4") {
                    this.model.idPantoneRetro1 = this.responseModel.idPantoneRetro1;
                }
                else if (this.model.idColori2 == "5") {
                    this.model.idPantoneRetro1 = this.responseModel.idPantoneRetro1;
                    this.model.idPantoneRetro2 = this.responseModel.idPantoneRetro2;
                }
                this.model.lavorazioniAccessorie = new Array();
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioneAccessoria = _a[_i];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var sub_1 = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.subManager.add(sub_1);
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = true;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.copieIsValid
                    && this.responseModel.bustaIsValid
                    && this.responseModel.lavorazioniIsValid
                    && this.responseModel.soggettiIsValid
                    && this.responseModel.colori1IsValid) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ChildComponent.prototype.validationColori = function () {
                var message;
                if (this.responseModel.idColori1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.colori1IsValid = false;
                }
                else {
                    this.responseModel.colori1IsValid = true;
                }
                if (this.responseModel.colori1 != null) {
                    this.responseModel.colori1Count = this.responseModel.colori1.filter(function (x) { return x.isVisible == true; }).length;
                }
                if (this.responseModel.colori2 != null) {
                    this.responseModel.colori2Count = this.responseModel.colori2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.colori1Message = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.responseModel.numSoggetti == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.soggettiIsValid = false;
                }
                else if (numSoggetti == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.soggettiIsValid = false;
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationBusta = function () {
                var message;
                if (this.responseModel.idBusta == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.bustaIsValid = false;
                }
                else {
                    this.responseModel.bustaIsValid = true;
                }
                if (this.responseModel.tipologieBusta != null) {
                    this.responseModel.tipologieBustaCount = this.responseModel.tipologieBusta.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.bustaMessage = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onBustaChange = function () {
                for (var _i = 0, _a = this.responseModel.tipologieBusta; _i < _a.length; _i++) {
                    var busta = _a[_i];
                    if (busta.chiave == this.responseModel.idBusta) {
                        this.responseModel.bustaDescription = busta.descrizione;
                        this.responseModel.bustaImage = busta.image;
                        this.responseModel.bustaHasInfo = busta.hasInfo;
                        this.responseModel.bustaShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onBustaVisualChange = function (bustaId) {
                this.responseModel.idBusta = bustaId;
                this.onBustaChange();
            };
            ChildComponent.prototype.onPantoneFronte1VisualChange = function (pantoneValue) {
                this.responseModel.idPantoneFronte1 = pantoneValue;
                this.onPantoneFronte1Change();
            };
            ChildComponent.prototype.onPantoneFronte1Change = function () {
                for (var _i = 0, _a = this.responseModel.pantoni; _i < _a.length; _i++) {
                    var pantone = _a[_i];
                    if (pantone.chiave == this.responseModel.idPantoneFronte1) {
                        this.responseModel.pantoneFronte1Description = pantone.descrizione;
                        this.responseModel.pantoneFronte1Image = pantone.image;
                        this.responseModel.pantoneFronte1HasInfo = pantone.hasInfo;
                        this.responseModel.pantoneFronte1ShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onPantoneFronte2VisualChange = function (pantoneValue) {
                this.responseModel.idPantoneFronte2 = pantoneValue;
                this.onPantoneFronte2Change();
            };
            ChildComponent.prototype.onPantoneFronte2Change = function () {
                for (var _i = 0, _a = this.responseModel.pantoni; _i < _a.length; _i++) {
                    var pantone = _a[_i];
                    if (pantone.chiave == this.responseModel.idPantoneFronte2) {
                        this.responseModel.pantoneFronte2Description = pantone.descrizione;
                        this.responseModel.pantoneFronte2Image = pantone.image;
                        this.responseModel.pantoneFronte2HasInfo = pantone.hasInfo;
                        this.responseModel.pantoneFronte2ShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onPantoneRetro1VisualChange = function (pantoneValue) {
                this.responseModel.idPantoneRetro1 = pantoneValue;
                this.onPantoneRetro1Change();
            };
            ChildComponent.prototype.onPantoneRetro1Change = function () {
                for (var _i = 0, _a = this.responseModel.pantoni; _i < _a.length; _i++) {
                    var pantone = _a[_i];
                    if (pantone.chiave == this.responseModel.idPantoneRetro1) {
                        this.responseModel.pantoneRetro1Description = pantone.descrizione;
                        this.responseModel.pantoneRetro1Image = pantone.image;
                        this.responseModel.pantoneRetro1HasInfo = pantone.hasInfo;
                        this.responseModel.pantoneRetro1ShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onPantoneRetro2VisualChange = function (pantoneValue) {
                this.responseModel.idPantoneRetro2 = pantoneValue;
                this.onPantoneRetro2Change();
            };
            ChildComponent.prototype.onPantoneRetro2Change = function () {
                for (var _i = 0, _a = this.responseModel.pantoni; _i < _a.length; _i++) {
                    var pantone = _a[_i];
                    if (pantone.chiave == this.responseModel.idPantoneRetro2) {
                        this.responseModel.pantoneRetro2Description = pantone.descrizione;
                        this.responseModel.pantoneRetro2Image = pantone.image;
                        this.responseModel.pantoneRetro2HasInfo = pantone.hasInfo;
                        this.responseModel.pantoneRetro2ShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaInternoVisualChange = function (stampaInternoValue) {
                this.responseModel.idColori1 = stampaInternoValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaRetroVisualChange = function (stampaCopertinaValue) {
                this.responseModel.idColori2 = stampaCopertinaValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione) {
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideBusteDescription = function () {
                if (this.responseModel.bustaShowInfo) {
                    this.responseModel.bustaShowInfo = false;
                }
                else {
                    this.responseModel.bustaShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePantoneFronte1Description = function () {
                if (this.responseModel.pantoneFronte1ShowInfo) {
                    this.responseModel.pantoneFronte1ShowInfo = false;
                }
                else {
                    this.responseModel.pantoneFronte1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePantoneFronte2Description = function () {
                if (this.responseModel.pantoneFronte2ShowInfo) {
                    this.responseModel.pantoneFronte2ShowInfo = false;
                }
                else {
                    this.responseModel.pantoneFronte2ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePantoneRetro1Description = function () {
                if (this.responseModel.pantoneRetro1ShowInfo) {
                    this.responseModel.pantoneRetro1ShowInfo = false;
                }
                else {
                    this.responseModel.pantoneRetro1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePantoneRetro2Description = function () {
                if (this.responseModel.pantoneRetro2ShowInfo) {
                    this.responseModel.pantoneRetro2ShowInfo = false;
                }
                else {
                    this.responseModel.pantoneRetro2ShowInfo = true;
                }
            };
            ChildComponent.prototype.isPantoneFronte1Showed = function () {
                var result = false;
                if (this.responseModel.idColori1 == "4" || this.responseModel.idColori1 == "5") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isPantoneFronte2Showed = function () {
                var result = false;
                if (this.responseModel.idColori1 == "5") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isPantoneRetro1Showed = function () {
                var result = false;
                if (this.responseModel.idColori2 == "4" || this.responseModel.idColori2 == "5") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isPantoneRetro2Showed = function () {
                var result = false;
                if (this.responseModel.idColori2 == "5") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.resetCanvasData();
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.resetCanvasData();
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoBusteToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.model.idPantoneFronte1, this.model.idPantoneFronte2, this.model.idPantoneRetro1, this.model.idPantoneRetro2, colType).subscribe(function (result) {
                    _this.cartService.resetCanvasData();
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaBusteToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, this.model.idPantoneFronte1, this.model.idPantoneFronte2, this.model.idPantoneRetro1, this.model.idPantoneRetro2, colType).subscribe(function (result) {
                    _this.cartService.resetCanvasData();
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                // set variable for check if product is canvas edited to a initial state, because of other products
                this.cartService.setIfProductIsCanvasEdited(false);
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(8, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _f) || Object, (typeof (_g = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _g) || Object, (typeof (_h = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _h) || Object, Boolean, (typeof (_j = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _j) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardBusteComponent.prototype, "resourceId", void 0);
    WizardBusteComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-buste-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardBusteComponent);
    return WizardBusteComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardBusteComponent = WizardBusteComponent;


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
//Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardCommercialeComponent = (function () {
    function WizardCommercialeComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardCommercialeComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardCommercialeData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardCommercialeComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardCommercialeComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, translate, cartService, routesService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.translate = translate;
                this.cartService = cartService;
                this.routesService = routesService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_4.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.listaProfonditaPackaging = new Array();
                this.listaFormatiFull = new Array();
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                this.packangingProfonditaChange = false;
                this.packangingBaseChange = false;
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.ExcludingRules.setMacrocategory("COMMERCIALE");
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.taglioShowed = this.responseModel.tipoTaglio;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                this.listaFormatiFull = this.responseModel.formati;
                if (this.responseModel.IsPackagingWizard == true) {
                    this.onBasePackagingChange();
                }
                else {
                    if (!this.isDataInitialized) {
                        //check if the all values is validated
                        this.parameterValidation();
                    }
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.CheckRegoleCommerciale = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldCarta = this.responseModel.idCarte1;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var oldPiegature = this.responseModel.idPiegature;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "FORMATO", "COMMERCIALE", null, null, this.responseModel);
                    //Reset regole carta e grammature
                    this.ExcludingRules.ResetRegole("PF", "CARTA", "", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "PIEGATURA", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "PLASTIFICAZIONE", "COMMERCIALE", null, null, this.responseModel);
                    //Reset regole taglio
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("PF", "ACCESSORIA", "", "COMMERCIALE", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "FORMATO", "COMMERCIALE", this.responseModel.idFormati, 0, this.responseModel);
                    if (this.responseModel.idCarte1 != null) {
                        var data = this.responseModel.idCarte1.split("_");
                        var idCarta = data[0];
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, 0, this.responseModel);
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, this.responseModel.idGrammature1, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PLASTIFICAZIONE", "COMMERCIALE", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PIEGATURA", "", this.responseModel.idPiegature, 0, this.responseModel);
                    if (!this.isTaglioCalculated()) {
                        this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", 1, 0, this.responseModel);
                    }
                    else {
                        this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", 2, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("PF", "COMMERCIALE", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldCarta != this.responseModel.idCarte1) {
                        this.onCartaInternoFieldChanged(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldPiegature != this.responseModel.idPiegature) {
                        this.onPiegaturaChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_1 = lavAccArray; _d < lavAccArray_1.length; _d++) {
                            var lavorazioneOld = lavAccArray_1[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                this.CheckRegoleCommerciale();
                //verify validation for all  parameters 
                this.validationCopie();
                if (this.responseModel.soggettiMultipli == true) {
                    this.validationSoggetti();
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                if (this.responseModel.IsPackagingWizard == true) {
                    this.validationBasePackaging();
                    this.validationProfonditaPackaging();
                }
                else {
                    this.responseModel.basePackagingIsValid = true;
                    this.responseModel.profonditaPackagingIsValid = true;
                }
                this.validationFormati();
                if (this.responseModel.idFormati == "0") {
                    this.validationBaseFormati();
                    this.validationAltezzaFormati();
                }
                else {
                    this.responseModel.baseFormatoIsValid = true;
                    this.responseModel.altezzaFormatoIsValid = true;
                }
                this.validationColori();
                this.validationCarteInterno();
                this.validationGrammatureCarteInterno();
                this.validationPiegatura();
                this.validationPlastificazione();
                this.validationLavorazioneAccessoria();
                this.countCartaCategories();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countCartaCategories = function () {
                if (this.responseModel.categorieCarte != null) {
                    this.responseModel.categorieCarteCount = this.responseModel.categorieCarte.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.idCarte1 = this.responseModel.idCarte1;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carta = _a[_i];
                    if (this.model.idCarte1 == carta.chiave) {
                        this.model.nomeCarte1 = carta.valore;
                    }
                }
                this.model.idGrammature1 = this.responseModel.idGrammature1;
                for (var _b = 0, _c = this.responseModel.grammature1; _b < _c.length; _b++) {
                    var grammatureInterno = _c[_b];
                    if (this.model.idGrammature1 == grammatureInterno.chiave) {
                        this.model.nomeGrammature1 = grammatureInterno.valore;
                    }
                }
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idColori1 = this.responseModel.idColori1;
                if (this.model.idColori1 != "1" && this.model.idColori1 != "2") {
                    this.model.stampa1_colori_fronte = this.responseModel.stampa1_colori_fronte;
                    this.model.stampa1_colori_retro = this.responseModel.stampa1_colori_retro;
                }
                this.model.idColori2 = this.responseModel.idColori2;
                if (this.responseModel.isPlastificazioneRequired == false && this.responseModel.idPlastificazioni1 == "-1") {
                    this.model.idPlastificazioni1 = "";
                }
                else {
                    this.model.idPlastificazioni1 = this.responseModel.idPlastificazioni1;
                }
                this.model.taglio = this.isTaglioCalculated();
                if (this.responseModel.idPiegature != "-1") {
                    this.model.idPiegature = this.responseModel.idPiegature;
                }
                this.model.lavorazioniAccessorie = new Array();
                for (var _d = 0, _e = this.responseModel.lavorazioniAccessorie; _d < _e.length; _d++) {
                    var lavorazioneAccessoria = _e[_d];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var sub_1 = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.subManager.add(sub_1);
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.showErrorMessage = true;
                        _this.isCalculatedWizard = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.copieIsValid
                    && this.responseModel.formatiIsValid
                    && this.responseModel.carte1IsValid
                    && this.responseModel.grammature1IsValid
                    && this.responseModel.piegatureIsValid
                    && this.responseModel.plastificazione1IsValid
                    && this.responseModel.lavorazioniIsValid
                    && this.responseModel.baseFormatoIsValid
                    && this.responseModel.altezzaFormatoIsValid
                    && this.responseModel.soggettiIsValid
                    && this.responseModel.colori1IsValid
                    && this.responseModel.basePackagingIsValid
                    && this.responseModel.profonditaPackagingIsValid) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ChildComponent.prototype.validationColori = function () {
                var message;
                if (this.responseModel.idColori1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.colori1IsValid = false;
                }
                else {
                    this.responseModel.colori1IsValid = true;
                }
                if (this.responseModel.colori1 != null) {
                    this.responseModel.colori1Count = this.responseModel.colori1.filter(function (x) { return x.isVisible == true; }).length;
                }
                if (this.responseModel.colori2 != null) {
                    this.responseModel.colori2Count = this.responseModel.colori2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.colori1Message = message;
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                //let base = parseFloat(this.responseModel.baseFormato)
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.responseModel.numSoggetti == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.soggettiIsValid = false;
                }
                else if (numSoggetti == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.soggettiIsValid = false;
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationBasePackaging = function () {
                var message;
                if (this.responseModel.idBasePackaging == 0 || this.responseModel.idBasePackaging == null) {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.basePackagingIsValid = false;
                }
                else {
                    this.responseModel.basePackagingIsValid = true;
                }
                this.responseModel.basePackagingMessage = message;
            };
            ChildComponent.prototype.validationProfonditaPackaging = function () {
                var message;
                if (this.responseModel.idProfonditaPackaging == 0 || this.responseModel.idProfonditaPackaging == null) {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.profonditaPackagingIsValid = false;
                }
                else {
                    this.responseModel.profonditaPackagingIsValid = true;
                }
                this.responseModel.profonditaPackagingMessage = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                this.responseModel.formatiMessage = message;
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.validationCarteInterno = function () {
                var message;
                if (this.responseModel.idCarte1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.carte1IsValid = false;
                }
                else {
                    this.responseModel.carte1IsValid = true;
                }
                if (this.responseModel.carte1 != null) {
                    this.responseModel.carte1Count = this.responseModel.carte1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.carte1Message = message;
            };
            ChildComponent.prototype.validationGrammatureCarteInterno = function () {
                var message;
                if (this.responseModel.idGrammature1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.grammature1IsValid = false;
                }
                else {
                    this.responseModel.grammature1IsValid = true;
                }
                if (this.responseModel.grammature1 != null) {
                    this.responseModel.grammature1Count = this.responseModel.grammature1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.grammature1Message = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.validationPiegatura = function () {
                var message;
                if (this.responseModel.idPiegature == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.piegatureIsValid = false;
                }
                else {
                    this.responseModel.piegatureIsValid = true;
                }
                if (this.responseModel.piegature != null) {
                    this.responseModel.piegatureCount = this.responseModel.piegature.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.piegatureMessage = message;
            };
            ChildComponent.prototype.validationPlastificazione = function () {
                var message;
                if (this.responseModel.idPlastificazioni1 == "-1") {
                    if (this.responseModel.isPlastificazioneRequired == true) {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.plastificazione1IsValid = false;
                    }
                    else {
                        this.responseModel.plastificazione1IsValid = true;
                    }
                }
                else {
                    this.responseModel.plastificazione1IsValid = true;
                }
                if (this.responseModel.plastificazioni1 != null) {
                    this.responseModel.plastificazioni1Count = this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.plastificazione1Message = message;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                return message;
            };
            ChildComponent.prototype.isTaglioCalculated = function () {
                var result = false;
                if (this.responseModel.isTaglioVisible == false) {
                    if (this.responseModel.tipoCalcoloTaglio == "si" && !this.responseModel.taglioShowed) {
                        result = true;
                    }
                    else if (this.responseModel.tipoCalcoloTaglio == "no" && !this.responseModel.taglioShowed) {
                        result = false;
                    }
                    else if (this.responseModel.taglioShowed) {
                        result = this.responseModel.tipoTaglio;
                    }
                }
                else {
                    result = false;
                }
                return result;
            };
            ChildComponent.prototype.checkIsPlastificazioneInternoIsShowed = function () {
                var result = false;
                if (this.responseModel.plastificazioni1 != null && this.responseModel.plastificazioni1.length > 0) {
                    result = true;
                    if (this.responseModel.isPlastificazioneRequired == false) {
                        if (this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length > 0) {
                            result = true;
                        }
                        else {
                            result = false;
                        }
                    }
                }
                return result;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsTaglioShowed = function () {
                var result = false;
                if (this.responseModel.taglioShowed && !this.responseModel.isTaglioVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onCategoriaCartaInternoFieldChanged = function () {
                var selectedPaper = false;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carte = _a[_i];
                    if (this.responseModel.idCategorieCarte1 != "-1") {
                        if (carte.parentId == this.responseModel.idCategorieCarte1) {
                            if (selectedPaper == false) {
                                this.responseModel.idCarte1 = carte.chiave;
                                this.model.idCarte1 = carte.chiave;
                                this.responseModel.carte1Description = carte.descrizione;
                                this.responseModel.carte1Image = carte.image;
                                this.responseModel.carte1HasInfo = carte.hasInfo;
                                this.responseModel.carte1ShowInfo = false;
                                this.responseModel.grammature1 = carte.subElements;
                                this.responseModel.idGrammature1 = carte.wrap_valore;
                                this.model.idGrammature1 = carte.wrap_valore;
                                selectedPaper = true;
                            }
                            carte.isVisible = true;
                        }
                        else {
                            carte.isVisible = false;
                        }
                    }
                    else {
                        if (selectedPaper == false) {
                            this.responseModel.idCarte1 = carte.chiave;
                            this.model.idCarte1 = carte.chiave;
                            this.responseModel.carte1Description = carte.descrizione;
                            this.responseModel.carte1Image = carte.image;
                            this.responseModel.carte1HasInfo = carte.hasInfo;
                            this.responseModel.carte1ShowInfo = false;
                            this.responseModel.grammature1 = carte.subElements;
                            this.responseModel.idGrammature1 = carte.wrap_valore;
                            this.model.idGrammature1 = carte.wrap_valore;
                            selectedPaper = true;
                        }
                        carte.isVisible = true;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onCartaInternoFieldChanged = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var grammature = _a[_i];
                    if (grammature.chiave == this.responseModel.idCarte1) {
                        this.responseModel.carte1Description = grammature.descrizione;
                        this.responseModel.carte1Image = grammature.image;
                        this.responseModel.carte1HasInfo = grammature.hasInfo;
                        this.responseModel.carte1ShowInfo = false;
                        this.responseModel.grammature1 = grammature.subElements;
                        this.responseModel.idGrammature1 = grammature.wrap_valore;
                        this.model.idGrammature1 = grammature.wrap_valore;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCartaInternoVisualFieldChanged = function (paperId) {
                this.responseModel.idCarte1 = paperId;
                this.onCartaInternoFieldChanged();
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                if (this.responseModel.idFormati == "-1") {
                    this.responseModel.formatoDescription = "";
                    this.responseModel.formatoImage = "";
                    this.responseModel.formatiHasInfo = false;
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                        var formato = _a[_i];
                        if (formato.chiave == this.responseModel.idFormati) {
                            this.responseModel.formatoDescription = formato.descrizione;
                            this.responseModel.formatoImage = formato.image;
                            this.responseModel.formatiHasInfo = formato.hasInfo;
                            this.responseModel.formatiShowInfo = false;
                        }
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onBasePackagingChange = function () {
                this.packangingBaseChange = false;
                this.packangingProfonditaChange = false;
                if (this.responseModel.listaPackagingParameter.length > 0 && this.responseModel.listaPackagingParameter != null) {
                    for (var _i = 0, _a = this.responseModel.listaPackagingParameter; _i < _a.length; _i++) {
                        var base = _a[_i];
                        if (base.IdBase == this.responseModel.idBasePackaging) {
                            this.listaProfonditaPackaging = base.listPackagingRelProfondita;
                            if (this.listaProfonditaPackaging != null && this.listaProfonditaPackaging.length > 0) {
                                this.packangingProfonditaChange = true;
                                this.packangingBaseChange = true;
                                this.responseModel.idProfonditaPackaging = this.listaProfonditaPackaging[0].IdProfondita;
                                this.onProfonditaPackagingChange();
                            }
                            else {
                                this.responseModel.formati = new Array();
                                this.responseModel.idProfonditaPackaging = 0;
                                this.onFormatiVisualChange("-1");
                            }
                        }
                    }
                }
                else {
                    this.responseModel.idBasePackaging = 0;
                    this.responseModel.idProfonditaPackaging = 0;
                    this.onFormatiVisualChange("-1");
                }
                if (this.packangingProfonditaChange == false) {
                    this.parameterValidation();
                    this.packangingBaseChange = false;
                }
            };
            ChildComponent.prototype.onProfonditaPackagingChange = function () {
                var _this = this;
                if (this.listaProfonditaPackaging.length > 0 && this.listaProfonditaPackaging != null) {
                    var firstFormato_1 = 0;
                    var _loop_1 = function(profondita) {
                        if (profondita.IdProfondita == this_1.responseModel.idProfonditaPackaging && profondita.IdBase == this_1.responseModel.idBasePackaging) {
                            this_1.responseModel.formati = new Array();
                            if (profondita.listPackagingRelFormato.length > 0 && profondita.listPackagingRelFormato != null) {
                                var idFIrstFormat_1 = "0";
                                profondita.listPackagingRelFormato.forEach(function (formatiRel) {
                                    var stringId = formatiRel.IdFormato + "";
                                    _this.listaFormatiFull.filter(function (x) { return x.chiave == stringId; }).forEach(function (formato) {
                                        _this.responseModel.formati.push(formato);
                                        if (firstFormato_1 == 0) {
                                            firstFormato_1++;
                                            idFIrstFormat_1 = formato.chiave;
                                        }
                                    });
                                });
                                //select firsformato
                                if (idFIrstFormat_1 != "0") {
                                    firstFormato_1++;
                                    this_1.packangingProfonditaChange = true;
                                    this_1.onFormatiVisualChange(idFIrstFormat_1);
                                }
                            }
                            else {
                                this_1.responseModel.formati = new Array();
                                this_1.onFormatiVisualChange("-1");
                            }
                            return "break";
                        }
                    };
                    var this_1 = this;
                    for (var _i = 0, _a = this.listaProfonditaPackaging; _i < _a.length; _i++) {
                        var profondita = _a[_i];
                        var state_1 = _loop_1(profondita);
                        if (state_1 === "break") break;
                    }
                }
                else {
                    this.responseModel.formati = new Array();
                    this.onFormatiVisualChange("-1");
                }
                // console.log("qui3")
                // if (this.packangingBaseChange == true ) {
                //   this.parameterValidation();
                // }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onStampaInternoVisualChange = function (stampaInternoValue) {
                this.responseModel.idColori1 = stampaInternoValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaRetroVisualChange = function (stampaCopertinaValue) {
                this.responseModel.idColori2 = stampaCopertinaValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onGrammatureInternoVisualFieldChanged = function (grammatureId) {
                this.responseModel.idGrammature1 = grammatureId;
                this.parameterValidation();
            };
            ChildComponent.prototype.onPlastificationInternoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.plastificazioni1; _i < _a.length; _i++) {
                    var plastification = _a[_i];
                    if (plastification.chiave == this.responseModel.idPlastificazioni1) {
                        this.responseModel.plastificazioni1Description = plastification.descrizione;
                        this.responseModel.plastificazioni1Image = plastification.image;
                        this.responseModel.plastificazioni1HasInfo = plastification.hasInfo;
                        this.responseModel.plastificazioni1ShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPlastificationInternoViasualChange = function (plastificationId) {
                this.responseModel.idPlastificazioni1 = plastificationId;
                this.onPlastificationInternoChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.onPiegaturaChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.piegature; _i < _a.length; _i++) {
                    var piegatura = _a[_i];
                    if (piegatura.chiave == this.responseModel.idPiegature) {
                        this.responseModel.piegatureDescription = piegatura.descrizione;
                        this.responseModel.piegatureImage = piegatura.image;
                        this.responseModel.piegatureHasInfo = piegatura.hasInfo;
                        this.responseModel.piegatureShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPiegaturaVisualChange = function (piegaturaId) {
                this.responseModel.idPiegature = piegaturaId;
                this.onPiegaturaChange();
            };
            ChildComponent.prototype.showHidePiegatureDescription = function () {
                if (this.responseModel.piegatureShowInfo) {
                    this.responseModel.piegatureShowInfo = false;
                }
                else {
                    this.responseModel.piegatureShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePaperInternoDescription = function () {
                if (this.responseModel.carte1ShowInfo) {
                    this.responseModel.carte1ShowInfo = false;
                }
                else {
                    this.responseModel.carte1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationInternoDescription = function () {
                if (this.responseModel.plastificazioni1ShowInfo) {
                    this.responseModel.plastificazioni1ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni1ShowInfo = true;
                }
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setActive = function (id) {
                $(".calendar-list").removeClass("hoverActive");
                $($(".calendar-list")[id]).addClass("hoverActive");
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (file.FormatId == this.responseModel.idFormati) {
                        if (this.responseModel.piegature != null) {
                            if (file.PiegaId == this.responseModel.idPiegature) {
                                var fileObj = new quoting_submit_model_3.FileCombinationModel();
                                fileObj.PathFile = file.PathFile;
                                if (file.NomeFile == null || file.NomeFile == "") {
                                    fileObj.NomeFile = file.FileName;
                                }
                                else {
                                    fileObj.NomeFile = file.NomeFile;
                                }
                                fileObj.PathIstruzioni = file.PathIstruzioni;
                                if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                    fileObj.NomeIstruzioni = file.FileIstructionName;
                                }
                                else {
                                    fileObj.NomeIstruzioni = file.NomeIstruzioni;
                                }
                                this.listaFile.push(fileObj);
                            }
                        }
                        else {
                            var fileObj = new quoting_submit_model_3.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                // console.log("price1")
                // console.log(price)
                if (price.Price == -1) {
                    return;
                }
                // console.log("this.resultPrice")
                // console.log(this.resultPrice)
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                // console.log("price2")
                // console.log(price)
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardCommercialeComponent.prototype, "resourceId", void 0);
    WizardCommercialeComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-commerciale-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardCommercialeComponent);
    return WizardCommercialeComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardCommercialeComponent = WizardCommercialeComponent;


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
var quoting_model_1 = __webpack_require__(56);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var shopping_cart_service_1 = __webpack_require__(20);
var bootbox_service_1 = __webpack_require__(40);
var routes_service_1 = __webpack_require__(5);
//Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_2 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardEditoriaComponent = (function () {
    function WizardEditoriaComponent(_compiler, componentHelper, authService, _elementRef, _quotingService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this.authService = authService;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardEditoriaComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardEditoriaData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId, _this.resourceType);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardEditoriaComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardEditoriaComponent.prototype.createSubComponent = function (result, InputresourceId, InputresourceType) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, cartService, routesService, bootboxService, translate, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.cartService = cartService;
                this.routesService = routesService;
                this.bootboxService = bootboxService;
                this.translate = translate;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.model = new quoting_submit_model_2.wizardFormEditoriaModel();
                this.components = new quoting_model_1.LavorazioniComponents();
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_2.QuotingModel();
                this.resourceId = InputresourceId;
                this.resourceType = InputresourceType;
                this.EditioriaCopertinaSelect = "-1";
                this.isValidated = false;
                this.resultPrice = new quoting_submit_model_3.PriceEstimationModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.ExcludingRules.setMacrocategory("EDITORIA");
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_2.QuotingModel();
                this.responseModel = result;
                this.responseModel.stampa1_colori_fronte = "1";
                this.responseModel.stampa1_colori_retro = "1";
                this.responseModel.stampa2_colori_fronte = "1";
                this.responseModel.stampa2_colori_retro = "1";
                this.EditioriaCopertinaSelect = this.responseModel.idCopertine;
                if (this.responseModel.idCopertine == null) {
                    this.responseModel.idCopertine = "-1";
                }
                this.responseModel.taglioShowed = this.responseModel.tipoTaglio;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.tipoFacciate = this.responseModel.tipoFacciate;
                if (this.responseModel.tipoFacciate != 'libera') {
                    this.model.idFacciate = this.responseModel.idFacciate;
                }
                else {
                    this.model.numFacciate = this.responseModel.numFacciate;
                }
                this.model.tipoStampaInternoSoloFronte = this.responseModel.valueStampaInternoSoloFronte;
                this.model.tipoStampaCopertinaSoloFronte = this.responseModel.valueStampaCopertinaSoloFronte;
                this.model.idCarte1 = this.responseModel.idCarte1;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carta = _a[_i];
                    if (this.model.idCarte1 == carta.chiave) {
                        this.model.nomeCarte1 = carta.valore;
                    }
                }
                this.model.idGrammature1 = this.responseModel.idGrammature1;
                for (var _b = 0, _c = this.responseModel.grammature1; _b < _c.length; _b++) {
                    var grammatureInterno = _c[_b];
                    if (this.model.idGrammature1 == grammatureInterno.chiave) {
                        this.model.nomeGrammature1 = grammatureInterno.valore;
                    }
                }
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idColori1 = this.responseModel.idColori1;
                if (this.model.idColori1 != "1" && this.model.idColori1 != "2") {
                    this.model.stampa1_colori_fronte = this.responseModel.stampa1_colori_fronte;
                    this.model.stampa1_colori_retro = this.responseModel.stampa1_colori_retro;
                }
                if (this.responseModel.isPlastificazioneRequired == false && this.responseModel.idPlastificazioni1 == "-1") {
                    this.model.idPlastificazioni1 = "";
                }
                else {
                    this.model.idPlastificazioni1 = this.responseModel.idPlastificazioni1;
                }
                if (this.EditioriaCopertinaSelect != "0" && this.EditioriaCopertinaSelect != "-1") {
                    this.model.idCarte2 = this.responseModel.idCarte2;
                    for (var _d = 0, _e = this.responseModel.carte2; _d < _e.length; _d++) {
                        var cartaCopertina = _e[_d];
                        if (this.model.idCarte2 == cartaCopertina.chiave) {
                            this.model.nomeCarte2 = cartaCopertina.valore;
                        }
                    }
                    this.model.idGrammature2 = this.responseModel.idGrammature2;
                    for (var _f = 0, _g = this.responseModel.grammature2; _f < _g.length; _f++) {
                        var grammatureCopertina = _g[_f];
                        if (this.model.idGrammature2 == grammatureCopertina.chiave) {
                            this.model.nomeGrammature2 = grammatureCopertina.valore;
                        }
                    }
                    this.model.idCopertine = this.responseModel.idCopertine;
                    if (this.responseModel.isPlastificazioneRequired == false && this.responseModel.idPlastificazioni2 == "-1") {
                        this.model.idPlastificazioni2 = "";
                    }
                    else {
                        this.model.idPlastificazioni2 = this.responseModel.idPlastificazioni2;
                    }
                    this.model.idColori2 = this.responseModel.idColori2;
                }
                else {
                    this.model.idGrammature2 = "0";
                    this.model.idCarte2 = "";
                    this.model.nomeCarte2 = "";
                    this.model.nomeGrammature2 = "0";
                    this.model.idCopertine = "";
                    this.model.idPlastificazioni2 = "";
                    this.model.idColori2 = "";
                }
                if (this.responseModel.cartoncini != null && this.responseModel.cartoncini.length > 0) {
                    this.model.idCartoncino = this.responseModel.idCartoncino;
                    for (var _h = 0, _j = this.responseModel.cartoncini; _h < _j.length; _h++) {
                        var cartaCartoncino = _j[_h];
                        if (this.model.idCartoncino == cartaCartoncino.chiave) {
                            this.model.nomeCartoncino = cartaCartoncino.valore;
                        }
                    }
                    this.model.idGrammatureCartoncino = this.responseModel.idGrammatureCartoncino;
                    for (var _k = 0, _l = this.responseModel.grammatureCartoncino; _k < _l.length; _k++) {
                        var grammatureCartoncino = _l[_k];
                        if (this.model.idGrammatureCartoncino == grammatureCartoncino.chiave) {
                            this.model.nomeGrammatureCartoncino = grammatureCartoncino.valore;
                        }
                    }
                }
                else {
                    this.model.idGrammatureCartoncino = "0";
                    this.model.idCartoncino = "0";
                    this.model.nomeCartoncino = "0";
                    this.model.nomeGrammatureCartoncino = "0";
                }
                this.model.taglio = this.isTaglioCalculated();
                if (this.responseModel.idRilegature != "-1") {
                    this.model.idRilegature = this.responseModel.idRilegature;
                }
                this.model.lavorazioniAccessorie = new Array();
                for (var _m = 0, _o = this.responseModel.lavorazioniAccessorie; _m < _o.length; _m++) {
                    var lavorazioneAccessoria = _o[_m];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        var dorsoString = parseFloat(_this.resultPrice.AltezzaDorso.toString());
                        var dorso = parseFloat(dorsoString.toFixed(2));
                        _this.resultPrice.AltezzaDorso = dorso;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = true;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.isTaglioCalculated = function () {
                var result = false;
                if (this.responseModel.isTaglioVisible == false) {
                    if (this.responseModel.tipoCalcoloTaglio == "si" && !this.responseModel.taglioShowed) {
                        result = true;
                    }
                    else if (this.responseModel.tipoCalcoloTaglio == "no" && !this.responseModel.taglioShowed) {
                        result = false;
                    }
                    else if (this.responseModel.taglioShowed) {
                        result = this.responseModel.tipoTaglio;
                    }
                }
                else {
                    result = false;
                }
                return result;
            };
            ChildComponent.prototype.checkIsCopertinaShowed = function () {
                var result = false;
                if (this.EditioriaCopertinaSelect != '0' && this.EditioriaCopertinaSelect != '-1') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsCartoncinoShowed = function () {
                var result = false;
                if (this.responseModel.cartoncini != null && this.responseModel.cartoncini.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsPlastificazioneInternoIsShowed = function () {
                var result = false;
                if (this.responseModel.plastificazioni1 != null && this.responseModel.plastificazioni1.length > 0) {
                    result = true;
                    if (this.responseModel.isPlastificazioneRequired == false) {
                        if (this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length > 0) {
                            result = true;
                        }
                        else {
                            result = false;
                        }
                    }
                }
                return result;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsPlastificazioneCopertinaIsShowed = function () {
                var result = false;
                if (this.responseModel.plastificazioni2 != null && this.responseModel.plastificazioni2.length > 0 && this.checkIsCopertinaShowed()) {
                    result = true;
                    if (this.responseModel.isPlastificazioneRequired == false) {
                        if (this.responseModel.plastificazioni2.filter(function (x) { return x.isVisible == true; }).length > 0) {
                            result = true;
                        }
                        else {
                            result = false;
                        }
                    }
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId, lavIsVisible) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsTaglioShowed = function () {
                var result = false;
                if (this.responseModel.taglioShowed && !this.responseModel.isTaglioVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onCategoriaCartaInternoFieldChanged = function () {
                var selectedPaper = false;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carte = _a[_i];
                    if (this.responseModel.idCategorieCarte1 != "-1") {
                        if (carte.parentId == this.responseModel.idCategorieCarte1) {
                            if (selectedPaper == false) {
                                this.responseModel.idCarte1 = carte.chiave;
                                this.model.idCarte1 = carte.chiave;
                                this.responseModel.carte1Description = carte.descrizione;
                                this.responseModel.carte1Image = carte.image;
                                this.responseModel.carte1HasInfo = carte.hasInfo;
                                this.responseModel.carte1ShowInfo = false;
                                this.responseModel.grammature1 = carte.subElements;
                                this.responseModel.idGrammature1 = carte.wrap_valore;
                                this.model.idGrammature1 = carte.wrap_valore;
                                selectedPaper = true;
                            }
                            carte.isVisible = true;
                        }
                        else {
                            carte.isVisible = false;
                        }
                    }
                    else {
                        if (selectedPaper == false) {
                            this.responseModel.idCarte1 = carte.chiave;
                            this.model.idCarte1 = carte.chiave;
                            this.responseModel.carte1Description = carte.descrizione;
                            this.responseModel.carte1Image = carte.image;
                            this.responseModel.carte1HasInfo = carte.hasInfo;
                            this.responseModel.carte1ShowInfo = false;
                            this.responseModel.grammature1 = carte.subElements;
                            this.responseModel.idGrammature1 = carte.wrap_valore;
                            this.model.idGrammature1 = carte.wrap_valore;
                            selectedPaper = true;
                        }
                        carte.isVisible = true;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onCartaInternoFieldChanged = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var grammature = _a[_i];
                    if (grammature.chiave == this.responseModel.idCarte1) {
                        this.responseModel.carte1Description = grammature.descrizione;
                        this.responseModel.carte1Image = grammature.image;
                        this.responseModel.carte1HasInfo = grammature.hasInfo;
                        this.responseModel.carte1ShowInfo = false;
                        this.responseModel.grammature1 = grammature.subElements;
                        this.responseModel.idGrammature1 = grammature.wrap_valore;
                        this.model.idGrammature1 = grammature.wrap_valore;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCartoncinoFieldChanged = function () {
                for (var _i = 0, _a = this.responseModel.cartoncini; _i < _a.length; _i++) {
                    var grammature = _a[_i];
                    if (grammature.chiave == this.responseModel.idCartoncino) {
                        this.responseModel.cartoncinoDescription = grammature.descrizione;
                        this.responseModel.cartoncinoImage = grammature.image;
                        this.responseModel.cartoncinoHasInfo = grammature.hasInfo;
                        this.responseModel.cartoncinoShowInfo = false;
                        this.responseModel.grammatureCartoncino = grammature.subElements;
                        this.responseModel.idGrammatureCartoncino = grammature.wrap_valore;
                        this.model.idGrammatureCartoncino = grammature.wrap_valore;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onCartaInternoVisualFieldChanged = function (paperId) {
                this.responseModel.idCarte1 = paperId;
                this.onCartaInternoFieldChanged();
            };
            ChildComponent.prototype.onCartoncinoVisualFieldChanged = function (paperId) {
                this.responseModel.idCartoncino = paperId;
                this.onCartoncinoFieldChanged();
            };
            ChildComponent.prototype.onCategoriaCartaCopertinaFieldChanged = function () {
                var selectedPaper = false;
                for (var _i = 0, _a = this.responseModel.carte2; _i < _a.length; _i++) {
                    var carteCopertina = _a[_i];
                    if (this.responseModel.idCategorieCarte2 != "-1") {
                        if (carteCopertina.parentId == this.responseModel.idCategorieCarte2) {
                            if (selectedPaper == false) {
                                this.responseModel.idCarte2 = carteCopertina.chiave;
                                this.model.idCarte2 = carteCopertina.chiave;
                                this.responseModel.carte2Description = carteCopertina.descrizione;
                                this.responseModel.carte2Image = carteCopertina.image;
                                this.responseModel.carte2HasInfo = carteCopertina.hasInfo;
                                this.responseModel.carte2ShowInfo = false;
                                this.responseModel.grammature2 = carteCopertina.subElements;
                                this.responseModel.idGrammature2 = carteCopertina.wrap_valore;
                                this.model.idGrammature2 = carteCopertina.wrap_valore;
                                selectedPaper = true;
                            }
                            carteCopertina.isVisible = true;
                        }
                        else {
                            carteCopertina.isVisible = false;
                        }
                    }
                    else {
                        if (selectedPaper == false) {
                            this.responseModel.idCarte2 = carteCopertina.chiave;
                            this.model.idCarte2 = carteCopertina.chiave;
                            this.responseModel.carte2Description = carteCopertina.descrizione;
                            this.responseModel.carte2Image = carteCopertina.image;
                            this.responseModel.carte2HasInfo = carteCopertina.hasInfo;
                            this.responseModel.carte2ShowInfo = false;
                            this.responseModel.grammature2 = carteCopertina.subElements;
                            this.responseModel.idGrammature2 = carteCopertina.wrap_valore;
                            this.model.idGrammature2 = carteCopertina.wrap_valore;
                            selectedPaper = true;
                        }
                        carteCopertina.isVisible = true;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onCartaCopertinaFieldChanged = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.carte2; _i < _a.length; _i++) {
                    var grammatureCartaCopertina = _a[_i];
                    if (grammatureCartaCopertina.chiave == this.responseModel.idCarte2) {
                        this.responseModel.carte2Description = grammatureCartaCopertina.descrizione;
                        this.responseModel.carte2Image = grammatureCartaCopertina.image;
                        this.responseModel.carte2HasInfo = grammatureCartaCopertina.hasInfo;
                        this.responseModel.carte2ShowInfo = false;
                        this.responseModel.grammature2 = grammatureCartaCopertina.subElements;
                        this.responseModel.idGrammature2 = grammatureCartaCopertina.wrap_valore;
                        this.model.idGrammature2 = grammatureCartaCopertina.wrap_valore;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCopertineFieldChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                this.EditioriaCopertinaSelect = this.responseModel.idCopertine;
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCopertineFieldVisualChange = function (copertinaId) {
                this.responseModel.idCopertine = copertinaId;
                this.onCopertineFieldChange();
            };
            ChildComponent.prototype.onCartaCopertinaVisualFieldChanged = function (paperId) {
                this.responseModel.idCarte2 = paperId;
                this.onCartaCopertinaFieldChanged();
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                    var formato = _a[_i];
                    if (formato.chiave == this.responseModel.idFormati) {
                        this.responseModel.formatoDescription = formato.descrizione;
                        this.responseModel.formatoImage = formato.image;
                        this.responseModel.formatiHasInfo = formato.hasInfo;
                        this.responseModel.formatiShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onStampaInternoVisualChange = function (stampaInternoValue) {
                this.responseModel.idColori1 = stampaInternoValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaCopertinaVisualChange = function (stampaCopertinaValue) {
                this.responseModel.idColori2 = stampaCopertinaValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onPlastificationInternoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.plastificazioni1; _i < _a.length; _i++) {
                    var plastification = _a[_i];
                    if (plastification.chiave == this.responseModel.idPlastificazioni1) {
                        this.responseModel.plastificazioni1Description = plastification.descrizione;
                        this.responseModel.plastificazioni1Image = plastification.image;
                        this.responseModel.plastificazioni1HasInfo = plastification.hasInfo;
                        this.responseModel.plastificazioni1ShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPlastificationInternoViasualChange = function (plastificationId) {
                this.responseModel.idPlastificazioni1 = plastificationId;
                this.onPlastificationInternoChange();
            };
            ChildComponent.prototype.onGrammatureInternoVisualFieldChanged = function (grammatureId) {
                this.responseModel.idGrammature1 = grammatureId;
                this.parameterValidation();
            };
            ChildComponent.prototype.onGrammatureCartoncinoVisualFieldChanged = function (grammatureId) {
                this.responseModel.idGrammatureCartoncino = grammatureId;
                this.parameterValidation();
            };
            ChildComponent.prototype.onGrammatureCopertinaVisualFieldChanged = function (grammatureId) {
                this.responseModel.idGrammature2 = grammatureId;
                this.parameterValidation();
            };
            ChildComponent.prototype.onPlastificationCopertinaChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.plastificazioni2; _i < _a.length; _i++) {
                    var plastification = _a[_i];
                    if (plastification.chiave == this.responseModel.idPlastificazioni2) {
                        this.responseModel.plastificazioni2Description = plastification.descrizione;
                        this.responseModel.plastificazioni2Image = plastification.image;
                        this.responseModel.plastificazioni2HasInfo = plastification.hasInfo;
                        this.responseModel.plastificazioni2ShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPlastificationCopertinaVisualChange = function (plastificationId) {
                this.responseModel.plastificazioni2 = plastificationId;
                this.onPlastificationCopertinaChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.onRilegaturaChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.rilegature; _i < _a.length; _i++) {
                    var rilegature = _a[_i];
                    if (rilegature.chiave == this.responseModel.idRilegature) {
                        this.responseModel.rilegatureDescription = rilegature.descrizione;
                        this.responseModel.rilegatureImage = rilegature.image;
                        this.responseModel.rilegatureHasInfo = rilegature.hasInfo;
                        this.responseModel.rilegatureShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onRilegaturaVisualChange = function (rilegaturaId) {
                this.responseModel.idRilegature = rilegaturaId;
                this.onRilegaturaChange();
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePaperInternoDescription = function () {
                if (this.responseModel.carte1ShowInfo) {
                    this.responseModel.carte1ShowInfo = false;
                }
                else {
                    this.responseModel.carte1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePaperCartoncinoDescription = function () {
                if (this.responseModel.cartoncinoShowInfo) {
                    this.responseModel.cartoncinoShowInfo = false;
                }
                else {
                    this.responseModel.cartoncinoShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePaperCopertinaDescription = function () {
                if (this.responseModel.carte2ShowInfo) {
                    this.responseModel.carte2ShowInfo = false;
                }
                else {
                    this.responseModel.carte2ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationInternoDescription = function () {
                if (this.responseModel.plastificazioni1ShowInfo) {
                    this.responseModel.plastificazioni1ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationCopertinaDescription = function () {
                if (this.responseModel.plastificazioni2ShowInfo) {
                    this.responseModel.plastificazioni2ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni2ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideRilegatureDescription = function () {
                if (this.responseModel.rilegatureShowInfo) {
                    this.responseModel.rilegatureShowInfo = false;
                }
                else {
                    this.responseModel.rilegatureShowInfo = true;
                }
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.copieIsValid
                    && this.responseModel.facciateIsValid
                    && this.responseModel.formatiIsValid
                    && this.responseModel.baseFormatoIsValid
                    && this.responseModel.altezzaFormatoIsValid
                    && this.responseModel.carte1IsValid
                    && this.responseModel.grammature1IsValid
                    && this.responseModel.plastificazione1IsValid
                    && this.responseModel.carte2IsValid
                    && this.responseModel.grammature2IsValid
                    && this.responseModel.plastificazione2IsValid
                    && this.responseModel.copertineIsValid
                    && this.responseModel.cartoncinoIsValid
                    && this.responseModel.rilegatureIsValid
                    && this.responseModel.lavorazioniIsValid
                    && this.responseModel.colori1IsValid) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.CheckRegoleEditoria = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldCarta = this.responseModel.idCarte1;
                    var oldCartaCopertina = this.responseModel.idCarte2;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var oldPlastificazioneCopertina = this.responseModel.idPlastificazioni2;
                    var oldCopertina = this.responseModel.idCopertine;
                    var oldRilegatura = this.responseModel.idRilegature;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "FORMATO", "EDITORIA", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "CARTA", "", "", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "PLASTIFICAZIONE", "EDITORIA", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "CARTA_COPERTINA", "", "", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "PLASTIFICAZIONE_COPERTINA", "", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "COPERTINA", "", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "RILEGATURA", "", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "TAGLIO", "EDITORIA", null, null, this.responseModel);
                    this.ExcludingRules.ResetRegole("PF", "ACCESSORIA", "", "EDITORIA", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "FORMATO", "EDITORIA", this.responseModel.idFormati, 0, this.responseModel);
                    if (this.responseModel.idCarte1 != null) {
                        var data = this.responseModel.idCarte1.split("_");
                        var idCarta = data[0];
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, 0, this.responseModel);
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, this.responseModel.idGrammature1, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PLASTIFICAZIONE", "EDITORIA", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    if (this.responseModel.idCarte2 != null) {
                        var data = this.responseModel.idCarte2.split("_");
                        var idCarta = data[0];
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA_COPERTINA", "", "", idCarta, 0, this.responseModel);
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA_COPERTINA", "", "", idCarta, this.responseModel.idGrammature2, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PLASTIFICAZIONE_COPERTINA", "EDITORIA", this.responseModel.idPlastificazioni2, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "COPERTINA", "", this.responseModel.idCopertine, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "RILEGATURA", "", this.responseModel.idRilegature, 0, this.responseModel);
                    if (!this.isTaglioCalculated()) {
                        this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "EDITORIA", 1, 0, this.responseModel);
                    }
                    else {
                        this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "EDITORIA", 2, 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("PF", "EDITORIA", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldCarta != this.responseModel.idCarte1) {
                        this.onCartaInternoFieldChanged(true);
                    }
                    if (oldCartaCopertina != this.responseModel.idCarte2) {
                        this.onCartaCopertinaFieldChanged(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldPlastificazioneCopertina != this.responseModel.idPlastificazioni2) {
                        this.onPlastificationCopertinaChange(true);
                    }
                    if (oldCopertina != this.responseModel.idCopertine) {
                        this.onCopertineFieldChange(true);
                    }
                    if (oldRilegatura != this.responseModel.idRilegature) {
                        this.onRilegaturaChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_1 = lavAccArray; _d < lavAccArray_1.length; _d++) {
                            var lavorazioneOld = lavAccArray_1[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            /// Check if all the value is validated
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                this.CheckRegoleEditoria();
                if (this.pageIsInit) {
                    this.pageIsInit = false;
                }
                this.validationCopie();
                this.validationFacciate();
                this.validationFormati();
                if (this.responseModel.idFormati == "0") {
                    this.validationBaseFormati();
                    this.validationAltezzaFormati();
                }
                else {
                    this.responseModel.baseFormatoIsValid = true;
                    this.responseModel.altezzaFormatoIsValid = true;
                }
                this.validationColori();
                this.validationCarteInterno();
                this.validationGrammatureCarteInterno();
                this.validationPlastificazioneInterno();
                this.validationCopertina();
                if (this.checkIsCopertinaShowed()) {
                    this.validationCarteCopertina();
                    this.validationGrammatureCarteCopertina();
                    this.validationPlastificazioneCopertina();
                }
                else {
                    this.responseModel.carte2IsValid = true;
                    this.responseModel.grammature2IsValid = true;
                    this.responseModel.plastificazione2IsValid = true;
                }
                if (this.checkIsCartoncinoShowed()) {
                    this.validationCartoncino();
                    this.validationGrammatureCartoncino();
                }
                else {
                    this.responseModel.cartoncinoIsValid = true;
                    this.responseModel.grammatureCartoncinoIsValid = true;
                }
                this.validationRilegatura();
                this.validationLavorazioneAccessoria();
                this.countCartaCategories();
                this.countCategorieCarteCopertina();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countCartaCategories = function () {
                if (this.responseModel.categorieCarte != null) {
                    this.responseModel.categorieCarteCount = this.responseModel.categorieCarte.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countCategorieCarteCopertina = function () {
                if (this.responseModel.categorieCarteCopertina != null) {
                    this.responseModel.categorieCarteCopertinaCount = this.responseModel.categorieCarteCopertina.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (file.FormatId == this.responseModel.idFormati) {
                        var fileObj = new quoting_submit_model_4.FileCombinationModel();
                        fileObj.PathFile = file.PathFile;
                        if (file.NomeFile == null || file.NomeFile == "") {
                            fileObj.NomeFile = file.FileName;
                        }
                        else {
                            fileObj.NomeFile = file.NomeFile;
                        }
                        fileObj.PathIstruzioni = file.PathIstruzioni;
                        if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                            fileObj.NomeIstruzioni = file.FileIstructionName;
                        }
                        else {
                            fileObj.NomeIstruzioni = file.NomeIstruzioni;
                        }
                        this.listaFile.push(fileObj);
                    }
                }
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationFacciate = function () {
                var message;
                if (this.responseModel.tipoFacciate == 'libera') {
                    var numFacciate = parseInt(this.responseModel.numFacciate);
                    var minFacciate = this.responseModel.minimoFacciate;
                    var maxFacciate = this.responseModel.massimoFacciate;
                    var multiploFacciate = this.responseModel.multiploFacciate;
                    //If the weight for the inside currently selected is in the ones defined in the validation rules, then the max and min are read directly from the ones of the rule.
                    //Else the ones on the wizard are used
                    //Note: The max and min facciate defined on weight wins over the ones defined on the wizard
                    var objGrammaturaFacciateValidation = this.checkValidationRulesGrammatureFacciate();
                    if (objGrammaturaFacciateValidation != null) {
                        minFacciate = objGrammaturaFacciateValidation.Facciate != null ? objGrammaturaFacciateValidation.Facciate : 0;
                        maxFacciate = objGrammaturaFacciateValidation.MassimoFacciate != null ? objGrammaturaFacciateValidation.MassimoFacciate : 0;
                    }
                    if (this.responseModel.numFacciate == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.facciateIsValid = false;
                    }
                    else if ((maxFacciate == 0 && (numFacciate == 0 || numFacciate < minFacciate)) || (multiploFacciate > 0 && (numFacciate == 0 || numFacciate % multiploFacciate > 0))) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + minFacciate;
                        if (multiploFacciate > 0 && (numFacciate == 0 || numFacciate % multiploFacciate > 0)) {
                            message += ", " + this.getLabel('inserisci_valore_multiplo_di');
                            message += " " + multiploFacciate;
                        }
                        this.responseModel.facciateIsValid = false;
                    }
                    else if ((maxFacciate > 0 && (numFacciate == 0 || numFacciate < minFacciate || numFacciate > maxFacciate)) || (multiploFacciate > 0 && (numFacciate == 0 || numFacciate % multiploFacciate > 0))) {
                        message = this.getLabel('inserisci_valore_compreso_tra');
                        message += " " + minFacciate;
                        message += " " + this.getLabel('inserisci_valore_compreso_e');
                        message += " " + maxFacciate;
                        if (multiploFacciate > 0 && (numFacciate == 0 || numFacciate % multiploFacciate > 0)) {
                            message += ", " + this.getLabel('inserisci_valore_multiplo_di');
                            message += " " + multiploFacciate;
                        }
                        this.responseModel.facciateIsValid = false;
                    }
                    else {
                        this.responseModel.facciateIsValid = true;
                    }
                }
                else {
                    if (this.responseModel.idFacciate == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.facciateIsValid = false;
                    }
                    else {
                        this.responseModel.facciateIsValid = true;
                    }
                    if (this.responseModel.tipoFacciate === 'fissa' && this.responseModel.facciate != null) {
                        this.responseModel.facciateCount = this.responseModel.facciate.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.facciateMessage = message;
            };
            ChildComponent.prototype.validationColori = function () {
                var message;
                if (this.responseModel.idColori1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.colori1IsValid = false;
                }
                else {
                    this.responseModel.colori1IsValid = true;
                }
                if (this.responseModel.colori1 != null) {
                    this.responseModel.colori1Count = this.responseModel.colori1.filter(function (x) { return x.isVisible == true; }).length;
                }
                if (this.responseModel.colori2 != null) {
                    this.responseModel.colori2Count = this.responseModel.colori2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.colori1Message = message;
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.formatiMessage = message;
            };
            ChildComponent.prototype.validationCarteInterno = function () {
                var message;
                if (this.responseModel.idCarte1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.carte1IsValid = false;
                }
                else {
                    this.responseModel.carte1IsValid = true;
                }
                if (this.responseModel.carte1 != null) {
                    this.responseModel.carte1Count = this.responseModel.carte1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.carte1Message = message;
            };
            ChildComponent.prototype.validationGrammatureCarteInterno = function () {
                var message;
                if (this.responseModel.idGrammature1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.grammature1IsValid = false;
                }
                else {
                    this.responseModel.grammature1IsValid = true;
                }
                if (this.responseModel.grammature1 != null) {
                    this.responseModel.grammature1Count = this.responseModel.grammature1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.grammature1Message = message;
            };
            ChildComponent.prototype.validationCartoncino = function () {
                var message;
                if (this.responseModel.idCartoncino == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.cartoncinoIsValid = false;
                }
                else {
                    this.responseModel.cartoncinoIsValid = true;
                }
                if (this.responseModel.cartoncini != null) {
                    this.responseModel.cartonciniCount = this.responseModel.cartoncini.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.cartoncinoMessage = message;
            };
            ChildComponent.prototype.validationGrammatureCartoncino = function () {
                var message;
                if (this.responseModel.idGrammatureCartoncino == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.grammatureCartoncinoIsValid = false;
                }
                else {
                    this.responseModel.grammatureCartoncinoIsValid = true;
                }
                if (this.responseModel.grammatureCartoncino != null) {
                    this.responseModel.grammatureCartoncinoCount = this.responseModel.grammatureCartoncino.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.grammatureCartoncinoMessage = message;
            };
            ChildComponent.prototype.validationPlastificazioneInterno = function () {
                var message;
                if (this.responseModel.idPlastificazioni1 == "-1") {
                    if (this.responseModel.isPlastificazioneRequired == true) {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.plastificazione1IsValid = false;
                    }
                    else {
                        this.responseModel.plastificazione1IsValid = true;
                    }
                }
                else {
                    this.responseModel.plastificazione1IsValid = true;
                }
                if (this.responseModel.plastificazioni1 != null) {
                    this.responseModel.plastificazioni1Count = this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.plastificazione1Message = message;
            };
            ChildComponent.prototype.validationPlastificazioneCopertina = function () {
                var message;
                if (this.responseModel.idPlastificazioni2 == "-1") {
                    if (this.responseModel.isPlastificazioneRequired == true) {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.plastificazione2IsValid = false;
                    }
                    else {
                        this.responseModel.plastificazione2IsValid = true;
                    }
                }
                else {
                    this.responseModel.plastificazione2IsValid = true;
                }
                if (this.responseModel.plastificazioni2 != null) {
                    this.responseModel.plastificazioni2Count = this.responseModel.plastificazioni2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.plastificazione2Message = message;
            };
            ChildComponent.prototype.validationCarteCopertina = function () {
                var message;
                if (this.responseModel.idCarte2 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.carte2IsValid = false;
                }
                else {
                    this.responseModel.carte2IsValid = true;
                }
                if (this.responseModel.carte2 != null) {
                    this.responseModel.carte2Count = this.responseModel.carte2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.carte2Message = message;
            };
            ChildComponent.prototype.validationGrammatureCarteCopertina = function () {
                var message;
                if (this.responseModel.idGrammature2 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.grammature2IsValid = false;
                }
                else {
                    this.responseModel.grammature2IsValid = true;
                }
                if (this.responseModel.grammature2 != null) {
                    this.responseModel.grammature2Count = this.responseModel.grammature2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.grammature2Message = message;
            };
            ChildComponent.prototype.validationCopertina = function () {
                var message;
                if (this.responseModel.idCopertine == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.copertineIsValid = false;
                }
                else {
                    this.responseModel.copertineIsValid = true;
                }
                if (this.responseModel.copertine != null) {
                    this.responseModel.copertineCount = this.responseModel.copertine.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.copertineMessage = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var _this = this;
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        if (lavorazione.umLavorazione == 84 && qta > 0) {
                            var numFacciate = 0;
                            if (this.responseModel.tipoFacciate != 'libera') {
                                var facciata = this.responseModel.facciate.filter(function (x) { return x.chiave == _this.responseModel.idFacciate; });
                                numFacciate = parseInt(facciata[0].valore);
                            }
                            else {
                                numFacciate = parseInt(this.responseModel.numFacciate);
                            }
                            var checkFacciateNum = parseInt(((numFacciate * lavorazione.percentualePagineTotEditoria) / 100) + "");
                            if (checkFacciateNum < qta) {
                                lavorazione.isValid = false;
                                valid = false;
                                message = this.getLabel('num_lower_or_equal_than');
                                message += " " + checkFacciateNum;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.validationRilegatura = function () {
                var message;
                if (this.responseModel.idRilegature == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.rilegatureIsValid = false;
                }
                else {
                    this.responseModel.rilegatureIsValid = true;
                }
                if (this.responseModel.rilegature != null) {
                    this.responseModel.rilegatureCount = this.responseModel.rilegature.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.rilegatureMessage = message;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setActive = function (id) {
                $(".calendar-list").removeClass("hoverActive");
                $($(".calendar-list")[id]).addClass("hoverActive");
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            //Check if the selected paper weight for the inside is in the ones defined in the validation rules for the facciate
            ChildComponent.prototype.checkValidationRulesGrammatureFacciate = function () {
                var output = null;
                //Reading current paper weight
                var idGrammatura = this.responseModel.idGrammature1;
                for (var i = 0; i < this.responseModel.listaRegoleGrammaturaFacciate.length; i++) {
                    var item = this.responseModel.listaRegoleGrammaturaFacciate[i];
                    if (item.IdGrammatura == idGrammatura) {
                        output = item;
                        break;
                    }
                }
                return output;
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _e) || Object, (typeof (_f = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _f) || Object, (typeof (_g = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardEditoriaComponent.prototype, "resourceId", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], WizardEditoriaComponent.prototype, "resourceType", void 0);
    WizardEditoriaComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-editoria-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _d) || Object, (typeof (_e = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardEditoriaComponent);
    return WizardEditoriaComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardEditoriaComponent = WizardEditoriaComponent;


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscription_1 = __webpack_require__(2);
//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
//Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardEtichetteComponent = (function () {
    function WizardEtichetteComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardEtichetteComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardEtichetteData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardEtichetteComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardEtichetteComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, routesService, translate, cartService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.routesService = routesService;
                this.translate = translate;
                this.cartService = cartService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.enableAltezzaLabel = true;
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.ExcludingRules.setMacrocategory("ETICHETTE");
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.CheckRegoleEtichette = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldCarta = this.responseModel.idCarte1;
                    var oldFormato = this.responseModel.idFormati;
                    var oldPlastificazione = this.responseModel.idPlastificazioni1;
                    var oldTaglio = this.responseModel.idTagli;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "FORMATO", "ETICHETTE", null, null, this.responseModel);
                    //Reset regole carta e grammature
                    this.ExcludingRules.ResetRegole("PF", "CARTA", "", "", null, null, this.responseModel);
                    //Reset regole taglio
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "FUSTELLATURA", "", null, null, this.responseModel);
                    //Reset regole plastificazione
                    this.ExcludingRules.ResetRegole("PF", "FINITURA", "PLASTIFICAZIONE", "ETICHETTE", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("PF", "ACCESSORIA", "", "ETICHETTE", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "FORMATO", "ETICHETTE", idFormato, 0, this.responseModel);
                    }
                    if (this.responseModel.idCarte1 != null) {
                        var data = this.responseModel.idCarte1.split("_");
                        var idCarta = data[0];
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, 0, this.responseModel);
                        this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, this.responseModel.idGrammature1, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PLASTIFICAZIONE", "ETICHETTE", this.responseModel.idPlastificazioni1, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "FUSTELLATURA", "", this.responseModel.idTagli, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("PF", "ETICHETTE", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldCarta != this.responseModel.idCarte1) {
                        this.onCartaInternoFieldChanged(true);
                    }
                    if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
                        this.onPlastificationInternoChange(true);
                    }
                    if (oldTaglio != this.responseModel.idTagli) {
                        this.onTaglioChange(true);
                    }
                    //if the old value id different to the new one i call the method for update description and image
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_1 = lavAccArray; _d < lavAccArray_1.length; _d++) {
                            var lavorazioneOld = lavAccArray_1[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                this.CheckRegoleEtichette();
                //verify validation for all  parameters 
                this.validationCopie();
                if (this.isLabelField()) {
                    this.validationSoggetti();
                    this.validationNumEtichetteLabel();
                    this.validationDiametroInternoAnimaLabel();
                    this.validationDiametroMassimoEsternoAnimaLabel();
                }
                else {
                    if (this.responseModel.soggettiMultipli == true) {
                        this.validationSoggetti();
                    }
                    else {
                        this.responseModel.soggettiIsValid = true;
                    }
                }
                this.validationFormati();
                if (this.responseModel.idFormati == "0") {
                    this.enableOrDisableAltezzaLabelByTipoFormato(this.responseModel.idFormatoTipo);
                    this.validationBaseFormati();
                    this.validationAltezzaFormati();
                }
                else {
                    this.responseModel.baseFormatoIsValid = true;
                    this.responseModel.altezzaFormatoIsValid = true;
                }
                this.validationColori();
                this.validationCarteInterno();
                this.validationGrammatureCarteInterno();
                this.validationPlastificazione();
                this.validationLavorazioneAccessoria();
                this.countCartaCategories();
                this.countTagli();
                this.countFustelle();
                this.countFormatiTipoLabel();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countCartaCategories = function () {
                if (this.responseModel.categorieCarte != null) {
                    this.responseModel.categorieCarteCount = this.responseModel.categorieCarte.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countTagli = function () {
                if (this.responseModel.tagli != null) {
                    this.responseModel.tagliCount = this.responseModel.tagli.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countFustelle = function () {
                if (this.responseModel.ListafustelleLabel != null) {
                    this.responseModel.fustelleLabelCount = this.responseModel.ListafustelleLabel.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countFormatiTipoLabel = function () {
                if (this.responseModel.TipologiaFormatiLabel != null) {
                    this.responseModel.formatiTipoLabelCount = this.responseModel.TipologiaFormatiLabel.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        if (file.FormatId == idFormato) {
                            var fileObj = new quoting_submit_model_4.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            /// Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.idCarte1 = this.responseModel.idCarte1;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carta = _a[_i];
                    if (this.model.idCarte1 == carta.chiave) {
                        this.model.nomeCarte1 = carta.valore;
                    }
                }
                this.model.idGrammature1 = this.responseModel.idGrammature1;
                for (var _b = 0, _c = this.responseModel.grammature1; _b < _c.length; _b++) {
                    var grammatureInterno = _c[_b];
                    if (this.model.idGrammature1 == grammatureInterno.chiave) {
                        this.model.nomeGrammature1 = grammatureInterno.valore;
                    }
                }
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idColori1 = this.responseModel.idColori1;
                if (this.model.idColori1 != "1" && this.model.idColori1 != "2") {
                    this.model.stampa1_colori_fronte = this.responseModel.stampa1_colori_fronte;
                    this.model.stampa1_colori_retro = this.responseModel.stampa1_colori_retro;
                }
                this.model.idColori2 = this.responseModel.idColori2;
                if (this.responseModel.isPlastificazioneRequired == false && this.responseModel.idPlastificazioni1 == "-1") {
                    this.model.idPlastificazioni1 = "";
                }
                else {
                    this.model.idPlastificazioni1 = this.responseModel.idPlastificazioni1;
                }
                if (this.responseModel.idTagli != "-1") {
                    this.model.idTagli = this.responseModel.idTagli;
                }
                if (this.responseModel.idFustella != "-1") {
                    this.model.idFustella = this.responseModel.idFustella;
                }
                if (this.responseModel.idAvvolgimento != "-1") {
                    this.model.idAvvolgimento = this.responseModel.idAvvolgimento;
                }
                if (this.responseModel.idTipoLavoroLabel != "-1") {
                    this.model.idTipoLavoroLabel = this.responseModel.idTipoLavoroLabel;
                }
                if (this.responseModel.idFormatoTipo != "-1") {
                    this.model.idFormatoTipo = this.responseModel.idFormatoTipo;
                }
                this.model.numDiametroInternoAnimaLabel = this.responseModel.numDiametroInternoAnimaLabel;
                this.model.numDiametroMassimoEsternoAnimaLabel = this.responseModel.numDiametroMassimoEsternoAnimaLabel;
                this.model.numEtichette = this.responseModel.numEtichette;
                this.model.subSection = this.responseModel.subSection;
                this.model.lavorazioniAccessorie = new Array();
                for (var _d = 0, _e = this.responseModel.lavorazioniAccessorie; _d < _e.length; _d++) {
                    var lavorazioneAccessoria = _e[_d];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var sub = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = false;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = false;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                    this.subManager.add(sub);
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.copieIsValid
                    && this.responseModel.formatiIsValid
                    && this.responseModel.carte1IsValid
                    && this.responseModel.grammature1IsValid
                    && this.responseModel.plastificazione1IsValid
                    && this.responseModel.lavorazioniIsValid
                    && this.responseModel.baseFormatoIsValid
                    && this.responseModel.altezzaFormatoIsValid
                    && this.responseModel.soggettiIsValid
                    && this.responseModel.colori1IsValid) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.isLabelField()) {
                    var minDistEtichette = this.responseModel.minimaDistanzaEtichetteLabel;
                    var maxDistEtichette = this.responseModel.massimaDistanzaEtichetteLabel;
                    if (this.responseModel.numSoggetti == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.soggettiIsValid = false;
                    }
                    else if (numSoggetti == 0) {
                        message = this.getLabel('inserisci_valore_maggiore_0');
                        this.responseModel.soggettiIsValid = false;
                    }
                    else {
                        if (maxDistEtichette == 0) {
                            if (numSoggetti < minDistEtichette) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minDistEtichette;
                                this.responseModel.soggettiIsValid = false;
                            }
                            else {
                                this.responseModel.soggettiIsValid = true;
                            }
                        }
                        else {
                            if ((numSoggetti >= minDistEtichette) && (numSoggetti <= maxDistEtichette)) {
                                this.responseModel.soggettiIsValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minDistEtichette;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxDistEtichette;
                                this.responseModel.soggettiIsValid = false;
                            }
                        }
                    }
                }
                else {
                    if (this.responseModel.numSoggetti == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.soggettiIsValid = false;
                    }
                    else if (numSoggetti == 0) {
                        message = this.getLabel('inserisci_valore_maggiore_0');
                        this.responseModel.soggettiIsValid = false;
                    }
                    else {
                        this.responseModel.soggettiIsValid = true;
                    }
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationNumEtichetteLabel = function () {
                var message;
                var numEtichette = parseInt(this.responseModel.numEtichette);
                if (this.responseModel.numEtichette == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.numEtichetteIsValid = false;
                }
                else if (numEtichette == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.numEtichetteIsValid = false;
                }
                else {
                    this.responseModel.numEtichetteIsValid = true;
                }
                this.responseModel.numEtichetteMessage = message;
            };
            ChildComponent.prototype.validationDiametroInternoAnimaLabel = function () {
                var message;
                var numDiametroInternoAnimaCustomer = this.responseModel.numDiametroInternoAnimaLabel;
                var numDiametroInternoAnima = this.responseModel.numDiametroInternoAnimaEditabileLabel;
                if (this.responseModel.numDiametroInternoAnimaLabel == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.DiametroInternoAnimaIsValid = false;
                }
                else if (numDiametroInternoAnimaCustomer == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.DiametroInternoAnimaIsValid = false;
                }
                else {
                    if (numDiametroInternoAnimaCustomer >= numDiametroInternoAnima) {
                        this.responseModel.DiametroInternoAnimaIsValid = true;
                    }
                    else {
                        message = this.getLabel('inserisci_valore_maggiore_uguale');
                        message += " " + numDiametroInternoAnima;
                        this.responseModel.DiametroInternoAnimaIsValid = false;
                    }
                }
                this.responseModel.DiametroInternoAnimaMessage = message;
            };
            ChildComponent.prototype.validationDiametroMassimoEsternoAnimaLabel = function () {
                var message;
                var numDiametroMassimoEsternoCustomer = this.responseModel.numDiametroMassimoEsternoAnimaLabel;
                var numDiametroMassimoEsterno = this.responseModel.numDiametroMassimoEsternoAnimaEditabile;
                if (this.responseModel.numDiametroMassimoEsternoAnimaLabel == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.DiametroMassimoEsternoAnimaIsValid = false;
                }
                else if (numDiametroMassimoEsternoCustomer == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.DiametroMassimoEsternoAnimaIsValid = false;
                }
                else {
                    if (numDiametroMassimoEsternoCustomer >= numDiametroMassimoEsterno) {
                        this.responseModel.DiametroMassimoEsternoAnimaIsValid = true;
                    }
                    else {
                        message = this.getLabel('inserisci_valore_maggiore_uguale');
                        message += " " + numDiametroMassimoEsterno;
                        this.responseModel.DiametroMassimoEsternoAnimaIsValid = false;
                    }
                }
                this.responseModel.DiametroMassimoEsternoAnimaMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationColori = function () {
                var message;
                if (this.responseModel.idColori1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.colori1IsValid = false;
                }
                else {
                    this.responseModel.colori1IsValid = true;
                }
                if (this.responseModel.colori1 != null) {
                    this.responseModel.colori1Count = this.responseModel.colori1.filter(function (x) { return x.isVisible == true; }).length;
                }
                if (this.responseModel.colori2 != null) {
                    this.responseModel.colori2Count = this.responseModel.colori2.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.colori1Message = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.formatiMessage = message;
            };
            ChildComponent.prototype.validationCarteInterno = function () {
                var message;
                if (this.responseModel.idCarte1 == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.carte1IsValid = false;
                }
                else {
                    this.responseModel.carte1IsValid = true;
                }
                if (this.responseModel.carte1 != null) {
                    this.responseModel.carte1Count = this.responseModel.carte1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.carte1Message = message;
            };
            ChildComponent.prototype.validationGrammatureCarteInterno = function () {
                var message;
                if (this.isLabelField()) {
                    this.responseModel.grammature1IsValid = true;
                }
                else {
                    if (this.responseModel.idGrammature1 == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.grammature1IsValid = false;
                    }
                    else {
                        this.responseModel.grammature1IsValid = true;
                    }
                    if (this.responseModel.grammature1 != null) {
                        this.responseModel.grammature1Count = this.responseModel.grammature1.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.grammature1Message = message;
            };
            ChildComponent.prototype.validationPlastificazione = function () {
                var message;
                if (this.responseModel.idPlastificazioni1 == "-1") {
                    if (this.responseModel.isPlastificazioneRequired == true) {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.plastificazione1IsValid = false;
                    }
                    else {
                        this.responseModel.plastificazione1IsValid = true;
                    }
                }
                else {
                    this.responseModel.plastificazione1IsValid = true;
                }
                if (this.responseModel.plastificazioni1 != null) {
                    this.responseModel.plastificazioni1Count = this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.plastificazione1Message = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.isLabelField = function () {
                var result = false;
                if (this.responseModel.subSection == "Label") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.checkIsPlastificazioneInternoIsShowed = function () {
                var result = false;
                if (this.responseModel.plastificazioni1 != null && this.responseModel.plastificazioni1.length > 0) {
                    result = true;
                    if (this.responseModel.isPlastificazioneRequired == false) {
                        if (this.responseModel.plastificazioni1.filter(function (x) { return x.isVisible == true; }).length > 0) {
                            result = true;
                        }
                        else {
                            result = false;
                        }
                    }
                }
                return result;
            };
            ChildComponent.prototype.checkIsTaglioIsShowed = function () {
                var result = false;
                if (this.responseModel.tagli != null && this.responseModel.tagli.length > 0) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsTaglioShowed = function () {
                var result = false;
                if (this.responseModel.taglioShowed && !this.responseModel.isTaglioVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onCategoriaCartaInternoFieldChanged = function () {
                var selectedPaper = false;
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var carte = _a[_i];
                    if (this.responseModel.idCategorieCarte1 != "-1") {
                        if (carte.parentId == this.responseModel.idCategorieCarte1) {
                            if (selectedPaper == false) {
                                this.responseModel.idCarte1 = carte.chiave;
                                this.model.idCarte1 = carte.chiave;
                                this.responseModel.carte1Description = carte.descrizione;
                                this.responseModel.carte1Image = carte.image;
                                this.responseModel.carte1HasInfo = carte.hasInfo;
                                this.responseModel.carte1ShowInfo = false;
                                this.responseModel.grammature1 = carte.subElements;
                                this.responseModel.idGrammature1 = carte.wrap_valore;
                                this.model.idGrammature1 = carte.wrap_valore;
                                selectedPaper = true;
                            }
                            carte.isVisible = true;
                        }
                        else {
                            carte.isVisible = false;
                        }
                    }
                    else {
                        if (selectedPaper == false) {
                            this.responseModel.idCarte1 = carte.chiave;
                            this.model.idCarte1 = carte.chiave;
                            this.responseModel.carte1Description = carte.descrizione;
                            this.responseModel.carte1Image = carte.image;
                            this.responseModel.carte1HasInfo = carte.hasInfo;
                            this.responseModel.carte1ShowInfo = false;
                            this.responseModel.grammature1 = carte.subElements;
                            this.responseModel.idGrammature1 = carte.wrap_valore;
                            this.model.idGrammature1 = carte.wrap_valore;
                            selectedPaper = true;
                        }
                        carte.isVisible = true;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onCartaInternoFieldChanged = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.carte1; _i < _a.length; _i++) {
                    var grammature = _a[_i];
                    if (grammature.chiave == this.responseModel.idCarte1) {
                        this.responseModel.carte1Description = grammature.descrizione;
                        this.responseModel.carte1Image = grammature.image;
                        this.responseModel.carte1HasInfo = grammature.hasInfo;
                        this.responseModel.carte1ShowInfo = false;
                        this.responseModel.grammature1 = grammature.subElements;
                        this.responseModel.idGrammature1 = grammature.wrap_valore;
                        this.model.idGrammature1 = grammature.wrap_valore;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onCartaInternoVisualFieldChanged = function (paperId) {
                this.responseModel.idCarte1 = paperId;
                this.onCartaInternoFieldChanged();
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                    var formato = _a[_i];
                    if (formato.chiave == this.responseModel.idFormati) {
                        this.responseModel.formatoDescription = formato.descrizione;
                        this.responseModel.formatoImage = formato.image;
                        this.responseModel.formatiHasInfo = formato.hasInfo;
                        this.responseModel.formatiShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onStampaInternoVisualChange = function (stampaInternoValue) {
                this.responseModel.idColori1 = stampaInternoValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onStampaRetroVisualChange = function (stampaCopertinaValue) {
                this.responseModel.idColori2 = stampaCopertinaValue;
                this.parameterValidation();
            };
            ChildComponent.prototype.onGrammatureInternoVisualFieldChanged = function (grammatureId) {
                this.responseModel.idGrammature1 = grammatureId;
                this.parameterValidation();
            };
            ChildComponent.prototype.onPlastificationInternoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.plastificazioni1; _i < _a.length; _i++) {
                    var plastification = _a[_i];
                    if (plastification.chiave == this.responseModel.idPlastificazioni1) {
                        this.responseModel.plastificazioni1Description = plastification.descrizione;
                        this.responseModel.plastificazioni1Image = plastification.image;
                        this.responseModel.plastificazioni1HasInfo = plastification.hasInfo;
                        this.responseModel.plastificazioni1ShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onPlastificationInternoViasualChange = function (plastificationId) {
                this.responseModel.idPlastificazioni1 = plastificationId;
                this.onPlastificationInternoChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.onTaglioChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.tagli; _i < _a.length; _i++) {
                    var taglio = _a[_i];
                    if (taglio.chiave == this.responseModel.idTagli) {
                        this.responseModel.taglioDescription = taglio.descrizione;
                        this.responseModel.taglioImage = taglio.image;
                        this.responseModel.taglioHasInfo = taglio.hasInfo;
                        this.responseModel.taglioShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onTaglioVisualChange = function (taglioId) {
                this.responseModel.idTagli = taglioId;
                this.onTaglioChange();
            };
            ChildComponent.prototype.onFormatiTipoLabelChange = function () {
                for (var _i = 0, _a = this.responseModel.TipologiaFormatiLabel; _i < _a.length; _i++) {
                    var formatoTipo = _a[_i];
                    if (formatoTipo.chiave == this.responseModel.idFormatoTipo) {
                        this.responseModel.formatiTipoImage = formatoTipo.image;
                        this.responseModel.formatiTipoHasInfo = formatoTipo.hasInfo;
                        this.responseModel.formatiTipoLabelShowInfo = false;
                        this.enableOrDisableAltezzaLabelByTipoFormato(formatoTipo.chiave);
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.enableOrDisableAltezzaLabelByTipoFormato = function (tipoFormato) {
                //checking tipo formato for anable or disable height
                if (this.responseModel.idFormati == "0") {
                    switch (tipoFormato) {
                        case "1":
                            this.enableAltezzaLabel = true;
                            break;
                        case "2":
                            this.enableAltezzaLabel = false;
                            this.responseModel.altezzaFormato = this.responseModel.baseFormato;
                            break;
                        case "3":
                            this.enableAltezzaLabel = false;
                            this.responseModel.altezzaFormato = this.responseModel.baseFormato;
                            break;
                        case "4":
                            this.enableAltezzaLabel = true;
                            break;
                    }
                }
            };
            ChildComponent.prototype.onFormatiTipoLabelVisualChange = function (fotmatoTipoId) {
                this.responseModel.idFormatoTipo = fotmatoTipoId;
                this.onFormatiTipoLabelChange();
            };
            ChildComponent.prototype.onAvvolgimentiChange = function () {
                for (var _i = 0, _a = this.responseModel.avvolgimentiLabel; _i < _a.length; _i++) {
                    var avvolgimento = _a[_i];
                    if (avvolgimento.chiave == this.responseModel.idAvvolgimento) {
                        this.responseModel.avvolgimentiImage = avvolgimento.image;
                        this.responseModel.avvolgimentiHasInfo = avvolgimento.hasInfo;
                        this.responseModel.avvolgimentiShowInfo = false;
                    }
                }
                this.parameterValidation();
            };
            ChildComponent.prototype.onAvvolgimentiVisualChange = function (avvolgimentoId) {
                this.responseModel.idAvvolgimento = avvolgimentoId;
                this.onAvvolgimentiChange();
            };
            ChildComponent.prototype.showHideTaglioDescription = function () {
                if (this.responseModel.taglioShowInfo) {
                    this.responseModel.taglioShowInfo = false;
                }
                else {
                    this.responseModel.taglioShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatiTipoLabelDescription = function () {
                if (this.responseModel.formatiTipoLabelShowInfo) {
                    this.responseModel.formatiTipoLabelShowInfo = false;
                }
                else {
                    this.responseModel.formatiTipoLabelShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideAvvolgimentiDescription = function () {
                if (this.responseModel.avvolgimentiShowInfo) {
                    this.responseModel.avvolgimentiShowInfo = false;
                }
                else {
                    this.responseModel.avvolgimentiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePaperInternoDescription = function () {
                if (this.responseModel.carte1ShowInfo) {
                    this.responseModel.carte1ShowInfo = false;
                }
                else {
                    this.responseModel.carte1ShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationInternoDescription = function () {
                if (this.responseModel.plastificazioni1ShowInfo) {
                    this.responseModel.plastificazioni1ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni1ShowInfo = true;
                }
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _d) || Object, (typeof (_e = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardEtichetteComponent.prototype, "resourceId", void 0);
    WizardEtichetteComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-etichette-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardEtichetteComponent);
    return WizardEtichetteComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardEtichetteComponent = WizardEtichetteComponent;


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Angular
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(27);
//Services
var component_helper_service_1 = __webpack_require__(4);
var quoting_service_1 = __webpack_require__(61);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var bootbox_service_1 = __webpack_require__(40);
var shopping_cart_service_1 = __webpack_require__(20);
var routes_service_1 = __webpack_require__(5);
///Components
var quoting_excluding_component_1 = __webpack_require__(72);
//Models
var quoting_model_1 = __webpack_require__(56);
var quoting_submit_model_1 = __webpack_require__(17);
var quoting_submit_model_2 = __webpack_require__(17);
var quoting_submit_model_3 = __webpack_require__(17);
var quoting_submit_model_4 = __webpack_require__(17);
var quoting_submit_model_5 = __webpack_require__(17);
var Subscription_1 = __webpack_require__(2);
var customerscanvas_service_1 = __webpack_require__(43);
var WizardStampaComponent = (function () {
    function WizardStampaComponent(_compiler, componentHelper, _elementRef, _quotingService, authService, languageService, isBrowser) {
        this._compiler = _compiler;
        this.componentHelper = componentHelper;
        this._elementRef = _elementRef;
        this._quotingService = _quotingService;
        this.authService = authService;
        this.languageService = languageService;
        this.isBrowser = isBrowser;
        this.autentification = this.authService.GetData();
        this.userId = this.authService.GetUserId();
        this.lang = this.languageService.getLongLang();
        this.subManager = new Subscription_1.Subscription();
    }
    WizardStampaComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBrowser)
            return;
        var sub = this._quotingService.getWizardStampaData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(function (result) {
            //Creating subcomponent whith the selected template to inject
            var subComponent = _this.createSubComponent(result, _this.resourceId);
            //injecting created component (OK)
            _this.componentHelper.injectComponent(_this._compiler, _this._elementRef, subComponent);
        });
        this.subManager.add(sub);
    };
    WizardStampaComponent.prototype.ngOnDestroy = function () {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    };
    WizardStampaComponent.prototype.createSubComponent = function (result, InputresourceId) {
        var ChildComponent = (function () {
            function ChildComponent(_quotingService, languageService, authService, translate, cartService, routesService, bootboxService, isBrowser, canvasService) {
                var _this = this;
                this._quotingService = _quotingService;
                this.languageService = languageService;
                this.authService = authService;
                this.translate = translate;
                this.cartService = cartService;
                this.routesService = routesService;
                this.bootboxService = bootboxService;
                this.isBrowser = isBrowser;
                this.canvasService = canvasService;
                this.pageIsInit = false;
                this.pageIsInitAfter = false;
                this.privacyPageName = this.routesService.getRoutePath('INFO PRIVACY');
                this.purchasePageName = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
                this.waiting = false;
                this.carteValue = -1;
                this.lang = this.languageService.getLongLang();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.autentification = this.authService.GetData();
                this.resourceId = InputresourceId;
                this.isDataInitialized = false;
                this.iShowHourForDay = false;
                this.resultPrice = new quoting_submit_model_2.PriceEstimationModel();
                this.ExcludingRules = new quoting_excluding_component_1.ExcludingComponent();
                this.model = new quoting_submit_model_3.wizardFormEditoriaModel();
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
                this.requestInfoSuccess = null;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.blockquoting = false;
                this.formatiMultipliList = new Array();
                this.isCalculatedWizard = false;
                // sending info to a child component
                this.parentWidgetData = result.CanvasInfo;
                this.subManager = new Subscription_1.Subscription();
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                var canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(function (isModalOpened) {
                    if (isModalOpened == false) {
                        $('html').css("overflow", "visible");
                    }
                    else {
                        // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                        window.scrollTo(0, 0);
                        $('html').css("overflow", "hidden");
                    }
                });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                var canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(function (isDesignApproved) {
                    if (isDesignApproved) {
                        $('#customerCanvasModal').modal('hide');
                        $('html').css("overflow", "visible");
                        // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                        cartService.setIfProductIsCanvasEdited(true);
                        if (_this.isCalculationTypeCalcolato()) {
                            _this.addToCartWizardCalcolato(1);
                        }
                        else if (_this.isCalculationTypeCalcolatoScontistica()) {
                            _this.addToCartWizardCalcolatoScontistica(1);
                        }
                        else if (_this.isCalculationTypeListino()) {
                            _this.addToCartWizardListino(1);
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            _this.addToCartWizardListinoScontistica(1);
                        }
                    }
                });
                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }
            ChildComponent.prototype.ngOnInit = function () {
                var _this = this;
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new quoting_model_1.QuotingModel();
                this.responseModel = result;
                this.responseModel.isTaglioVisible = false;
                this.typePriceResult = "no-tax";
                this.responseModel.valueStampaInternoSoloFronte = false;
                this.responseModel.valueStampaCopertinaSoloFronte = false;
                this.ExcludingRules.setMacrocategory("STAMPA_DIRETTA");
                this.responseModel.isStampaBifaccialeNoHide = false;
                this.responseModel.isStampaBifaccialeSiHide = false;
                if (this.responseModel.isFormatiMultiliEnabled) {
                    this.aggiungiFormatoMultiplo(true);
                }
                if (!this.isDataInitialized) {
                    //check if the all values is validated
                    this.parameterValidation();
                }
                setInterval(function () {
                    if (_this.isDataInitialized) {
                        _this.parameterValidation();
                    }
                }, 300000); //5 minutes
                //this.parameterValidation();},60000); //1 minutes
            };
            ChildComponent.prototype.checkFirstDayForHour = function (priceList) {
                for (var _i = 0, priceList_1 = priceList; _i < priceList_1.length; _i++) {
                    var priceRow = priceList_1[_i];
                    var result = false;
                    if (!priceRow.IsHour) {
                        if (!this.iShowHourForDay) {
                            this.iShowHourForDay = true;
                            result = true;
                        }
                    }
                    priceRow.iShowHourForDay = result;
                }
            };
            ChildComponent.prototype.aggiungiFormatoMultiplo = function (firstLoad) {
                if (firstLoad === void 0) { firstLoad = false; }
                var fileObj = new quoting_submit_model_5.FormatiMultipliObj();
                var lastId = 0;
                if (this.formatiMultipliList.length > 0) {
                    lastId = this.formatiMultipliList.sort(function (x) { return x.Id; }).reverse()[0].Id;
                }
                fileObj.Id = (lastId + 1);
                fileObj.Copie = 1;
                fileObj.Width = parseFloat(this.responseModel.minimoBase + "");
                fileObj.Height = parseFloat(this.responseModel.minimoAltezza + "");
                fileObj.Name = this.getLabel('new_format');
                this.formatiMultipliList.push(fileObj);
                if (!firstLoad) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.deleteFormatoMultiplo = function (id) {
                this.formatiMultipliList.splice(this.formatiMultipliList.findIndex(function (e) { return e.Id === id; }), 1);
            };
            ChildComponent.prototype.openCanvasEditor = function () {
                if (result.CanvasInfo.TemplateImagesFolderPath) {
                    $('html').css("overflow", "hidden");
                    var canvasConfigData = this.setCanvasConfig();
                    // because here we don't have a state id, it is a new product
                    var isStateId = false;
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            };
            ChildComponent.prototype.setCanvasConfig = function () {
                var canvasConfigData = {
                    CanvasUrl: result.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
                    Watermark: result.CanvasInfo.WatermarkText
                };
                return canvasConfigData;
            };
            ChildComponent.prototype.toShowCanvasButton = function () {
                var toShow = false;
                var isModuleActive = false;
                var isUserLoggedIn = false;
                if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
                }
                if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
                    isUserLoggedIn = this.loggedIdUser.isAuthenticated;
                }
                toShow = isModuleActive && isUserLoggedIn ? true : false;
                return toShow;
            };
            ChildComponent.prototype.CheckRegoleStampa = function () {
                try {
                    this.blockquoting = false;
                    //save in the array all parameter value before to apply rules
                    var oldFormato = this.responseModel.idFormati;
                    var oldSupporto = this.responseModel.idSupportiRigidi;
                    var oldTaglio = this.responseModel.idTagli;
                    var lavAccArray = new Array();
                    for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                        var lavorazione = _a[_i];
                        var lav = new quoting_submit_model_1.LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }
                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FORMATO", "STAMPA_DIRETTA", null, null, this.responseModel);
                    //Reset regole supporto rigido
                    this.ExcludingRules.ResetRegole("GF", "SUPPORTO_RIGIDO", "", "", null, null, this.responseModel);
                    //Reset regole stampa bifacciale
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "STAMPA_BIFACCIALE", "", null, null, this.responseModel);
                    //Reset regole stampa bianco coprente
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "BIANCO_COPRENTE", "", null, null, this.responseModel);
                    //Reset regole taglio
                    this.ExcludingRules.ResetRegole("GF", "FINITURA", "FUSTELLATURA", "", null, null, this.responseModel);
                    //Reset regole accessorie
                    this.ExcludingRules.ResetRegole("GF", "ACCESSORIA", "", "STAMPA_DIRETTA", null, null, this.responseModel);
                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FORMATO", "STAMPA_DIRETTA", idFormato, 0, this.responseModel);
                    }
                    if (this.responseModel.tipoBifacciale == "0") {
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "STAMPA_BIFACCIALE", "", "1", 0, this.responseModel);
                    }
                    else if (this.responseModel.tipoBifacciale == "1") {
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "STAMPA_BIFACCIALE", "", "2", 0, this.responseModel);
                    }
                    if (this.responseModel.idBiancoCoprente == "0") {
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "BIANCO_COPRENTE", "", "1", 0, this.responseModel);
                    }
                    else if (this.responseModel.idBiancoCoprente == "1") {
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "BIANCO_COPRENTE", "", "2", 0, this.responseModel);
                    }
                    else if (this.responseModel.idBiancoCoprente == "2") {
                        this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "BIANCO_COPRENTE", "", "3", 0, this.responseModel);
                    }
                    this.ExcludingRules.ApplicaRegole("GF", "SUPPORTO_RIGIDO", "", "", this.responseModel.idSupportiRigidi, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegole("GF", "FINITURA", "FUSTELLATURA", "", this.responseModel.idTagli, 0, this.responseModel);
                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("GF", "STAMPA_DIRETTA", this.responseModel);
                    //if the old value id different to the new one i call the method for update description and image
                    if (oldFormato != this.responseModel.idFormati) {
                        this.onFormatiChange(true);
                    }
                    if (oldSupporto != this.responseModel.idSupportiRigidi) {
                        this.onSuportoChange(true);
                    }
                    if (oldTaglio != this.responseModel.idTagli) {
                        this.onTaglioChange(true);
                    }
                    var count = 0;
                    for (var _b = 0, _c = this.responseModel.lavorazioniAccessorie; _b < _c.length; _b++) {
                        var lavorazione = _c[_b];
                        count = 0;
                        for (var _d = 0, lavAccArray_1 = lavAccArray; _d < lavAccArray_1.length; _d++) {
                            var lavorazioneOld = lavAccArray_1[_d];
                            if (count > 0) {
                                continue;
                            }
                            else {
                                if (lavorazione.tipo == "2") {
                                    if (lavorazione.isVisible == true) {
                                        if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                                            if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                                                this.lavorazioniAccessorieComboChange(lavorazione, true);
                                                count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    this.blockquoting = true;
                    this.showErrorMessage = true;
                    return;
                }
            };
            ChildComponent.prototype.parameterValidation = function () {
                this.iShowHourForDay = false;
                this.isCalculatedWizard = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;
                this.requestInfoSuccess = null;
                //apply all rules
                this.CheckRegoleStampa();
                if (this.responseModel.isFormatiMultiliEnabled) {
                    //check id all data into formatimultipli list is setted
                    this.validationFormatiMultipli();
                }
                else {
                    //verify validation for all  parameters 
                    this.validationCopie();
                    this.validationFormati();
                    if (this.responseModel.idFormati == "0") {
                        this.validationBaseFormati();
                        this.validationAltezzaFormati();
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                    if (this.responseModel.soggettiMultipli == true) {
                        this.validationSoggetti();
                    }
                    else {
                        this.responseModel.soggettiIsValid = true;
                    }
                }
                this.countTagli();
                this.countBiancoCoprente();
                this.validationSupporti();
                this.validationLavorazioneAccessoria();
                if (this.responseModel.ManageAttachment == "Combinazioni") {
                    this.selectFileCombination();
                }
                //if all parameters are validated  call a method who getting price
                if (this.checkValidation()) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel();
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            };
            ChildComponent.prototype.countTagli = function () {
                if (this.responseModel.tagli != null) {
                    this.responseModel.tagliCount = this.responseModel.tagli.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.countBiancoCoprente = function () {
                if (this.responseModel.biancoCoprente != null) {
                    this.responseModel.biancoCoprenteCount = this.responseModel.biancoCoprente.filter(function (x) { return x.isVisible == true; }).length;
                }
            };
            ChildComponent.prototype.selectFileCombination = function () {
                this.listaFile = new Array();
                for (var _i = 0, _a = this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni; _i < _a.length; _i++) {
                    var file = _a[_i];
                    if (this.responseModel.idFormati != null) {
                        var data = this.responseModel.idFormati.split("_");
                        var idFormato = data[0];
                        if (file.FormatId == idFormato) {
                            var fileObj = new quoting_submit_model_4.FileCombinationModel();
                            fileObj.PathFile = file.PathFile;
                            if (file.NomeFile == null || file.NomeFile == "") {
                                fileObj.NomeFile = file.FileName;
                            }
                            else {
                                fileObj.NomeFile = file.NomeFile;
                            }
                            fileObj.PathIstruzioni = file.PathIstruzioni;
                            if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                                fileObj.NomeIstruzioni = file.FileIstructionName;
                            }
                            else {
                                fileObj.NomeIstruzioni = file.NomeIstruzioni;
                            }
                            this.listaFile.push(fileObj);
                        }
                    }
                }
            };
            ChildComponent.prototype.checkZero = function (val) {
                if (val == "" || val == null) {
                    return "0";
                }
                else {
                    return val;
                }
            };
            ChildComponent.prototype.setTypePriceResult = function (type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            };
            ChildComponent.prototype.setListinoScontisticaPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.setListinoPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            };
            ChildComponent.prototype.isRowSelected = function (rowIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelected = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelected = function (columnIndex) {
                var result = false;
                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndex = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            ChildComponent.prototype.clearSelectedIndex = function () {
                this.currentRowIndex = -1;
                this.currentColumnIndex = -1;
            };
            ChildComponent.prototype.isRowSelectedListino = function (rowIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCellSelectedListino = function (rowIndex, columnIndex) {
                var result = false;
                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isColumnSelectedListino = function (columnIndex) {
                var result = false;
                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.setSelectedIndexListino = function (rowIndex, columnIndex) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            };
            // Create model for passed in input to the calculation method
            ChildComponent.prototype.getCalculationModel = function () {
                var _this = this;
                this.model.macrocategoryWizardId = this.responseModel.idGruppo;
                this.model.tipoCopie = this.responseModel.tipoCopie;
                this.model.isFormatoMultiploEnabled = this.responseModel.isFormatiMultiliEnabled;
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                if (this.responseModel.tipoCopie != 'libera') {
                    this.model.idCopie = this.responseModel.idCopie;
                }
                else {
                    this.model.numCopie = this.responseModel.numCopie;
                }
                this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
                this.model.numSoggetti = this.responseModel.numSoggetti;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = this.resourceId;
                this.model.idFormati = this.responseModel.idFormati;
                if (this.responseModel.idFormati == "0") {
                    this.model.baseFormato = this.responseModel.baseFormato;
                    this.model.altezzaFormato = this.responseModel.altezzaFormato;
                }
                this.model.idSupportiRigidi = this.responseModel.idSupportiRigidi;
                if (this.responseModel.stampaBifacciale == 1) {
                    this.model.tipoBifacciale = this.responseModel.tipoBifacciale;
                }
                else {
                    this.model.tipoBifacciale = "0";
                }
                if (this.responseModel.biancoCoprente != null && this.responseModel.biancoCoprente.length > 0) {
                    this.model.idBiancoCoprente = this.responseModel.idBiancoCoprente;
                }
                else {
                    this.model.idBiancoCoprente = "0";
                }
                if (this.responseModel.idTagli != "-1") {
                    this.model.idTagli = this.responseModel.idTagli;
                }
                this.model.listaFormatiMultipli = this.formatiMultipliList;
                this.model.lavorazioniAccessorie = new Array();
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioneAccessoria = _a[_i];
                    var lavorazione = new quoting_submit_model_1.LavorazioniAccessorieModel();
                    if (lavorazioneAccessoria.isVisible == true) {
                        //checkbox
                        if (parseInt(lavorazioneAccessoria.tipo) == 0) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
                            if (lavorazioneAccessoria.valore != "-1") {
                                if (lavorazioneAccessoria.valore != "0") {
                                    lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
                            if (lavorazioneAccessoria.value != null) {
                                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                                if (lavorazioneAccessoria.value != "0") {
                                    lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                                }
                            }
                        }
                        else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
                            lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                            lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                        }
                        if (lavorazione.lavorazioneId != null) {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                }
                this.model.lavorazioniAccessorie.sort(function (a, b) { return 0 - (a > b ? -1 : 1); });
                if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
                    var sub = this._quotingService.getCalculatedWizard(this.model).subscribe(function (result) {
                        _this.resultPrice = result;
                        _this.isCalculatedWizard = true;
                        if (_this.isCalculationTypeCalcolatoScontistica()) {
                            var scontisticaTable = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(scontisticaTable);
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (var i = scontisticaTable.length - 1; i >= 0; i--) {
                                    var price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        _this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            var tableScontisticaPriceListSliced = _this.resultPrice.TableScontisticaPriceList.slice(1);
                            var breakFlag = false;
                            for (var _i = 0, tableScontisticaPriceListSliced_1 = tableScontisticaPriceListSliced; _i < tableScontisticaPriceListSliced_1.length; _i++) {
                                var priceRow = tableScontisticaPriceListSliced_1[_i];
                                var slicedPriceRow = priceRow.slice(1);
                                _this.checkFirstDayForHour(slicedPriceRow);
                                //reverse the obj for select the last data and first price available
                                var reverse = slicedPriceRow.reverse();
                                for (var _a = 0, reverse_1 = reverse; _a < reverse_1.length; _a++) {
                                    var price = reverse_1[_a];
                                    if (price.Price != -1) {
                                        _this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }
                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (_this.isCalculationTypeListino()) {
                            var tableScontisticaPriceListSliced = _this.resultPrice.TablePriceList;
                            _this.checkFirstDayForHour(tableScontisticaPriceListSliced);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                var slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    _this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }
                        _this.resultCalculation = true;
                        _this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    }, function (err) {
                        _this.isCalculatedWizard = true;
                        _this.showErrorMessage = true;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    });
                    this.subManager.add(sub);
                }
                else {
                    this.resultCalculation = true;
                    this.showErrorMessage = false;
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                }
                this.isDataInitialized = true;
            };
            ChildComponent.prototype.ngAfterViewInit = function () {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                $('#quotingFormLoader').hide();
                var $wrapper = $('#listWizard');
                $wrapper.find('.sortable-div ').sort(function (a, b) {
                    return +a.dataset.order - +b.dataset.order;
                }).appendTo($wrapper);
                var altezza = $("#footer").outerHeight();
                var margintop = parseInt($("#footer").css('margin-top'));
                var paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;
                var altezza1 = $(".footerplus").outerHeight() || 0;
                var margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                var paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;
                var altezzaHead = $(".header-body").outerHeight();
                var margintopHead = parseInt($(".header-body").css('margin-bottom'));
                var paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;
                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            };
            ChildComponent.prototype.checkValidation = function () {
                if (this.responseModel.isFormatiMultiliEnabled) {
                    if (this.responseModel.formatiMultipliIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.supportoIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    if (this.responseModel.copieIsValid
                        && this.responseModel.formatiIsValid
                        && this.responseModel.lavorazioniIsValid
                        && this.responseModel.baseFormatoIsValid
                        && this.responseModel.altezzaFormatoIsValid
                        && this.responseModel.soggettiIsValid
                        && this.responseModel.supportoIsValid) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            };
            ChildComponent.prototype.validationBaseFormati = function () {
                var message;
                var base = parseFloat(this.responseModel.baseFormato.replace(",", "."));
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base >= minBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base >= minBase) && (base <= maxBase)) {
                            this.responseModel.baseFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                            this.responseModel.baseFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (base <= 0 || this.responseModel.baseFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.baseFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.baseFormatoIsValid = true;
                    }
                }
                this.responseModel.baseFormatoMessage = message;
            };
            ChildComponent.prototype.validationAltezzaFormati = function () {
                var message;
                var altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."));
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if ((altezza >= minAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
                            this.responseModel.altezzaFormatoIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                            this.responseModel.altezzaFormatoIsValid = false;
                        }
                    }
                }
                else {
                    if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + 0;
                        this.responseModel.altezzaFormatoIsValid = false;
                    }
                    else {
                        this.responseModel.altezzaFormatoIsValid = true;
                    }
                }
                this.responseModel.altezzaFormatoMessage = message;
            };
            ChildComponent.prototype.validationSoggetti = function () {
                var message;
                var numSoggetti = parseInt(this.responseModel.numSoggetti);
                if (this.responseModel.numSoggetti == null) {
                    message = this.getLabel('inserisci_valore_valido');
                    this.responseModel.soggettiIsValid = false;
                }
                else if (numSoggetti == 0) {
                    message = this.getLabel('inserisci_valore_maggiore_0');
                    this.responseModel.soggettiIsValid = false;
                }
                else {
                    this.responseModel.soggettiIsValid = true;
                }
                this.responseModel.soggettiMessage = message;
            };
            ChildComponent.prototype.validationCopie = function () {
                var message;
                if (this.responseModel.tipoCopie == 'libera') {
                    var numCopie = parseInt(this.responseModel.numCopie);
                    var minCopie = this.responseModel.minimoCopie;
                    var maxCopie = this.responseModel.massimoCopie;
                    if (this.responseModel.numCopie == null) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.responseModel.copieIsValid = false;
                    }
                    else if (maxCopie == 0) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.responseModel.copieIsValid = false;
                        }
                        else {
                            this.responseModel.copieIsValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.responseModel.copieIsValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.responseModel.copieIsValid = false;
                        }
                    }
                }
                else {
                    if (this.responseModel.idCopie == "-1") {
                        message = this.getLabel('mandatory_field');
                        this.responseModel.copieIsValid = false;
                    }
                    else {
                        this.responseModel.copieIsValid = true;
                    }
                    if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
                        this.responseModel.copieCount = this.responseModel.copie.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.copieMessage = message;
            };
            ChildComponent.prototype.validationFormati = function () {
                var message;
                if (this.responseModel.idFormati == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.formatiIsValid = false;
                }
                else {
                    this.responseModel.formatiIsValid = true;
                }
                if (this.responseModel.formati != null) {
                    this.responseModel.formatiCount = this.responseModel.formati.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.formatiMessage = message;
            };
            ChildComponent.prototype.validationBaseFormatiMultipli = function (baseInput) {
                var message = "";
                var base = parseFloat(baseInput);
                var minBase = this.responseModel.minimoBase;
                var maxBase = this.responseModel.massimoBase;
                if (base <= 0 || baseInput == "" || baseInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minBase > 0 || maxBase > 0) {
                    if (minBase > 0 && maxBase == 0) {
                        if ((base < minBase)) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minBase;
                        }
                    }
                    else if (minBase == 0 && maxBase > 0) {
                        if ((base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                    else if (minBase > 0 && maxBase > 0) {
                        if ((base < minBase) || (base > maxBase)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minBase;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxBase;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationAltezzaFormatiMultipli = function (altezzaInput) {
                var message = "";
                var altezza = parseFloat(altezzaInput);
                var minAltezza = this.responseModel.minimoAltezza;
                var maxAltezza = this.responseModel.massimoAltezza;
                if (altezza <= 0 || altezzaInput == "" || altezzaInput == null) {
                    message = this.getLabel('inserisci_valore_maggiore');
                    message += " " + 0;
                }
                else if (minAltezza > 0 || maxAltezza > 0) {
                    if (minAltezza > 0 && maxAltezza == 0) {
                        if (altezza < minAltezza) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minAltezza;
                        }
                    }
                    else if (minAltezza == 0 && maxAltezza > 0) {
                        if ((altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                    else if (minAltezza > 0 && maxAltezza > 0) {
                        if ((altezza < minAltezza) || (altezza > maxAltezza)) {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minAltezza;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxAltezza;
                        }
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationCopieFormatiMultipli = function (copieInput) {
                var message = "";
                var numCopie = parseInt(copieInput);
                var minCopie = this.responseModel.minimoCopie;
                var maxCopie = this.responseModel.massimoCopie;
                if (numCopie <= 0 || copieInput == "" || copieInput == null) {
                    message = this.getLabel('inserisci_valore_valido');
                }
                else if (maxCopie == 0) {
                    if (numCopie < minCopie) {
                        message = this.getLabel('inserisci_valore_maggiore');
                        message += " " + minCopie;
                    }
                }
                else {
                    if ((numCopie < minCopie) || (numCopie > maxCopie)) {
                        message = this.getLabel('inserisci_valore_compreso_tra');
                        message += " " + minCopie;
                        message += " " + this.getLabel('inserisci_valore_compreso_e');
                        message += " " + maxCopie;
                    }
                }
                return message;
            };
            ChildComponent.prototype.validationFormatiMultipli = function () {
                var _this = this;
                this.responseModel.formatiMultipliIsValid = true;
                console.log(this.formatiMultipliList);
                this.formatiMultipliList.forEach(function (x) {
                    var copieMessage = _this.validationCopieFormatiMultipli(x.Copie);
                    if (copieMessage == "") {
                        x.copieIsValid = true;
                        x.copieMessage = "";
                    }
                    else {
                        x.copieIsValid = false;
                        x.copieMessage = copieMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var heighMessage = _this.validationAltezzaFormatiMultipli(x.Height);
                    if (heighMessage == "") {
                        x.heightIsValid = true;
                        x.heightMessage = "";
                    }
                    else {
                        x.heightIsValid = false;
                        x.heightMessage = heighMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                    var widthMessage = _this.validationBaseFormatiMultipli(x.Width);
                    if (widthMessage == "") {
                        x.widthIsValid = true;
                        x.widthMessage = "";
                    }
                    else {
                        x.widthIsValid = false;
                        x.widthMessage = widthMessage;
                        _this.responseModel.formatiMultipliIsValid = false;
                    }
                });
            };
            ChildComponent.prototype.validationSupporti = function () {
                var message;
                if (this.responseModel.idSupportiRigidi == "-1") {
                    message = this.getLabel('mandatory_field');
                    this.responseModel.supportoIsValid = false;
                }
                else {
                    this.responseModel.supportoIsValid = true;
                }
                if (this.responseModel.supportiRigidi != null) {
                    this.responseModel.supportiRigidiCount = this.responseModel.supportiRigidi.filter(function (x) { return x.isVisible == true; }).length;
                }
                this.responseModel.supportoMessage = message;
            };
            ChildComponent.prototype.validationLavorazioneAccessoria = function () {
                var message = "";
                var valid = true;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazione = _a[_i];
                    if (lavorazione.tipo == "2" && lavorazione.isVisible) {
                        if (lavorazione.obbligatorio == true) {
                            if (lavorazione.valore == "-1") {
                                message = this.getLabel('mandatory_field');
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    //check min qta  and max qta  for input field
                    if (lavorazione.tipo == "1" && lavorazione.isVisible) {
                        var qta = parseInt(lavorazione.value);
                        var minQta = lavorazione.minQtaInput;
                        var maxQta = lavorazione.maxQtaInput;
                        if (lavorazione.value == null) {
                            message = this.getLabel('inserisci_valore_valido');
                            lavorazione.isValid = false;
                            valid = false;
                        }
                        else if (maxQta == 0) {
                            if (qta < minQta) {
                                message = this.getLabel('inserisci_valore_maggiore');
                                message += " " + minQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                            else {
                                lavorazione.isValid = true;
                            }
                        }
                        else {
                            if ((qta >= minQta) && (qta <= maxQta)) {
                                lavorazione.isValid = true;
                            }
                            else {
                                message = this.getLabel('inserisci_valore_compreso_tra');
                                message += " " + minQta;
                                message += " " + this.getLabel('inserisci_valore_compreso_e');
                                message += " " + maxQta;
                                lavorazione.isValid = false;
                                valid = false;
                            }
                        }
                        lavorazione.lavorazioneMessage = message;
                    }
                    if (lavorazione.valori != null) {
                        lavorazione.valoriCount = lavorazione.valori.filter(function (x) { return x.isVisible == true; }).length;
                    }
                }
                this.responseModel.lavorazioniIsValid = valid;
            };
            ChildComponent.prototype.getLabel = function (label) {
                var message;
                var sub = this.translate.get(label, this.translate).subscribe(function (res) {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            };
            ChildComponent.prototype.isAttributeFixed = function (tipoLavorazione) {
                var result = false;
                if (tipoLavorazione == 'fisso') {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaCheckShowed = function (tipo, tipoSelezione, isVisible) {
                var result = false;
                if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaNumericShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 1 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaTextAreaShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 6 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.textAreaCheck = function (event) {
                if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
                    return false;
                }
                return true;
            };
            ChildComponent.prototype.InputNumberCheck = function (event) {
                var result = false;
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaComboShowed = function (tipo, selectedValue, lavId) {
                var result = false;
                var isVisible = false;
                for (var _i = 0, _a = this.responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
                    var lavorazioniAccessorie = _a[_i];
                    if (lavorazioniAccessorie.id == lavId) {
                        isVisible = lavorazioniAccessorie.isVisible;
                    }
                }
                if (tipo == 2 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.checkIsLavorazioneAccessoriaDescrittivoShowed = function (tipo, isVisible) {
                var result = false;
                if (tipo == 5 && isVisible) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.onFormatiChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.formati; _i < _a.length; _i++) {
                    var formato = _a[_i];
                    if (formato.chiave == this.responseModel.idFormati) {
                        this.responseModel.formatoDescription = formato.descrizione;
                        this.responseModel.formatoImage = formato.image;
                        this.responseModel.formatiHasInfo = formato.hasInfo;
                        this.responseModel.formatiShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onFormatiVisualChange = function (formatId) {
                this.responseModel.idFormati = formatId;
                this.onFormatiChange();
            };
            ChildComponent.prototype.onSuportoChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.supportiRigidi; _i < _a.length; _i++) {
                    var supporto = _a[_i];
                    if (supporto.chiave == this.responseModel.idSupportiRigidi) {
                        this.responseModel.supportoDescription = supporto.descrizione;
                        this.responseModel.supportoImage = supporto.image;
                        this.responseModel.supportoHasInfo = supporto.hasInfo;
                        this.responseModel.supportoShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onSuportoVisualChange = function (supportoId) {
                this.responseModel.idSupportiRigidi = supportoId;
                this.onSuportoChange();
            };
            ChildComponent.prototype.onTaglioChange = function (isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = this.responseModel.tagli; _i < _a.length; _i++) {
                    var taglio = _a[_i];
                    if (taglio.chiave == this.responseModel.idTagli) {
                        this.responseModel.taglioDescription = taglio.descrizione;
                        this.responseModel.taglioImage = taglio.image;
                        this.responseModel.taglioHasInfo = taglio.hasInfo;
                        this.responseModel.taglioShowInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.onTaglioVisualChange = function (taglioId) {
                this.responseModel.idTagli = taglioId;
                this.onTaglioChange();
            };
            ChildComponent.prototype.lavorazioniAccessorieComboChange = function (lavorazione, isrules) {
                if (isrules === void 0) { isrules = false; }
                for (var _i = 0, _a = lavorazione.valori; _i < _a.length; _i++) {
                    var variante = _a[_i];
                    if (lavorazione.valore == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;
                    }
                }
                if (isrules == false) {
                    this.parameterValidation();
                }
            };
            ChildComponent.prototype.lavorazioniAccessorieComboVisualChange = function (lavorazioneId, lavorazione) {
                lavorazione.valore = lavorazioneId;
                this.lavorazioniAccessorieComboChange(lavorazione);
            };
            ChildComponent.prototype.checkIsBifaccialeShowed = function () {
                var result = false;
                if (this.responseModel.stampaBifacciale == 1 &&
                    (this.responseModel.isStampaBifaccialeNoHide == false || this.responseModel.isStampaBifaccialeSiHide == false)) {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.showHideLavDescription = function (lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }
                else {
                    lavorazione.showInfo = true;
                }
            };
            ChildComponent.prototype.showHideFormatDescription = function () {
                if (this.responseModel.formatiShowInfo) {
                    this.responseModel.formatiShowInfo = false;
                }
                else {
                    this.responseModel.formatiShowInfo = true;
                }
            };
            ChildComponent.prototype.showHideSupportoDescription = function () {
                if (this.responseModel.supportoShowInfo) {
                    this.responseModel.supportoShowInfo = false;
                }
                else {
                    this.responseModel.supportoShowInfo = true;
                }
            };
            ChildComponent.prototype.showHidePlastficationInternoDescription = function () {
                if (this.responseModel.plastificazioni1ShowInfo) {
                    this.responseModel.plastificazioni1ShowInfo = false;
                }
                else {
                    this.responseModel.plastificazioni1ShowInfo = true;
                }
            };
            ChildComponent.prototype.isCalculationTypeCalcolato = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeCalcolatoQuotigPrev = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListino = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.isCalculationTypeListinoScontistica = function () {
                var result = false;
                if (this.responseModel.calculationType == "listino_scontistica") {
                    result = true;
                }
                return result;
            };
            ChildComponent.prototype.addToCartWizardCalcolato = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardCalcolatoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    _this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListino = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.addToCartWizardListinoScontistica = function (quantityId) {
                var _this = this;
                var wizardId = this.resourceId;
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                var colType = this.resultPrice.IsHour == true ? "H" : "D";
                var sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(function (result) {
                    _this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("productAddedToCart");
                    _this.resultCalculation = true;
                }, function (err) {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    _this.bootboxService.i18nAlert("errorMex");
                    _this.resultCalculation = true;
                });
                this.subManager.add(sub);
            };
            ChildComponent.prototype.setPriceResult = function (price) {
                if (price.Price == -1) {
                    return;
                }
                //Deselecting the current price and selected the one passed in input
                for (var _i = 0, _a = this.resultPrice.TablePriceList; _i < _a.length; _i++) {
                    var prices = _a[_i];
                    prices.IsSelected = false;
                }
                price.IsSelected = true;
                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;
                this.resultPrice.IsHour = price.IsHour;
                this.resultPrice.TimePickup = price.TimePickup;
                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.TotalAmount = price.Total;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
                this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
                this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
            };
            ChildComponent.prototype.isCustomerLoggedIn = function () {
                return this.loggedIdUser.isAuthenticated;
            };
            ChildComponent.prototype.checkEmailIsValid = function () {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            };
            ChildComponent.prototype.checkFormRichiestaPrevIsValid = function () {
                var result = false;
                if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }
                return result;
            };
            ChildComponent.prototype.sendRequestInfo = function () {
                var _this = this;
                if (this.checkFormRichiestaPrevIsValid()) {
                    this.resultCalculation = false;
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    var sub = this._quotingService.sendRequestInfo(this.model).subscribe(function (result) {
                        if (result == true) {
                            _this.requestInfoSuccess = true;
                        }
                        else {
                            _this.requestInfoSuccess = false;
                        }
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    }, function (err) {
                        _this.requestInfoSuccess = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        _this.resultCalculation = true;
                    });
                    this.subManager.add(sub);
                }
            };
            ChildComponent.prototype.ngAfterViewChecked = function () {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                layoutTheme.initToggle();
                this.pageIsInitAfter = true;
            };
            ChildComponent.prototype.ngOnDestroy = function () {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            };
            ChildComponent = __decorate([
                core_1.Component({
                    template: result.templateHtml
                }),
                __param(7, core_1.Inject('isBrowser')), 
                __metadata('design:paramtypes', [(typeof (_a = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _a) || Object, (typeof (_b = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object, (typeof (_f = typeof routes_service_1.RoutesService !== 'undefined' && routes_service_1.RoutesService) === 'function' && _f) || Object, (typeof (_g = typeof bootbox_service_1.BootboxService !== 'undefined' && bootbox_service_1.BootboxService) === 'function' && _g) || Object, Boolean, (typeof (_h = typeof customerscanvas_service_1.CustomersCanvasService !== 'undefined' && customerscanvas_service_1.CustomersCanvasService) === 'function' && _h) || Object])
            ], ChildComponent);
            return ChildComponent;
            var _a, _b, _c, _d, _e, _f, _g, _h;
        }());
        return ChildComponent;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], WizardStampaComponent.prototype, "resourceId", void 0);
    WizardStampaComponent = __decorate([
        core_1.Component({
            selector: "dy-wizard-stampa-widget",
            template: ""
        }),
        __param(6, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.Compiler !== 'undefined' && core_1.Compiler) === 'function' && _a) || Object, (typeof (_b = typeof component_helper_service_1.ComponentHelperService !== 'undefined' && component_helper_service_1.ComponentHelperService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _c) || Object, (typeof (_d = typeof quoting_service_1.QuotingService !== 'undefined' && quoting_service_1.QuotingService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _f) || Object, Boolean])
    ], WizardStampaComponent);
    return WizardStampaComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.WizardStampaComponent = WizardStampaComponent;


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var category_component_1 = __webpack_require__(389);
var InventoryCategoryModule = (function () {
    function InventoryCategoryModule() {
    }
    InventoryCategoryModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule
            ],
            declarations: [
                category_component_1.CategoryComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], InventoryCategoryModule);
    return InventoryCategoryModule;
}());
exports.InventoryCategoryModule = InventoryCategoryModule;


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var other_product_component_1 = __webpack_require__(390);
var product_page_list_component_1 = __webpack_require__(392);
var promotions_component_1 = __webpack_require__(393);
var product_details_component_1 = __webpack_require__(391);
var InventoryProductModule = (function () {
    function InventoryProductModule() {
    }
    InventoryProductModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule
            ],
            declarations: [
                other_product_component_1.OtherProductComponent,
                product_page_list_component_1.ProductPageListComponent,
                promotions_component_1.PromotionsComponent,
                product_details_component_1.ProductDetailsComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], InventoryProductModule);
    return InventoryProductModule;
}());
exports.InventoryProductModule = InventoryProductModule;


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(86);
var register_component_1 = __webpack_require__(407);
var SettingsModule = (function () {
    function SettingsModule() {
    }
    SettingsModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule
            ],
            declarations: [
                register_component_1.RegisterComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SettingsModule);
    return SettingsModule;
}());
exports.SettingsModule = SettingsModule;


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Breadcrumbs = (function () {
    function Breadcrumbs() {
    }
    return Breadcrumbs;
}());
exports.Breadcrumbs = Breadcrumbs;


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var InfoRequest = (function () {
    function InfoRequest() {
    }
    return InfoRequest;
}());
exports.InfoRequest = InfoRequest;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var currency_service_1 = __webpack_require__(29);
var shopping_cart_service_1 = __webpack_require__(20);
var ClientAreaService = (function () {
    function ClientAreaService(_api, _cache, languageService, currencyService, mappings, ShoppingCartService) {
        this._api = _api;
        this._cache = _cache;
        this.languageService = languageService;
        this.currencyService = currencyService;
        this.mappings = mappings;
        this.ShoppingCartService = ShoppingCartService;
    }
    ClientAreaService.prototype.getDetailsClientArea = function (id) {
        var cartId = this.ShoppingCartService.getCartId();
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Client_Area_Details.replace('{id}', id.toString()).replace('{lang}', lang).replace('{cartid}', cartId);
        var key = url;
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.getUserAreaProfile = function (userId) {
        var lang = this.languageService.getLongLang();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Get_Client_Area_User_Profile.replace('{userId}', userId).replace('{lang}', lang).replace('{cartid}', cartId);
        var key = url;
        return this._api.get(url);
    };
    ClientAreaService.prototype.updateUserPassword = function (param) {
        param.Language = this.languageService.getLongLang();
        return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Password, param)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.updateUserProfile = function (collection) {
        return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Profile, collection)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.addNewAddress = function (param) {
        return this._api.post(this.mappings.Web_Api_Post_Client_Area_Add_New_Address, param)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.updateAddresses = function (addresses, userId, defaultAddress) {
        var param = {
            Addresses: addresses,
            UserId: userId,
            DefaultAddress: defaultAddress
        };
        return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Address, param)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.removeAddress = function (param) {
        return this._api.post(this.mappings.Web_Api_Post_Client_Area_Remove_Address, param)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.getClientAreaOrderDetails = function (userId, orderId) {
        var cartId = this.ShoppingCartService.getCartId();
        var lang = this.languageService.getLongLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Client_Area_Order_Details.replace('{userId}', userId).replace('{orderId}', orderId.toString()).replace('{lang}', lang).replace('{currency}', curr).replace("{cartid}", cartId);
        var key = url;
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.getClientAreaCatalogPrivate = function (userId) {
        var cartId = this.ShoppingCartService.getCartId();
        var lang = this.languageService.getLongLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Client_Area_Catalog_Private
            .replace('{userId}', userId)
            .replace('{lang}', lang)
            .replace('{currency}', curr)
            .replace("{cartid}", cartId);
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.getClientAreaOrdersList = function (userId, dateFrom, dateTo, orderNumber, orderStatus) {
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Client_Area_Order_List.replace('{userId}', userId.toString()).replace('{dateFrom}', dateFrom.toTimeString()).replace('{dateTo}', dateTo.toTimeString()).replace('{orderNumber}', orderNumber).replace('{orderStatus}', orderStatus).replace('{currency}', curr);
        var key = url;
        return this._api.get(url);
    };
    ClientAreaService.prototype.getClientAreaOrdersList1 = function (userId, dateFrom, dateTo, orderNumber, orderStatus) {
        var cartId = this.ShoppingCartService.getCartId();
        var curr = this.currencyService.getCurrency();
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Client_Area_Order_List
            .replace('{userId}', userId).replace('{dateFrom}', dateFrom)
            .replace('{dateTo}', dateTo).replace('{orderNumber}', orderNumber)
            .replace('{orderStatus}', orderStatus).replace('{lang}', lang)
            .replace('{currency}', curr).replace('{cartid}', cartId);
        var key = url;
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.getClientAreaRiorderList = function (orderId) {
        var curr = this.currencyService.getCurrency();
        var lang = this.languageService.getLongLang();
        var url = this.mappings.Web_Api_Get_Client_Area_Riorder_List
            .replace('{orderid}', orderId)
            .replace('{lang}', lang)
            .replace('{currency}', curr);
        var key = url;
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.CalculatePriceRiorder = function (lavorazioneQuery, prodId) {
        // let parameter: Array<any> = [];
        var lang = this.languageService.getLongLang();
        var dictionary = {
            "lang": lang,
            "query": lavorazioneQuery,
            "wizardId": prodId,
        };
        return this._api.post(this.mappings.Web_Api_Get_Client_Area_CalculatePrice_Riorder, dictionary)
            .do(function (result) { return result; })
            .share();
    };
    ClientAreaService.prototype.getClientAreaInvoicesList = function (userId, orderNumber, invoiceNumber, documentType) {
        var curr = this.currencyService.getCurrency();
        var lang = this.languageService.getLongLang();
        var cartId = this.ShoppingCartService.getCartId();
        var url = this.mappings.Web_Api_Get_Client_Area_Invoices.replace('{userId}', userId).replace('{orderNumber}', orderNumber).replace('{invoiceNumber}', invoiceNumber).replace('{documentType}', documentType).replace('{lang}', lang).replace('{currency}', curr).replace('{cartid}', cartId);
        var key = url;
        return this._api.getUniversalCached(url);
    };
    ClientAreaService.prototype.postClientAreaSendProcessOrderMessageint = function (userId, orderId, orderRowId, orderNumber, sendTo, messageObject, message, lang) {
        var url = this.mappings.Web_Api_Get_Client_Area_Order_Send_Message;
        var params = {
            UserId: userId,
            OrderId: orderId,
            OrderRowId: orderRowId,
            OrderNumber: orderNumber,
            SendTo: sendTo,
            MessageObject: messageObject,
            Message: message,
            Lang: lang
        };
        return this._api.post(url, params);
    };
    ClientAreaService.prototype.getProcessOrderFiles = function (processId, orderId) {
        var url = this.mappings.Web_Api_Get_Client_Area_Proccess_Order_File;
        var params = {
            ProcessId: processId,
            OrderId: orderId
        };
        return this._api.post(url, params);
    };
    ClientAreaService.prototype.cancelOrders = function (userId, orderId) {
        var url = this.mappings.Web_Api_Post_Cancel_Order.replace('{userId}', userId).replace('{orderId}', orderId.toString());
        return this._api.post(url);
    };
    ClientAreaService.prototype.updateBonificoPaymentDetails = function (orderId, numeroCro, numeroTrn) {
        var url = this.mappings.Web_Api_Get_Client_Area_Update_Bonifico_Payment;
        var params = {
            IdOrder: orderId,
            numeroCro: numeroCro,
            numeroTrn: numeroTrn
        };
        return this._api.post(url, params);
    };
    ClientAreaService.prototype.getBonificoUploadedFiles = function (orderId) {
        var url = this.mappings.Web_Api_Post_Get_Bonifico_Uploaded_Files;
        var params = {
            OrderId: orderId
        };
        return this._api.post(url, params);
    };
    ClientAreaService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _d) || Object, (typeof (_e = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _e) || Object, (typeof (_f = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _f) || Object])
    ], ClientAreaService);
    return ClientAreaService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ClientAreaService = ClientAreaService;


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QuotingConstants = (function () {
    function QuotingConstants() {
    }
    ;
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO = "calcolato";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_SCONTISTICA = "calcolato_scontistica";
    QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO = "listino";
    QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO_SCONTISTICA = "listino_scontistica";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO = "calcolato_richiesta_preventivo";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO = "calcolato_listino_standard";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_SCONTISTICA = "calcolato_listino_scontistica";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI = "calcolato_listino_fornitori";
    QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI_SCONTISTICA = "calcolato_listino_fornitori_scontistica";
    return QuotingConstants;
}());
exports.QuotingConstants = QuotingConstants;


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SharedConstants = (function () {
    function SharedConstants() {
    }
    SharedConstants.OTHER_PRODUCTS_TYPE = "ALTRO_PRODOTTO";
    return SharedConstants;
}());
exports.SharedConstants = SharedConstants;


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(7);
var cookie_options_1 = __webpack_require__(420);
var CookieBrowserService = (function () {
    function CookieBrowserService(document) {
        this.document = document;
    }
    CookieBrowserService.prototype.setOptions = function (options) {
        this.defaultOptions = new cookie_options_1.CookieOptions(options);
    };
    CookieBrowserService.prototype.get = function (key) {
        return this.cookieReader()[key];
    };
    CookieBrowserService.prototype.getObject = function (key) {
        var value = this.get(key);
        return value ? JSON.parse(value) : value;
    };
    CookieBrowserService.prototype.getAll = function () {
        return this.cookieReader();
    };
    CookieBrowserService.prototype.put = function (key, value, options) {
        this.cookieWriter()(key, value, options);
    };
    CookieBrowserService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    CookieBrowserService.prototype.remove = function (key, options) {
        this.cookieWriter()(key, undefined, options);
    };
    CookieBrowserService.prototype.removeAll = function () {
        var _this = this;
        var cookies = this.getAll();
        Object.keys(cookies).forEach(function (key) {
            _this.remove(key);
        });
    };
    CookieBrowserService.prototype.cookieReader = function () {
        var rawDocument = this.document;
        var lastCookies = {};
        var lastCookieString = '';
        var that = this;
        var cookieArray, cookie, i, index, name;
        var currentCookieString = rawDocument.cookie || '';
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookieArray.length; i++) {
                cookie = cookieArray[i];
                index = cookie.indexOf('=');
                if (index > 0) {
                    name = that.safeDecodeURIComponent(cookie.substring(0, index));
                    if (this.isBlank(lastCookies[name])) {
                        lastCookies[name] = that.safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
        }
        return lastCookies;
    };
    CookieBrowserService.prototype.cookieWriter = function () {
        var that = this;
        var rawDocument = this.document;
        return function (name, value, options) {
            rawDocument.cookie = that.buildCookieString(name, value, options);
        };
    };
    CookieBrowserService.prototype.safeDecodeURIComponent = function (str) {
        try {
            return decodeURIComponent(str);
        }
        catch (e) {
            return str;
        }
    };
    CookieBrowserService.prototype.buildCookieString = function (name, value, options) {
        var cookiePath = '/';
        var path, expires;
        var defaultOpts = this.defaultOptions || new cookie_options_1.CookieOptions({ path: cookiePath });
        var opts = this.mergeOptions(defaultOpts, options);
        expires = opts.expires;
        if (this.isBlank(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
        }
        if (this.isString(expires)) {
            expires = new Date(expires);
        }
        var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? ';path=' + opts.path : '';
        str += opts.domain ? ';domain=' + opts.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += opts.secure ? ';secure' : '';
        var cookieLength = str.length + 1;
        if (cookieLength > 4096) {
            console.log("Cookie '" + name + "' possibly not set or overflowed because it was too \n      large (" + cookieLength + " > 4096 bytes)!");
        }
        return str;
    };
    CookieBrowserService.prototype.mergeOptions = function (defaultOpts, providedOpts) {
        var newOpts = defaultOpts;
        if (this.isPresent(providedOpts)) {
            return newOpts.merge(new cookie_options_1.CookieOptions(providedOpts));
        }
        return newOpts;
    };
    CookieBrowserService.prototype.isBlank = function (obj) {
        return obj === undefined || obj === null;
    };
    CookieBrowserService.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    CookieBrowserService.prototype.isString = function (obj) {
        return typeof obj === 'string';
    };
    CookieBrowserService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Object])
    ], CookieBrowserService);
    return CookieBrowserService;
}());
exports.CookieBrowserService = CookieBrowserService;


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var CookieNodeService = (function () {
    function CookieNodeService(req, res) {
        this.req = req;
        this.res = res;
    }
    Object.defineProperty(CookieNodeService.prototype, "cookies", {
        get: function () {
            return this.req.cookies;
        },
        enumerable: true,
        configurable: true
    });
    CookieNodeService.prototype.setOptions = function (options) {
        this.defaultOptions = Object.assign(options);
    };
    CookieNodeService.prototype.get = function (key) {
        return this.cookies[key];
    };
    CookieNodeService.prototype.getObject = function (key) {
        var value = this.get(key);
        var obj = value ? JSON.parse(value) : value;
        return obj;
    };
    CookieNodeService.prototype.getAll = function () {
        return this.cookies;
    };
    CookieNodeService.prototype.put = function (key, value, options) {
        options = this.generateOptions();
        this.res.cookie(key, value, options);
    };
    CookieNodeService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    CookieNodeService.prototype.remove = function (key, options) {
        options = this.generateOptions();
        this.res.clearCookie(key, options);
    };
    CookieNodeService.prototype.removeAll = function () {
        this.res.clearCookie();
    };
    CookieNodeService.prototype.generateOptions = function (options) {
        return Object.assign({}, options, { path: '/' }, this.defaultOptions);
    };
    CookieNodeService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject('req')),
        __param(1, core_1.Inject('res')), 
        __metadata('design:paramtypes', [Object, Object])
    ], CookieNodeService);
    return CookieNodeService;
}());
exports.CookieNodeService = CookieNodeService;


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(95);
var DefaultRequestOptions = (function (_super) {
    __extends(DefaultRequestOptions, _super);
    function DefaultRequestOptions() {
        _super.apply(this, arguments);
        this.headers = new http_1.Headers({
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    DefaultRequestOptions = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], DefaultRequestOptions);
    return DefaultRequestOptions;
}(http_1.BaseRequestOptions));
exports.DefaultRequestOptions = DefaultRequestOptions;


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var LoadingOverlayService = (function () {
    function LoadingOverlayService(isBrowser) {
        this.isBrowser = isBrowser;
    }
    LoadingOverlayService.prototype.showPageLoadingOverlay = function () {
        if (this.isBrowser) {
            jQuery('body').addClass('loading-overlay-showing');
        }
    };
    LoadingOverlayService.prototype.hidePageLoadingOverlay = function () {
        if (this.isBrowser) {
            jQuery('body').removeClass('loading-overlay-showing');
        }
    };
    LoadingOverlayService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject('isBrowser')), 
        __metadata('design:paramtypes', [Boolean])
    ], LoadingOverlayService);
    return LoadingOverlayService;
}());
exports.LoadingOverlayService = LoadingOverlayService;


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var user_login_1 = __webpack_require__(73);
var LocalStorageService = (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.Write = function (key, value) {
        if (value) {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    };
    LocalStorageService.prototype.Read = function (key) {
        var value = localStorage.getItem(key);
        if (value && value != "undefined" && value != "null") {
            var userLoginParsed = Helper.toInstance(new user_login_1.UserLogin(), JSON.parse(value));
            return userLoginParsed;
        }
        return null;
    };
    LocalStorageService.prototype.Remove = function (key) {
        localStorage.removeItem(key);
    };
    LocalStorageService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], LocalStorageService);
    return LocalStorageService;
}());
exports.LocalStorageService = LocalStorageService;
var Helper = (function () {
    function Helper() {
    }
    Helper.toInstance = function (obj, json) {
        var jsonObj = JSON.parse(json);
        if (typeof obj["fromJSON"] === "function") {
            obj["fromJSON"](jsonObj);
        }
        else {
            for (var propName in jsonObj) {
                obj[propName] = jsonObj[propName];
            }
        }
        return obj;
    };
    return Helper;
}());


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(12);
var common_1 = __webpack_require__(44);
var core_2 = __webpack_require__(27);
var routes_service_1 = __webpack_require__(5);
var cookie_1 = __webpack_require__(85);
var cache_service_1 = __webpack_require__(21);
var RoutesBrowserService = (function (_super) {
    __extends(RoutesBrowserService, _super);
    function RoutesBrowserService(router, translate, cookie, location, cache) {
        _super.call(this, router, translate, cookie, location, true, cache);
        this.router = router;
        this.translate = translate;
        this.cookie = cookie;
        this.location = location;
        this.cache = cache;
        this.browserLangs = RoutesBrowserService.getBrowserLangs();
    }
    RoutesBrowserService.prototype.loadRoutes = function () {
        var lang = this.getLang();
        var requestUrl = "/assets/i18n-routes/" + lang + ".json";
        var rawRoutes = this.cache.get(requestUrl);
        var routes = this.getRoutesWithComponents(rawRoutes);
        this.router.resetConfig(routes);
        this.cache.set(requestUrl, rawRoutes);
        this.cookie.put(routes_service_1.RoutesService.COOKIE_LANG_KEY, lang);
    };
    RoutesBrowserService.getBrowserLangs = function () {
        var browserLangs = window.navigator['languages'] || null;
        browserLangs = browserLangs ||
            (window.navigator.language && [window.navigator.language]) ||
            (window.navigator['browserLanguage'] && [window.navigator['browserLanguage']]) ||
            (window.navigator['userLanguage'] && [window.navigator['userLanguage']]);
        return browserLangs.map(function (lang) {
            if (lang.indexOf('-') !== -1) {
                return lang.split('-')[0];
            }
            if (lang.indexOf('_') !== -1) {
                return lang.split('_')[0];
            }
            return lang;
        });
    };
    RoutesBrowserService.prototype.getRoutes = function () {
        var lang = this.getLang();
        var requestUrl = "/assets/i18n-routes/" + lang + ".json";
        var rawRoutes = this.cache.get(requestUrl);
        return rawRoutes;
    };
    RoutesBrowserService = __decorate([
        core_1.Injectable(),
        __param(2, core_1.Inject('CookieService')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof core_2.TranslateService !== 'undefined' && core_2.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof cookie_1.CookieService !== 'undefined' && cookie_1.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _d) || Object, (typeof (_e = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _e) || Object])
    ], RoutesBrowserService);
    return RoutesBrowserService;
    var _a, _b, _c, _d, _e;
}(routes_service_1.RoutesService));
exports.RoutesBrowserService = RoutesBrowserService;


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(630));


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(436);
var TranslateStaticLoader = (function () {
    function TranslateStaticLoader(http, application) {
        this.http = http;
        this.application = application;
    }
    TranslateStaticLoader.prototype.getTranslation = function (lang) {
        var _this = this;
        if (!this.observable$) {
            var appConfig = this.application.getConfig();
            var templateName = appConfig.template;
            this.observable$ = this.http
                .get("/template/b2c/" + templateName + "/translations/" + lang + ".json")
                .finally(function () { return _this.observable$ = null; });
        }
        return this.observable$;
    };
    return TranslateStaticLoader;
}());
exports.TranslateStaticLoader = TranslateStaticLoader;


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
function hashCodeString(str) {
    var hash = 0;
    if (str.length === 0) {
        return hash + '';
    }
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash + '';
}
exports.hashCodeString = hashCodeString;
// domain/feature service
var ModelService = (function () {
    // This is only one example of one Model depending on your domain
    function ModelService(_api, _cache) {
        this._api = _api;
        this._cache = _cache;
    }
    /**
     * whatever domain/feature method name
     */
    ModelService.prototype.get = function (url) {
        var _this = this;
        // you want to return the cache if there is a response in it.
        // This would cache the first response so if your API isn't idempotent
        // you probably want to remove the item from the cache after you use it. LRU of 10
        // you can use also hashCodeString here
        var key = url;
        if (this._cache.has(key)) {
            return Observable_1.Observable.of(this._cache.get(key));
        }
        // you probably shouldn't .share() and you should write the correct logic
        return this._api.get(url)
            .do(function (json) {
            _this._cache.set(key, json);
        })
            .share();
    };
    // don't cache here since we're creating
    ModelService.prototype.create = function () {
        // TODO
    };
    ModelService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object])
    ], ModelService);
    return ModelService;
    var _a, _b;
}());
exports.ModelService = ModelService;


/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"routesService.visiblePageLoader\" class=\"bounce-loader\" id=\"loading-dots\">\r\n    <div class=\"bounce1\"></div>\r\n    <div class=\"bounce2\"></div>\r\n    <div class=\"bounce3\"></div>\r\n</div>\r\n<router-outlet></router-outlet>\r\n<div (window:beforeunload)=\"clearMemory()\"></div>"

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var quoting_model_1 = __webpack_require__(56);
var ExcludingComponent = (function () {
    function ExcludingComponent() {
        this.components = new quoting_model_1.LavorazioniComponents();
    }
    ExcludingComponent.prototype.getMacrocategory = function () {
        return this.Macrocategory;
    };
    ExcludingComponent.prototype.setMacrocategory = function (macrocategory) {
        this.Macrocategory = macrocategory;
    };
    ExcludingComponent.prototype.getModelItemName = function (sezione) {
        switch (sezione) {
            case "formato":
                {
                    return "formato";
                }
            case "copertina":
                {
                    return "";
                }
            case "fustellatura":
                {
                    return "";
                }
            case "plastificazione":
                {
                    return "plastificazioni1";
                }
            case "plastificazione_copertina":
                {
                    return "plastificazioni2";
                }
            case "rilegatura":
                {
                    return "rilegature";
                }
            case "taglio":
                {
                    return "tagli";
                }
            default:
                {
                    return "";
                }
        }
    };
    //remove all excluding rules from model
    ExcludingComponent.prototype.removeSelectRules = function (model) {
        for (var key in model) {
            if (model[key] != null) {
                if (this.getLowerCase(key) == "lavorazioniaccessorie") {
                    for (var lavorazioneKey in model[key]) {
                        model[key][lavorazioneKey].isVisible = true;
                        for (var subKey in model[key][lavorazioneKey].valori) {
                            try {
                                model[key][lavorazioneKey].valori[subKey].isVisible = true;
                            }
                            catch (Exception) { }
                        }
                    }
                }
                else {
                    for (var subKey in model[key]) {
                        try {
                            if (Array.isArray(model[key])) {
                                model[key][subKey].isVisible = true;
                            }
                            model.tipoTaglio = true;
                        }
                        catch (Exception) { }
                    }
                }
            }
        }
        return model;
    };
    // remove excluding rules from one component
    // if is lavorazione we need to remove rull from model.lavorazione not from model
    ExcludingComponent.prototype.removeRuleFromComponent = function (model, component, lavorazione) {
        if (lavorazione === void 0) { lavorazione = false; }
        if (model != null && model != undefined) {
            if (!lavorazione) {
                for (var key in model[component]) {
                    try {
                        model[component][key].isVisible = true;
                    }
                    catch (Exception) { }
                }
            }
            else {
                for (var subKey in model.lavorazioniAccessorie) {
                    for (var valoriSubKey in model.lavorazioniAccessorie[subKey].valori) {
                        try {
                            model.lavorazioniAccessorie[subKey].valori[valoriSubKey].isVisible = true;
                        }
                        catch (Exception) { }
                    }
                }
            }
        }
        return model;
    };
    // remove excluding rules list
    ExcludingComponent.prototype.removeSelectRuleFromList = function (model, regoles) {
        for (var regoleKey in regoles) {
            switch (this.getLowerCase(regoles[regoleKey].Categoria_2)) {
                case "accessoria":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Id_Elemento_2));
                        model = this.removeRuleFromComponent(model, component, true);
                        break;
                    }
                case "finitura":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Sezione_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }
                case "carte":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Categoria_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }
                case "carte_copertina":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Categoria_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }
                default: { }
            }
        }
        return model;
    };
    // return  rules list for certain category
    ExcludingComponent.prototype.filter = function (list, field, value) {
        var returnList = new Array();
        for (var key in list) {
            var text = "";
            try {
                text = this.getLowerCase(list[key][field]);
            }
            catch (exception) { }
            if (text == this.getLowerCase(value)) {
                returnList.push(list[key]);
            }
        }
        return returnList;
    };
    // return excluding rules for custom categoria and sezione
    ExcludingComponent.prototype.getRegole = function (regolesList, categoria, sezione) {
        var allRegoles = regolesList;
        var regoles = null;
        if (allRegoles != null && allRegoles != undefined && allRegoles.length > 0) {
            var categoryRegoles = this.filter(allRegoles, "Categoria_1", categoria); //get regoles for certain cattegory
            if (categoryRegoles != null && categoryRegoles != undefined && categoryRegoles.length > 0) {
                var regoles = null;
                //get regoles for certain cattegory
                switch (this.getLowerCase(categoria)) {
                    case "finiture":
                        {
                            regoles = this.filter(categoryRegoles, "Sezione_1", sezione);
                            for (var regolesKey in regoles) {
                                var sezioneInput = this.getModelItemName(this.getLowerCase(regoles[regolesKey].Sezione_2)); //return name for current rules 
                            }
                            break;
                        }
                    case "accessoria":
                        {
                            regoles = this.filter(categoryRegoles, "Id_Elemento_1", sezione);
                            for (var regolesKey in regoles) {
                                var sezioneInput = this.getModelItemName(this.getLowerCase(regoles[regolesKey].Sezione_2));
                            }
                            break;
                        }
                    default:
                        {
                            regoles = categoryRegoles;
                        }
                }
                if (sezione == "") {
                    regoles = categoryRegoles;
                }
                else { }
            }
        }
        return regoles;
    };
    ExcludingComponent.prototype.getLavorazioneValue = function (lavorazione, tipo, id) {
        try {
            var tipoNum = parseInt(tipo);
            switch (tipoNum) {
                case this.components.checkBox:
                    {
                        if (lavorazione.value == null || lavorazione.value == undefined) {
                            switch (lavorazione.tipoSelezione) {
                                case "non_selezionato":
                                    {
                                        lavorazione.value = false;
                                        return lavorazione.value;
                                    }
                                case "selezionato":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }
                                case "fisso":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }
                                case "nascosto":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }
                                default:
                                    {
                                        lavorazione.value = false;
                                        return lavorazione.value;
                                    }
                            }
                        }
                        else {
                            return !lavorazione.value;
                        }
                    }
                    ;
                case this.components.selectBox:
                    { }
                    ;
                case this.components.inputBox:
                    { }
                default:
                    {
                        return null;
                    }
            }
        }
        catch (exception) { }
    };
    // hidding field for finiture category
    //regole - because we need element to hide.
    ExcludingComponent.prototype.hideFinituraValue = function (model, component, regole, macro) {
        switch (this.getLowerCase(macro)) {
            case "editoria":
                {
                    for (var key in model[component]) {
                        if (model[component][key].chiave == regole.Id_Elemento_2) {
                            model[component][key].isVisible = false;
                        }
                    }
                    if (component == "taglio") {
                        model[component] = false;
                        model.tipoTaglio = false;
                    }
                }
        }
        return model;
    };
    //not finished, method that hode lavorazine
    ExcludingComponent.prototype.hideLavorazioneValue = function (model, component, regole, macro) {
        switch (this.getLowerCase(macro)) {
            case "editoria":
                {
                    for (var key in model.lavorazioniAccessorie) {
                        try {
                            if (model.lavorazioniAccessorie[key] != null) {
                                if (model.lavorazioniAccessorie[key].id == component) {
                                    if (parseInt(model.lavorazioniAccessorie[key].tipo) == this.components.selectBox) {
                                        for (var subKey in model.lavorazioniAccessorie[key].valori) {
                                            if (model.lavorazioniAccessorie[key].valori[subKey].chiave == regole.Id_Elemento_Sottochiave_2) {
                                                model.lavorazioniAccessorie[key].valori[subKey].isVisible = false;
                                                model.lavorazioniAccessorie[key].valori[subKey].chiave = 0;
                                            }
                                        }
                                    }
                                    else if (model.lavorazioniAccessorie[key].tipo == this.components.checkBox) {
                                        model.lavorazioniAccessorie[key].value = false;
                                        model.lavorazioniAccessorie[key].isVisible = false;
                                    }
                                    else if (model.lavorazioniAccessorie[key].tipo == this.components.inputBox) {
                                        model.lavorazioniAccessorie[key].value = "";
                                        model.lavorazioniAccessorie[key].isVisible = false;
                                        ;
                                    }
                                }
                            }
                        }
                        catch (Exception) { }
                    }
                }
        }
        return model;
    };
    /// hidding option from regole id_element2
    ExcludingComponent.prototype.hideSelectValue = function (model, regole, macro, elemento) {
        switch (this.getLowerCase(regole.Categoria_2)) {
            case "carta":
            case "carta copertina": { }
            case "finitura":
                {
                    var sezioneInput = this.getModelItemName(this.getLowerCase(regole.Sezione_2));
                    model = this.hideFinituraValue(model, sezioneInput, regole, macro);
                }
            case "accessoria":
                {
                    if (this.getLowerCase(regole.Categoria_1) == "accessoria") {
                        for (var key in model.lavorazioniAccessorie) {
                            if (model.lavorazioniAccessorie[key].tipo == this.components.checkBox && model.lavorazioniAccessorie[key].id == regole.Id_Elemento_1) {
                                if ((model.lavorazioniAccessorie[key].value == false && regole.Id_Elemento_Sottochiave_1 == 2) || (model.lavorazioniAccessorie[key].value == true && regole.Id_Elemento_Sottochiave_1 == 1) || regole.Id_Elemento_Sottochiave_1 == 0) {
                                    model = this.hideLavorazioneValue(model, this.getLowerCase(regole.Id_Elemento_2), regole, macro);
                                }
                            }
                            else if (model.lavorazioniAccessorie[key].tipo != this.components.checkBox) { }
                        }
                    }
                    else {
                        model = this.hideLavorazioneValue(model, this.getLowerCase(regole.Id_Elemento_2), regole, macro);
                    }
                }
            case "busta": { }
            default: { }
        }
        return model;
    };
    //method to get lower case in implement method we get error for null etc
    ExcludingComponent.prototype.getLowerCase = function (inputString) {
        var outString = "";
        try {
            outString = inputString.toLowerCase();
        }
        catch (Exception) {
            outString = inputString;
        }
        return outString;
    };
    //     Get excluding rules for certain component, and from category_1 choise witch
    ExcludingComponent.prototype.setSelectRules = function (model, rulesList, categoria, sezione, elemento, sotoelemento, macro) {
        var regoleList = this.getRegole(rulesList, categoria, sezione);
        if (regoleList) {
            var regole = null;
            if (this.getLowerCase(categoria) == "accessoria") {
                if (elemento == true) {
                    elemento = 1;
                }
                else {
                    elemento = 0;
                }
                regole = regoleList;
                if (!regole) {
                    regole = this.filter(regoleList, "Id_Elemento_Sottochiave_1", "");
                }
            }
            else {
                regole = this.filter(regoleList, "Id_Elemento_1", elemento);
                if (!regole) {
                    regole = this.filter(regoleList, "Id_Elemento_1", "");
                }
            }
            if (regole) {
                for (var regoleKey in regole) {
                    model = this.hideSelectValue(model, regole[regoleKey], macro, elemento);
                }
            }
            else { }
        }
        else { }
        return model;
    };
    /// <param name="tipo">"PF" </param>
    /// <param name="categoria">"FINITURA"</param>
    /// <param name="sezione">"FORMATO"</param>
    /// <param name="macroCategoria">"EDITORIA"</param>
    /// <param name="elemento">null </param>
    /// <param name="sottoElemento">null</param>
    ExcludingComponent.prototype.ResetRegole = function (tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct) {
        if (responseModelOtherProduct === void 0) { responseModelOtherProduct = []; }
        var regoleToReset = this.FindRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel);
        var flagReset;
        for (var _i = 0, regoleToReset_1 = regoleToReset; _i < regoleToReset_1.length; _i++) {
            var regola = regoleToReset_1[_i];
            if (this.CheckMacroCategoria(regola, this.Macrocategory)) {
                flagReset = true;
                this.ApplicaRegola(regola, flagReset, responseModel, responseModelOtherProduct);
            }
        }
    };
    ExcludingComponent.prototype.ApplicaRegole = function (tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct) {
        if (responseModelOtherProduct === void 0) { responseModelOtherProduct = []; }
        //console.log("ApplicaRegole");
        var regoleToApply = this.FindRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel);
        var flagReset;
        for (var _i = 0, regoleToApply_1 = regoleToApply; _i < regoleToApply_1.length; _i++) {
            var regola = regoleToApply_1[_i];
            //console.log(regola)
            if (this.CheckMacroCategoria(regola, this.Macrocategory)) {
                flagReset = false;
                this.ApplicaRegola(regola, flagReset, responseModel, responseModelOtherProduct);
            }
        }
    };
    ExcludingComponent.prototype.ApplicaRegola = function (regola, flagReset, responseModel, responseModelOtherProduct) {
        if (responseModelOtherProduct === void 0) { responseModelOtherProduct = []; }
        var hideOrShow;
        if (flagReset == false) {
            hideOrShow = "hide";
        }
        else {
            hideOrShow = "show";
        }
        if (regola.Tipo_Regola == "ESCLUDE") {
            if (regola.Categoria_2 == "CARTA") {
                //In questo caso è stata esclusa una carta e/o grammatura
                var idElemento = regola.Id_Elemento_2;
                var idSottoElemento = regola.Id_Elemento_Sottochiave_2;
                //Se la sottochiave non è valorizzata bisogna escludere l'intera carta, 
                //altrimenti una singola grammatura (solo per la relativa carta)
                if (idSottoElemento == null || idSottoElemento == 0) {
                    var attributo = regola.Categoria_2;
                    this.hideOrShowComboItem("CARTA", idElemento, hideOrShow, responseModel);
                }
                else {
                    if (responseModel.idCarte1 != null) {
                        var data = responseModel.idCarte1.split("_");
                        var idCarta = data[0];
                        //Se la carta scelta è quella della regola, allora viene nascosta la grammatura
                        if (idCarta == idElemento) {
                            this.hideOrShowComboItem("GRAMMATURA_CARTA", idSottoElemento, hideOrShow, responseModel);
                        }
                    }
                }
            }
            else if (regola.Categoria_2 == "CARTA_COPERTINA") {
                //In questo caso è stata esclusa una carta e/o grammatura
                var idElemento = regola.Id_Elemento_2;
                var idSottoElemento = regola.Id_Elemento_Sottochiave_2;
                //Se la sottochiave non è valorizzata bisogna escludere l'intera carta, 
                //altrimenti una singola grammatura (solo per la relativa carta)
                if (idSottoElemento == null || idSottoElemento == 0) {
                    var attributo = regola.Categoria_2;
                    this.hideOrShowComboItem("CARTA_COPERTINA", idElemento, hideOrShow, responseModel);
                }
                else {
                    if (responseModel.idCarte2 != null) {
                        var data = responseModel.idCarte2.split("_");
                        var idCarta = data[0];
                        //Se la carta scelta è quella della regola, allora viene nascosta la grammatura
                        if (idCarta == idElemento) {
                            this.hideOrShowComboItem("GRAMMATURA_CARTA_COPERTINA", idSottoElemento, hideOrShow, responseModel);
                        }
                    }
                }
            }
            else if (regola.Categoria_2 == "FINITURA") {
                var sezione = regola.Sezione_2;
                var idElemento_1 = regola.Id_Elemento_2;
                if (sezione == "TAGLIO") {
                    this.hideOrShowAttribute("TAGLIO", hideOrShow, responseModel);
                }
                else if (sezione == "STAMPA_BIFACCIALE") {
                    this.hideOrShowComboItem(sezione, idElemento_1, hideOrShow, responseModel);
                }
                else if (sezione == "BIANCO_COPRENTE") {
                    if (idElemento_1 == "1") {
                        this.hideOrShowComboItem(sezione, "0", hideOrShow, responseModel);
                    }
                    else if (idElemento_1 == "2") {
                        this.hideOrShowComboItem(sezione, "1", hideOrShow, responseModel);
                    }
                    else if (idElemento_1 == "3") {
                        this.hideOrShowComboItem(sezione, "2", hideOrShow, responseModel);
                    }
                }
                else {
                    this.hideOrShowComboItem(sezione, idElemento_1, hideOrShow, responseModel);
                }
            }
            else if (regola.Categoria_2 == "SUPPORTO_RIGIDO") {
                //In questo caso è stato escluso un supporto rigido
                var idElemento = regola.Id_Elemento_2;
                this.hideOrShowComboItem("SUPPORTO_RIGIDO", idElemento, hideOrShow, responseModel);
            }
            else if (regola.Categoria_2 == "MATERIALE_FLESSIBILE") {
                //In questo caso è stato escluso un supporto rigido
                var idElemento = regola.Id_Elemento_2;
                this.hideOrShowComboItem("MATERIALE_FLESSIBILE", idElemento, hideOrShow, responseModel);
            }
            else if (regola.Categoria_2 == "ACCESSORIA") {
                var idLavorazione = regola.Id_Elemento_2;
                var idVariante = regola.Id_Elemento_Sottochiave_2;
                this.hideOrShowLavorazioneAccessoria(idLavorazione, idVariante, hideOrShow, responseModel, responseModelOtherProduct);
            }
        }
    };
    ExcludingComponent.prototype.hideOrShowAttribute = function (attributo, hideOrShow, responseModel) {
        if (attributo == "TAGLIO") {
            if (hideOrShow == "hide") {
                responseModel.isTaglioVisible = true;
            }
            else if (hideOrShow == "show") {
                responseModel.isTaglioVisible = false;
            }
        }
    };
    ExcludingComponent.prototype.hideOrShowComboItem = function (attributo, id, hideOrShow, responseModel) {
        //console.log("hideOrShowComboItem")
        //console.log(this.Macrocategory)
        //console.log(id)
        //console.log(hideOrShow)
        //console.log(attributo)
        //console.log("finehideOrShowComboItem")
        if (this.Macrocategory == "EDITORIA") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "CARTA_COPERTINA") {
                this.hideOrShowRadComboItem(responseModel.carte2, "CARTA_COPERTINA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA_COPERTINA") {
                this.hideOrShowRadComboItem(responseModel.grammature2, "GRAMMATURA_CARTA_COPERTINA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "PLASTIFICAZIONE_COPERTINA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni2, "PLASTIFICAZIONE_COPERTINA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni2, "PLASTIFICAZIONE_COPERTINA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "COPERTINA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.copertine, "COPERTINA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.copertine, "COPERTINA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "RILEGATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.rilegature, "RILEGATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.rilegature, "RILEGATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "COMMERCIALE") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "PIEGATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.piegature, "PIEGATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.piegature, "PIEGATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "ETICHETTE") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "FUSTELLATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.tagli, "FUSTELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.tagli, "FUSTELLATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "ADESIVI" || this.Macrocategory == "MANIFESTI" || this.Macrocategory == "PANNELLI" || this.Macrocategory == "STAMPA_DIRETTA") {
            if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "SUPPORTO_RIGIDO") {
                this.hideOrShowRadComboItem(responseModel.supportiRigidi, "SUPPORTO_RIGIDO", id, hideOrShow, responseModel);
            }
            else if (attributo == "MATERIALE_FLESSIBILE") {
                this.hideOrShowRadComboItem(responseModel.materialiFlessibili, "MATERIALE_FLESSIBILE", id, hideOrShow, responseModel);
            }
            else if (attributo == "BIANCO_COPRENTE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutto il bianco coprente
                this.hideOrShowRadComboItem(responseModel.biancoCoprente, "BIANCO_COPRENTE", id, hideOrShow, responseModel);
            }
            else if (attributo == "STAMPA_BIFACCIALE") {
                if (hideOrShow == "hide") {
                    if (id == "1") {
                        responseModel.isStampaBifaccialeNoHide = true;
                        responseModel.tipoBifacciale = "1";
                    }
                    else {
                        responseModel.isStampaBifaccialeSiHide = true;
                        responseModel.tipoBifacciale = "0";
                    }
                }
                else {
                    responseModel.isStampaBifaccialeNoHide = false;
                    responseModel.isStampaBifaccialeSiHide = false;
                }
            }
            else if (attributo == "FUSTELLATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.tagli, "FUSTELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.tagli, "FUSTELLATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "BANDIERE" || this.Macrocategory == "BANNER") {
            if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "OCCHIELLATURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.occhielli, "OCCHIELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.occhielli, "OCCHIELLATURA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "ASOLA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.asole, "ASOLA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.asole, "ASOLA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "CUCITURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.cuciture, "CUCITURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.cuciture, "CUCITURA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "ELETTROSALDATURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.elettrosaldature, "ELETTROSALDATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.elettrosaldature, "ELETTROSALDATURA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "MATERIALE_FLESSIBILE") {
                this.hideOrShowRadComboItem(responseModel.materialiFlessibili, "MATERIALE_FLESSIBILE", id, hideOrShow, responseModel);
            }
        }
    };
    ExcludingComponent.prototype.hideOrShowAllRadComboItems = function (parameterList, tipo, hideOrShow, responseModel) {
        var emptyValue;
        if (tipo == "COPERTINA") {
            emptyValue = "0";
        }
        else {
            emptyValue = "-1";
        }
        var selected = false;
        for (var _i = 0, parameterList_1 = parameterList; _i < parameterList_1.length; _i++) {
            var parameter = parameterList_1[_i];
            if (hideOrShow == "show") {
                parameter.isVisible = true;
                if (selected == false) {
                    if (tipo == "RILEGATURA") {
                        if (responseModel.idRilegature == "-1") {
                            responseModel.idRilegature = parameter.chiave;
                        }
                    }
                    else if (tipo == "PIEGATURA") {
                        if (responseModel.idPiegature == "-1") {
                            responseModel.idPiegature = parameter.chiave;
                        }
                    }
                    else if (tipo == "OCCHIELLATURA") {
                        if (responseModel.idOcchielli == "-1") {
                            responseModel.idOcchielli = parameter.chiave;
                        }
                    }
                    else if (tipo == "CUCITURA") {
                        if (responseModel.idCuciture == "-1") {
                            responseModel.idCuciture = parameter.chiave;
                        }
                    }
                    else if (tipo == "ELETTROSALDATURA") {
                        if (responseModel.idElettrosaldature == "-1") {
                            responseModel.idElettrosaldature = parameter.chiave;
                        }
                    }
                    else if (tipo == "ASOLA") {
                        if (responseModel.idAsole == "-1") {
                            responseModel.idAsole = parameter.chiave;
                        }
                    }
                    else if (tipo == "FUSTELLATURA") {
                        if (responseModel.idTagli == "-1") {
                            responseModel.idTagli = parameter.chiave;
                        }
                    }
                    else if (tipo == "PLASTIFICAZIONE") {
                        if (responseModel.idPlastificazioni1 == "-1") {
                            responseModel.idPlastificazioni1 = parameter.chiave;
                        }
                    }
                    else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                        if (responseModel.idPlastificazioni2 == "-1") {
                            responseModel.idPlastificazioni2 = parameter.chiave;
                        }
                    }
                    else if (tipo == "COPERTINA") {
                        if (responseModel.idCopertine == "-1") {
                            responseModel.idCopertine = parameter.chiave;
                        }
                    }
                    selected = true;
                }
            }
            else if (hideOrShow == "hide") {
                if (parameter.chiave != emptyValue) {
                    parameter.isVisible = false;
                }
                else {
                    if (selected == false && parameter.isVisible == true) {
                        if (tipo == "RILEGATURA") {
                            if (responseModel.idRilegature == emptyValue) {
                                responseModel.idRilegature = parameter.chiave;
                            }
                        }
                        else if (tipo == "PIEGATURA") {
                            if (responseModel.idPiegature == emptyValue) {
                                responseModel.idPiegature = parameter.chiave;
                            }
                        }
                        else if (tipo == "OCCHIELLATURA") {
                            if (responseModel.idOcchielli == emptyValue) {
                                responseModel.idOcchielli = parameter.chiave;
                            }
                        }
                        else if (tipo == "CUCITURA") {
                            if (responseModel.idCuciture == emptyValue) {
                                responseModel.idCuciture = parameter.chiave;
                            }
                        }
                        else if (tipo == "ELETTROSALDATURA") {
                            if (responseModel.idElettrosaldature == emptyValue) {
                                responseModel.idElettrosaldature = parameter.chiave;
                            }
                        }
                        else if (tipo == "ASOLA") {
                            if (responseModel.idAsole == emptyValue) {
                                responseModel.idAsole = parameter.chiave;
                            }
                        }
                        else if (tipo == "FUSTELLATURA") {
                            if (responseModel.idTagli == emptyValue) {
                                responseModel.idTagli = parameter.chiave;
                            }
                        }
                        else if (tipo == "PLASTIFICAZIONE") {
                            if (responseModel.idPlastificazioni1 == emptyValue) {
                                responseModel.idPlastificazioni1 = parameter.chiave;
                            }
                        }
                        else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                            if (responseModel.idPlastificazioni2 == emptyValue) {
                                responseModel.idPlastificazioni2 = parameter.chiave;
                            }
                        }
                        else if (tipo == "COPERTINA") {
                            if (responseModel.idCopertine == emptyValue) {
                                responseModel.idCopertine = parameter.chiave;
                            }
                        }
                        selected = true;
                    }
                }
            }
            if (selected == false) {
                if (tipo == "RILEGATURA") {
                    responseModel.idRilegature = "-1";
                }
                else if (tipo == "PIEGATURA") {
                    responseModel.idPiegature = "-1";
                }
                else if (tipo == "FUSTELLATURA") {
                    responseModel.idTagli = "-1";
                }
                else if (tipo == "OCCHIELLATURA") {
                    responseModel.idOcchielli = "-1";
                }
                else if (tipo == "CUCITURA") {
                    responseModel.idCuciture = "-1";
                }
                else if (tipo == "ELETTROSALDATURA") {
                    responseModel.idElettrosaldature = "-1";
                }
                else if (tipo == "ASOLA") {
                    responseModel.idAsole = "-1";
                }
                else if (tipo == "PLASTIFICAZIONE") {
                    responseModel.idPlastificazioni1 = "-1";
                }
                else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                    responseModel.idPlastificazioni2 = "-1";
                }
                else if (tipo == "COPERTINA") {
                    responseModel.idCopertine = "-1";
                }
            }
        }
    };
    ExcludingComponent.prototype.hideOrShowRadComboItem = function (parameterList, tipo, id, hideOrShow, responseModel) {
        //Recupero delle info sulla combo
        var selected = false;
        for (var _i = 0, parameterList_2 = parameterList; _i < parameterList_2.length; _i++) {
            var parameter = parameterList_2[_i];
            //Se l'elemento non è il valore 'Scegli' (-1) o vuoto, non bisogna considerarlo
            //Tranne per la copertina, dove -1 corrisponde all'autocopertinato, che può essere escluso
            if (tipo != "COPERTINA" && (parameter.chiave == "-1" || parameter.chiave == null)) {
                continue;
            }
            else {
                var idElemento;
                if (tipo == "CARTA"
                    || tipo == "CARTA_COPERTINA"
                    || (this.Macrocategory == "ETICHETTE" && tipo == "FORMATO")
                    || (this.Macrocategory == "STAMPA_DIRETTA" && tipo == "FORMATO")
                    || (this.Macrocategory == "PANNELLI" && tipo == "FORMATO")
                    || (this.Macrocategory == "BANDIERE" && tipo == "FORMATO")
                    || (this.Macrocategory == "MANIFESTI" && tipo == "FORMATO")
                    || (this.Macrocategory == "BANNER" && tipo == "FORMATO")
                    || (this.Macrocategory == "ADESIVI" && tipo == "FORMATO")) {
                    var data = parameter.chiave.split("_");
                    idElemento = data[0];
                }
                else if (tipo == "COPERTINA") {
                    if (parameter.chiave == "0") {
                        //Il value dell'option della combo per l'autocopertina è il valore vuoto,
                        //inveCe per le regole il valore dell'autocopertinato è -1, quindi occorre una conversione
                        idElemento = "-1";
                    }
                    else {
                        idElemento = parameter.chiave;
                    }
                }
                else {
                    idElemento = parameter.chiave;
                }
                if (hideOrShow == "show") {
                    if (idElemento == id) {
                        parameter.isVisible = true;
                        if (selected == false) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == "-1") {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == "-1") {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == "-1") {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == "-1") {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == "-1") {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == "-1") {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == "-1") {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == "-1") {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == "-1") {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                var idCarta = data[0];
                                if (idCarta == "-1") {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == "-1") {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                var idCarta = data[0];
                                if (idCarta == "-1") {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == "-1") {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (responseModel.idFormati == "-1") {
                                    responseModel.idFormati = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == "-1") {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == "-1") {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == "-1") {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }
                            else if (tipo == "BIANCO_COPRENTE") {
                                if (responseModel.idBiancoCoprente == "-1") {
                                    responseModel.idBiancoCoprente = parameter.chiave;
                                }
                            }
                            selected = true;
                        }
                    }
                    else {
                        if (selected == false) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == "-1") {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == "-1") {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == "-1") {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == "-1") {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == "-1") {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == "-1") {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == "-1") {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == "-1") {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == "-1") {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                var idCarta = data[0];
                                if (idCarta == "-1") {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == "-1") {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                var idCarta = data[0];
                                if (idCarta == "-1") {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == "-1") {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (responseModel.idFormati == "-1") {
                                    responseModel.idFormati = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == "-1") {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == "-1") {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == "-1") {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }
                            selected = true;
                        }
                    }
                }
                else if (hideOrShow == "hide") {
                    if (idElemento == id) {
                        parameter.isVisible = false;
                    }
                    else {
                        if (selected == false && parameter.isVisible == true) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == id) {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == id) {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == id) {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == id) {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == id) {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == id) {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == id) {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == id) {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == id) {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                var idCarta = data[0];
                                if (idCarta == id) {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == id) {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                var idCarta = data[0];
                                if (idCarta == id) {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == id) {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (this.Macrocategory == "ETICHETTE"
                                    || this.Macrocategory == "ADESIVI"
                                    || this.Macrocategory == "PANNELLI"
                                    || this.Macrocategory == "MANIFESTI"
                                    || this.Macrocategory == "STAMPA_DIRETTA"
                                    || this.Macrocategory == "BANDIERE"
                                    || this.Macrocategory == "BANNER") {
                                    var data = responseModel.idFormati.split("_");
                                    var idFormato = data[0];
                                    if (idFormato == id) {
                                        responseModel.idFormati = parameter.chiave;
                                    }
                                }
                                else {
                                    if (responseModel.idFormati == id) {
                                        responseModel.idFormati = parameter.chiave;
                                    }
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == id) {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == id) {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == id) {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }
                            else if (tipo == "BIANCO_COPRENTE") {
                                if (responseModel.idBiancoCoprente == id) {
                                    responseModel.idBiancoCoprente = parameter.chiave;
                                }
                            }
                            selected = true;
                        }
                    }
                }
            }
        }
        if (selected == false) {
            if (tipo == "RILEGATURA") {
                responseModel.idRilegature = "-1";
            }
            else if (tipo == "MATERIALE_FLESSIBILE") {
                responseModel.idMaterialiFlessibili = "-1";
            }
            else if (tipo == "SUPPORTO_RIGIDO") {
                responseModel.idSupportiRigidi = "-1";
            }
            else if (tipo == "OCCHIELLATURA") {
                responseModel.idOcchielli = "-1";
            }
            else if (tipo == "CUCITURA") {
                responseModel.idCuciture = "-1";
            }
            else if (tipo == "ELETTROSALDATURA") {
                responseModel.idElettrosaldature = "-1";
            }
            else if (tipo == "ASOLA") {
                responseModel.idAsole = "-1";
            }
            else if (tipo == "PIEGATURA") {
                responseModel.idPiegature = "-1";
            }
            else if (tipo == "FUSTELLATURA") {
                responseModel.idTagli = "-1";
            }
            else if (tipo == "CARTA") {
                responseModel.idCarte1 = "-1";
                responseModel.grammature1 = new Array();
                responseModel.idGrammature1 = "-1";
            }
            else if (tipo == "GRAMMATURA_CARTA") {
                responseModel.idGrammature1 = "-1";
            }
            else if (tipo == "CARTA_COPERTINA") {
                responseModel.idCarte2 = "-1";
                responseModel.grammature2 = new Array();
                responseModel.idGrammature2 = "-1";
            }
            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                responseModel.idGrammature2 = "-1";
            }
            else if (tipo == "PLASTIFICAZIONE") {
                responseModel.idPlastificazioni1 = "-1";
            }
            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                responseModel.idPlastificazioni2 = "-1";
            }
            else if (tipo == "FORMATO") {
                responseModel.idFormati = "-1";
            }
            else if (tipo == "COPERTINA") {
                responseModel.idCopertine = "-1";
            }
            else if (tipo == "BIANCO_COPRENTE") {
                responseModel.idBiancoCoprente = "0";
            }
        }
    };
    /// <param name="tipo">"PF" </param>
    /// <param name="categoria">"FINITURA"</param>
    /// <param name="sezione">"FORMATO"</param>
    /// <param name="macroCategoria">"EDITORIA"</param>
    /// <param name="elemento">null </param>
    /// <param name="sottoElemento">null</param>
    ExcludingComponent.prototype.FindRegole = function (tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel) {
        var regole = new Array();
        for (var _i = 0, _a = responseModel.listaRegole; _i < _a.length; _i++) {
            var regola = _a[_i];
            //console.log("FindRegole(" + tipo + "," + categoria + "," + sezione + "," + macroCategoria + "," + elemento + "," + sottoElemento + ")");
            if (regola.Tipo == tipo
                && regola.Categoria_1 == categoria && regola.Sezione_1 == sezione
                && regola.Macro_Categoria_1 == macroCategoria) {
                //console.log("regola (" + regola.Tipo + "," + regola.Categoria_1 + "," + regola.Sezione_1 + "," + regola.Macro_Categoria_1 + "," + regola.Id_Elemento_1 + "," + regola.Id_Elemento_Sottochiave_1 + ")");
                if (elemento != null && regola.Id_Elemento_1 == elemento) {
                    if (sottoElemento != null && regola.Id_Elemento_Sottochiave_1 == sottoElemento) {
                        regole.push(regola);
                    }
                    else if (sottoElemento == null || regola.Id_Elemento_Sottochiave_1 == 0) {
                        regole.push(regola);
                    }
                }
                else if (elemento == null) {
                    regole.push(regola);
                }
            }
        }
        //console.log(regole.length);
        return regole;
    };
    ExcludingComponent.prototype.CheckMacroCategoria = function (regola, macroCategoria) {
        var result = false;
        if (regola.Macro_Categoria_2 == null || regola.Macro_Categoria_2 == "") {
            result = true;
        }
        else if (regola.Macro_Categoria_2 != null && regola.Macro_Categoria_2.toUpperCase() == macroCategoria.toUpperCase()) {
            result = true;
        }
        return result;
    };
    ExcludingComponent.prototype.ApplicaRegoleLavorazioniAccessorie = function (tipo, macroCategoria, responseModel, responseModelOtherProduct) {
        if (responseModelOtherProduct === void 0) { responseModelOtherProduct = []; }
        var categoria = "ACCESSORIA";
        var sezione = "";
        var elemento;
        var sottoElemento;
        //Lettura della lista delle lavorazioni accessorie
        //Vengono applicate le regole per ogni lavorazione accessoria
        for (var _i = 0, _a = responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
            var lavorazioneAccessoria = _a[_i];
            elemento = lavorazioneAccessoria.id;
            var tipoLavorazioneAccessoria = void 0;
            if (lavorazioneAccessoria.tipo == "0") {
                tipoLavorazioneAccessoria = "check";
            }
            else if (lavorazioneAccessoria.tipo == "2") {
                tipoLavorazioneAccessoria = "select";
            }
            else if (lavorazioneAccessoria.tipo == "6") {
                tipoLavorazioneAccessoria = "textarea";
            }
            //Per le lavorazioni di tipo combo bisogna leggere il valore della select
            //Invece se si tratta di una check bisogna vedere se è checkata o meno.
            if (tipoLavorazioneAccessoria == "check") {
                sottoElemento = null;
                //se la lavorazione è stata checkata allora vengono applicate le eventuali regole associate
                if (lavorazioneAccessoria.lavorazioneCheckValue == false || lavorazioneAccessoria.lavorazioneCheckValue == "false" || lavorazioneAccessoria.tipoSelezione == 'nascosto') {
                    sottoElemento = "1"; //Corrispone a No nella regola
                }
                else if (lavorazioneAccessoria.lavorazioneCheckValue) {
                    sottoElemento = "2"; //Corrispone a Si nella regola
                }
                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
            else if (tipoLavorazioneAccessoria == "select") {
                sottoElemento = this.getComboValue("ACCESSORIA", lavorazioneAccessoria.valore, lavorazioneAccessoria);
                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
            else if (tipoLavorazioneAccessoria = "textarea") {
                sottoElemento = '0';
                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
        }
    };
    ExcludingComponent.prototype.getComboValue = function (attributo, id, lavorazioneAccessoria) {
        var value = "";
        //Controllo prima se si tratta di una lavorazione accessoria, dato che la loro gestione è uguale per tutte le macrocategorie
        if (attributo == "ACCESSORIA") {
            //Lettura di tutta la lista delle lavorazioni accessorie
            for (var _i = 0, _a = lavorazioneAccessoria.valori; _i < _a.length; _i++) {
                var varianti = _a[_i];
                //console.log(varianti)
                var item = varianti;
                var display = varianti.isVisible;
                //Lettura dell'id della lavorazione corrente
                var idLav = item.chiave;
                var tipoLavorazione = lavorazioneAccessoria.tipo;
                var idLavAcc = lavorazioneAccessoria.valore;
                if (id == idLav) {
                    //Se la riga non è mostrata viene considerata come non selezionata
                    if (display == false) {
                        value = "-1";
                    }
                    else {
                        //Lettura del valore selezionato nella select
                        value = idLav;
                        break;
                    }
                }
            }
            return value;
        }
    };
    ExcludingComponent.prototype.hideOrShowLavorazioneAccessoria = function (idLavorazione, idVariante, hideOrShow, responseModel, responseModelOtherProduct) {
        if (responseModelOtherProduct === void 0) { responseModelOtherProduct = []; }
        for (var _i = 0, _a = responseModel.lavorazioniAccessorie; _i < _a.length; _i++) {
            var lavorazioneAccessoria = _a[_i];
            var tipoLavorazione = lavorazioneAccessoria.tipo;
            var idLavAcc = lavorazioneAccessoria.id;
            if (idLavAcc == idLavorazione) {
                if (tipoLavorazione == "2") {
                    var comboItemNumber = -1;
                    if (idVariante == null || idVariante == 0) {
                        if (hideOrShow == "hide") {
                            lavorazioneAccessoria.isVisible = false;
                        }
                        else if (hideOrShow == "show") {
                            lavorazioneAccessoria.isVisible = true;
                        }
                    }
                    else {
                        var selected = false;
                        for (var _b = 0, _c = lavorazioneAccessoria.valori; _b < _c.length; _b++) {
                            var variante = _c[_b];
                            if (hideOrShow == "hide") {
                                if (variante.chiave == idVariante) {
                                    variante.isVisible = false;
                                    //-- If type is combobox and we want to hide just one combo option, we will send it's id
                                    comboItemNumber = idVariante;
                                }
                            }
                            else if (hideOrShow == "show") {
                                variante.isVisible = true;
                                if (selected == false) {
                                    if (lavorazioneAccessoria.valore == "-1") {
                                        lavorazioneAccessoria.valore = variante.chiave;
                                    }
                                    selected = true;
                                }
                            }
                        }
                        var firstVariableVisible = 0;
                        for (var _d = 0, _e = lavorazioneAccessoria.valori; _d < _e.length; _d++) {
                            var variante = _e[_d];
                            if (firstVariableVisible == 0) {
                                if (variante.isVisible == true) {
                                    firstVariableVisible = variante.chiave;
                                }
                            }
                            if (lavorazioneAccessoria.valore == variante.chiave) {
                                if (variante.isVisible == true) {
                                    selected = true;
                                }
                            }
                        }
                        if (selected == false && firstVariableVisible == 0) {
                            lavorazioneAccessoria.valore = "-1";
                        }
                        else if (selected == false) {
                            lavorazioneAccessoria.valore = firstVariableVisible;
                        }
                    }
                    this.reflectChangesOnOtherProducts(responseModelOtherProduct, hideOrShow, lavorazioneAccessoria, comboItemNumber);
                }
                else {
                    if (hideOrShow == "hide") {
                        lavorazioneAccessoria.isVisible = false;
                    }
                    else if (hideOrShow == "show") {
                        lavorazioneAccessoria.isVisible = true;
                    }
                    this.reflectChangesOnOtherProducts(responseModelOtherProduct, hideOrShow, lavorazioneAccessoria);
                }
            }
        }
    };
    /*-- In other products we don't use lavorazzioniAccessorie object but gruppi,
         so for every change on one object we need to reflect it on the another one */
    ExcludingComponent.prototype.reflectChangesOnOtherProducts = function (responseModelOtherProduct, hideOrShow, lavorazioneAccessoria, comboItemNumber) {
        if (comboItemNumber === void 0) { comboItemNumber = -1; }
        if (responseModelOtherProduct === undefined || responseModelOtherProduct.length == 0)
            return;
        var idLavorazione = lavorazioneAccessoria.id;
        var isFoundElement = false;
        //-- From gruppi obect get all varianti and convert it to Lavorazioni Accessorie model
        for (var _i = 0, responseModelOtherProduct_1 = responseModelOtherProduct; _i < responseModelOtherProduct_1.length; _i++) {
            var group = responseModelOtherProduct_1[_i];
            for (var _a = 0, _b = group.varianti; _a < _b.length; _a++) {
                var variante = _b[_a];
                if (variante.id == idLavorazione) {
                    if (variante.tipo != '2' || comboItemNumber == -1) {
                        variante.isVisible = hideOrShow == "hide" ? false : true;
                        //-- If item from select we want to hide was selected before rule is applied on it, we are changing it's value
                        if (!variante.isVisible && (lavorazioneAccessoria.valore || lavorazioneAccessoria.valore == 0)) {
                            variante.intFormValue = lavorazioneAccessoria.valore;
                        }
                    }
                    else {
                        if (variante.valori) {
                            var comboOption = variante.valori.filter(function (x) { return x.chiave == comboItemNumber; });
                            if (comboOption) {
                                comboOption.isVisible = hideOrShow == "hide" ? false : true;
                                //-- If selected element need to be hidden because of regola, we are selecting first visible element
                                if (!comboOption.isVisible) {
                                    //  let value = lavorazioneAccessoria.valori.filter(x => x.isVisible == true)[0].chiave;
                                    //  if(variante.intFormValue)
                                    variante.intFormValue = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                    }
                    isFoundElement = true;
                    break;
                }
            }
            //-- If variante is found, break both loops, because we don't need to look for any other variante
            if (isFoundElement)
                break;
        }
    };
    return ExcludingComponent;
}());
exports.ExcludingComponent = ExcludingComponent;


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UserLogin = (function () {
    function UserLogin() {
        // this.id = 0;
        this.username = "";
        this.isAuthenticated = false;
    }
    return UserLogin;
}());
exports.UserLogin = UserLogin;


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var shopping_cart_service_1 = __webpack_require__(20);
var currency_service_1 = __webpack_require__(29);
var CmsComponentService = (function () {
    function CmsComponentService(_api, mappings, language, authService, cartService, currencyService) {
        this._api = _api;
        this.mappings = mappings;
        this.language = language;
        this.authService = authService;
        this.cartService = cartService;
        this.currencyService = currencyService;
    }
    CmsComponentService.prototype.getHeaderData = function () {
        //reading language
        var longLang = this.language.getLongLang();
        console.log(longLang);
        //reading userId
        var userId = this.authService.getCurrentUserId();
        var curr = this.currencyService.getCurrency();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        //reading cartId
        var cartId = this.cartService.getCartId();
        cartId = encodeURIComponent(cartId);
        var url = this.mappings.Web_Api_Get_Header_Data
            .replace('{lang}', longLang)
            .replace('{userid}', userId)
            .replace('{cartid}', cartId)
            .replace('{currency}', curr)
            .replace('{templatebuilderid}', templateBuilderId);
        return this._api.get(url);
    };
    CmsComponentService.prototype.getSideMenuData = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Side_Menu_Data
            .replace('{lang}', longLang)
            .replace('{templatebuilderid}', templateBuilderId);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getHomePageDataOptimized = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        //reading userId
        var userId = this.authService.getCurrentUserId();
        //reading cartId
        var cartId = this.cartService.getCartId();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        //reading currency
        var curr = this.currencyService.getCurrency();
        cartId = encodeURIComponent(cartId);
        var url = this.mappings.Web_Api_Get_Home_Page_Data_Optimized
            .replace('{lang}', longLang)
            .replace('{userid}', userId)
            .replace('{cartid}', cartId)
            .replace('{currency}', curr)
            .replace('{templatebuilderid}', templateBuilderId);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getproductHilightpromo = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        var url = this.mappings.Web_Api_Get_Home_HilightPromoProduct
            .replace('{lang}', longLang);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getSeoData = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        var url = this.mappings.Web_Api_Get_Seo_Data.replace('{lang}', longLang);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getSliderData = function (type, id) {
        //Reading language
        var longLang = this.language.getLongLang();
        var url = this.mappings.Web_Api_Get_Slider_Data
            .replace('{lang}', longLang)
            .replace('{id}', id)
            .replace('{type}', type);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getFooterData = function () {
        //reading language
        var longLang = this.language.getLongLang();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Footer_Data
            .replace('{lang}', longLang)
            .replace('{currency}', curr);
        return this._api.get(url);
    };
    CmsComponentService.prototype.getShoppingCartData = function () {
        //reading language
        var longLang = this.language.getLongLang();
        //reading userId
        var userInfo = this.authService.GetData();
        var userId;
        if (userInfo != null) {
            userId = this.authService.GetUserId();
        }
        //reading cartId
        var cartId = this.cartService.getCartId();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Shopping_Cart_Data
            .replace('{lang}', longLang)
            .replace('{userid}', userId.toString())
            .replace('{cartid}', cartId)
            .replace('{currency}', curr);
        return this._api.getUniversalCached(url);
    };
    CmsComponentService.prototype.getShoppingCartCashData = function () {
        //reading language
        var longLang = this.language.getLongLang();
        //reading userId
        var userInfo = this.authService.GetData();
        var userId;
        if (userInfo != null) {
            userId = this.authService.GetUserId();
        }
        //reading cartId
        var cartId = this.cartService.getCartId();
        var curr = this.currencyService.getCurrency();
        var url = this.mappings.Web_Api_Get_Shopping_Cart_Cash_Data
            .replace('{lang}', longLang)
            .replace('{userid}', userId.toString())
            .replace('{cartid}', cartId.toString())
            .replace('{currency}', curr);
        return this._api.getUniversalCached(url);
    };
    CmsComponentService.prototype.getShoppingCartSubmittedData = function (orderId) {
        //reading language
        var longLang = this.language.getLongLang();
        //reading userId
        var userInfo = this.authService.GetData();
        var userId;
        if (userInfo != null) {
            userId = this.authService.GetUserId();
        }
        var curr = this.currencyService.getCurrency();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Shopping_Cart_Submitted_Data
            .replace('{lang}', longLang)
            .replace('{userid}', userId.toString())
            .replace('{orderid}', orderId.toString())
            .replace('{currency}', curr)
            .replace("{cartid}", cartId);
        return this._api.getUniversalCached(url);
    };
    CmsComponentService.prototype.getOtherProductData = function (productId, userId) {
        //reading language
        var longLang = this.language.getLongLang();
        //reading template builder id
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Other_Product_Form_Data
            .replace('{lang}', longLang)
            .replace('{productid}', productId)
            .replace('{userId}', userId)
            .replace('{templatebuilderid}', templateBuilderId);
        return this._api.get(url);
    };
    CmsComponentService.prototype.getOfflinePageData = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Offline_Page_Data
            .replace('{lang}', longLang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService.prototype.getLoginPageData = function () {
        //Reading language
        var longLang = this.language.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Login_Page_Data
            .replace('{lang}', longLang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        //Sending request to the server
        return this._api.get(url);
    };
    CmsComponentService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _e) || Object, (typeof (_f = typeof currency_service_1.CurrencyService !== 'undefined' && currency_service_1.CurrencyService) === 'function' && _f) || Object])
    ], CmsComponentService);
    return CmsComponentService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.CmsComponentService = CmsComponentService;


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var NewsletterService = (function () {
    function NewsletterService(_api, _cache, languageService, mappings) {
        this._api = _api;
        this._cache = _cache;
        this.languageService = languageService;
        this.mappings = mappings;
        //getting language
        this.lang = this.languageService.getLongLang();
    }
    NewsletterService.prototype.newsletterSubscribe = function (email) {
        var url = this.mappings.Web_Api_Post_Newsletter_Subscribe.replace('{email}', email).replace('{lang}', this.lang);
        return this._api.get(url);
    };
    NewsletterService.prototype.getNewsletterPageData = function () {
        var url = this.mappings.Web_Api_Get_Newsletter_Page_Data.replace('{lang}', this.lang);
        return this._api.get(url);
    };
    NewsletterService.prototype.getNewsletterConfirmationPageData = function () {
        var url = this.mappings.Web_Api_Get_Newsletter_Confirmation_Page_Data.replace('{lang}', this.lang);
        return this._api.get(url);
    };
    NewsletterService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _c) || Object, (typeof (_d = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _d) || Object])
    ], NewsletterService);
    return NewsletterService;
    var _a, _b, _c, _d;
}());
exports.NewsletterService = NewsletterService;


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(60));
__export(__webpack_require__(622));
__export(__webpack_require__(623));
__export(__webpack_require__(420));
__export(__webpack_require__(624));


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trustpilot_service_1 = __webpack_require__(418);
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(44);
var router_1 = __webpack_require__(12);
var forms_1 = __webpack_require__(228);
var core_2 = __webpack_require__(27);
var api_service_1 = __webpack_require__(13);
var model_service_1 = __webpack_require__(631);
var component_helper_service_1 = __webpack_require__(4);
var template_service_1 = __webpack_require__(35);
var cms_content_service_1 = __webpack_require__(413);
var company_service_1 = __webpack_require__(129);
var article_service_1 = __webpack_require__(126);
var cms_menu_list_service_1 = __webpack_require__(414);
var faq_service_1 = __webpack_require__(415);
var newsletter_service_1 = __webpack_require__(84);
var slider_service_1 = __webpack_require__(417);
var info_request_service_1 = __webpack_require__(416);
var login_service_1 = __webpack_require__(179);
var recover_password_service_1 = __webpack_require__(257);
var register_service_1 = __webpack_require__(98);
var local_storage_1 = __webpack_require__(627);
var quoting_service_1 = __webpack_require__(61);
var category_service_1 = __webpack_require__(262);
var product_service_1 = __webpack_require__(132);
var shopping_cart_service_1 = __webpack_require__(20);
var client_area_service_1 = __webpack_require__(62);
var auth_service_1 = __webpack_require__(9);
var language_service_1 = __webpack_require__(3);
var configuration_service_1 = __webpack_require__(258);
var cms_component_service_1 = __webpack_require__(8);
var seo_service_1 = __webpack_require__(11);
var privacy_policy_service_1 = __webpack_require__(421);
var cookie_policy_service_1 = __webpack_require__(419);
var purchase_condition_service_1 = __webpack_require__(422);
var bootbox_service_1 = __webpack_require__(40);
var loading_overlay_service_1 = __webpack_require__(626);
var script_service_1 = __webpack_require__(14);
var helper_service_1 = __webpack_require__(48);
var order_payment_service_1 = __webpack_require__(256);
var currency_service_1 = __webpack_require__(29);
var messages_service_1 = __webpack_require__(130);
var application_service_1 = __webpack_require__(128);
var search_service_1 = __webpack_require__(263);
var breadcrumbs_service_1 = __webpack_require__(22);
var validation_service_1 = __webpack_require__(131);
var check_existence_service_1 = __webpack_require__(255);
//Components  
var header_component_1 = __webpack_require__(598);
var footer_component_1 = __webpack_require__(596);
var article_category_component_1 = __webpack_require__(372);
var blog_page_component_1 = __webpack_require__(373);
var news_page_component_1 = __webpack_require__(374);
var news_list_component_1 = __webpack_require__(595);
var side_bar_menu_component_1 = __webpack_require__(600);
var newsletter_component_1 = __webpack_require__(597);
var quoting_main_component_1 = __webpack_require__(607);
var wizard_form_commerciale_component_1 = __webpack_require__(611);
var wizard_form_editoria_component_1 = __webpack_require__(612);
var wizard_form_adesivi_component_1 = __webpack_require__(608);
var wizard_form_banner_component_1 = __webpack_require__(609);
var wizard_form_buste_component_1 = __webpack_require__(610);
var wizard_form_etichette_component_1 = __webpack_require__(613);
var wizard_form_stampa_component_1 = __webpack_require__(614);
var other_product_form_component_1 = __webpack_require__(606);
var quoting_order_totals_component_1 = __webpack_require__(605);
var cookie_policy_component_1 = __webpack_require__(378);
var faq_component_1 = __webpack_require__(379);
var info_request_component_1 = __webpack_require__(380);
var privacy_policy_component_1 = __webpack_require__(383);
var purchase_condition_component_1 = __webpack_require__(384);
var cart_empty_page_component_1 = __webpack_require__(385);
var client_area_order_list_component_1 = __webpack_require__(388);
var user_login_component_1 = __webpack_require__(410);
var user_password_component_1 = __webpack_require__(411);
var cart_component_1 = __webpack_require__(396);
var client_area_home_component_1 = __webpack_require__(398);
var client_area_profile_component_1 = __webpack_require__(401);
var cart_cash_component_1 = __webpack_require__(394);
var cart_submitted_component_1 = __webpack_require__(395);
var slider_widget_component_1 = __webpack_require__(603);
var client_area_order_details_component_1 = __webpack_require__(400);
var client_area_catalog_private_component_1 = __webpack_require__(397);
var offline_page_component_1 = __webpack_require__(387);
var not_found_page_component_1 = __webpack_require__(386);
var registration_confirmation_component_1 = __webpack_require__(409);
var payment_confirmation_component_1 = __webpack_require__(403);
var payment_unicredit_confirmation_component_1 = __webpack_require__(405);
var payment_nexi_confirmation_component_1 = __webpack_require__(404);
var payment_banca_sella_confirmation_component_1 = __webpack_require__(402);
var ng2_table_1 = __webpack_require__(428);
var mapping_1 = __webpack_require__(10);
var angular2_material_datepicker_1 = __webpack_require__(591);
var ng2_bs3_modal_1 = __webpack_require__(636);
var crypto_service_1 = __webpack_require__(259);
var search_component_1 = __webpack_require__(375);
var client_area_invoices_component_1 = __webpack_require__(399);
var newsletter_page_component_1 = __webpack_require__(382);
var newsletter_confirmation_page_component_1 = __webpack_require__(381);
var registration_complete_component_1 = __webpack_require__(408);
var customerscanvas_service_1 = __webpack_require__(43);
var canvas_widget_components_1 = __webpack_require__(602);
var paypal_service_1 = __webpack_require__(261);
var quick_registration_component_1 = __webpack_require__(406);
var trustpilot_widget_component_1 = __webpack_require__(604);
var header_service_1 = __webpack_require__(127);
var MODULES = [
    // Do NOT include UniversalModule, HttpModule, or JsonpModule here
    common_1.CommonModule,
    router_1.RouterModule,
    forms_1.FormsModule,
    forms_1.ReactiveFormsModule,
    core_2.TranslateModule,
    ng2_table_1.Ng2TableModule,
    angular2_material_datepicker_1.DatepickerModule,
    ng2_bs3_modal_1.Ng2Bs3ModalModule,
];
var PIPES = [];
var COMPONENTS = [
    // put shared components here
    header_component_1.HeaderComponent,
    footer_component_1.FooterComponent,
    article_category_component_1.ArticleCategoryComponent,
    blog_page_component_1.BlogPageComponent,
    news_page_component_1.ArticleComponent,
    news_list_component_1.NewsListComponent,
    side_bar_menu_component_1.SideBarMenuComponent,
    newsletter_component_1.NewsletterComponent,
    quoting_main_component_1.QuotingMainComponent,
    wizard_form_commerciale_component_1.WizardCommercialeComponent,
    wizard_form_editoria_component_1.WizardEditoriaComponent,
    wizard_form_adesivi_component_1.WizardAdesiviComponent,
    wizard_form_banner_component_1.WizardBannerComponent,
    wizard_form_buste_component_1.WizardBusteComponent,
    wizard_form_etichette_component_1.WizardEtichetteComponent,
    wizard_form_stampa_component_1.WizardStampaComponent,
    other_product_form_component_1.OtherProductFormComponent,
    quoting_order_totals_component_1.QuotingOrderTotalsComponent,
    cookie_policy_component_1.CookiePolicyComponent,
    faq_component_1.FaqComponent,
    info_request_component_1.InfoRequestComponent,
    privacy_policy_component_1.PrivacyPolicyComponent,
    purchase_condition_component_1.PurchaseConditionComponent,
    cart_empty_page_component_1.CartEmptyPageComponent,
    client_area_order_list_component_1.ClientAreaOrderListComponent,
    client_area_invoices_component_1.ClientAreaInvoicesComponent,
    user_login_component_1.UserLoginComponent,
    user_password_component_1.UserPasswordComponent,
    cart_component_1.CartComponent,
    client_area_home_component_1.ClientAreaHomeComponent,
    client_area_profile_component_1.ClientAreaProfileComponent,
    cart_cash_component_1.CartCashComponent,
    cart_submitted_component_1.CartSubmittedComponent,
    slider_widget_component_1.SliderWidgetComponent,
    client_area_order_details_component_1.ClientAreaOrderDetailsComponent,
    client_area_catalog_private_component_1.ClientAreaCatalogPrivateComponent,
    registration_confirmation_component_1.RegistrationConfirmationComponent,
    payment_confirmation_component_1.PaymentConfirmationComponent,
    payment_unicredit_confirmation_component_1.PaymentUnicreditConfirmationComponent,
    payment_nexi_confirmation_component_1.PaymentNexiConfirmationComponent,
    payment_banca_sella_confirmation_component_1.PaymentBancaSellaConfirmationComponent,
    offline_page_component_1.OfflinePageComponent,
    not_found_page_component_1.NotFoundPageComponent,
    search_component_1.SearchComponent,
    newsletter_page_component_1.NewsletterPageComponent,
    newsletter_confirmation_page_component_1.NewsletterConfirmationPageComponent,
    registration_complete_component_1.RegistrationConfirmationPageComponent,
    canvas_widget_components_1.CanvasWidgetComponent,
    quick_registration_component_1.QuickRegistrationComponent,
    trustpilot_widget_component_1.TrustpilotWidgetComponent
];
var PROVIDERS = [
    model_service_1.ModelService,
    api_service_1.ApiService,
    component_helper_service_1.ComponentHelperService,
    template_service_1.TemplateService,
    cms_content_service_1.CmsContentService,
    company_service_1.CompanyService,
    article_service_1.ArticleService,
    cms_menu_list_service_1.CmsMenuListService,
    faq_service_1.FaqListService,
    newsletter_service_1.NewsletterService,
    slider_service_1.SliderService,
    info_request_service_1.InfoRequestService,
    login_service_1.LoginService,
    recover_password_service_1.RecoverPasswordService,
    register_service_1.RegisterService,
    local_storage_1.LocalStorageService,
    quoting_service_1.QuotingService,
    category_service_1.CategoryService,
    product_service_1.ProductService,
    shopping_cart_service_1.ShoppingCartService,
    client_area_service_1.ClientAreaService,
    auth_service_1.AuthService,
    language_service_1.LanguageService,
    configuration_service_1.ConfigurationService,
    application_service_1.ApplicationService,
    mapping_1.Mappings,
    cms_component_service_1.CmsComponentService,
    seo_service_1.SeoService,
    privacy_policy_service_1.PrivacyPolicyService,
    cookie_policy_service_1.CookiePolicyService,
    purchase_condition_service_1.PurchaseConditionService,
    bootbox_service_1.BootboxService,
    loading_overlay_service_1.LoadingOverlayService,
    messages_service_1.MessagesService,
    check_existence_service_1.CheckIfExistService,
    order_payment_service_1.OrderPaymentService,
    script_service_1.ScriptService,
    helper_service_1.HelperService,
    currency_service_1.CurrencyService,
    crypto_service_1.CryptoService,
    search_service_1.SearchService,
    breadcrumbs_service_1.BreadcrumbsService,
    validation_service_1.ValidationService,
    customerscanvas_service_1.CustomersCanvasService,
    paypal_service_1.PaypalService,
    trustpilot_service_1.TrustpilotService,
    header_service_1.HeaderService
];
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule,
            providers: PROVIDERS.slice()
        };
    };
    SharedModule = __decorate([
        core_1.NgModule({
            imports: MODULES.slice(),
            declarations: PIPES.concat(COMPONENTS),
            exports: MODULES.concat(PIPES, COMPONENTS)
        }), 
        __metadata('design:paramtypes', [])
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;


/***/ }),

/***/ 897:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// the polyfills must be the first thing imported
__webpack_require__(468);
__webpack_require__(471);
__webpack_require__(469); // temporary until 2.1.1 things are patched in Core
// Angular 2
var core_1 = __webpack_require__(0);
var browser_1 = __webpack_require__(280);
var bootloader_1 = __webpack_require__(467);
var webfontloader_1 = __webpack_require__(472);
// enable prod for faster renders
core_1.enableProdMode();
var browser_module_1 = __webpack_require__(470);
exports.platformRef = browser_1.platformUniversalDynamic();
// on document ready bootstrap Angular 2
function main() {
    // Load fonts async
    // https://github.com/typekit/webfontloader#configuration
    webfontloader_1.load({
        google: {
            families: ['Droid Sans']
        }
    });
    return exports.platformRef.bootstrapModule(browser_module_1.MainModule);
}
exports.main = main;
// support async tag or hmr
bootloader_1.bootloader(main);


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
//Model
var user_login_1 = __webpack_require__(73);
var cookie_service_1 = __webpack_require__(60);
var router_1 = __webpack_require__(12);
var crypto_service_1 = __webpack_require__(259);
var AuthService = (function () {
    function AuthService(_api, _cache, cookie, router, cryptoService) {
        this._api = _api;
        this._cache = _cache;
        this.cookie = cookie;
        this.router = router;
        this.cryptoService = cryptoService;
        this.loggedInUser = null;
    }
    AuthService.prototype.GetData = function () {
        var user = new user_login_1.UserLogin();
        if (this.cookie.getObject("user") === undefined) {
            this.loggedInUser = null;
        }
        else if (this.cookie.getObject("user") != undefined) {
            var regUser = this.cookie.getObject("user");
            user.username = regUser["username"];
            user.isAuthenticated = Boolean(regUser["isAuthenticated"]);
            var registeredUser = { "isAuthenticated": user.isAuthenticated, "username": user.username };
            this.loggedInUser = registeredUser;
            user = this.loggedInUser;
        }
        return user;
    };
    AuthService.prototype.GetUserId = function () {
        var decryptedUserId = "0";
        var encryptedUserId = this.cookie.get("qazwsxedc");
        if (encryptedUserId != null || encryptedUserId != undefined) {
            decryptedUserId = encryptedUserId;
        }
        else {
            decryptedUserId = this.cryptoService.encryptNumber(Number(decryptedUserId));
        }
        return decryptedUserId;
    };
    AuthService.prototype.GetDecryptedUserId = function () {
        var decryptedUserId = 0;
        var encryptedUserId = this.cookie.get("qazwsxedc");
        if (encryptedUserId != null || encryptedUserId != undefined) {
            decryptedUserId = this.cryptoService.decryptNumber(encryptedUserId);
        }
        else {
            decryptedUserId = Number(this.cryptoService.encryptNumber(decryptedUserId));
        }
        return decryptedUserId;
    };
    AuthService.prototype.Login = function (id, username) {
        var user = new user_login_1.UserLogin();
        // user.id = Number(id);
        user.isAuthenticated = true;
        user.username = username;
        var cryptedUserId = this.cryptoService.encryptNumber(Number(id));
        this.cookie.putObject("user", { "isAuthenticated": "true", "username": username });
        this.cookie.put("qazwsxedc", cryptedUserId);
    };
    AuthService.prototype.Logout = function () {
        this.loggedInUser = null;
        this.cookie.remove("user");
        this.cookie.remove("qazwsxedc");
        var currentRoute = this.router.url;
        if (currentRoute == "/it/home" || "/en/home" || "/de/home" || "/al/home") {
            window.location.reload();
        }
        this.router.navigateByUrl("");
    };
    AuthService.prototype.getCurrentUserId = function () {
        var userId = this.GetUserId();
        return userId;
    };
    AuthService.prototype.setTemplBuilderId = function (templateBuilderId) {
        this.cookie.put("templateBuilderId", templateBuilderId);
    };
    AuthService.prototype.getTemplBuilderId = function () {
        var templateBuilderId = this.cookie.get("templateBuilderId");
        if (templateBuilderId == undefined || templateBuilderId == "undefined") {
            templateBuilderId = "0";
        }
        return templateBuilderId;
    };
    AuthService = __decorate([
        core_1.Injectable(),
        __param(2, core_1.Inject('CookieService')), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof cookie_service_1.CookieService !== 'undefined' && cookie_service_1.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof crypto_service_1.CryptoService !== 'undefined' && crypto_service_1.CryptoService) === 'function' && _e) || Object])
    ], AuthService);
    return AuthService;
    var _a, _b, _c, _d, _e;
}());
exports.AuthService = AuthService;


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ClientAreaDetails = (function () {
    function ClientAreaDetails() {
    }
    return ClientAreaDetails;
}());
exports.ClientAreaDetails = ClientAreaDetails;
var ClientAreaOrderNote = (function () {
    function ClientAreaOrderNote() {
    }
    return ClientAreaOrderNote;
}());
exports.ClientAreaOrderNote = ClientAreaOrderNote;
var ClientAreaUserProfile = (function () {
    function ClientAreaUserProfile() {
    }
    return ClientAreaUserProfile;
}());
exports.ClientAreaUserProfile = ClientAreaUserProfile;
var ClientAreaUserAddress = (function () {
    function ClientAreaUserAddress() {
    }
    return ClientAreaUserAddress;
}());
exports.ClientAreaUserAddress = ClientAreaUserAddress;
var ClientAreaOrderDetails = (function () {
    function ClientAreaOrderDetails() {
    }
    return ClientAreaOrderDetails;
}());
exports.ClientAreaOrderDetails = ClientAreaOrderDetails;
var PaypalButtonStyleModel = (function () {
    function PaypalButtonStyleModel() {
    }
    return PaypalButtonStyleModel;
}());
exports.PaypalButtonStyleModel = PaypalButtonStyleModel;
var ClientAreaProcessingOrders = (function () {
    function ClientAreaProcessingOrders() {
    }
    return ClientAreaProcessingOrders;
}());
exports.ClientAreaProcessingOrders = ClientAreaProcessingOrders;
var ClientAreaOrderProcessMessages = (function () {
    function ClientAreaOrderProcessMessages() {
    }
    return ClientAreaOrderProcessMessages;
}());
exports.ClientAreaOrderProcessMessages = ClientAreaOrderProcessMessages;
var ClientAreaOrderProcessFile = (function () {
    function ClientAreaOrderProcessFile() {
    }
    return ClientAreaOrderProcessFile;
}());
exports.ClientAreaOrderProcessFile = ClientAreaOrderProcessFile;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shopping_cart_service_1 = __webpack_require__(20);
var core_1 = __webpack_require__(0);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(24);
var cache_service_1 = __webpack_require__(21);
var api_service_1 = __webpack_require__(13);
var mapping_1 = __webpack_require__(10);
var language_service_1 = __webpack_require__(3);
var auth_service_1 = __webpack_require__(9);
var RegisterService = (function () {
    function RegisterService(_api, _cache, mappings, cartService, languageService, authService) {
        this._api = _api;
        this._cache = _cache;
        this.mappings = mappings;
        this.cartService = cartService;
        this.languageService = languageService;
        this.authService = authService;
    }
    RegisterService.prototype.sendInfoRequest = function (parameters) {
        var cartId = this.cartService.getCartId();
        parameters.CartId = cartId;
        parameters.EmailRegister = parameters.EmailRegister ? parameters.EmailRegister.toLowerCase() : "";
        parameters.EmailRepeat = parameters.EmailRepeat ? parameters.EmailRepeat.toLowerCase() : "";
        parameters.PecEmail = parameters.PecEmail ? parameters.PecEmail.toLowerCase() : "";
        return this._api.post(this.mappings.Web_Api_Post_Register, parameters)
            .do(function (result) { return result; })
            .share();
    };
    RegisterService.prototype.getRegisterPageData = function () {
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var lang = this.languageService.getLongLang();
        var templateBuilderId = this.authService.getTemplBuilderId();
        var url = this.mappings.Web_Api_Get_Register_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId)
            .replace('{templatebuilderid}', templateBuilderId);
        return this._api.get(url);
    };
    RegisterService.prototype.confirmationRegistration = function (id) {
        var url = this.mappings.Web_Api_Post_Confirm_Registration.replace('{id}', id);
        return this._api.post(url);
    };
    RegisterService.prototype.setFacebookLoginData = function (registerData) {
        this.facebookLoginData = registerData;
    };
    RegisterService.prototype.getFacebookLoginData = function () {
        return this.facebookLoginData;
    };
    RegisterService.prototype.getRegistrationCompletePageData = function () {
        var lang = this.languageService.getLongLang();
        var customerId = this.authService.GetUserId();
        var cartId = this.cartService.getCartId();
        var url = this.mappings.Web_Api_Get_Registration_Complete_Page_Data
            .replace('{lang}', lang)
            .replace('{userid}', customerId)
            .replace('{cartid}', cartId);
        return this._api.get(url);
    };
    RegisterService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object, (typeof (_c = typeof mapping_1.Mappings !== 'undefined' && mapping_1.Mappings) === 'function' && _c) || Object, (typeof (_d = typeof shopping_cart_service_1.ShoppingCartService !== 'undefined' && shopping_cart_service_1.ShoppingCartService) === 'function' && _d) || Object, (typeof (_e = typeof language_service_1.LanguageService !== 'undefined' && language_service_1.LanguageService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
    ], RegisterService);
    return RegisterService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.RegisterService = RegisterService;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var core_1 = __webpack_require__(0);
// es6-modules are used here
var dom_adapter_1 = __webpack_require__(32);
var platform_browser_1 = __webpack_require__(7);
/**
 * A service that can be used to get and add meta tags.
 *
 * @experimental
 */
var Meta = (function () {
    function Meta(_document) {
        this._document = _document;
        this._dom = dom_adapter_1.getDOM();
    }
    /**
     * Adds a new meta tag to the dom.
     *
     *  ### Example
     *
     * ```ts
     * const name: MetaDefinition = {name: 'application-name', content: 'Name of my application'};
     * const desc: MetaDefinition = {name: 'description', content: 'A description of the page'};
     * const tags: HTMLMetaElement[] = this.meta.addTags([name, desc]);
     * ```
     *
     * @param tags
     * @returns {HTMLMetaElement[]}
     */
    Meta.prototype.addTags = function () {
        var _this = this;
        var tags = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tags[_i - 0] = arguments[_i];
        }
        var presentTags = this._flattenArray(tags);
        if (presentTags.length === 0)
            return [];
        return presentTags.map(function (tag) { return _this._addInternal(tag); });
    };
    /**
     * Gets the meta tag by the given selector. Returns element or null
     * if there's no such meta element.
     *
     *  ### Example
     *
     * ```ts
     * const meta: HTMLMetaElement = this.meta.getTag('name=description');
     * const twitterMeta: HTMLMetaElement = this.meta.getTag('name="twitter:title"');
     * const fbMeta: HTMLMetaElement = this.meta.getTag('property="fb:app_id"');
     * ```
     *
     * @param selector
     * @returns {HTMLMetaElement}
     */
    Meta.prototype.getTag = function (selector) {
        if (!selector)
            return null;
        return this._dom.query("meta[" + selector + "]");
    };
    /**
     * Updates the meta tag with the given selector.
     *
     * *  ### Example
     *
     * ```ts
     * const meta: HTMLMetaElement = this.meta.updateTag('name=description', {name: 'description',
     * content: 'New description'});
     * console.log(meta.content); // 'New description'
     * ```
     *
     * @param selector
     * @param tag updated tag definition
     * @returns {HTMLMetaElement}
     */
    Meta.prototype.updateTag = function (selector, tag) {
        var meta = this.getTag(selector);
        if (!meta) {
            // create element if it doesn't exist
            return this._addInternal(tag);
        }
        return this._prepareMetaElement(tag, meta);
    };
    /**
     * Removes meta tag with the given selector from the dom.
     *
     *  ### Example
     *
     * ```ts
     * this.meta.removeTagBySelector('name=description');
     * ```
     *
     * @param selector
     */
    Meta.prototype.removeTagBySelector = function (selector) {
        var meta = this.getTag(selector);
        this.removeTagElement(meta);
    };
    /**
     * Removes given meta element from the dom.
     *
     *  ### Example
     *  ```ts
     * const elem: HTMLMetaElement = this.meta.getTag('name=description');
     * this.meta.removeTagElement(elem);
     * ```
     *
     * @param meta meta element
     */
    Meta.prototype.removeTagElement = function (meta) {
        if (meta) {
            this._removeMetaElement(meta);
        }
    };
    Meta.prototype.setTitle = function (title) {
        this._document.title = title;
    };
    Meta.prototype._addInternal = function (tag) {
        var meta = this._createMetaElement();
        this._prepareMetaElement(tag, meta);
        this._appendMetaElement(meta);
        return meta;
    };
    Meta.prototype._createMetaElement = function () {
        return this._dom.createElement('meta');
    };
    Meta.prototype._prepareMetaElement = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    Meta.prototype._appendMetaElement = function (meta) {
        var head = this._document.head;
        this._dom.appendChild(head, meta);
    };
    Meta.prototype._removeMetaElement = function (meta) {
        var head = this._dom.parentElement(meta);
        this._dom.removeChild(head, meta);
    };
    Meta.prototype._flattenArray = function (input, out) {
        if (out === void 0) { out = []; }
        if (input) {
            for (var i = 0; i < input.length; i++) {
                var item = input[i];
                if (Array.isArray(item)) {
                    this._flattenArray(item, out);
                }
                else if (item) {
                    out.push(item);
                }
            }
        }
        return out;
    };
    Meta = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Object])
    ], Meta);
    return Meta;
}());
exports.Meta = Meta;


/***/ })

},[898]);


// WEBPACK FOOTER //
// main.bundle.js